webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) {
        s = '0' + s;
    }
    return s;
};

exports.default = {
    validateEmail: function validateEmail(rule, value, callback) {
        var reg = /^([a-zA-Z]|[0-9])(\w|\-|\.)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
        if (reg.test(value)) {
            callback();
        } else {
            callback(new Error('Invalid email.'));
        }
    },
    getQueryStringByName: function getQueryStringByName(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null) context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    formatDate: {

        format: function format(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function parse(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int);break;
                        case 'M':
                            _date.setMonth(_int - 1);break;
                        case 'd':
                            _date.setDate(_int);break;
                        case 'h':
                            _date.setHours(_int);break;
                        case 'm':
                            _date.setMinutes(_int);break;
                        case 's':
                            _date.setSeconds(_int);break;
                    }
                }
                return _date;
            }
            return null;
        }

    }

};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var role = exports.role = '';
var serverUrl = exports.serverUrl = "https://bpisglobal.com/liugh-web/";
var url = exports.url = "/";
var defaultPageSize = exports.defaultPageSize = 50;

var conditions = exports.conditions = ["New", "Refurbished", "Used like new", "Used very good", "Used good", "Used acceptable", "Collectible like new", "Collectible very good", "Collectible good", "Collectible acceptable"];

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(107);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(106);

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__(198);

var _axios2 = _interopRequireDefault(_axios);

var _nprogress = __webpack_require__(195);

var _nprogress2 = _interopRequireDefault(_nprogress);

var _globalVar = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_axios2.default.defaults.baseURL = _globalVar.serverUrl;
_axios2.default.defaults.transformRequest = function (data) {
    data = (0, _stringify2.default)(data);
    return data;
};

_axios2.default.interceptors.request.use(function (config) {
    var token = sessionStorage.getItem("authorization");
    if (token) {
        config.headers['Authorization'] = token;
    }
    if (!config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'application/json;charset=UTF-8';
    }

    _nprogress2.default.start();
    return config;
}, function (error) {
    _nprogress2.default.done();
    return _promise2.default.reject(error.response);
});

_axios2.default.interceptors.response.use(function (response) {
    _nprogress2.default.done();
    if (response.data.status === 401) {
        window.location.href = _globalVar.url + "/";
    } else {
        return response;
    }
}, function (error) {
    _nprogress2.default.done();
    return _promise2.default.reject(error);
});
exports.default = _axios2.default;

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUserBalance = exports.getDoctorNurse = exports.getMemberWithGroup = exports.getNurseDoctor = exports.invitationDoctor = exports.getAdminInvitationList = exports.editUserStatus = exports.getAllMemberList = exports.getMemberById = exports.getGroupById = exports.addGroup = exports.deleteGroup = exports.getGroupList = exports.getDoctorMemberList = exports.editInvitationStatus = exports.getInvitations = exports.invitationRegister = exports.getDoctorMembers = exports.editMember = exports.getMembersById = undefined;

var _axiosInit = __webpack_require__(14);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMembersById = exports.getMembersById = function getMembersById(params) {
    return _axiosInit2.default.post('/member/getMemberById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editMember = exports.editMember = function editMember(params) {
    return _axiosInit2.default.post('/member/editInfo', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getDoctorMembers = exports.getDoctorMembers = function getDoctorMembers(params) {
    return _axiosInit2.default.post('/member/getListByLogin', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var invitationRegister = exports.invitationRegister = function invitationRegister(params) {
    return _axiosInit2.default.post('/invitation/inviteUser', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getInvitations = exports.getInvitations = function getInvitations(params) {
    return _axiosInit2.default.post('/invitation/invitationList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editInvitationStatus = exports.editInvitationStatus = function editInvitationStatus(params) {
    return _axiosInit2.default.post('/invitation/editInvitaStatus', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getDoctorMemberList = exports.getDoctorMemberList = function getDoctorMemberList(params) {
    return _axiosInit2.default.post('/member/getAllUserByLogin', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getGroupList = exports.getGroupList = function getGroupList(params) {
    return _axiosInit2.default.post('/group/getList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var deleteGroup = exports.deleteGroup = function deleteGroup(params) {
    return _axiosInit2.default.post('/group/delGroupById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var addGroup = exports.addGroup = function addGroup(params) {
    return _axiosInit2.default.post('/group/saveOrUpdateGroup', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getGroupById = exports.getGroupById = function getGroupById(params) {
    return _axiosInit2.default.post('/group/getGroupInfoById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getMemberById = exports.getMemberById = function getMemberById(params) {
    return _axiosInit2.default.post('/member/getMemberById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getAllMemberList = exports.getAllMemberList = function getAllMemberList(params) {
    return _axiosInit2.default.post('/admin/queryUsersInfoList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editUserStatus = exports.editUserStatus = function editUserStatus(params) {
    return _axiosInit2.default.post('/admin/modifyUserStatus', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getAdminInvitationList = exports.getAdminInvitationList = function getAdminInvitationList(params) {
    return _axiosInit2.default.post('/admin/invitationList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var invitationDoctor = exports.invitationDoctor = function invitationDoctor(params) {
    return _axiosInit2.default.post('/admin/InvitedDoctor', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getNurseDoctor = exports.getNurseDoctor = function getNurseDoctor(params) {
    return _axiosInit2.default.post('/member/getDoctorInfoByCurrentUser', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getMemberWithGroup = exports.getMemberWithGroup = function getMemberWithGroup(params) {
    return _axiosInit2.default.post('/group/getGroupAndMemberInfoList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getDoctorNurse = exports.getDoctorNurse = function getDoctorNurse(params) {
    return _axiosInit2.default.post('/offer/getNurseInfoListByCurrentUser', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getUserBalance = exports.getUserBalance = function getUserBalance(params) {
    return _axiosInit2.default.post('/member/getMemberBalance', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(776),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.postExportExcel = exports.exportExcel = undefined;

var _axiosInit = __webpack_require__(14);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var exportExcel = exports.exportExcel = function exportExcel(param) {
    return _axiosInit2.default.get(param.url, { responseType: 'blob' }).then(function (res) {
        var blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
        var fileName = param.fileName;
        if ('download' in document.createElement('a')) {
            var elink = document.createElement('a');
            elink.download = fileName;
            elink.style.display = 'none';
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);
            document.body.removeChild(elink);
        } else {
            navigator.msSaveBlob(blob, fileName);
        }
    }).catch(function (error) {
        return error;
    });
};

var postExportExcel = exports.postExportExcel = function postExportExcel(param) {
    return _axiosInit2.default.post(param.url, param, { responseType: 'blob' }).then(function (res) {
        var blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
        var fileName = param.fileName;
        if ('download' in document.createElement('a')) {
            var elink = document.createElement('a');
            elink.download = fileName;
            elink.style.display = 'none';
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);
            document.body.removeChild(elink);
        } else {
            navigator.msSaveBlob(blob, fileName);
        }
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetPassword = exports.validateResetPassword = exports.requestForgetPassword = exports.getNurseHome = exports.getDoctorHome = exports.logout = exports.getCurrentUser = exports.changeUserInfo = exports.changePassword = exports.register = exports.validateRegister = exports.login = undefined;

var _axiosInit = __webpack_require__(14);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var login = exports.login = function login(params) {
    return _axiosInit2.default.post('/invite/inviteLogin', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var validateRegister = exports.validateRegister = function validateRegister(params) {
    return _axiosInit2.default.post('/invite/validateInvitedId', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var register = exports.register = function register(params) {
    return _axiosInit2.default.post('/invite/inviteRegister', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var changePassword = exports.changePassword = function changePassword(params) {
    return _axiosInit2.default.post('/invitation/changePwd', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var changeUserInfo = exports.changeUserInfo = function changeUserInfo(params) {
    return _axiosInit2.default.post('/user/modifyPhoneNumber', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getCurrentUser = exports.getCurrentUser = function getCurrentUser(params) {
    return _axiosInit2.default.post('/user/currentUser', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var logout = exports.logout = function logout(params) {
    return _axiosInit2.default.post('/invitation/logout', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getDoctorHome = exports.getDoctorHome = function getDoctorHome(params) {
    return _axiosInit2.default.post('/common/getDoctorHomeData', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getNurseHome = exports.getNurseHome = function getNurseHome(params) {
    return _axiosInit2.default.post('/statistics/statisticsNurseData', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var requestForgetPassword = exports.requestForgetPassword = function requestForgetPassword(params) {
    return _axiosInit2.default.post('/passwordResetRequest/sendResetPasswordEmail', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var validateResetPassword = exports.validateResetPassword = function validateResetPassword(params) {
    return _axiosInit2.default.post('/passwordResetRequest/validateResetId', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var resetPassword = exports.resetPassword = function resetPassword(params) {
    return _axiosInit2.default.post('/passwordResetRequest/resetPassword', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sendEmail = exports.getStorageFeeList = exports.getWarehouseForWarehouseAdmin = exports.getCurrentWarehouse = exports.addWarehouses = exports.deleteWarehouses = exports.getWarehousesById = exports.getWarehouses = exports.getNurseWarehouses = undefined;

var _axiosInit = __webpack_require__(14);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getNurseWarehouses = exports.getNurseWarehouses = function getNurseWarehouses(params) {
    return _axiosInit2.default.post('/warehouse/queryWareHouseInfoListForNurse', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getWarehouses = exports.getWarehouses = function getWarehouses(params) {
    return _axiosInit2.default.post('/warehouse/queryWareHouseInfoList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getWarehousesById = exports.getWarehousesById = function getWarehousesById(params) {
    return _axiosInit2.default.post('/warehouse/queryWareHouseById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var deleteWarehouses = exports.deleteWarehouses = function deleteWarehouses(params) {
    return _axiosInit2.default.post('/warehouse/deleteWareHouseById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var addWarehouses = exports.addWarehouses = function addWarehouses(params) {
    return _axiosInit2.default.post('/warehouse/addWareHouse', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getCurrentWarehouse = exports.getCurrentWarehouse = function getCurrentWarehouse(params) {
    return _axiosInit2.default.post('/warehouse/queryCurrentWareHouse', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getWarehouseForWarehouseAdmin = exports.getWarehouseForWarehouseAdmin = function getWarehouseForWarehouseAdmin(params) {
    return _axiosInit2.default.post('/warehouse/getWarehouseByUser', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getStorageFeeList = exports.getStorageFeeList = function getStorageFeeList(params) {
    return _axiosInit2.default.post('/storageChargeStatistics/getStorageChargeTotal', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var sendEmail = exports.sendEmail = function sendEmail(params) {
    return _axiosInit2.default.post('/warehouse/sendUpcMatchEmailToDoctor', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.distributeProductTempate = exports.getProductTemplateListByCondition = exports.deleteProductTemplate = exports.getDistributedDoctorName = exports.getProductTemplateById = exports.addProductTemplate = exports.getServiceList = exports.getSizeList = exports.getStockHistory = exports.deleteProduct = exports.getProductFBM = exports.getNotClaimed = exports.getFBM = exports.editFBM = exports.editReportStatus = exports.getInventoryReportList = exports.getInventoryByProduct = exports.reportInventory = exports.getZeroInventory = exports.getUserInventory = exports.getProductById = exports.getDoctorProductList = exports.addProduct = exports.getInventory = exports.getDoctorProduct = undefined;

var _axiosInit = __webpack_require__(14);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDoctorProduct = exports.getDoctorProduct = function getDoctorProduct(params) {
    return _axiosInit2.default.post('/products/getProductListByCurrentUser', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getInventory = exports.getInventory = function getInventory(params) {
    return _axiosInit2.default.post('/products/getProductList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var addProduct = exports.addProduct = function addProduct(params) {
    return _axiosInit2.default.post('/products/saveOrUpdateById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getDoctorProductList = exports.getDoctorProductList = function getDoctorProductList(params) {
    return _axiosInit2.default.post('/products/getDoctorProductList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getProductById = exports.getProductById = function getProductById(params) {
    return _axiosInit2.default.post('/products/getProductAndDiscount', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getUserInventory = exports.getUserInventory = function getUserInventory(params) {
    return _axiosInit2.default.post('/inbound/getUserInventoryList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getZeroInventory = exports.getZeroInventory = function getZeroInventory(params) {
    return _axiosInit2.default.post('/inbound/getUserInventoryZeroList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var reportInventory = exports.reportInventory = function reportInventory(params) {
    return _axiosInit2.default.post('/inventoryReport/saveOrUpdateReportInfo', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getInventoryByProduct = exports.getInventoryByProduct = function getInventoryByProduct(params) {
    return _axiosInit2.default.post('/inventoryReport/getInventoryListByProduct', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getInventoryReportList = exports.getInventoryReportList = function getInventoryReportList(params) {
    return _axiosInit2.default.post('/inventoryReport/getInventoryReportList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editReportStatus = exports.editReportStatus = function editReportStatus(params) {
    return _axiosInit2.default.post('/inventoryReport/changeInventoryReportStausById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editFBM = exports.editFBM = function editFBM(params) {
    return _axiosInit2.default.post('/fbm/saveOrUpdateFbmInfo', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getFBM = exports.getFBM = function getFBM(params) {
    return _axiosInit2.default.post('/fbm/getFbmList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getNotClaimed = exports.getNotClaimed = function getNotClaimed(params) {
    return _axiosInit2.default.post('/confirmWarehouse/getNotClaimedList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getProductFBM = exports.getProductFBM = function getProductFBM(params) {
    return _axiosInit2.default.post('/fbm/getProductFBM', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var deleteProduct = exports.deleteProduct = function deleteProduct(params) {
    return _axiosInit2.default.post('/products/deleteProduct', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getStockHistory = exports.getStockHistory = function getStockHistory(params) {
    return _axiosInit2.default.post('/stockOperationLog/getStockOperationLogList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getSizeList = exports.getSizeList = function getSizeList(params) {
    return _axiosInit2.default.post('/boxsizes/selectOptions', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getServiceList = exports.getServiceList = function getServiceList(params) {
    return _axiosInit2.default.post('/serviceFee/selectOptions', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var addProductTemplate = exports.addProductTemplate = function addProductTemplate(params) {
    return _axiosInit2.default.post('/products_template/saveOrUpdateTemplateById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getProductTemplateById = exports.getProductTemplateById = function getProductTemplateById(params) {
    return _axiosInit2.default.post('/products_template/getProductTemplateById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getDistributedDoctorName = exports.getDistributedDoctorName = function getDistributedDoctorName(params) {
    return _axiosInit2.default.post('/products_template/getDistributedDoctorName', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var deleteProductTemplate = exports.deleteProductTemplate = function deleteProductTemplate(params) {
    return _axiosInit2.default.post('/products_template/deleteProductTemplate', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getProductTemplateListByCondition = exports.getProductTemplateListByCondition = function getProductTemplateListByCondition(params) {
    return _axiosInit2.default.post('/products_template/getProductListByCondition', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var distributeProductTempate = exports.distributeProductTempate = function distributeProductTempate(params) {
    return _axiosInit2.default.post('/products_template/distribute', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(795),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(774),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(689)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(804),
  /* scopeId */
  "data-v-cb3238cc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.batchRemoveImportTracking = exports.removeImportTracking = exports.getQtyByTracking = exports.bulkClaim = exports.claimTracking = exports.editInboundTracking = exports.bulkReverse = exports.reverseById = exports.bulkConfirm = exports.getBulkConfirmListByBatchNum = exports.bulkRemove = exports.getBatchNumberList = exports.editTrackingById = exports.getTrackingById = exports.removeTracking = exports.importTracking = exports.getTrackingConfirmList = exports.getDoctorTrackingList = exports.getTrackingList = exports.getBatchNumber = exports.cancelInboundByDoctor = exports.cancelNurseInbound = exports.confirmNurseInbound = exports.getNurseConfirmList = exports.getInboundDetail = exports.getUnClaimTracking = exports.getInboundHistoryList = exports.getCancelInboundList = exports.getInboundDetailList = exports.getProductInboundList = exports.getInboundList = undefined;

var _promise = __webpack_require__(107);

var _promise2 = _interopRequireDefault(_promise);

var _axiosInit = __webpack_require__(14);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getInboundList = exports.getInboundList = function getInboundList(params) {
    var list = [{
        id: "1",
        offer: "product1",
        quantity: "100",
        createDate: "2019-07-20 12:00:00"
    }, {
        id: "1",
        offer: "product2",
        quantity: "150",
        createDate: "2019-07-20 12:00:00"
    }];
    return _promise2.default.resolve(list);
};

var getProductInboundList = exports.getProductInboundList = function getProductInboundList(params) {
    return _axiosInit2.default.post("/inbound/getDetailByProductNo", params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getInboundDetailList = exports.getInboundDetailList = function getInboundDetailList(params) {
    return _axiosInit2.default.post("/inbound/getOfferDetail", params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getCancelInboundList = exports.getCancelInboundList = function getCancelInboundList(params) {
    return _axiosInit2.default.post("/inbound/getInboundCancelInfoByDoctorId", params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getInboundHistoryList = exports.getInboundHistoryList = function getInboundHistoryList(params) {
    return _axiosInit2.default.post("/inbound/getHistoryInboundData", params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getUnClaimTracking = exports.getUnClaimTracking = function getUnClaimTracking(params) {
    return _axiosInit2.default.post("/inbound/getUnClaimTracking", params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getInboundDetail = exports.getInboundDetail = function getInboundDetail(params) {
    return _axiosInit2.default.post("/inbound/getInBoundById", params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getNurseConfirmList = exports.getNurseConfirmList = function getNurseConfirmList(params) {
    return _axiosInit2.default.post("/inbound/getInboundListByStatus", params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var confirmNurseInbound = exports.confirmNurseInbound = function confirmNurseInbound(params) {
    return _axiosInit2.default.post("/inbound/nurseAddStock", params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var cancelNurseInbound = exports.cancelNurseInbound = function cancelNurseInbound(params) {
    return _axiosInit2.default.post("/inbound/cancelInboundById", params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var cancelInboundByDoctor = exports.cancelInboundByDoctor = function cancelInboundByDoctor(params) {
    return _axiosInit2.default.post("/inbound/cancelInboundByDoctor", params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getBatchNumber = exports.getBatchNumber = function getBatchNumber(params) {
    return _axiosInit2.default.post("/inbound/getBatchNumber", params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getTrackingList = exports.getTrackingList = function getTrackingList(params) {
    return _axiosInit2.default.post("/confirmWarehouse/getNoMatchData", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getDoctorTrackingList = exports.getDoctorTrackingList = function getDoctorTrackingList(params) {
    return _axiosInit2.default.post("/confirmWarehouse/getTrackingListForDoctor", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getTrackingConfirmList = exports.getTrackingConfirmList = function getTrackingConfirmList(params) {
    return _axiosInit2.default.post("/confirmWarehouse/getComfiringDataAndProductList", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var importTracking = exports.importTracking = function importTracking(params) {
    return _axiosInit2.default.post("/confirmWarehouse/saveImportData", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var removeTracking = exports.removeTracking = function removeTracking(params) {
    return _axiosInit2.default.post("/confirmWarehouse/removeById", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getTrackingById = exports.getTrackingById = function getTrackingById(params) {
    return _axiosInit2.default.post("/confirmWarehouse/getDetailById", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editTrackingById = exports.editTrackingById = function editTrackingById(params) {
    return _axiosInit2.default.post("/confirmWarehouse/editById", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getBatchNumberList = exports.getBatchNumberList = function getBatchNumberList(params) {
    return _axiosInit2.default.post("/confirmWarehouse/getBatchNumberByType", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var bulkRemove = exports.bulkRemove = function bulkRemove(params) {
    return _axiosInit2.default.post("/confirmWarehouse/batchBulkRemoveByBatchNumber", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getBulkConfirmListByBatchNum = exports.getBulkConfirmListByBatchNum = function getBulkConfirmListByBatchNum(params) {
    return _axiosInit2.default.post("/confirmWarehouse/getComfiringDataAndProductList", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var bulkConfirm = exports.bulkConfirm = function bulkConfirm(params) {
    return _axiosInit2.default.post("/confirmWarehouse/batchBulkComfirmed", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var reverseById = exports.reverseById = function reverseById(params) {
    return _axiosInit2.default.post("/confirmWarehouse/reverseByCwId", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var bulkReverse = exports.bulkReverse = function bulkReverse(params) {
    return _axiosInit2.default.post("/confirmWarehouse/reverseByBatchNumber", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editInboundTracking = exports.editInboundTracking = function editInboundTracking(params) {
    return _axiosInit2.default.post("/confirmWarehouse/editTracking", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var claimTracking = exports.claimTracking = function claimTracking(params) {
    return _axiosInit2.default.post("/inbound/nurseClaimCompareInboundDetail", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var bulkClaim = exports.bulkClaim = function bulkClaim(params) {
    return _axiosInit2.default.post("/inbound/bulkClaim", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getQtyByTracking = exports.getQtyByTracking = function getQtyByTracking(params) {
    return _axiosInit2.default.post("/common/getNumBytrackingS", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var removeImportTracking = exports.removeImportTracking = function removeImportTracking(params) {
    return _axiosInit2.default.post("/inbound/deleteUnClaimedTrackingImportData", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var batchRemoveImportTracking = exports.batchRemoveImportTracking = function batchRemoveImportTracking(params) {
    return _axiosInit2.default.post("/inbound/batchDeleteUnClaimedTrackingImportData", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getOfferDetail = exports.getOpenOffers = exports.removeProposedOffer = exports.editProposedOfferStatus = exports.requestProposedOffers = exports.getProposedOffers = exports.expiredOffers = exports.addOffer = exports.editOfferStatus = exports.getOfferById = exports.getNurseOffer = exports.getDoctorOffer = exports.takeOffer = exports.getTakeOfferDetail = exports.getProposedOfferList = exports.getNurseOfferHistoryList = undefined;

var _promise = __webpack_require__(107);

var _promise2 = _interopRequireDefault(_promise);

var _axiosInit = __webpack_require__(14);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getNurseOfferHistoryList = exports.getNurseOfferHistoryList = function getNurseOfferHistoryList(params) {
    return _axiosInit2.default.post('/offer/getOfferTakeListHistory', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getProposedOfferList = exports.getProposedOfferList = function getProposedOfferList(params) {
    return _axiosInit2.default.post('/offer/getOfferListByStatus', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getTakeOfferDetail = exports.getTakeOfferDetail = function getTakeOfferDetail(params) {
    return _axiosInit2.default.post('/offer/getOfferTakeListByStatusAndOfferNo', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var takeOffer = exports.takeOffer = function takeOffer(params) {
    return _axiosInit2.default.post('/offerTake/takeOffer', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getDoctorOffer = exports.getDoctorOffer = function getDoctorOffer(params) {
    return _axiosInit2.default.post('/offer/queryOfferInfoList', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getNurseOffer = exports.getNurseOffer = function getNurseOffer(params) {
    return _axiosInit2.default.post('/offer/getOfferListByDoctorId', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getOfferById = exports.getOfferById = function getOfferById(params) {
    return _axiosInit2.default.post('/offer/queryOfferInfoById', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var editOfferStatus = exports.editOfferStatus = function editOfferStatus(params) {
    return _axiosInit2.default.post('/offer/changeOfferStausById', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var addOffer = exports.addOffer = function addOffer(params) {
    return _axiosInit2.default.post('/offer/saveOrUpdateOfferInfo', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var expiredOffers = exports.expiredOffers = function expiredOffers(params) {
    return _axiosInit2.default.post('/offer/queryExpiredOfferInfoListForNurse', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getProposedOffers = exports.getProposedOffers = function getProposedOffers(params) {
    return _axiosInit2.default.post('/offerProposed/getOfferProposedList', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var requestProposedOffers = exports.requestProposedOffers = function requestProposedOffers(params) {
    return _axiosInit2.default.post('/offerProposed/saveOrUpdateProposedInfo', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var editProposedOfferStatus = exports.editProposedOfferStatus = function editProposedOfferStatus(params) {
    return _axiosInit2.default.post('/offerProposed/changeProposedStausById', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var removeProposedOffer = exports.removeProposedOffer = function removeProposedOffer(params) {
    return _axiosInit2.default.post('/offerProposed/removeProposedOffer', params).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return err;
    });
};

var getOpenOffers = exports.getOpenOffers = function getOpenOffers(params) {
    var list = [{
        id: "1",
        product: 'Product1',
        price: "100",
        total: 100,
        user: "护士1",
        quantity: 15,
        createBy: "神医1",
        createDate: "2019-07-15 07:00:00",
        expires: '2019-07-20 00:00:00',
        note: 'test add offer',
        bonus: "10",
        serviceTag: false,
        scope: "private",
        notify: true,
        users: [1, 2, 3],
        status: "archived"
    }, {
        id: "2",
        product: 'Product2',
        price: "90",
        total: 150,
        quantity: 20,
        user: "护士1",
        createBy: "神医1",
        createDate: "2019-07-15 07:00:00",
        expires: '2019-07-15 00:00:00',
        note: 'test add offer',
        bonus: "10",
        serviceTag: false,
        scope: "private",
        notify: true,
        users: [1, 2],
        status: "archived"
    }, {
        id: "2",
        product: 'Product3',
        price: "150",
        total: 120,
        quantity: 100,
        user: "护士2",
        createBy: "神医1",
        createDate: "2019-07-15 07:00:00",
        expires: '2019-07-15 00:00:00',
        note: 'test add offer',
        bonus: "10",
        serviceTag: false,
        scope: "private",
        notify: true,
        users: [1, 2],
        status: "canceled"
    }];
    return _promise2.default.resolve(list);
};

var getOfferDetail = exports.getOfferDetail = function getOfferDetail(params) {
    var list = [{
        id: "1",
        product: 'Product1',
        price: "100",
        quantity: "20",
        user: "护士1",
        company: "神医1",
        warehouse: "FL 0001",
        date: "2019-07-20 12:00:00"
    }, {
        id: "2",
        product: 'Product1',
        price: "105",
        quantity: "15",
        user: "护士1",
        company: "神医1",
        warehouse: "FL 0002",
        date: "2019-07-20 12:00:00"
    }, {
        id: "1",
        product: 'Product1',
        price: "105",
        quantity: "30",
        user: "护士2",
        company: "神医1",
        warehouse: "FL 0002",
        date: "2019-07-20 12:00:00"
    }];
    return _promise2.default.resolve(list);
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uploadET = exports.updateOutboundStatus = exports.getCustomizationProduct = exports.markChecked = exports.getTransferUserInfoWithWarehouseByDoctorNo = exports.getTransferUserInfoByDoctorNo = exports.getTransferList = exports.getOutboundList = exports.deleteCustomizationTemplate = exports.addCustomizationTemplate = exports.getOutboundByProduct = exports.getProductsByWarehouseId = exports.getInventorySummary = exports.transferTo = exports.getProductFBM = exports.getInventoryList = exports.deleteInstruction = exports.addInstruction = exports.getInstructionListByPage = exports.getInstructionList = exports.outbound = undefined;

var _axiosInit = __webpack_require__(14);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var outbound = exports.outbound = function outbound(params) {
    return _axiosInit2.default.post('/outbound/submitOutBound', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getInstructionList = exports.getInstructionList = function getInstructionList(params) {
    return _axiosInit2.default.post('/instruction/getListByUser', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getInstructionListByPage = exports.getInstructionListByPage = function getInstructionListByPage(params) {
    return _axiosInit2.default.post('/instruction/getList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var addInstruction = exports.addInstruction = function addInstruction(params) {
    return _axiosInit2.default.post('/instruction/addOrEditInfo', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var deleteInstruction = exports.deleteInstruction = function deleteInstruction(params) {
    return _axiosInit2.default.post('/instruction/deleteInstruction', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getInventoryList = exports.getInventoryList = function getInventoryList(params) {
    return _axiosInit2.default.post('/outbound/getOutBoundAddProduct', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getProductFBM = exports.getProductFBM = function getProductFBM(params) {
    return _axiosInit2.default.post('/transfer/getProductFBM', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var transferTo = exports.transferTo = function transferTo(params) {
    return _axiosInit2.default.post('/transfer/transferTo', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getInventorySummary = exports.getInventorySummary = function getInventorySummary(params) {
    return _axiosInit2.default.post('/outbound/getOutBoundProductSummary', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getProductsByWarehouseId = exports.getProductsByWarehouseId = function getProductsByWarehouseId(params) {
    return _axiosInit2.default.post('/outbound/getProductsByWarehouseId', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getOutboundByProduct = exports.getOutboundByProduct = function getOutboundByProduct(params) {
    return _axiosInit2.default.post('/outbound/getOutboundByProduct', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var addCustomizationTemplate = exports.addCustomizationTemplate = function addCustomizationTemplate(params) {
    return _axiosInit2.default.post('/outbound/addOrUpdateCustomizationTemplate4Outbound', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var deleteCustomizationTemplate = exports.deleteCustomizationTemplate = function deleteCustomizationTemplate(params) {
    return _axiosInit2.default.post('/outbound/removeCustomizationTemplate4Outbound', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getOutboundList = exports.getOutboundList = function getOutboundList(params) {
    return _axiosInit2.default.post('/outbound/getDataByType', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getTransferList = exports.getTransferList = function getTransferList(params) {
    return _axiosInit2.default.post('/transfer/getTransferList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getTransferUserInfoByDoctorNo = exports.getTransferUserInfoByDoctorNo = function getTransferUserInfoByDoctorNo(params) {
    return _axiosInit2.default.post('/transfer/getTransferUserInfoByDoctorNo', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getTransferUserInfoWithWarehouseByDoctorNo = exports.getTransferUserInfoWithWarehouseByDoctorNo = function getTransferUserInfoWithWarehouseByDoctorNo(params) {
    return _axiosInit2.default.post('/transfer/getTransferUserInfoWithWarehouseByDoctorNo', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var markChecked = exports.markChecked = function markChecked(params) {
    return _axiosInit2.default.post('/transfer/markChecked', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getCustomizationProduct = exports.getCustomizationProduct = function getCustomizationProduct(params) {
    return _axiosInit2.default.post('/outbound/getCustomizationTemplate4Outbound', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var updateOutboundStatus = exports.updateOutboundStatus = function updateOutboundStatus(params) {
    return _axiosInit2.default.post('/outbound/changeOutboundStausById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var uploadET = exports.uploadET = function uploadET(params) {
    return _axiosInit2.default.post('/outboundFile/upload', params, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deleteNurseBanks = exports.getNurseBanks = exports.addBanks = exports.queryBankById = exports.getTransaction = exports.addAdjust = exports.getBalance = exports.pay = exports.queryPaymentById = exports.getTransactionHistory = exports.getPendingTransaction = exports.editPaymentStatus = exports.getBankList = exports.addPaymentRequest = exports.getPaymentRequest = undefined;

var _promise = __webpack_require__(107);

var _promise2 = _interopRequireDefault(_promise);

var _axiosInit = __webpack_require__(14);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPaymentRequest = exports.getPaymentRequest = function getPaymentRequest(params) {
    return _axiosInit2.default.post("/payment/getPayments", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var addPaymentRequest = exports.addPaymentRequest = function addPaymentRequest(params) {
    return _axiosInit2.default.post("/payment/saveOrUpdateById", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getBankList = exports.getBankList = function getBankList(params) {
    return _axiosInit2.default.post("/bank/queryBankInfoListNoPage", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editPaymentStatus = exports.editPaymentStatus = function editPaymentStatus(params) {
    return _axiosInit2.default.post("/payment/updatePaymentStatus", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getPendingTransaction = exports.getPendingTransaction = function getPendingTransaction(params) {
    return _axiosInit2.default.post("/payment/getPendingTransaction", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getTransactionHistory = exports.getTransactionHistory = function getTransactionHistory(params) {
    return _axiosInit2.default.post("/payment/getTransactionHistory", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var queryPaymentById = exports.queryPaymentById = function queryPaymentById(params) {
    return _axiosInit2.default.post("/payment/queryPaymentInfo", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var pay = exports.pay = function pay(params) {
    return _axiosInit2.default.post("/payment/pay", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getBalance = exports.getBalance = function getBalance(params) {
    return _axiosInit2.default.post("/payment/getBalance", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var addAdjust = exports.addAdjust = function addAdjust(params) {
    return _axiosInit2.default.post("/payment/addAdjustBalance", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getTransaction = exports.getTransaction = function getTransaction(params) {
    var list = [{
        title: "Withdraw to chase visa 123456",
        user: "护士1",
        amount: 1555,
        balance: "0",
        note: "支付$1555"
    }, {
        user: "护士1",
        product: "product3",
        price: 80,
        quantity: 1,
        amount: 80,
        warehouse: "FL0002",
        date: "2019-08-01",
        balance: "1555"
    }, {
        user: "护士1",
        product: "product2",
        price: 95,
        quantity: 5,
        amount: "475",
        warehouse: "FL0001",
        date: "2019-08-01",
        balance: "1475"
    }, {
        user: "护士1",
        product: "product1",
        price: 100,
        quantity: 10,
        amount: 1000,
        warehouse: "FL0001",
        date: "2019-07-31",
        balance: "1000"
    }];
    return _promise2.default.resolve(list);
};

var queryBankById = exports.queryBankById = function queryBankById(params) {
    return _axiosInit2.default.post("/bank/queryBankInfoById", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var addBanks = exports.addBanks = function addBanks(params) {
    return _axiosInit2.default.post("/bank/saveOrUpdateBankInfo", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getNurseBanks = exports.getNurseBanks = function getNurseBanks(params) {
    return _axiosInit2.default.post("/bank/queryBankInfoList", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var deleteNurseBanks = exports.deleteNurseBanks = function deleteNurseBanks(params) {
    return _axiosInit2.default.post("/bank/deleteBankInfoById", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(792),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(796),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(798),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.editDiscount = exports.getDiscountList = undefined;

var _axiosInit = __webpack_require__(14);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDiscountList = exports.getDiscountList = function getDiscountList(params) {
    return _axiosInit2.default.post('/discount/getDiscountList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editDiscount = exports.editDiscount = function editDiscount(params) {
    return _axiosInit2.default.post('/discount/addOrEditDiscount', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pay4Warehouse = exports.queryPaymentById4Warehouse = exports.editPaymentStatus4Warehouse = exports.addPaymentRequest4Warehouse = exports.getPaymentRequest4Warehouse = undefined;

var _axiosInit = __webpack_require__(14);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPaymentRequest4Warehouse = exports.getPaymentRequest4Warehouse = function getPaymentRequest4Warehouse(params) {
    return _axiosInit2.default.post('/payment_warehouse/getPayments', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var addPaymentRequest4Warehouse = exports.addPaymentRequest4Warehouse = function addPaymentRequest4Warehouse(params) {
    return _axiosInit2.default.post('/payment_warehouse/saveOrUpdateById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editPaymentStatus4Warehouse = exports.editPaymentStatus4Warehouse = function editPaymentStatus4Warehouse(params) {
    return _axiosInit2.default.post('/payment_warehouse/updatePaymentStatus', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var queryPaymentById4Warehouse = exports.queryPaymentById4Warehouse = function queryPaymentById4Warehouse(params) {
    return _axiosInit2.default.post('/payment_warehouse/queryPaymentInfo', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var pay4Warehouse = exports.pay4Warehouse = function pay4Warehouse(params) {
    return _axiosInit2.default.post('/payment_warehouse/pay', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.warehouseFeeSummary = exports.warehouseFeeDetail = exports.storageFeePay = exports.getWarehouseList = exports.getDoctorList = exports.testRebuildStorageFeeByDaily = exports.testGenStorageFeeByDaily = exports.testGenStorageFeeByMonthly = undefined;

var _axiosInit = __webpack_require__(14);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var testGenStorageFeeByMonthly = exports.testGenStorageFeeByMonthly = function testGenStorageFeeByMonthly(params) {
    return _axiosInit2.default.get('/thirdPartyLogin/sina_qq', { params: { log_id: params.logId } }).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var testGenStorageFeeByDaily = exports.testGenStorageFeeByDaily = function testGenStorageFeeByDaily(params) {
    return _axiosInit2.default.get('/thirdPartyLogin/sina_qqq', { params: {} }).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var testRebuildStorageFeeByDaily = exports.testRebuildStorageFeeByDaily = function testRebuildStorageFeeByDaily(params) {
    return _axiosInit2.default.get('/thirdPartyLogin/sina_163', { params: { dates: params.dates } }).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getDoctorList = exports.getDoctorList = function getDoctorList(params) {
    return _axiosInit2.default.post('/storageFeePayment/getDoctorPaymentList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getWarehouseList = exports.getWarehouseList = function getWarehouseList(params) {
    return _axiosInit2.default.post('/storageFeePayment/getWarehousePaymentList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var storageFeePay = exports.storageFeePay = function storageFeePay(params) {
    return _axiosInit2.default.post('/storageFeePayment/pay', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var warehouseFeeDetail = exports.warehouseFeeDetail = function warehouseFeeDetail(params) {
    return _axiosInit2.default.post('/storageFeePayment/warehouseFeeDetail', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var warehouseFeeSummary = exports.warehouseFeeSummary = function warehouseFeeSummary(params) {
    return _axiosInit2.default.post('/storageFeePayment/warehouseFeeSummary', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(793),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(772),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(807),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(800),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(676)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(767),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = __webpack_require__(41);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Print = function Print(dom, options) {
    if (!(this instanceof Print)) return new Print(dom, options);

    this.options = this.extend({
        'noPrint': '.no-print'
    }, options);

    if (typeof dom === "string") {
        this.dom = document.querySelector(dom);
    } else {
        this.isDOM(dom);
        this.dom = this.isDOM(dom) ? dom : dom.$el;
    }

    this.init();
};
Print.prototype = {
    init: function init() {
        var content = this.getStyle() + this.getHtml();
        this.writeIframe(content);
    },
    extend: function extend(obj, obj2) {
        for (var k in obj2) {
            obj[k] = obj2[k];
        }
        return obj;
    },

    getStyle: function getStyle() {
        var str = "",
            styles = document.querySelectorAll('style,link');
        for (var i = 0; i < styles.length; i++) {
            str += styles[i].outerHTML;
        }
        str += "<style>" + (this.options.noPrint ? this.options.noPrint : '.no-print') + "{display:none;}</style>";

        return str;
    },

    getHtml: function getHtml() {
        var inputs = document.querySelectorAll('input');
        var textareas = document.querySelectorAll('textarea');
        var selects = document.querySelectorAll('select');

        for (var k = 0; k < inputs.length; k++) {
            if (inputs[k].type == "checkbox" || inputs[k].type == "radio") {
                if (inputs[k].checked == true) {
                    inputs[k].setAttribute('checked', "checked");
                } else {
                    inputs[k].removeAttribute('checked');
                }
            } else if (inputs[k].type == "text") {
                inputs[k].setAttribute('value', inputs[k].value);
            } else {
                inputs[k].setAttribute('value', inputs[k].value);
            }
        }

        for (var k2 = 0; k2 < textareas.length; k2++) {
            if (textareas[k2].type == 'textarea') {
                textareas[k2].innerHTML = textareas[k2].value;
            }
        }

        for (var k3 = 0; k3 < selects.length; k3++) {
            if (selects[k3].type == 'select-one') {
                var child = selects[k3].children;
                for (var i in child) {
                    if (child[i].tagName == 'OPTION') {
                        if (child[i].selected == true) {
                            child[i].setAttribute('selected', "selected");
                        } else {
                            child[i].removeAttribute('selected');
                        }
                    }
                }
            }
        }
        return this.dom.outerHTML;
    },

    writeIframe: function writeIframe(content) {
        var w,
            doc,
            iframe = document.createElement('iframe'),
            f = document.body.appendChild(iframe);
        iframe.id = "myIframe";

        iframe.setAttribute('style', 'position:absolute;width:0;height:0;top:-10px;left:-10px;');
        w = f.contentWindow || f.contentDocument;
        doc = f.contentDocument || f.contentWindow.document;
        doc.open();
        doc.write(content);
        doc.close();
        var _this = this;
        iframe.onload = function () {
            _this.toPrint(w);
            setTimeout(function () {
                document.body.removeChild(iframe);
            }, 100);
        };
    },

    toPrint: function toPrint(frameWindow) {
        try {
            setTimeout(function () {
                frameWindow.focus();
                try {
                    if (!frameWindow.document.execCommand('print', false, null)) {
                        frameWindow.print();
                    }
                } catch (e) {
                    frameWindow.print();
                }
                frameWindow.close();
            }, 10);
        } catch (err) {
            console.log('err', err);
        }
    },
    isDOM: (typeof HTMLElement === 'undefined' ? 'undefined' : (0, _typeof3.default)(HTMLElement)) === 'object' ? function (obj) {
        return obj instanceof HTMLElement;
    } : function (obj) {
        return obj && (typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) === 'object' && obj.nodeType === 1 && typeof obj.nodeName === 'string';
    }
};
Print.install = function (Vue, options) {
    Vue.prototype.$print = Print;
};
exports.default = Print;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.superAdminRouter = exports.warehouseAdminRoutes = exports.nurseRoutes = exports.doctorRoutes = exports.defaultRoutes = undefined;

var _Login = __webpack_require__(738);

var _Login2 = _interopRequireDefault(_Login);

var _ = __webpack_require__(737);

var _2 = _interopRequireDefault(_);

var _Home = __webpack_require__(101);

var _Home2 = _interopRequireDefault(_Home);

var _register = __webpack_require__(758);

var _register2 = _interopRequireDefault(_register);

var _forgetPassword = __webpack_require__(751);

var _forgetPassword2 = _interopRequireDefault(_forgetPassword);

var _changePassword = __webpack_require__(740);

var _changePassword2 = _interopRequireDefault(_changePassword);

var _doctorRouter = __webpack_require__(392);

var _doctorRouter2 = _interopRequireDefault(_doctorRouter);

var _nurseRouter = __webpack_require__(393);

var _nurseRouter2 = _interopRequireDefault(_nurseRouter);

var _warehouseAdminRouter = __webpack_require__(395);

var _warehouseAdminRouter2 = _interopRequireDefault(_warehouseAdminRouter);

var _superAdminRouter = __webpack_require__(394);

var _superAdminRouter2 = _interopRequireDefault(_superAdminRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultRoutes = exports.defaultRoutes = [{
    path: '/register',
    component: _register2.default,
    name: '',
    hidden: true
}, {
    path: '/login',
    component: _Login2.default,
    name: '',
    hidden: true
}, {
    path: '/forgetPassword',
    component: _forgetPassword2.default,
    name: '',
    hidden: true
}, {
    path: '/changePassword',
    component: _changePassword2.default,
    name: '',
    hidden: true
}, {
    path: '/home',
    component: _Home2.default,
    name: '',
    hidden: true,
    beforeEnter: function beforeEnter(to, from, next) {
        if (from.path === "/login") {
            var user = window.sessionStorage.getItem("user");
            if (user) {
                user = JSON.parse(user);
                var roleId = user.roleId;
                if (roleId === '0') {
                    next({ path: "/users" });
                } else if (roleId === '3') {
                    next({ path: "/inbound" });
                } else {
                    next({ path: "/overview" });
                }
            }
        } else {
            next();
        }
    }
}, {
    path: '/404',
    component: _2.default,
    name: '',
    hidden: true
}];

var doctorRoutes = exports.doctorRoutes = _doctorRouter2.default;

var nurseRoutes = exports.nurseRoutes = _nurseRouter2.default;

var warehouseAdminRoutes = exports.warehouseAdminRoutes = _warehouseAdminRouter2.default;

var superAdminRouter = exports.superAdminRouter = _superAdminRouter2.default;

exports.default = defaultRoutes;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(196);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(396);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(397);

var getters = _interopRequireWildcard(_getters);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
    count: 10
};

var mutations = {
    INCREMENT: function INCREMENT(state) {
        state.count++;
    },
    DECREMENT: function DECREMENT(state) {
        state.count--;
    }
};

exports.default = new _vuex2.default.Store({
    actions: actions,
    getters: getters,
    state: state,
    mutations: mutations
});

/***/ }),
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(686)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(797),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'ElButton',

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  props: {
    type: {
      type: String,
      default: 'default'
    },
    size: String,
    icon: {
      type: String,
      default: ''
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    loading: Boolean,
    disabled: Boolean,
    plain: Boolean,
    autofocus: Boolean,
    round: Boolean,
    circle: Boolean
  },

  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    buttonSize: function buttonSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    buttonDisabled: function buttonDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },

  methods: {
    handleClick: function handleClick(evt) {
      this.$emit('click', evt);
    }
  }
};

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _input = __webpack_require__(339);

var _input2 = _interopRequireDefault(_input);

var _focus = __webpack_require__(342);

var _focus2 = _interopRequireDefault(_focus);

var _repeatClick = __webpack_require__(341);

var _repeatClick2 = _interopRequireDefault(_repeatClick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElInputNumber',
  mixins: [(0, _focus2.default)('input')],
  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },
  directives: {
    repeatClick: _repeatClick2.default
  },
  components: {
    ElInput: _input2.default
  },
  props: {
    step: {
      type: Number,
      default: 1
    },
    stepStrictly: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: Infinity
    },
    min: {
      type: Number,
      default: -Infinity
    },
    value: {},
    disabled: Boolean,
    size: String,
    controls: {
      type: Boolean,
      default: true
    },
    controlsPosition: {
      type: String,
      default: ''
    },
    name: String,
    label: String,
    placeholder: String,
    precision: {
      type: Number,
      validator: function validator(val) {
        return val >= 0 && val === parseInt(val, 10);
      }
    }
  },
  data: function data() {
    return {
      currentValue: 0,
      userInput: null
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler(value) {
        var newVal = value === undefined ? value : Number(value);
        if (newVal !== undefined) {
          if (isNaN(newVal)) {
            return;
          }

          if (this.stepStrictly) {
            var stepPrecision = this.getPrecision(this.step);
            var precisionFactor = Math.pow(10, stepPrecision);
            newVal = Math.round(newVal / this.step) * precisionFactor * this.step / precisionFactor;
          }

          if (this.precision !== undefined) {
            newVal = this.toPrecision(newVal, this.precision);
          }
        }
        if (newVal >= this.max) newVal = this.max;
        if (newVal <= this.min) newVal = this.min;
        this.currentValue = newVal;
        this.userInput = null;
        this.$emit('input', newVal);
      }
    }
  },
  computed: {
    minDisabled: function minDisabled() {
      return this._decrease(this.value, this.step) < this.min;
    },
    maxDisabled: function maxDisabled() {
      return this._increase(this.value, this.step) > this.max;
    },
    numPrecision: function numPrecision() {
      var value = this.value,
          step = this.step,
          getPrecision = this.getPrecision,
          precision = this.precision;

      var stepPrecision = getPrecision(step);
      if (precision !== undefined) {
        if (stepPrecision > precision) {
          console.warn('[Element Warn][InputNumber]precision should not be less than the decimal places of step');
        }
        return precision;
      } else {
        return Math.max(getPrecision(value), stepPrecision);
      }
    },
    controlsAtRight: function controlsAtRight() {
      return this.controls && this.controlsPosition === 'right';
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    inputNumberSize: function inputNumberSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    inputNumberDisabled: function inputNumberDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    displayValue: function displayValue() {
      if (this.userInput !== null) {
        return this.userInput;
      }

      var currentValue = this.currentValue;

      if (typeof currentValue === 'number') {
        if (this.stepStrictly) {
          var stepPrecision = this.getPrecision(this.step);
          var precisionFactor = Math.pow(10, stepPrecision);
          currentValue = Math.round(currentValue / this.step) * precisionFactor * this.step / precisionFactor;
        }

        if (this.precision !== undefined) {
          currentValue = currentValue.toFixed(this.precision);
        }
      }

      return currentValue;
    }
  },
  methods: {
    toPrecision: function toPrecision(num, precision) {
      if (precision === undefined) precision = this.numPrecision;
      return parseFloat(Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision));
    },
    getPrecision: function getPrecision(value) {
      if (value === undefined) return 0;
      var valueString = value.toString();
      var dotPosition = valueString.indexOf('.');
      var precision = 0;
      if (dotPosition !== -1) {
        precision = valueString.length - dotPosition - 1;
      }
      return precision;
    },
    _increase: function _increase(val, step) {
      if (typeof val !== 'number' && val !== undefined) return this.currentValue;

      var precisionFactor = Math.pow(10, this.numPrecision);

      return this.toPrecision((precisionFactor * val + precisionFactor * step) / precisionFactor);
    },
    _decrease: function _decrease(val, step) {
      if (typeof val !== 'number' && val !== undefined) return this.currentValue;

      var precisionFactor = Math.pow(10, this.numPrecision);

      return this.toPrecision((precisionFactor * val - precisionFactor * step) / precisionFactor);
    },
    increase: function increase() {
      if (this.inputNumberDisabled || this.maxDisabled) return;
      var value = this.value || 0;
      var newVal = this._increase(value, this.step);
      this.setCurrentValue(newVal);
    },
    decrease: function decrease() {
      if (this.inputNumberDisabled || this.minDisabled) return;
      var value = this.value || 0;
      var newVal = this._decrease(value, this.step);
      this.setCurrentValue(newVal);
    },
    handleBlur: function handleBlur(event) {
      this.$emit('blur', event);
    },
    handleFocus: function handleFocus(event) {
      this.$emit('focus', event);
    },
    setCurrentValue: function setCurrentValue(newVal) {
      var oldVal = this.currentValue;
      if (typeof newVal === 'number' && this.precision !== undefined) {
        newVal = this.toPrecision(newVal, this.precision);
      }
      if (newVal >= this.max) newVal = this.max;
      if (newVal <= this.min) newVal = this.min;
      if (oldVal === newVal) return;
      this.userInput = null;
      this.$emit('input', newVal);
      this.$emit('change', newVal, oldVal);
      this.currentValue = newVal;
    },
    handleInput: function handleInput(value) {
      this.userInput = value;
    },
    handleInputChange: function handleInputChange(value) {
      var newVal = value === '' ? undefined : Number(value);
      if (!isNaN(newVal) || value === '') {
        this.setCurrentValue(newVal);
      }
      this.userInput = null;
    },
    select: function select() {
      this.$refs.input.select();
    }
  },
  mounted: function mounted() {
    var innerInput = this.$refs.input.$refs.input;
    innerInput.setAttribute('role', 'spinbutton');
    innerInput.setAttribute('aria-valuemax', this.max);
    innerInput.setAttribute('aria-valuemin', this.min);
    innerInput.setAttribute('aria-valuenow', this.currentValue);
    innerInput.setAttribute('aria-disabled', this.inputNumberDisabled);
  },
  updated: function updated() {
    if (!this.$refs || !this.$refs.input) return;
    var innerInput = this.$refs.input.$refs.input;
    innerInput.setAttribute('aria-valuenow', this.currentValue);
  }
};

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _emitter = __webpack_require__(205);

var _emitter2 = _interopRequireDefault(_emitter);

var _migrating = __webpack_require__(343);

var _migrating2 = _interopRequireDefault(_migrating);

var _calcTextareaHeight = __webpack_require__(340);

var _calcTextareaHeight2 = _interopRequireDefault(_calcTextareaHeight);

var _merge = __webpack_require__(345);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElInput',

  componentName: 'ElInput',

  mixins: [_emitter2.default, _migrating2.default],

  inheritAttrs: false,

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  data: function data() {
    return {
      textareaCalcStyle: {},
      hovering: false,
      focused: false,
      isComposing: false,
      passwordVisible: false
    };
  },


  props: {
    value: [String, Number],
    size: String,
    resize: String,
    form: String,
    disabled: Boolean,
    readonly: Boolean,
    type: {
      type: String,
      default: 'text'
    },
    autosize: {
      type: [Boolean, Object],
      default: false
    },
    autocomplete: {
      type: String,
      default: 'off'
    },

    autoComplete: {
      type: String,
      validator: function validator(val) {
        "production" !== 'production' && console.warn('[Element Warn][Input]\'auto-complete\' property will be deprecated in next major version. please use \'autocomplete\' instead.');
        return true;
      }
    },
    validateEvent: {
      type: Boolean,
      default: true
    },
    suffixIcon: String,
    prefixIcon: String,
    label: String,
    clearable: {
      type: Boolean,
      default: false
    },
    showPassword: {
      type: Boolean,
      default: false
    },
    showWordLimit: {
      type: Boolean,
      default: false
    },
    tabindex: String
  },

  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    validateState: function validateState() {
      return this.elFormItem ? this.elFormItem.validateState : '';
    },
    needStatusIcon: function needStatusIcon() {
      return this.elForm ? this.elForm.statusIcon : false;
    },
    validateIcon: function validateIcon() {
      return {
        validating: 'el-icon-loading',
        success: 'el-icon-circle-check',
        error: 'el-icon-circle-close'
      }[this.validateState];
    },
    textareaStyle: function textareaStyle() {
      return (0, _merge2.default)({}, this.textareaCalcStyle, { resize: this.resize });
    },
    inputSize: function inputSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    inputDisabled: function inputDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    nativeInputValue: function nativeInputValue() {
      return this.value === null || this.value === undefined ? '' : String(this.value);
    },
    showClear: function showClear() {
      return this.clearable && !this.inputDisabled && !this.readonly && this.nativeInputValue && (this.focused || this.hovering);
    },
    showPwdVisible: function showPwdVisible() {
      return this.showPassword && !this.inputDisabled && !this.readonly && (!!this.nativeInputValue || this.focused);
    },
    isWordLimitVisible: function isWordLimitVisible() {
      return this.showWordLimit && this.$attrs.maxlength && (this.type === 'text' || this.type === 'textarea') && !this.inputDisabled && !this.readonly && !this.showPassword;
    },
    upperLimit: function upperLimit() {
      return this.$attrs.maxlength;
    },
    textLength: function textLength() {
      if (typeof this.value === 'number') {
        return String(this.value).length;
      }

      return (this.value || '').length;
    },
    inputExceed: function inputExceed() {
      return this.isWordLimitVisible && this.textLength > this.upperLimit;
    }
  },

  watch: {
    value: function value(val) {
      this.$nextTick(this.resizeTextarea);
      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.change', [val]);
      }
    },
    nativeInputValue: function nativeInputValue() {
      this.setNativeInputValue();
    },
    type: function type() {
      var _this = this;

      this.$nextTick(function () {
        _this.setNativeInputValue();
        _this.resizeTextarea();
        _this.updateIconOffset();
      });
    }
  },

  methods: {
    focus: function focus() {
      this.getInput().focus();
    },
    blur: function blur() {
      this.getInput().blur();
    },
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'icon': 'icon is removed, use suffix-icon / prefix-icon instead.',
          'on-icon-click': 'on-icon-click is removed.'
        },
        events: {
          'click': 'click is removed.'
        }
      };
    },
    handleBlur: function handleBlur(event) {
      this.focused = false;
      this.$emit('blur', event);
      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.blur', [this.value]);
      }
    },
    select: function select() {
      this.getInput().select();
    },
    resizeTextarea: function resizeTextarea() {
      if (this.$isServer) return;
      var autosize = this.autosize,
          type = this.type;

      if (type !== 'textarea') return;
      if (!autosize) {
        this.textareaCalcStyle = {
          minHeight: (0, _calcTextareaHeight2.default)(this.$refs.textarea).minHeight
        };
        return;
      }
      var minRows = autosize.minRows;
      var maxRows = autosize.maxRows;

      this.textareaCalcStyle = (0, _calcTextareaHeight2.default)(this.$refs.textarea, minRows, maxRows);
    },
    setNativeInputValue: function setNativeInputValue() {
      var input = this.getInput();
      if (!input) return;
      if (input.value === this.nativeInputValue) return;
      input.value = this.nativeInputValue;
    },
    handleFocus: function handleFocus(event) {
      this.focused = true;
      this.$emit('focus', event);
    },
    handleCompositionStart: function handleCompositionStart() {
      this.isComposing = true;
    },
    handleCompositionEnd: function handleCompositionEnd(event) {
      this.isComposing = false;
      this.handleInput(event);
    },
    handleInput: function handleInput(event) {
      if (this.isComposing) return;

      if (event.target.value === this.nativeInputValue) return;

      this.$emit('input', event.target.value);

      this.$nextTick(this.setNativeInputValue);
    },
    handleChange: function handleChange(event) {
      this.$emit('change', event.target.value);
    },
    calcIconOffset: function calcIconOffset(place) {
      var elList = [].slice.call(this.$el.querySelectorAll('.el-input__' + place) || []);
      if (!elList.length) return;
      var el = null;
      for (var i = 0; i < elList.length; i++) {
        if (elList[i].parentNode === this.$el) {
          el = elList[i];
          break;
        }
      }
      if (!el) return;
      var pendantMap = {
        suffix: 'append',
        prefix: 'prepend'
      };

      var pendant = pendantMap[place];
      if (this.$slots[pendant]) {
        el.style.transform = 'translateX(' + (place === 'suffix' ? '-' : '') + this.$el.querySelector('.el-input-group__' + pendant).offsetWidth + 'px)';
      } else {
        el.removeAttribute('style');
      }
    },
    updateIconOffset: function updateIconOffset() {
      this.calcIconOffset('prefix');
      this.calcIconOffset('suffix');
    },
    clear: function clear() {
      this.$emit('input', '');
      this.$emit('change', '');
      this.$emit('clear');
    },
    handlePasswordVisible: function handlePasswordVisible() {
      this.passwordVisible = !this.passwordVisible;
      this.focus();
    },
    getInput: function getInput() {
      return this.$refs.input || this.$refs.textarea;
    },
    getSuffixVisible: function getSuffixVisible() {
      return this.$slots.suffix || this.suffixIcon || this.showClear || this.showPassword || this.isWordLimitVisible || this.validateState && this.needStatusIcon;
    }
  },

  created: function created() {
    this.$on('inputSelect', this.select);
  },
  mounted: function mounted() {
    this.setNativeInputValue();
    this.resizeTextarea();
    this.updateIconOffset();
  },
  updated: function updated() {
    this.$nextTick(this.updateIconOffset);
  }
};

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'ElLink',

  props: {
    type: {
      type: String,
      default: 'default'
    },
    underline: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
    href: String,
    icon: String
  },

  methods: {
    handleClick: function handleClick(event) {
      if (!this.disabled) {
        if (!this.href) {
          this.$emit('click', event);
        }
      }
    }
  }
};

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(41);

var _typeof3 = _interopRequireDefault(_typeof2);

var _emitter = __webpack_require__(205);

var _emitter2 = _interopRequireDefault(_emitter);

var _util = __webpack_require__(206);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_emitter2.default],

  name: 'ElOption',

  componentName: 'ElOption',

  inject: ['select'],

  props: {
    value: {
      required: true
    },
    label: [String, Number],
    created: Boolean,
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      index: -1,
      groupDisabled: false,
      visible: true,
      hitState: false,
      hover: false
    };
  },


  computed: {
    isObject: function isObject() {
      return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
    },
    currentLabel: function currentLabel() {
      return this.label || (this.isObject ? '' : this.value);
    },
    currentValue: function currentValue() {
      return this.value || this.label || '';
    },
    itemSelected: function itemSelected() {
      if (!this.select.multiple) {
        return this.isEqual(this.value, this.select.value);
      } else {
        return this.contains(this.select.value, this.value);
      }
    },
    limitReached: function limitReached() {
      if (this.select.multiple) {
        return !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0;
      } else {
        return false;
      }
    }
  },

  watch: {
    currentLabel: function currentLabel() {
      if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
    },
    value: function value(val, oldVal) {
      var _select = this.select,
          remote = _select.remote,
          valueKey = _select.valueKey;

      if (!this.created && !remote) {
        if (valueKey && (typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object' && (typeof oldVal === 'undefined' ? 'undefined' : (0, _typeof3.default)(oldVal)) === 'object' && val[valueKey] === oldVal[valueKey]) {
          return;
        }
        this.dispatch('ElSelect', 'setSelected');
      }
    }
  },

  methods: {
    isEqual: function isEqual(a, b) {
      if (!this.isObject) {
        return a === b;
      } else {
        var valueKey = this.select.valueKey;
        return (0, _util.getValueByPath)(a, valueKey) === (0, _util.getValueByPath)(b, valueKey);
      }
    },
    contains: function contains() {
      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var target = arguments[1];

      if (!this.isObject) {
        return arr && arr.indexOf(target) > -1;
      } else {
        var valueKey = this.select.valueKey;
        return arr && arr.some(function (item) {
          return (0, _util.getValueByPath)(item, valueKey) === (0, _util.getValueByPath)(target, valueKey);
        });
      }
    },
    handleGroupDisabled: function handleGroupDisabled(val) {
      this.groupDisabled = val;
    },
    hoverItem: function hoverItem() {
      if (!this.disabled && !this.groupDisabled) {
        this.select.hoverIndex = this.select.options.indexOf(this);
      }
    },
    selectOptionClick: function selectOptionClick() {
      if (this.disabled !== true && this.groupDisabled !== true) {
        this.dispatch('ElSelect', 'handleOptionClick', [this, true]);
      }
    },
    queryChange: function queryChange(query) {
      this.visible = new RegExp((0, _util.escapeRegexpString)(query), 'i').test(this.currentLabel) || this.created;
      if (!this.visible) {
        this.select.filteredOptionsCount--;
      }
    }
  },

  created: function created() {
    this.select.options.push(this);
    this.select.cachedOptions.push(this);
    this.select.optionsCount++;
    this.select.filteredOptionsCount++;

    this.$on('queryChange', this.queryChange);
    this.$on('handleGroupDisabled', this.handleGroupDisabled);
  },
  beforeDestroy: function beforeDestroy() {
    this.select.onOptionDestroy(this.select.options.indexOf(this));
  }
};

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: 'app',
    components: {}
};

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _globalVar = __webpack_require__(7);

var _securityService = __webpack_require__(48);

var _memberService = __webpack_require__(20);

var _option = __webpack_require__(22);

var _option2 = _interopRequireDefault(_option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { ElOption: _option2.default },
    computed: {
        getRoutes: function getRoutes() {
            return global.antRouter;
        }
    },
    data: function data() {
        return {
            currentCompany: "",
            user: {},
            doctors: [],
            sysName: 'BSCI',
            collapsed: false,
            sysUserName: '',
            sysUserAvatar: '',
            form: {
                name: '',
                region: '',
                date1: '',
                date2: '',
                delivery: false,
                type: [],
                resource: '',
                desc: ''
            }
        };
    },

    methods: {
        changeDoctor: function changeDoctor() {
            this.$refs.child.$emit('changeDoctor', this.currentCompany);
            window.sessionStorage.setItem("currentCompany", this.currentCompany);
        },
        getDoctors: function getDoctors() {
            var _this = this;

            (0, _memberService.getNurseDoctor)().then(function (res) {
                if (res.status === 200) {
                    _this.doctors = res.result;
                    if (_this.doctors.length > 0) {
                        var currentCompany = window.sessionStorage.getItem("currentCompany");
                        if (!currentCompany) {
                            window.sessionStorage.setItem("currentCompany", _this.doctors[0].userNo);
                            _this.currentCompany = res.result[0].userNo;
                        } else {
                            _this.currentCompany = currentCompany;
                        }
                    }
                }
            });
        },

        logout: function logout() {
            this.$confirm('Are you sure?', 'Warning', {}).then(function () {
                (0, _securityService.logout)().then(function (res) {
                    sessionStorage.removeItem('user');
                    sessionStorage.removeItem('authorization');
                    sessionStorage.removeItem('currentCompany');
                    window.location.href = _globalVar.url;
                }).catch(function () {
                    sessionStorage.removeItem('user');
                    sessionStorage.removeItem('authorization');
                    sessionStorage.removeItem('currentCompany');
                    window.location.href = _globalVar.url;
                });
            }).catch(function () {});
        },

        collapse: function collapse() {
            this.collapsed = !this.collapsed;
        },
        showMenu: function showMenu(i, status) {
            this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
        }
    },
    mounted: function mounted() {
        var user = sessionStorage.getItem('user');
        if (user) {
            user = JSON.parse(user);
            this.user = user;
            this.sysUserName = user.username || '';
            if (user.roleId === '2' || user.roleId === "3") {
                this.getDoctors();
            }
        }
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)))

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(106);

var _stringify2 = _interopRequireDefault(_stringify);

var _securityService = __webpack_require__(48);

var _memberService = __webpack_require__(20);

var _option = __webpack_require__(22);

var _option2 = _interopRequireDefault(_option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { ElOption: _option2.default },
    data: function data() {
        return {
            obj: {
                currentCompany: ""
            },
            doctors: [],
            selectCompanyVisible: false,
            logining: false,
            ruleForm2: {
                account: '',
                checkPass: ''
            },
            rule: {
                currentCompany: [{ required: true, message: 'You must select a company before login.', trigger: 'blur' }]
            },
            rules2: {
                account: [{ required: true, message: 'Please enter username', trigger: 'blur' }],
                checkPass: [{ required: true, message: 'Please enter password', trigger: 'blur' }]
            },
            checked: true
        };
    },

    methods: {
        handleSelectCompany: function handleSelectCompany() {
            var _this2 = this;

            this.$refs.obj.validate(function (valid) {
                if (valid) {
                    window.sessionStorage.setItem("currentCompany", _this2.obj.currentCompany);
                    _this2.$router.push({ path: '/home' });
                }
            });
        },
        handleReset2: function handleReset2() {
            this.$refs.ruleForm2.resetFields();
        },
        getDoctors: function getDoctors() {
            var _this3 = this;

            (0, _memberService.getNurseDoctor)().then(function (res) {
                if (res.status === 200) {
                    _this3.doctors = res.result;
                    _this3.selectCompanyVisible = true;
                    if (_this3.doctors.length == 1) {
                        _this3.obj.currentCompany = _this3.doctors[0].userNo;
                        if (_this3.obj.currentCompany) {
                            window.sessionStorage.setItem("currentCompany", _this3.obj.currentCompany);
                            _this3.$router.push({ path: '/home' });
                        }
                    }
                }
            });
        },
        handleSubmit2: function handleSubmit2(ev) {
            var _this4 = this;

            var _this = this;
            this.$refs.ruleForm2.validate(function (valid) {
                if (valid) {
                    _this4.logining = true;
                    var loginParams = { userName: _this4.ruleForm2.account, password: _this4.ruleForm2.checkPass };
                    (0, _securityService.login)(loginParams).then(function (data) {
                        _this4.logining = false;
                        if (data.status === 200) {
                            sessionStorage.setItem('user', (0, _stringify2.default)(data.result.user));
                            sessionStorage.setItem("authorization", data.result.user.token);
                            if (data.result.user.roleId == 1 || data.result.user.roleId == 0) {
                                _this4.$router.push({ path: '/home' });
                            } else {
                                _this4.getDoctors();
                            }
                        } else {
                            _this4.$message.error(data.message);
                        }
                    }).catch(function (data) {
                        console.log(data);
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    }
};

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _memberService = __webpack_require__(20);

var _globalVar = __webpack_require__(7);

var _button = __webpack_require__(99);

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { ElButton: _button2.default },
    data: function data() {
        return {
            loading: false,
            firstListLoading: false,
            secondListLoading: false,
            pageSize: _globalVar.defaultPageSize,

            activeName: "first",

            filters: {
                email: '',
                invitationEmail: ""
            },

            users: [],
            invitations: [],

            total: 0,
            userPage: 1,

            invitationPage: 1,
            invitationTotal: 0,

            invitationVisible: false,

            editLoading: false,

            addLoading: false,
            invitationRules: {
                email: [{ required: true, message: 'Email is required.', trigger: 'blur' }, { validator: _util2.default.validateEmail, trigger: 'blur' }]
            },

            member: {
                id: "",
                userName: "",
                email: "",
                phone: "",
                status: "",
                pendingTransaction: 7,
                pendingAmount: "",
                alias: ""
            },
            group: {
                id: '',
                groupName: "",
                users: [],
                pendingTransaction: 7,
                pendingAmount: ""
            },
            invitation: {
                id: "",
                email: ""
            }

        };
    },

    methods: {
        formatRole: function formatRole(row, column) {
            if (row.status === 0) {
                return "Pending";
            } else if (row.status === 1) {
                return "Approve";
            } else {
                return "Reject";
            }
        },
        formatTimesTamp: function formatTimesTamp(row, column) {
            var date = row.createTime || row.createDate;
            return _util2.default.formatDate.format(new Date(date), 'yyyy-MM-dd hh:mm:ss');
        },
        handleUserPageChange: function handleUserPageChange(val) {
            this.userPage = val;
            this.getUserList();
        },
        handleInvitationPageChange: function handleInvitationPageChange(val) {
            this.invitationPage = val;
            this.getInvitationList();
        },
        editUserStatus: function editUserStatus(id, status) {
            var _this = this;

            this.$confirm("Are you sure?", "Warning", {
                type: "warning"
            }).then(function () {
                (0, _memberService.editUserStatus)({ userNo: id, status: status }).then(function (res) {
                    if (res.status === 200) {
                        _this.$message({
                            message: res.message,
                            type: "success"
                        });
                        _this.getUserList();
                    } else {
                        _this.$message({
                            message: res.message,
                            type: "error"
                        });
                    }
                });
            }).catch(function () {});
        },
        getUserList: function getUserList() {
            var _this2 = this;

            var para = {
                current: this.userPage,
                size: this.pageSize,
                condition: this.filters.email
            };

            this.firstListLoading = true;
            (0, _memberService.getAllMemberList)(para).then(function (res) {
                _this2.firstListLoading = false;
                if (res.status === 200) {
                    _this2.users = res.result.records;
                    _this2.total = res.result.total;
                } else {
                    _this2.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        getInvitationList: function getInvitationList() {
            var _this3 = this;

            var para = {
                current: this.invitationPage,
                size: this.pageSize,
                condition: this.filters.invitationEmail
            };

            this.secondListLoading = true;
            (0, _memberService.getAdminInvitationList)(para).then(function (res) {
                _this3.secondListLoading = false;
                if (res.status === 200) {
                    _this3.invitations = res.result.records;
                    _this3.invitationTotal = res.result.total;
                } else {
                    _this3.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        invitationRegister: function invitationRegister(param) {
            var _this4 = this;

            this.$refs.invitation.validate(function (valid) {
                if (valid) {
                    (0, _memberService.invitationDoctor)({ email: _this4.invitation.email }).then(function (res) {
                        if (res.status === 200) {
                            _this4.$message({
                                message: 'Success',
                                type: 'success'
                            });
                            _this4.invitationVisible = false;
                            _this4.getInvitationList();
                            _this4.$refs.invitation.resetFields();
                        } else {
                            _this4.$message({
                                message: res.message,
                                type: 'error'
                            });
                        }
                    }).catch(function (error) {
                        return console.log(error);
                    });
                }
            });
        }
    },
    mounted: function mounted() {
        this.getUserList();
        this.getInvitationList();
    }
};

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _securityService = __webpack_require__(48);

var id = "";
var validate = false;
exports.default = {
    data: function data() {
        return {
            validate: validate,
            loading: false,
            ruleForm2: {
                id: id,
                password: '',
                rePassword: ''
            },
            rules2: {
                password: [{ required: true, message: 'Please enter password', trigger: 'blur' }],
                rePassword: [{ required: true, message: 'Please confirm password', trigger: 'blur' }, { validator: this.validatePassword, trigger: 'blur' }]
            },
            checked: true
        };
    },

    methods: {
        validatePassword: function validatePassword(rule, value, callback) {
            if (this.ruleForm2.password !== this.ruleForm2.rePassword) {
                callback(new Error('Password not match.'));
            } else {
                callback();
            }
        },
        submitRegister: function submitRegister() {},
        handleSubmit: function handleSubmit(ev) {
            var _this2 = this;

            var _this = this;
            this.$refs.ruleForm2.validate(function (valid) {
                if (valid) {
                    _this2.loading = true;
                    var params = {
                        rePassword: _this2.ruleForm2.rePassword,
                        password: _this2.ruleForm2.password,
                        id: _this2.ruleForm2.id
                    };
                    (0, _securityService.resetPassword)(params).then(function (data) {
                        _this2.loading = false;
                        if (data.status === 200) {
                            _this2.$message.success("Reset Password Success.");
                            setTimeout(function () {
                                _this2.$router.push({ path: "/login" });
                            }, 3000);
                        } else {
                            _this2.$message.error(data.message);
                        }
                    }).catch(function (error) {
                        _this2.loading = false;
                        console.log(error);
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    },
    created: function created() {
        var _this3 = this;

        var query = this.$route.query;
        if (!query.id) {
            this.$router.push({ path: "/login" });
        } else {
            this.ruleForm2.id = query.id;
            (0, _securityService.validateResetPassword)({ id: this.ruleForm2.id }).then(function (data) {
                if (data.status === 200) {
                    _this3.validate = true;
                } else {
                    _this3.validate = false;
                    setTimeout(function () {
                        _this3.$router.push({ path: "/login" });
                    }, 3000);
                    _this3.$message.error(data.message);
                }
            }).catch(function (error) {
                console.log(error);
            });
        }
    }
};

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _inboundService = __webpack_require__(102);

var _offerService = __webpack_require__(103);

var _inventoryService = __webpack_require__(75);

var _globalVar = __webpack_require__(7);

var _exportService = __webpack_require__(23);

var _option = __webpack_require__(22);

var _option2 = _interopRequireDefault(_option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { ElOption: _option2.default },
    data: function data() {
        return {
            pageSize: _globalVar.defaultPageSize,

            currentDetailNo: "",
            inboundDetailPage: 1,
            inboundDetailTotal: 0,

            viewInboundPage: 1,
            viewInboundTotal: 0,

            historyPage: 1,
            historyTotal: 0,

            cancelPage: 1,
            cancelTotal: 0,

            reportPage: 1,
            reportTotal: 0,

            trackingPage: 1,
            trackingTotal: 0,

            activeName: "first",
            filters: {
                name: '',
                reportFilter: "",
                cancelFilter: "",
                viewedInboundFilter: "",
                historyFilter: "",
                trackingNumFilter: "",
                trackingWarehouse: "",
                trackingDate: ""
            },

            detailLoading: false,
            firstLoading: false,
            secondLoading: false,
            thirdLoading: false,
            fourthLoading: false,
            fiveLoading: false,

            cancelList: [],
            viewedInbound: [],
            reportedInbound: [],
            inboundHistory: [],
            inboundDetail: [],
            trackingList: [],
            total: 0,
            page: 1,
            listLoading: false,
            detailVisible: false,
            globalLoading: false

        };
    },

    methods: {
        cancelInbound: function cancelInbound(inboundNo) {
            var _this = this;

            if (!inboundNo) {
                this.$message.error("Empty InboundNo");
                return;
            }
            this.$confirm('Are you sure?', 'Warning', {
                type: 'warning'
            }).then(function () {
                (0, _inboundService.cancelInboundByDoctor)({ inboundNo: inboundNo }).then(function (res) {
                    if (res.status === 200) {
                        _this.$message.success(res.message);
                        _this.getInboundList();
                    } else {
                        _this.$message.error(res.message);
                    }
                });
            }).catch(function () {});
        },
        exportExcel: function exportExcel(url, fileName) {
            var param = {
                url: url,
                fileName: fileName
            };
            (0, _exportService.exportExcel)(param).then(function () {});
        },
        editReportStatus: function editReportStatus(id, status, row) {
            var _this2 = this;

            this.$confirm("Are you sure?", "Warning", {
                type: "warning"
            }).then(function () {
                row.loading = true;
                var param = {
                    id: id,
                    status: status
                };
                _this2.globalLoading = true;
                (0, _inventoryService.editReportStatus)(param).then(function (data) {
                    row.loading = false;
                    _this2.globalLoading = false;
                    if (data.status === 200) {
                        _this2.$message.success(data.message);
                        _this2.getReportList();
                    } else {
                        _this2.$message.error(data.message);
                    }
                });
            }).catch(function () {
                _this2.globalLoading = false;
            });
        },
        changeHistoryList: function changeHistoryList(val) {
            this.historyPage = val;
            this.getInboundHistoryList();
        },
        changeViewList: function changeViewList(val) {
            this.viewInboundPage = val;
            this.getInboundList();
        },
        changeReportPage: function changeReportPage(val) {
            this.reportPage = val;
            this.getReportList();
        },
        changeCancelList: function changeCancelList(val) {
            this.cancelPage = val;
            this.getCancelInboundList();
        },
        handleClick: function handleClick(tab, event) {
            if (tab.paneName === "first" && this.viewedInbound.length === 0) {
                this.getInboundList();
            } else if (tab.paneName === "second" && this.reportedInbound.length === 0) {
                this.getReportList();
            } else if (tab.paneName === "third" && this.inboundHistory.length === 0) {
                this.getInboundHistoryList();
            } else if (tab.paneName === "fourth" && this.cancelList.length === 0) {
                this.getCancelInboundList();
            }
        },
        getInboundList: function getInboundList() {
            var _this3 = this;

            var param = {
                current: this.viewInboundPage,
                size: this.pageSize,
                condition: this.filters.viewedInboundFilter
            };
            this.firstLoading = true;
            (0, _inboundService.getInboundDetailList)(param).then(function (data) {
                _this3.firstLoading = false;
                if (data.status === 200) {
                    _this3.viewedInbound = data.result.records;
                    _this3.viewInboundTotal = data.result.total;
                }
            });
        },
        getReportList: function getReportList() {
            var _this4 = this;

            var param = {
                current: this.reportPage,
                size: this.pageSize,
                condition: this.filters.reportFilter,
                status: this.filters.reportStatus
            };
            this.secondLoading = true;
            this.reportedInbound = [];
            (0, _inventoryService.getInventoryReportList)(param).then(function (data) {
                _this4.secondLoading = false;
                if (data.status === 200) {
                    data.result.records.forEach(function (item) {
                        item.loading = false;
                        _this4.reportedInbound.push(item);
                    });
                    _this4.reportTotal = data.result.total;
                }
            });
        },
        getInboundHistoryList: function getInboundHistoryList() {
            var _this5 = this;

            var param = {
                current: this.historyPage,
                size: this.pageSize,
                productName: this.filters.historyFilter
            };
            this.thirdLoading = true;
            (0, _inboundService.getInboundHistoryList)(param).then(function (data) {
                _this5.thirdLoading = false;
                if (data.status === 200) {
                    _this5.inboundHistory = data.result.records;
                    _this5.historyTotal = data.result.total;
                }
            });
        },
        getCancelInboundList: function getCancelInboundList() {
            var _this6 = this;

            var param = {
                current: this.cancelPage,
                size: this.pageSize,
                productName: this.filters.cancelFilter
            };
            this.fourthLoading = true;
            (0, _inboundService.getCancelInboundList)(param).then(function (data) {
                _this6.fourthLoading = false;
                if (data.status === 200) {
                    _this6.cancelList = data.result.records;
                    _this6.cancelTotal = data.result.total;
                }
            });
        },
        getInboundDetailList: function getInboundDetailList(id) {
            var _this7 = this;

            if (id) {
                this.currentDetailNo = id;
            }
            var param = {
                offerNo: this.currentDetailNo,
                current: this.inboundDetailPage,
                size: this.pageSize,
                productName: ""
            };
            this.detailLoading = true;
            (0, _inboundService.getInboundDetailList)(param).then(function (data) {
                _this7.detailLoading = false;
                if (data.status === 200) {
                    _this7.inboundDetail = data.result.records;
                    _this7.inboundDetailTotal = data.result.total;
                    _this7.detailVisible = true;
                }
            });
        },
        changeTracking: function changeTracking(val) {
            this.trackingPage = val;
            this.getTrackingList();
        },
        getTrackingList: function getTrackingList() {
            var _this8 = this;

            var param = {
                current: this.trackingPage,
                size: this.pageSize,
                warehouseNo: this.filters.trackingWarehouse,
                startDate: "",
                endDate: "",
                tracking: this.filters.trackingNumFilter
            };
            if (this.filters.trackingDate) {
                param.startDate = this.filters.trackingDate[0];
                param.endDate = this.filters.trackingDate[2];
            }
            this.fiveLoading = true;
            (0, _inboundService.getDoctorTrackingList)(param).then(function (data) {
                _this8.fiveLoading = false;
                if (data.status === 200) {
                    _this8.trackingList = data.result.records;
                    _this8.trackingTotal = data.result.total;
                }
            });
        }
    },
    mounted: function mounted() {
        this.getInboundList();
        this.getTrackingList();
        this.getReportList();
        this.getInboundHistoryList();
        this.getCancelInboundList();
        var active = this.$route.params.active;
        if (active) {
            this.activeName = active;
        }
    }
};

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(134);

var _assign2 = _interopRequireDefault(_assign);

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _globalVar = __webpack_require__(7);

var _inventoryService = __webpack_require__(75);

var _option = __webpack_require__(22);

var _option2 = _interopRequireDefault(_option);

var _inboundService = __webpack_require__(102);

var _warehouseService = __webpack_require__(59);

var _memberService = __webpack_require__(20);

var _outboundService = __webpack_require__(104);

var _exportService = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { ElOption: _option2.default },
    data: function data() {
        return {
            pageSize: _globalVar.defaultPageSize,

            conditions: _globalVar.conditions,
            activeName: "first",
            filters: {
                fbmWarehouse: "",
                fbmStatus: "",
                reportFilter: "",
                inboundFilter: "",
                inboundUser: "",
                outboundUser: "",
                tracking: "",
                name: '',
                product: "",
                inboundType: "",
                inventoryProductSummary: "",
                notClaimedTracking: "",
                stockFilter: ""
            },
            fbmDetailVisible: false,

            currentDetailNo: "",
            currentInventroy: "",

            products: [],
            inventoryPage: 1,
            inventoryTotal: 0,

            inboundPage: 1,
            inboundTotal: 0,

            reportPage: 1,
            reportTotal: 0,

            outboundPage: 1,
            outboundTotal: 0,

            notClaimedPage: 1,
            notClaimedTotal: 0,

            inventorySummaryPage: 1,
            inventorySummaryTotal: 0,

            stockPage: 1,
            stockTotal: 0,

            fbmDetail: [],
            fbmPage: 1,
            fbmTotal: 0,

            total: 0,
            page: 1,
            listLoading: false,
            sels: [],

            nurseList: [],
            inboundList: [],
            outboundList: [],
            fbmList: [],
            fmaList: [],
            reportedInbound: [],
            notClaimed: [],
            inventoriesSummary: [],
            stockList: [],

            members: [],

            sizeList: [],

            firstListLoading: false,
            secondListLoading: false,
            thirdListLoading: false,
            fourthListLoading: false,
            fiveListLoading: false,
            sixListLoading: false,

            editFBMVisible: false,
            editFormVisible: false,
            editLoading: false,
            inventorySummaryLoading: false,

            addFormVisible: false,
            loading: false,
            formRules: {
                product: [{ required: true, message: 'Product Name is required.', trigger: 'blur' }],
                price: [{ required: true, message: 'Price is required.', trigger: 'blur' }]
            },
            fbmFormRules: {
                warehouseNo: [{ required: true, message: 'Warehouse is required.', trigger: 'blur' }],
                quantity: [{ required: true, message: 'Quantity is required.', trigger: 'blur' }, { validator: this.checkQuantity, trigger: 'blur' }]
            },

            inputVisible: false,
            inputValue: "",

            detailVisible: false,
            fbmDetailLoading: false,

            editProduct: {
                id: "",
                product: '',
                condition: "New",
                price: "",
                asin: "",
                upc: "",
                weight: '',
                note: "",
                size: ""
            },

            addProduct: {
                id: "",
                product: '',
                condition: "New",
                price: "",
                asin: "",
                upc: "",
                weight: '',
                note: "",
                size: ""
            },
            fbm: {
                warehouseNo: "",
                price: 0,
                quantity: 0,
                productNo: "",
                productName: "",
                note: ""
            },
            warehouseList: []
        };
    },

    methods: {
        deleteProduct: function deleteProduct(productNo) {
            var _this = this;

            (0, _inventoryService.getProductFBM)({ productNo: productNo }).then(function (data) {
                if (data.status == "200") {
                    if (data.result > 0) {
                        _this.$message.error("You can't delete a product if FBM left more then 0.");
                    } else {
                        _this.$confirm("Are you sure?", "Warning", {
                            type: "warning"
                        }).then(function () {
                            (0, _inventoryService.deleteProduct)({ productNo: productNo }).then(function (data) {
                                if (data.status == "200") {
                                    _this.$message.success("Success");
                                    _this.getInventory();
                                } else {
                                    _this.$message.error(data.message);
                                }
                            });
                        }).catch(function () {});
                    }
                }
            });
        },
        exportExcel: function exportExcel(url, fileName) {
            var param = {
                url: url,
                fileName: fileName
            };
            (0, _exportService.exportExcel)(param).then(function () {});
        },
        tableRowClassName: function tableRowClassName(_ref) {
            var row = _ref.row,
                rowIndex = _ref.rowIndex;

            if (row.stock === 0) {
                return 'warning';
            } else {
                return '';
            }
        },
        handleInventorySummaryPageChange: function handleInventorySummaryPageChange(val) {
            this.inventorySummaryPage = val;
            this.getInventorySummary();
        },
        getInventorySummary: function getInventorySummary() {
            var _this2 = this;

            var param = {
                current: this.inventorySummaryPage,
                size: this.pageSize,
                productName: this.filters.inventoryProductSummary
            };
            this.inventorySummaryLoading = true;
            return (0, _outboundService.getInventorySummary)(param).then(function (data) {
                _this2.inventorySummaryLoading = false;
                if (data.status === 200) {
                    _this2.inventoriesSummary = data.result.records;
                    _this2.inventorySummaryTotal = data.result.total;
                }
            });
        },
        handleInventoryDetailPageChange: function handleInventoryDetailPageChange(val) {
            this.fbmPage = val;
            this.getInventoryDetail();
        },
        getInventoryDetail: function getInventoryDetail() {
            var _this3 = this;

            var param = {
                current: this.fbmPage,
                size: this.pageSize,
                productName: this.filters.inventoryProduct,
                nurseId: this.filters.inventoryNurse,
                productNo: this.currentDetailNo
            };
            this.fbmDetailLoading = true;
            return (0, _outboundService.getInventoryList)(param).then(function (data) {
                _this3.fbmDetailLoading = false;
                if (data.status === 200) {
                    _this3.fbmDetail = data.result.records;
                    _this3.fbmTotal = data.result.total;
                }
            });
        },
        getNotClaimed: function getNotClaimed() {
            var _this4 = this;

            var param = {
                current: this.notClaimedPage,
                size: this.pageSize,
                productNo: this.currentDetailNo,
                tracking: this.filters.notClaimedTracking
            };
            this.fiveListLoading = true;
            (0, _inventoryService.getNotClaimed)(param).then(function (res) {
                _this4.fiveListLoading = false;
                if (res.status === 200) {
                    _this4.notClaimed = res.result.records;
                    _this4.notClaimedTotal = res.result.total;
                }
            });
        },
        getDoctorMembers: function getDoctorMembers() {
            var _this5 = this;

            (0, _memberService.getDoctorMemberList)({}).then(function (data) {
                if (data.status === 200) {
                    _this5.members = data.result;
                }
            });
        },
        getSizeList: function getSizeList() {
            var _this6 = this;

            (0, _inventoryService.getSizeList)({}).then(function (data) {
                if (data.status === 200) {
                    _this6.sizeList = data.result;
                }
            });
        },
        getFBMList: function getFBMList() {
            var _this7 = this;

            var param = {
                current: this.fbmPage,
                size: this.pageSize,
                warehouseNo: this.filters.fbmWarehouse,
                type: this.filters.fbmStatus,
                productNo: this.currentDetailNo
            };
            this.thirdListLoading = true;
            (0, _inventoryService.getFBM)(param).then(function (data) {
                _this7.thirdListLoading = false;
                if (data.status === 200) {
                    _this7.fbmList = data.result.records;
                    _this7.fbmTotal = data.result.total;
                }
            });
        },
        addFBM: function addFBM() {
            var _this8 = this;

            this.$refs.fbm.validate(function (valid) {
                if (valid) {
                    var param = {
                        productNo: _this8.fbm.productNo,
                        price: _this8.fbm.price,
                        warehouseNo: _this8.fbm.warehouseNo,
                        note: _this8.fbm.note,
                        qty: _this8.fbm.quantity
                    };
                    _this8.loading = true;
                    (0, _inventoryService.editFBM)(param).then(function (data) {
                        _this8.loading = false;
                        if (data.status === 200) {
                            _this8.$message.success(data.message);
                            _this8.editFBMVisible = false;
                            _this8.$refs.fbm.resetFields();
                            _this8.getInventory();
                        } else {
                            _this8.$message.error(data.message);
                        }
                    });
                }
            });
        },
        checkQuantity: function checkQuantity(rule, value, callback) {
            if (!value > 0) {
                return callback(new Error('Quantity must more than 1.'));
            } else {
                callback();
            }
        },
        getCurrentWarehouse: function getCurrentWarehouse() {
            var _this9 = this;

            (0, _warehouseService.getCurrentWarehouse)({}).then(function (data) {
                if (data.status === 200) {
                    _this9.warehouseList = data.result;
                }
            });
        },
        showEditFBM: function showEditFBM(row) {
            this.fbm.productName = row.productName;
            this.fbm.productNo = row.productNo;
            this.editFBMVisible = true;
        },
        changeNotClaimedPage: function changeNotClaimedPage(val) {
            this.notClaimedPage = val;
            this.getNotClaimed();
        },
        changeReportPage: function changeReportPage(val) {
            this.reportPage = val;
            this.getReportList();
        },
        changeFBMPage: function changeFBMPage(val) {
            this.fbmPage = val;
            this.getFBMList();
        },
        changeStockPage: function changeStockPage(val) {
            this.stockPage = val;
            this.getStockList();
        },
        getReportList: function getReportList() {
            var _this10 = this;

            var param = {
                current: this.reportPage,
                size: this.pageSize,
                condition: this.filters.reportFilter,
                status: this.filters.reportStatus,
                productId: this.currentDetailNo
            };
            this.fourthListLoading = true;
            (0, _inventoryService.getInventoryReportList)(param).then(function (data) {
                _this10.fourthListLoading = false;
                if (data.status === 200) {
                    _this10.reportedInbound = data.result.records;
                    _this10.reportTotal = data.result.total;
                }
            });
        },
        getInboundList: function getInboundList() {
            var _this11 = this;

            var param = {
                current: this.inboundPage,
                size: this.pageSize,
                productNo: this.currentDetailNo,
                condition: this.filters.inboundFilter,
                userNo: this.filters.inboundUser,
                type: this.filters.inboundType,
                tracking: this.filters.tracking
            };
            this.firstListLoading = true;
            (0, _inboundService.getProductInboundList)(param).then(function (data) {
                _this11.firstListLoading = false;
                if (data.status === 200) {
                    _this11.inboundList = data.result.records;
                    _this11.inboundTotal = data.result.total;
                }
            });
        },
        getOutboundList: function getOutboundList() {
            var _this12 = this;

            var param = {
                current: this.outboundPage,
                size: this.pageSize,
                productNo: this.currentDetailNo,
                userNo: this.filters.outboundUser
            };
            this.thirdListLoading = true;
            (0, _outboundService.getOutboundByProduct)(param).then(function (data) {
                _this12.thirdListLoading = false;
                if (data.status === 200) {
                    _this12.outboundList = data.result.records;
                    _this12.outboundTotal = data.result.total;
                }
            });
        },
        getStockList: function getStockList() {
            var _this13 = this;

            var param = {
                current: this.stockPage,
                size: this.pageSize,
                productNo: this.currentDetailNo,
                bizType: this.filters.stockFilter
            };
            this.sixListLoading = true;
            (0, _inventoryService.getStockHistory)(param).then(function (data) {
                _this13.sixListLoading = false;
                if (data.status === 200) {
                    _this13.stockList = data.result.records;
                    _this13.stockTotal = data.result.total;
                }
            });
        },
        showDetail: function showDetail(id) {
            this.currentDetailNo = id;
            this.detailVisible = true;
            this.filters.tracking = "";
            this.getInboundList();
            this.getReportList();
            this.getOutboundList();
            this.getNotClaimed();
            this.getInventoryDetail();
            this.getStockList();
        },
        handleInventoryChange: function handleInventoryChange(val) {
            this.inventoryPage = val;
            this.getInventory();
        },
        handleEditProduct: function handleEditProduct(row) {
            this.editProduct = row;
            this.editFormVisible = true;
        },
        handleCurrentChange: function handleCurrentChange(val) {
            this.page = val;
        },
        handleChangeInboundList: function handleChangeInboundList(val) {
            this.inboundPage = val;
            this.getInboundList();
        },
        handleChangeOutboundList: function handleChangeOutboundList(val) {
            this.outboundPage = val;
            this.getOutboundList();
        },
        getInventory: function getInventory() {
            var _this14 = this;

            var para = {
                current: this.inventoryPage,
                size: this.pageSize,
                condition: this.filters.name
            };
            this.listLoading = true;
            (0, _inventoryService.getInventory)(para).then(function (res) {
                _this14.listLoading = false;
                if (res.status === 200) {
                    _this14.products = res.result.records;
                    _this14.inventoryTotal = res.result.total;
                }
            });
        },

        handleEdit: function handleEdit(index, row) {
            this.editFormVisible = true;
            this.editForm = (0, _assign2.default)({}, row);
        },

        editSubmit: function editSubmit() {
            var _this15 = this;

            this.$refs.editProduct.validate(function (valid) {
                if (valid) {
                    var param = {
                        productNo: _this15.editProduct.productNo,

                        condition: _this15.editProduct.condition,
                        asin: _this15.editProduct.asin,
                        upc: _this15.editProduct.upc,
                        weight: _this15.editProduct.weight,
                        note: _this15.editProduct.note,
                        price: _this15.editProduct.price
                    };
                    _this15.loading = true;
                    (0, _inventoryService.addProduct)(param).then(function (res) {
                        _this15.loading = false;
                        if (res.status === 200) {
                            _this15.$message({
                                message: res.message,
                                type: "success"
                            });
                            _this15.editFormVisible = false;
                            _this15.$refs.editProduct.resetFields();
                            _this15.getInventory();
                        } else {
                            _this15.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    });
                }
            });
        },

        handleAddProduct: function handleAddProduct() {
            var _this16 = this;

            this.$refs.addProduct.validate(function (valid) {
                if (valid) {
                    var param = {
                        productName: _this16.addProduct.product,
                        condition: _this16.addProduct.condition,
                        asin: _this16.addProduct.asin,
                        upc: _this16.addProduct.upc,
                        weight: _this16.addProduct.weight,
                        note: _this16.addProduct.note,
                        price: _this16.addProduct.price
                    };
                    _this16.loading = true;
                    (0, _inventoryService.addProduct)(param).then(function (res) {
                        _this16.loading = false;
                        if (res.status === 200) {
                            _this16.$message({
                                message: res.message,
                                type: "success"
                            });
                            _this16.addFormVisible = false;
                            _this16.$refs.addProduct.resetFields();
                            _this16.getInventory();
                        } else {
                            _this16.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    });
                }
            });
        }
    },
    mounted: function mounted() {
        this.getInventory();
        this.getCurrentWarehouse();
        this.getDoctorMembers();
    }
};

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _set = __webpack_require__(402);

var _set2 = _interopRequireDefault(_set);

var _from = __webpack_require__(399);

var _from2 = _interopRequireDefault(_from);

var _vueQuillEditor = __webpack_require__(74);

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _globalVar = __webpack_require__(7);

var _offerService = __webpack_require__(103);

var _inventoryService = __webpack_require__(75);

var _memberService = __webpack_require__(20);

var _exportService = __webpack_require__(23);

var _option = __webpack_require__(22);

var _option2 = _interopRequireDefault(_option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { ElOption: _option2.default },
    data: function data() {
        return {
            editorOption: {
                theme: "snow",
                placeholder: "Note",
                height: "400px",
                modules: {
                    toolbar: {
                        container: [["bold", "italic", "underline", "strike"], ["link"]]
                    }
                }
            },
            relistFormVisible: false,
            offerDetailVisible: false,
            offerHistory: [],
            proposedOffers: [],
            offerDetails: [],
            conditions: _globalVar.conditions,
            activeName: "first",
            filters: {
                offerDetailFilter: "",
                historyFilter: "",
                proposedFilter: "",
                openOfferFilter: "",
                name: '',
                status: ""
            },
            currentDetailNo: "",

            products: [],
            openOffers: [],

            nurseList: [],

            pageSize: _globalVar.defaultPageSize,
            total: 0,
            page: 1,

            offerDetailPage: 1,
            offerDetailTotal: 0,

            historyPage: 1,
            historyTotal: 0,

            proposedPage: 1,
            proposedTotal: 0,

            openOfferPage: 0,
            openOfferTotal: 0,

            loading: false,
            listLoading: false,
            firstListLoading: false,
            secondListLoading: false,
            thirdListLoading: false,

            groups: [],

            addProductVisible: false,
            inputVisible: false,
            inputValue: "",

            editFormVisible: false,
            editOffer: {},
            relistOffer: {
                newExpireDate: ""
            },
            editLoading: false,

            editOfferFormRules: {
                productNo: [{ required: true, message: 'Product is required.', trigger: 'blur' }],
                price: [{ required: true, message: 'Price is required.', trigger: 'blur' }],
                quantity: [{ required: true, message: 'Original Total is required.', trigger: 'blur' }],
                leftNum: [{ required: true, message: 'Left is required.', trigger: 'blur' }],
                expireDate: [{ required: true, message: 'Expire Date is required.', trigger: 'blur' }],
                bouns: [{ required: true, message: 'Bonus is required.', trigger: 'blur' }]
            },

            addOfferFormRules: {
                productNo: [{ required: true, message: 'Product is required.', trigger: 'blur' }],
                price: [{ required: true, message: 'Price is required.', trigger: 'blur' }],
                total: [{ required: true, message: 'Total is required.', trigger: 'blur' }],
                expireDate: [{ required: true, message: 'Expire Date is required.', trigger: 'blur' }],
                bouns: [{ required: true, message: 'Bonus is required.', trigger: 'blur' }]
            },

            addProductFormRules: {
                product: [{ required: true, message: 'Product Name is  required.', trigger: 'blur' }],
                price: [{ required: true, message: 'Price is required.', trigger: 'blur' }]
            },

            addProduct: {
                id: "",
                product: '',
                condition: "New",
                price: "",
                asin: "",
                upc: "",
                weight: '',
                note: ""
            },

            addFormVisible: false,
            addLoading: false,
            addFormRules: {
                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
            },

            addOffer: {
                id: "",
                title: "",
                productNo: '',
                price: "",
                total: 0,
                expireDate: '',
                note: '',
                bouns: "",
                scope: "public",
                notify: true,
                users: []
            },
            defaultProps: {
                children: 'members',
                label: 'label'
            },
            dateOption: {
                disabledDate: function disabledDate(date) {
                    return date.getTime() < Date.now() - 8.64e7;
                }
            }
        };
    },

    methods: {
        exportExcel: function exportExcel(url, fileName) {
            var param = {
                url: url,
                fileName: fileName
            };
            (0, _exportService.exportExcel)(param).then(function () {});
        },
        getNurseList: function getNurseList() {
            var _this = this;

            (0, _memberService.getDoctorNurse)().then(function (data) {
                if (data.status === 200) {
                    _this.nurseList = data.result;
                }
            });
        },
        getOfferDetail: function getOfferDetail(id) {
            var _this2 = this;

            if (id) {
                this.currentDetailNo = id;
            }
            var param = {
                offerNo: id ? id : this.currentDetailNo,
                current: this.offerDetailPage,
                size: this.pageSize,
                userNo: this.filters.offerDetailFilter
            };
            this.listLoading = true;
            (0, _offerService.getTakeOfferDetail)(param).then(function (data) {
                _this2.listLoading = false;
                if (data.status === 200) {
                    _this2.offerDetails = data.result.records;
                    _this2.offerDetailTotal = data.result.total;
                    _this2.offerDetailVisible = true;
                } else {
                    _this2.$message.error(data.messaeg);
                }
            });
        },
        confirmProposed: function confirmProposed(id, status) {
            var _this3 = this;

            this.$confirm('Are you sure?', 'Warning', {
                type: 'warning'
            }).then(function () {
                (0, _offerService.editProposedOfferStatus)({ id: id, status: status }).then(function (res) {
                    if (res.status === 200) {
                        _this3.$message.success(res.message);
                        _this3.getProposedOffers();
                    } else {
                        _this3.$message.error(res.message);
                        _this3.getProposedOffers();
                    }
                });
            }).catch(function () {});
        },
        getProposedOffers: function getProposedOffers() {
            var _this4 = this;

            var param = {
                current: this.proposedPage,
                size: this.pageSize,
                condition: this.filters.proposedFilter,
                status: this.filters.status
            };
            this.secondListLoading = true;
            (0, _offerService.getProposedOffers)(param).then(function (data) {
                _this4.secondListLoading = false;
                if (data.status === 200) {
                    _this4.proposedOffers = data.result.records;
                    _this4.proposedTotal = data.result.total;
                }
            });
        },
        formatProposedStatus: function formatProposedStatus(row, column) {
            if (row.status === 0) {
                return "Pending";
            } else if (row.status === 1) {
                return "Confirmed";
            } else if (row.status === 3) {
                return "Cancelled";
            } else {
                return "Rejected";
            }
        },
        getMembers: function getMembers() {
            var _this5 = this;

            (0, _memberService.getMemberWithGroup)().then(function (res) {
                console.log(res);
                if (res.status === 200) {
                    var groups = [];
                    var unGroup = { label: "No Group", members: [] };
                    res.result.forEach(function (item) {
                        if (item.groupName) {
                            var result = groups.find(function (group) {
                                return item.groupName === group.label;
                            });
                            if (result) {
                                result.members.push({ label: item.userName, userNo: item.userNo });
                            } else {
                                groups.push({ label: item.groupName, members: [{ label: item.userName, userNo: item.userNo }] });
                            }
                        } else {
                            unGroup.members.push({ label: item.userName, userNo: item.userNo });
                        }
                    });
                    if (unGroup.members.length > 0) {
                        groups.unshift(unGroup);
                    }
                    _this5.groups = groups;
                }
            });
        },
        archiveOffer: function archiveOffer(offerId) {
            var _this6 = this;

            this.$confirm('Are you sure?', 'Warning', {
                type: 'warning'
            }).then(function () {
                (0, _offerService.editOfferStatus)({ offerNo: offerId, status: 'archived' }).then(function (res) {
                    if (res.status === 200) {
                        _this6.$message.success(res.message);
                        _this6.getOpenOffers();
                        _this6.getOfferHistory();
                    } else {
                        _this6.$message.error(res.message);
                    }
                });
            }).catch(function () {});
        },
        getProductList: function getProductList() {
            var _this7 = this;

            (0, _inventoryService.getDoctorProduct)({ condition: "" }).then(function (res) {
                if (res.status === 200) {
                    _this7.products = res.result;
                }
            });
        },
        showAddProduct: function showAddProduct() {
            var _this8 = this;

            var temp = new Date();
            temp.setDate(temp.getDate() + 3);
            this.addOffer.expireDate = _util2.default.formatDate.format(temp, 'yyyy-MM-dd hh:mm:ss');
            (0, _memberService.getDoctorMemberList)({ roleId: 2 }).then(function (res) {
                if (res.status === 200) {
                    _this8.addFormVisible = true;
                    _this8.members = res.result;
                }
            });
        },
        handleAddProduct: function handleAddProduct() {
            var _this9 = this;

            this.$refs.addProduct.validate(function (valid) {
                if (valid) {
                    var param = {
                        productName: _this9.addProduct.product,
                        condition: _this9.addProduct.condition,
                        asin: _this9.addProduct.asin,
                        upc: _this9.addProduct.upc,
                        weight: _this9.addProduct.weight,
                        note: _this9.addProduct.note,
                        price: _this9.addProduct.price
                    };
                    _this9.loading = true;
                    (0, _inventoryService.addProduct)(param).then(function (res) {
                        _this9.loading = false;
                        if (res.status === 200) {
                            _this9.$message({
                                message: res.message,
                                type: "success"
                            });
                            _this9.$refs.addProduct.resetFields();
                            _this9.addProductVisible = false;
                            _this9.getProductList();
                        } else {
                            _this9.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    });
                }
            });
        },
        handleChangeOfferDetail: function handleChangeOfferDetail(val) {
            this.offerDetailPage = val;
            this.getOfferDetail();
        },
        handleChangeOfferHistory: function handleChangeOfferHistory(val) {
            this.historyPage = val;
            this.getOfferHistory();
        },
        handleChangeOpenOffer: function handleChangeOpenOffer(val) {
            this.openOfferPage = val;
            this.getOpenOffers();
        },
        handleCurrentChange: function handleCurrentChange(val) {
            this.page = val;
        },
        getOpenOffers: function getOpenOffers() {
            var _this10 = this;

            var param = {
                current: this.openOfferPage,
                size: this.pageSize,
                condition: this.filters.openOfferFilter,
                status: "offering"
            };
            this.firstListLoading = true;
            (0, _offerService.getDoctorOffer)(param).then(function (res) {
                _this10.firstListLoading = false;
                if (res.status === 200) {
                    _this10.openOffers = res.result.records;
                    _this10.openOfferTotal = res.result.total;
                } else {
                    _this10.$message.error(res.message);
                }
            });
        },
        getOfferHistory: function getOfferHistory() {
            var _this11 = this;

            var param = {
                current: this.historyPage,
                size: this.pageSize,
                condition: this.filters.historyFilter,
                status: this.filters.status
            };
            this.thirdListLoading = true;
            (0, _offerService.getDoctorOffer)(param).then(function (res) {
                _this11.thirdListLoading = false;
                if (res.status === 200) {
                    _this11.offerHistory = res.result.records;
                    _this11.historyTotal = res.result.total;
                } else {
                    _this11.$message.error(res.message);
                }
            });
        },

        showEditOffer: function showEditOffer(offerId) {
            var _this12 = this;

            (0, _offerService.getOfferById)({ offerNo: offerId }).then(function (res) {
                if (res.status === 200) {
                    _this12.editFormVisible = true;
                    _this12.editOffer = res.result.offer;
                    if (res.result.offerUsers) {
                        var users = res.result.offerUsers.split(",");
                        _this12.editOffer.users = users;
                    }
                }
            });
        },
        reListOffer: function reListOffer(offerId) {
            var _this13 = this;

            (0, _offerService.getOfferById)({ offerNo: offerId }).then(function (res) {
                if (res.status === 200) {
                    _this13.relistFormVisible = true;
                    _this13.relistOffer = res.result.offer;
                    var temp = new Date();
                    temp.setDate(temp.getDate() + 3);

                    _this13.$set(_this13.relistOffer, "newExpireDate", _util2.default.formatDate.format(temp, 'yyyy-MM-dd hh:mm:ss'));
                    if (res.result.offerUsers) {
                        var users = res.result.offerUsers.split(",");
                        _this13.relistOffer.users = users;
                    }
                }
            });
        },
        handleAddOffer: function handleAddOffer() {
            var _this14 = this;

            this.$refs.addOffer.validate(function (valid) {
                if (valid) {
                    _this14.loading = true;
                    var param = {
                        productNo: _this14.addOffer.productNo,
                        price: _this14.addOffer.price,
                        quantity: _this14.addOffer.total,
                        leftNum: _this14.addOffer.total,
                        expireDate: _this14.addOffer.expireDate,
                        bouns: _this14.addOffer.bouns,
                        scope: _this14.addOffer.scope,
                        note: _this14.addOffer.note,
                        notify: _this14.addOffer.notify
                    };
                    if (_this14.addOffer.scope === "private") {
                        var checked = _this14.$refs.tree.getCheckedKeys();
                        if (checked.length > 0) {
                            checked = checked.filter(function (item) {
                                return item !== undefined;
                            });
                        }
                        var array = (0, _from2.default)(new _set2.default(checked));
                        param.nurseStr = array.join(",");
                    }
                    (0, _offerService.addOffer)(param).then(function (res) {
                        _this14.loading = false;
                        if (res.status === 200) {
                            _this14.addFormVisible = false;
                            _this14.$message.success(res.message);
                            _this14.$refs.addOffer.resetFields();
                            _this14.getOpenOffers();
                        } else {
                            _this14.$message.error(res.message);
                        }
                    });
                }
            });
        },
        handleEditOffer: function handleEditOffer() {
            var _this15 = this;

            this.loading = true;
            this.$refs.editOffer.validate(function (valid) {
                _this15.loading = false;
                if (valid) {
                    var param = {
                        offerNo: _this15.editOffer.offerNo,
                        price: _this15.editOffer.price,
                        quantity: _this15.editOffer.quantity,
                        leftNum: _this15.editOffer.leftNum,
                        expireDate: _this15.editOffer.expireDate,
                        bouns: _this15.editOffer.bouns,
                        scope: _this15.editOffer.scope,
                        notify: _this15.editOffer.notify,
                        note: _this15.editOffer.note
                    };
                    (0, _offerService.addOffer)(param).then(function (res) {
                        if (res.status === 200) {
                            _this15.editFormVisible = false;
                            _this15.$message.success(res.message);
                            _this15.getOpenOffers();
                            _this15.getOfferHistory();
                        } else {
                            _this15.$message.error(res.message);
                        }
                    });
                }
            });
        },
        handleReListOffer: function handleReListOffer() {
            var _this16 = this;

            this.loading = true;
            this.$refs.relistOffer.validate(function (valid) {
                _this16.loading = false;
                if (valid) {
                    var param = {
                        offerNo: _this16.relistOffer.offerNo,
                        price: _this16.relistOffer.price,
                        quantity: _this16.relistOffer.quantity,
                        leftNum: _this16.relistOffer.leftNum,
                        expireDate: _this16.relistOffer.newExpireDate,
                        bouns: _this16.relistOffer.bouns,
                        scope: _this16.relistOffer.scope,
                        notify: _this16.relistOffer.notify,
                        note: _this16.relistOffer.note,
                        status: "offering"
                    };
                    (0, _offerService.addOffer)(param).then(function (res) {
                        if (res.status === 200) {
                            _this16.relistFormVisible = false;
                            _this16.$message.success(res.message);
                            _this16.getOpenOffers();
                            _this16.getOfferHistory();
                        } else {
                            _this16.$message.error(res.message);
                        }
                    });
                }
            });
        }
    },
    mounted: function mounted() {
        this.getOpenOffers();
        this.getProductList();
        this.getMembers();
        this.getProposedOffers();
        this.getOfferHistory();
        this.getNurseList();
        var active = this.$route.params.active;
        if (active) {
            this.activeName = active;
        }
    }
};

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = __webpack_require__(41);

var _typeof3 = _interopRequireDefault(_typeof2);

var _jquery = __webpack_require__(272);

var _jquery2 = _interopRequireDefault(_jquery);

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _memberService = __webpack_require__(20);

var _inventoryService = __webpack_require__(75);

var _outboundService = __webpack_require__(104);

var _warehouseService = __webpack_require__(59);

var _button = __webpack_require__(99);

var _button2 = _interopRequireDefault(_button);

var _main = __webpack_require__(282);

var _main2 = _interopRequireDefault(_main);

var _option = __webpack_require__(22);

var _option2 = _interopRequireDefault(_option);

var _input = __webpack_require__(100);

var _input2 = _interopRequireDefault(_input);

var _globalVar = __webpack_require__(7);

var _vueQuillEditor = __webpack_require__(74);

var _exportService = __webpack_require__(23);

var _inputNumber = __webpack_require__(281);

var _inputNumber2 = _interopRequireDefault(_inputNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        ElInputNumber: _inputNumber2.default,
        ElInput: _input2.default,
        ElOption: _option2.default,
        ElLink: _main2.default,
        ElButton: _button2.default },
    data: function data() {
        return {
            editorOption: {
                theme: "snow",
                placeholder: "Note",
                height: "400px",
                modules: {
                    toolbar: {
                        container: [["bold", "italic", "underline", "strike"], ["link"]]
                    }
                }
            },
            activeName: "first",
            filters: {
                workingFilter: "",
                workingMainFilter: "",
                archivedFilter: "",
                archivedMainFilter: "",
                closeFilter: "",
                closeMainFilter: "",
                inventoryProduct: "",
                inventoryProductSummary: "",
                inventoryNurse: "",
                inventorySummaryNurse: "",
                customizationName: "",
                name: '',
                transferFilter: "",
                productFilter: "",
                fbmFilter: ""
            },
            headers: {
                Authorization: window.sessionStorage.getItem("authorization")
            },
            uploadUrl: _globalVar.serverUrl + "/outboundFile/upload",

            pageSize: _globalVar.defaultPageSize,

            inventoryLoading: false,
            inventorySummaryLoading: false,

            inventorySummaryPage: 1,
            inventorySummaryTotal: 0,

            inventorySummaryByUserPage: 1,
            inventorySummaryByUserTotal: 0,

            inventoryPage: 1,
            inventoryTotal: 0,

            customizationPage: 1,
            customizationTotal: 0,
            customizationLoading: false,

            instructionTemps: [],
            instruction: {},

            workingList: [],
            workingPage: 1,
            workingTotal: 0,
            workingLoading: false,

            archivedList: [],
            archivedPage: 1,
            archivedTotal: 0,
            archivedLoading: false,

            instructionTemplateVisiable: false,
            instructionListPage: [],
            instructionPage: 1,
            instructionTotal: 0,
            instructionLoading: false,

            closeList: [],
            closePage: 1,
            closeTotal: 0,
            closeLoading: false,

            transferList: [],
            transferPage: 1,
            transferTotal: 0,
            transferLoading: false,
            transferModelVisiable: false,

            transferLogsPage: 1,
            transferLogsPageSize: 50,
            transferLogsWorkingTotal: 0,
            transferLogsList: [],
            transferLogsLoading: false,

            productList: [],
            productPage: 1,
            productTotal: 0,
            productLoading: false,

            fbmDetail: [],
            fbmPage: 1,
            fbmTotal: 0,
            fbmLoading: false,

            serviceList: [],

            editCustomizationVisible: false,
            addCustomizationVisible: false,
            customizationProduct: [],
            addInstructionVisible: false,
            editInstructionVisible: false,
            workingOutboundList: [],
            inventories: [],
            inventoriesSummary: [],
            inventoriesSummaryByUser: [],
            outboundItems: [],
            archivedOutbound: [],
            total: 0,
            invitationTotalPage: 0,
            invitationPage: 1,
            listLoading: false,
            sels: [],
            customizationVisible: false,
            addInventory: false,
            inventroySummary: false,
            fbmModelVisiable: false,

            currentInventroy: "",

            currentDetailNo: "",

            nurseList: [],
            warehouses: [],

            loading: false,

            outbound: {
                id: "",
                warehouseNo: "",
                items: [],
                packageLabel: "",
                trackingNumber: "",
                carrier: "",
                carrierName: "",
                user: "",
                note: "",
                instruction: "",
                priority: 0,

                splitPackagesNum: 0,
                fileId: "",
                mainProduct: "",
                mainProductName: ""
            },

            selectedInstruction: null,

            members: [],

            addInstructionRule: {
                name: [{ required: true, message: 'Name is required.', trigger: 'blur' }]
            },

            customizationRule: {
                warehouse: [{ required: true, message: 'Warehouse is required.', trigger: 'blur' }],
                name: [{ required: true, message: 'Template name is required.', trigger: 'blur' }],
                mainProduct: [{ required: true, message: 'Main Product is required.', trigger: 'blur' }],
                mainProductQty: [{ required: true, message: 'Main Product Qty is required.', trigger: 'blur' }]
            },

            transferRule: {
                to: [{ required: true, message: 'Transfer To is required.', trigger: 'blur' }],
                transferQty: [{ required: true, message: 'Transfer Qty is required.', trigger: 'blur' }, { validator: this.checkQuantity, trigger: 'blur' }]
            },

            addInstruction: {
                name: "",
                text: "",
                note: ""
            },
            editInstructionObj: {
                name: "",
                text: "",
                note: "",
                id: ""
            },
            customization: {
                name: "",
                warehouse: "",
                mainProduct: "",
                mainProductQty: "",
                sub: []
            },

            editCustomization: {
                id: "",
                name: "",
                warehouse: "",
                sub: [],
                mainProduct: "",
                mainProductQty: ""
            },

            transferForm: {
                productNo: "",
                productName: "",
                warehouseNo: "",
                warehouse: "",
                qty: "",
                to: "",
                transferQty: "",
                upc: ""
            },
            fileList: [],
            uploadForm: new FormData(),
            currentUser: null
        };
    },

    methods: {
        checkQuantity: function checkQuantity(rule, value, callback) {
            if (!value > 0) {
                return callback(new Error('Quantity must more than 1.'));
            } else {
                callback();
            }
        },
        exportExcel: function exportExcel(url, fileName, type) {
            var param = {
                url: url,
                fileName: fileName,
                status: type
            };
            (0, _exportService.postExportExcel)(param).then(function () {});
        },
        closeOutbound: function closeOutbound(id) {
            var _this = this;

            this.$confirm('Are you sure?', 'Warning', {
                type: 'warning'
            }).then(function () {
                var param = {
                    outboundNo: id,
                    status: 3
                };
                (0, _outboundService.updateOutboundStatus)(param).then(function (data) {
                    if (data.status === 200) {
                        _this.$message.success(data.message);
                        _this.getWorkingOutboundList();
                        _this.getCloseOutboundList();
                    } else {
                        _this.$message.error(data.message);
                    }
                });
            }).catch(function () {});
        },
        download: function download(id) {
            window.open(_globalVar.serverUrl + "/outboundFile/exportPackageLabelImageById?outboundNo=" + id, "_blank");
        },
        deleteCustomization: function deleteCustomization(id) {
            var _this2 = this;

            this.$confirm('Are you sure?', 'Warning', {
                type: 'warning'
            }).then(function () {
                (0, _outboundService.deleteCustomizationTemplate)({ customization_id: id }).then(function (res) {
                    if (res.status === 200) {
                        _this2.$message.success(res.message);
                        _this2.getCustomizationProduct();
                    } else {
                        _this2.$message.error(res.message);
                    }
                });
            }).catch(function () {});
        },
        deleteEditSub: function deleteEditSub(row) {
            this.editCustomization.sub.splice(this.editCustomization.sub.indexOf(row), 1);
        },
        deleteSub: function deleteSub(row) {
            this.customization.sub.splice(this.customization.sub.indexOf(row), 1);
        },
        openNewCustomizationWindow: function openNewCustomizationWindow() {
            var _this3 = this;

            this.addCustomizationVisible = true;
            this.$nextTick(function () {
                _this3.$refs.customization.resetFields();
            });
        },
        addCustomizationTemplate: function addCustomizationTemplate() {
            var _this4 = this;

            this.$refs.customization.validate(function (valid) {
                if (valid) {
                    var _ret = function () {
                        var items = [];
                        var products = _this4.customization.sub;

                        var _loop = function _loop(i) {
                            if (!products[i].productNo) {
                                _this4.$message.error("You must select a product for each rows.");
                                return {
                                    v: {
                                        v: void 0
                                    }
                                };
                            }
                            if (products[i].productNo == _this4.customization.mainProduct) {
                                _this4.$message.error("You select a sub product same with main product, please delete this product or replace.");
                                return {
                                    v: {
                                        v: void 0
                                    }
                                };
                            }
                            if (!products[i].service) {
                                _this4.$message.error("You must select a service for each rows.");
                                return {
                                    v: {
                                        v: void 0
                                    }
                                };
                            }
                            var exsit = items.find(function (f) {
                                return f.productNo == products[i].productNo;
                            });
                            if (exsit) {
                                _this4.$message.error("Duplicate product in the list.");
                                return {
                                    v: {
                                        v: void 0
                                    }
                                };
                            } else {
                                items.push({ productNo: products[i].productNo, qty: products[i].qty, service: products[i].service ? products[i].service : "None" });
                            }
                        };

                        for (var i = 0; i < products.length; i++) {
                            var _ret2 = _loop(i);

                            if ((typeof _ret2 === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret2)) === "object") return _ret2.v;
                        }

                        var param = {
                            items: items,
                            templateName: _this4.customization.name,
                            warehouseNo: _this4.customization.warehouse,
                            product_no: _this4.customization.mainProduct,
                            mainProductQty: _this4.customization.mainProductQty
                        };
                        _this4.loading = true;
                        (0, _outboundService.addCustomizationTemplate)(param).then(function (data) {
                            _this4.loading = false;
                            if (data.status === 200) {
                                _this4.addCustomizationVisible = false;
                                _this4.getCustomizationProduct();
                                _this4.$refs.customization.resetFields();
                                _this4.customization.sub = [];
                                _this4.$message.success(data.message);
                            } else {
                                _this4.$message.error(data.message);
                            }
                        });
                    }();

                    if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
                }
            });
        },
        editCustomizationTemplate: function editCustomizationTemplate() {
            var _this5 = this;

            this.$refs.editCustomization.validate(function (valid) {
                if (valid) {
                    var _ret3 = function () {
                        var items = [];
                        var products = _this5.editCustomization.sub;

                        var _loop2 = function _loop2(i) {
                            if (!products[i].productNo) {
                                _this5.$message.error("You must select a product for each rows.");
                                return {
                                    v: {
                                        v: void 0
                                    }
                                };
                            }
                            if (products[i].productNo == _this5.editCustomization.mainProduct) {
                                _this5.$message.error("You select a sub product same with main product, please delete this product or replace.");
                                return {
                                    v: {
                                        v: void 0
                                    }
                                };
                            }
                            if (!products[i].qty) {
                                _this5.$message.error("You must set quantity for each rows.");
                                return {
                                    v: {
                                        v: void 0
                                    }
                                };
                            }
                            if (!products[i].service) {
                                _this5.$message.error("You must select a service for each rows.");
                                return {
                                    v: {
                                        v: void 0
                                    }
                                };
                            }
                            var exsit = items.find(function (f) {
                                return f.productNo == products[i].productNo;
                            });
                            if (exsit) {
                                _this5.$message.error("Duplicate product in the list.");
                                return {
                                    v: {
                                        v: void 0
                                    }
                                };
                            } else {
                                items.push({ productNo: products[i].productNo, qty: products[i].qty, service: products[i].service ? products[i].service : "None" });
                            }
                        };

                        for (var i = 0; i < products.length; i++) {
                            var _ret4 = _loop2(i);

                            if ((typeof _ret4 === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret4)) === "object") return _ret4.v;
                        }

                        var param = {
                            customizationOutboundId: _this5.editCustomization.id,
                            items: items,
                            templateName: _this5.editCustomization.name,
                            warehouseNo: _this5.editCustomization.warehouse,
                            product_no: _this5.editCustomization.mainProduct,
                            mainProductQty: _this5.editCustomization.mainProductQty
                        };
                        _this5.loading = true;
                        (0, _outboundService.addCustomizationTemplate)(param).then(function (data) {
                            _this5.loading = false;
                            if (data.status === 200) {
                                _this5.editCustomizationVisible = false;
                                _this5.getCustomizationProduct();
                                _this5.$refs.editCustomization.resetFields();
                                _this5.editCustomization.sub = [];
                                _this5.$message.success(data.message);
                            } else {
                                _this5.$message.error(data.message);
                            }
                        });
                    }();

                    if ((typeof _ret3 === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret3)) === "object") return _ret3.v;
                }
            });
        },
        getProductsByWarehouseId: function getProductsByWarehouseId(id) {
            var _this6 = this;

            if (this.customization.warehouse || id) {
                this.customization.sub = [];
                this.editCustomization.sub = [];
                return (0, _outboundService.getProductsByWarehouseId)({ warehouseNo: this.customization.warehouse || id }).then(function (data) {
                    if (data.status === 200) {
                        var param = {
                            warehouseNo: _this6.customization.warehouse || id
                        };
                        (0, _inventoryService.getServiceList)(param).then(function (data) {
                            if (data.status === 200) {
                                _this6.serviceList = data.result;
                            }
                        });
                        _this6.inventories = data.result;
                    }
                });
            } else {
                this.inventories = [];
            }
        },
        handleOutbound: function handleOutbound() {
            var _this7 = this;

            if (this.outbound.items.length === 0) {
                this.$message.error("You must select a product to shipment.");
                return;
            }
            if (!this.outbound.user) {
                this.$message.error("You must select a user to notify.");
                return;
            }
            if (this.outbound.splitPackagesNum < 1) {
                this.$message.error("You must set Numb of box Per Shipment greater than 0.");
                return;
            }
            var data = [];
            for (var i = 0; i < this.outbound.items.length; i++) {
                var item = this.outbound.items[i];
                if (item.items) {
                    if (!item.toShip) {
                        this.$message.error("Toship can't be empty.");
                        return;
                    } else {
                        var sub = item.items;
                        for (var j = 0; j < sub.length; j++) {
                            data.push({ toShip: item.toShip * sub[j].qty, productNo: sub[j].productNo, service: sub[j].service });
                        }
                    }
                } else {
                    if (item.toShip) {
                        data.push({ toShip: item.toShip, qty: item.qty, inboundNo: item.boundId, type: item.type, productNo: item.productNo, service: item.service });
                    } else {
                        this.$message.error("Toship can't be empty.");
                        return;
                    }
                }
            }

            var param = {
                data: data,
                fileNo: "",
                carrier: this.outbound.carrier,
                carrierName: this.outbound.carrierName,
                instruction: this.outbound.instruction,
                note: this.outbound.note,
                notifiyUserNo: this.outbound.user,
                priority: this.outbound.priority,

                splitPackagesNum: this.outbound.splitPackagesNum,
                tracking: this.outbound.trackingNumber,
                warehouseNo: this.outbound.warehouseNo,
                mainProduct: this.outbound.mainProduct
            };

            this.uploadForm = new FormData();
            this.$refs.upload.submit();
            var files = this.uploadForm.get("file");
            if (!files) {
                this.$message.error("Please upload package label before submit.");
                return;
            }
            this.loading = true;
            _jquery2.default.ajax({
                url: _globalVar.serverUrl + '/outboundFile/uploadFiles',
                type: "POST",
                data: this.uploadForm,
                cache: false,
                processData: false,
                contentType: false,
                beforeSend: function beforeSend(xhr) {
                    xhr.setRequestHeader("Authorization", window.sessionStorage.getItem("authorization"));
                }
            }).then(function (response) {
                if (response.status === 200) {
                    param.fileNo = response.result;
                    (0, _outboundService.outbound)(param).then(function (data) {
                        _this7.loading = false;
                        if (data.status === 200) {
                            _this7.fileList = [];
                            _this7.$message.success(data.message);
                            _this7.$refs.outbound.resetFields();
                            _this7.outbound.warehouseNo = "";
                            _this7.outbound.fileId = "";
                            _this7.outbound.items = [];
                            _this7.activeName = "second";
                            _this7.selectedInstruction = null;
                            _this7.outbound.mainProduct = "";
                            _this7.getWorkingOutboundList();
                        } else {
                            _this7.$message.error(data.message);
                        }
                    });
                } else {
                    _this7.$message.error(data.message);
                }
            });
        },
        removeFile: function removeFile() {
            this.outbound.fileId = "";
        },
        upload: function upload(file) {
            this.uploadForm.append('file', file.file);
        },
        uploadError: function uploadError(a) {
            this.$message.error(a.message);
            this.$refs.upload.clearFiles();
        },
        changeToship: function changeToship(value, row) {
            if (row.sub) {
                for (var i = 0; i < row.sub.length; i++) {
                    row.sub[i].quantity = row.sub[i].quantity * value;
                }
            }
        },
        addEditAccessories: function addEditAccessories() {
            this.editCustomization.sub.push({ productNo: "", qty: 1 });
        },
        addAccessories: function addAccessories() {
            this.customization.sub.push({ productNo: "", qty: 1 });
        },
        getCustomizationProduct: function getCustomizationProduct() {
            var _this8 = this;

            var param = {
                current: this.customizationPage,
                size: this.pageSize,
                condition: this.filters.customizationName
            };
            this.customizationLoading = true;
            (0, _outboundService.getCustomizationProduct)(param).then(function (data) {
                _this8.customizationLoading = false;
                if (data.status === 200) {
                    _this8.customizationProduct = data.result.records;
                    _this8.customizationTotal = data.result.total;
                }
            });
        },
        changeCustomizationPage: function changeCustomizationPage(val) {
            this.customizationPage = val;
            this.customizationVisible = true;
            this.getCustomizationProduct();
        },
        formatOutboundShipment: function formatOutboundShipment(row, columns) {
            return row.product + " * " + row.quantity;
        },
        removeInventory: function removeInventory(row) {
            this.outbound.items.splice(this.outbound.items.indexOf(row), 1);

            if (row.mainProductId) {
                this.outbound.mainProduct = "";
            }

            if (this.outbound.items.length === 0) {
                this.outbound.warehouseNo = "";
                this.outbound.user = "";
                this.outbound.mainProduct = "";
            }
        },
        selectInventory: function selectInventory(row) {
            var _this9 = this;

            if (row.selected) {
                var selectedItem = this.outbound.items.find(function (item) {
                    return item.productNo == row.productNo && _this9.outbound.warehouseNo == item.warehouseNo;
                });
                if (selectedItem) {
                    this.outbound.items.splice(this.outbound.items.indexOf(selectedItem), 1);
                }
                this.$set(row, "selected", false);
                if (this.outbound.items.length == 0) {
                    this.outbound.warehouseNo = "";
                    this.outbound.mainProduct = "";
                }
                return;
            }
            this.$set(row, 'toShip', 1);
            var exsit = this.outbound.items.filter(function (item) {
                return item.productNo == row.productNo && item.warehouseNo == row.warehouseNo;
            });
            if (exsit.length > 0) {
                this.$message.error("Product selected.");
                return;
            }
            if (!this.outbound.warehouseNo) {
                this.$set(row, "selected", true);
                this.outbound.items.push(row);
                this.outbound.warehouseNo = row.warehouseNo;
                this.addInventory = false;
                this.inventroySummary = false;
                this.outbound.user = row.warehouseUserNo;
            } else {
                if (this.outbound.warehouseNo == row.warehouseNo) {
                    this.$set(row, "selected", true);
                    this.outbound.items.push(row);
                    this.addInventory = false;
                    this.inventroySummary = false;
                } else {
                    this.$message.error("Products from different warehouses cannot be shipped out together.");
                }
            }
        },
        eitCustomization: function eitCustomization(row) {
            var _this10 = this;

            var param = {
                warehouseNo: row.warehouseNo
            };
            (0, _inventoryService.getServiceList)(param).then(function (data) {
                if (data.status === 200) {
                    _this10.serviceList = data.result;
                }
            });
            (0, _outboundService.getProductsByWarehouseId)({ warehouseNo: row.warehouseNo }).then(function (data) {
                if (data.status === 200) {
                    _this10.inventories = data.result;
                    _this10.editCustomization.id = row.id;
                    _this10.editCustomization.warehouse = row.warehouseNo;
                    _this10.editCustomization.mainProduct = row.mainProductId;
                    _this10.editCustomization.qty = row.qty;
                    var sub = row.items.filter(function (item) {
                        return item.productNo != row.mainProductId;
                    });
                    sub.forEach(function (item) {
                        item.productNo = item.productNo.toString();

                        var inventory = _this10.inventories.filter(function (i) {
                            return i.productNo == item.productNo;
                        });
                        if (inventory) {
                            item.fbm = inventory[0].fbm;
                        }
                    });
                    _this10.editCustomization.sub = sub;
                    _this10.editCustomization.name = row.templateName;
                    _this10.editCustomizationVisible = true;
                }
            });
        },
        selectCustomization: function selectCustomization(row) {
            row.qty = row.stock;
            if (!row.mainProductId) {
                this.$message.error("You must select a main product before outbound.");
                return;
            }
            this.$set(row, "toShip", 1);

            row.items.forEach(function (item) {
                item.type = 3;
            });
            if (!this.outbound.warehouseNo) {
                this.outbound.items.push(row);
                this.outbound.warehouseNo = row.warehouseNo;
                this.customizationVisible = false;
                this.outbound.user = row.warehouseUserNo;
            } else {
                if (this.outbound.warehouseNo == row.warehouseNo) {
                    this.outbound.items.push(row);
                    this.customizationVisible = false;
                } else {
                    this.$message.error("Products from different warehouses cannot be shipped out together.");
                }
            }
            if (row.mainProductId) {
                this.outbound.mainProduct = row.mainProductId;
                this.outbound.mainProductName = row.mainProductName;
            }
            this.outbound.note = row.templateName;
        },
        showAddInventory: function showAddInventory() {
            var _this11 = this;

            this.filters.inventoryNurse = "";
            this.filters.inventorySummaryNurse = "";
            this.getInventorySummary().then(function (data) {
                _this11.inventroySummary = true;
                _this11.filters.inventorySummaryNurse = "";
            });
        },
        getInventorySummary: function getInventorySummary() {
            var _this12 = this;

            var param = {
                current: this.inventorySummaryPage,
                size: this.pageSize,
                productName: this.filters.inventoryProductSummary
            };
            this.inventorySummaryLoading = true;
            return (0, _outboundService.getInventorySummary)(param).then(function (data) {
                _this12.inventorySummaryLoading = false;
                if (data.status === 200) {
                    _this12.inventoriesSummary = data.result.records;
                    _this12.inventorySummaryTotal = data.result.total;
                }
            });
        },
        getInventory: function getInventory(productNo) {
            var _this13 = this;

            if (productNo) {
                this.currentInventroy = productNo;
            }
            var param = {
                current: this.inventoryPage,
                size: this.pageSize,
                productName: this.filters.inventoryProduct,
                nurseId: this.filters.inventoryNurse,
                productNo: productNo ? productNo : this.currentInventroy
            };
            this.addInventory = true;
            this.inventoryLoading = true;
            return (0, _outboundService.getInventoryList)(param).then(function (data) {
                _this13.inventoryLoading = false;
                if (data.status === 200) {
                    _this13.inventories = data.result.records;
                    _this13.inventoryTotal = data.result.total;
                    _this13.inventories.forEach(function (item) {
                        var selected = _this13.outbound.items.filter(function (i) {
                            return i.productNo == item.productNo && i.warehouseNo == item.warehouseNo;
                        });
                        if (selected && selected.length > 0) {
                            _this13.$set(item, "selected", true);
                        }
                    });
                }
            });
        },
        getInventorySummaryByUser: function getInventorySummaryByUser() {
            var _this14 = this;

            if (this.filters.inventorySummaryNurse) {
                var param = {
                    current: this.inventorySummaryByUserPage,
                    size: this.pageSize,
                    productName: this.filters.inventoryProductSummary,
                    nurseId: this.filters.inventorySummaryNurse
                };
                this.inventoryLoading = true;
                return (0, _outboundService.getInventoryList)(param).then(function (data) {
                    _this14.inventoryLoading = false;
                    if (data.status === 200) {
                        _this14.inventoriesSummaryByUser = data.result.records;
                        _this14.inventorySummaryByUserTotal = data.result.total;
                        _this14.inventoriesSummaryByUser.forEach(function (item) {
                            var selected = _this14.outbound.items.filter(function (i) {
                                return i.productNo == item.productNo && i.warehouseNo == item.warehouseNo;
                            });
                            if (selected && selected.length > 0) {
                                _this14.$set(item, "selected", true);
                            }
                        });
                    }
                });
            } else {
                this.getInventorySummary();
            }
        },
        searchInventorySummary: function searchInventorySummary() {
            if (this.filters.inventorySummaryNurse) {
                this.getInventorySummaryByUser();
            } else {
                this.getInventorySummary();
            }
        },
        handleInventorySummaryByUserPageChange: function handleInventorySummaryByUserPageChange(val) {
            this.inventorySummaryByUserPage = val;
            this.getInventorySummaryByUser();
        },
        handleInventoryPageChange: function handleInventoryPageChange(val) {
            this.inventoryPage = val;
            this.getInventory(this.currentInventroy);
        },
        handleInventorySummaryPageChange: function handleInventorySummaryPageChange(val) {
            this.inventorySummaryPage = val;
            this.getInventorySummary();
        },
        changeWorkingList: function changeWorkingList(val) {
            this.workingPage = val;
            this.getWorkingOutboundList();
        },
        getWorkingOutboundList: function getWorkingOutboundList() {
            var _this15 = this;

            var param = {
                current: this.workingPage,
                size: this.pageSize,
                status: 1,
                condition: this.filters.workingFilter,
                main: this.filters.workingMainFilter
            };
            this.workingLoading = true;
            (0, _outboundService.getOutboundList)(param).then(function (data) {
                _this15.workingLoading = false;
                if (data.status === 200) {
                    _this15.workingList = data.result.records;
                    _this15.workingTotal = data.result.total;
                }
            });
        },
        getTransferList: function getTransferList() {
            var _this16 = this;

            var param = {
                current: this.transferPage,
                size: this.pageSize,
                condition: this.filters.transferFilter
            };
            this.transferLoading = true;
            (0, _outboundService.getTransferList)(param).then(function (data) {
                _this16.workingLoading = false;
                if (data.status === 200) {
                    _this16.transferList = data.result.records;
                    _this16.transferTotal = data.result.total;
                }
            });
        },
        handleTabClick: function handleTabClick(tab) {
            if (tab.name === 'six') {
                this.getTrasferUserLogs();
            }
        },
        getTrasferUserLogs: function getTrasferUserLogs() {
            var _this17 = this;

            var param = {
                current: this.transferLogsPage,
                size: this.transferLogsPageSize,
                doctorNo: this.currentUser.userNo
            };
            this.transferLogsLoading = true;
            (0, _outboundService.getTransferUserInfoByDoctorNo)(param).then(function (data) {
                _this17.transferLogsLoading = false;
                if (data.status === 200) {
                    _this17.transferLogsList = data.result.records;
                    _this17.transferLogsWorkingTotal = data.result.total;
                }
            });
        },
        changeArchivedList: function changeArchivedList(val) {
            this.archivedPage = val;
            this.getArchivedOutboundList();
        },
        getArchivedOutboundList: function getArchivedOutboundList() {
            var _this18 = this;

            var param = {
                current: this.archivedPage,
                size: this.pageSize,
                status: 2,
                condition: this.filters.archivedFilter,
                main: this.filters.archivedMainFilter
            };
            this.archivedLoading = true;
            (0, _outboundService.getOutboundList)(param).then(function (data) {
                _this18.archivedLoading = false;
                if (data.status === 200) {
                    _this18.archivedList = data.result.records;
                    _this18.archivedTotal = data.result.total;
                }
            });
        },
        changeCloseList: function changeCloseList(val) {
            this.closePage = val;
            this.getCloseOutboundList();
        },
        changeTransferList: function changeTransferList(val) {
            this.transferPage = val;
            this.getTransferList();
        },
        getCloseOutboundList: function getCloseOutboundList() {
            var _this19 = this;

            var param = {
                current: this.closePage,
                size: this.pageSize,
                status: 3,
                condition: this.filters.closeFilter,
                main: this.filters.closeMainFilter
            };
            this.closeLoading = true;
            (0, _outboundService.getOutboundList)(param).then(function (data) {
                _this19.closeLoading = false;
                if (data.status === 200) {
                    _this19.closeList = data.result.records;
                    _this19.closeTotal = data.result.total;
                }
            });
        },
        changeInstruction: function changeInstruction(selected) {
            this.outbound.note = selected.instructionNote;
            this.outbound.instruction = selected.instructionText;
        },
        getInstructionList: function getInstructionList() {
            var _this20 = this;

            (0, _outboundService.getInstructionList)({}).then(function (data) {
                if (data.status === 200) {
                    _this20.instructionTemps = data.result;
                }
            });
        },
        handleAddInstruction: function handleAddInstruction() {
            var _this21 = this;

            this.$refs.addInstruction.validate(function (valid) {
                if (valid) {
                    var param = {
                        instructionName: _this21.addInstruction.name,
                        instructionText: _this21.addInstruction.text,
                        instructionNote: _this21.addInstruction.note
                    };
                    (0, _outboundService.addInstruction)(param).then(function (data) {
                        if (data.status === 200) {
                            _this21.$message.success(data.message);
                            _this21.$refs.addInstruction.resetFields();
                            _this21.addInstructionVisible = false;
                            _this21.getInstructionList();
                            _this21.getInstructionListByPage();
                        } else {
                            _this21.$message.error(data.message);
                        }
                    });
                }
            });
        },
        handleEditInstruction: function handleEditInstruction() {
            var _this22 = this;

            this.$refs.editInstructionObj.validate(function (valid) {
                if (valid) {
                    var param = {
                        instructionName: _this22.editInstructionObj.name,
                        instructionText: _this22.editInstructionObj.text,
                        instructionNote: _this22.editInstructionObj.note,
                        id: _this22.editInstructionObj.id
                    };
                    (0, _outboundService.addInstruction)(param).then(function (data) {
                        if (data.status === 200) {
                            _this22.$message.success(data.message);
                            _this22.$refs.editInstructionObj.resetFields();
                            _this22.editInstructionVisible = false;
                            _this22.getInstructionList();
                            _this22.getInstructionListByPage();
                        } else {
                            _this22.$message.error(data.message);
                        }
                    });
                }
            });
        },
        editInstruction: function editInstruction(row) {
            this.editInstructionObj.name = row.instructionName;
            this.editInstructionObj.note = row.instructionNote;
            this.editInstructionObj.text = row.instructionText;
            this.editInstructionObj.id = row.id;
            this.editInstructionVisible = true;
        },
        deleteInstruction: function deleteInstruction(id) {
            var _this23 = this;

            this.$confirm('Are you sure?', 'Warning', {
                type: 'warning'
            }).then(function () {
                var param = {
                    id: id
                };
                (0, _outboundService.deleteInstruction)(param).then(function (data) {
                    if (data.status === 200) {
                        _this23.$message.success(data.message);
                        _this23.getInstructionListByPage();
                        _this23.getInstructionList();
                    } else {
                        _this23.$message.error(data.message);
                    }
                });
            }).catch(function () {});
        },
        getNurseList: function getNurseList() {
            var _this24 = this;

            (0, _memberService.getDoctorNurse)().then(function (data) {
                if (data.status === 200) {
                    _this24.nurseList = data.result;
                }
            });
        },
        getDoctorMembers: function getDoctorMembers() {
            var _this25 = this;

            (0, _memberService.getDoctorMemberList)({}).then(function (data) {
                if (data.status === 200) {
                    _this25.members = data.result;
                }
            });
        },
        getWarehouse: function getWarehouse() {
            var _this26 = this;

            (0, _warehouseService.getCurrentWarehouse)({}).then(function (data) {
                if (data.status === 200) {
                    _this26.warehouses = data.result;
                }
            });
        },
        getInstructionListByPage: function getInstructionListByPage() {
            var _this27 = this;

            var param = {
                current: this.instructionPage,
                size: this.pageSize
            };
            this.instructionLoading = true;
            (0, _outboundService.getInstructionListByPage)(param).then(function (data) {
                _this27.instructionLoading = false;
                if (data.status === 200) {
                    _this27.instructionListPage = data.result.records;
                    _this27.instructionTotal = data.result.total;
                    _this27.instructionTemplateVisiable = true;
                }
            });
        },
        handleChangeInstructionListByPage: function handleChangeInstructionListByPage(val) {
            this.instructionPage = val;
            this.getInstructionListByPage();
        },
        showProductList: function showProductList() {
            this.fbmModelVisiable = true;
            this.getTransferProductList();
        },
        getTransferProductList: function getTransferProductList() {
            var _this28 = this;

            var param = {
                current: this.productPage,
                size: this.pageSize,
                condition: this.filters.productFilter
            };
            this.productLoading = true;
            (0, _inventoryService.getInventory)(param).then(function (res) {
                _this28.productLoading = false;
                if (res.status === 200) {
                    _this28.productList = res.result.records;
                    _this28.productTotal = res.result.total;
                }
            });
        },
        handleProductPageChange: function handleProductPageChange(val) {
            this.productPage = val;
            this.getTransferProductList();
        },
        showWarehouseFBM: function showWarehouseFBM(productNo) {
            this.fbmModelVisiable = true;
            this.currentDetailNo = productNo;
            this.getInventoryDetail();
        },
        getInventoryDetail: function getInventoryDetail() {
            var _this29 = this;

            var param = {
                current: this.fbmPage,
                size: this.pageSize,
                productName: this.filters.fbmFilter,
                productNo: this.currentDetailNo,
                warehouseOnly: "1"
            };
            this.fbmLoading = true;
            return (0, _outboundService.getInventoryList)(param).then(function (data) {
                _this29.fbmLoading = false;
                if (data.status === 200) {
                    _this29.fbmDetail = data.result.records;
                    _this29.fbmTotal = data.result.total;
                }
            });
        },
        handleInventoryDetailPageChange: function handleInventoryDetailPageChange(val) {
            this.fbmPage = val;
            this.getInventoryDetail();
        },
        showTransfer: function showTransfer(productNo, warehouseNo) {
            var _this30 = this;

            (0, _outboundService.getProductFBM)({ productId: productNo, warehouseNo: warehouseNo }).then(function (data) {
                _this30.transferModelVisiable = true;
                _this30.transferForm.to = "";
                _this30.transferForm.transferQty = "";
                if (data.status === 200) {
                    _this30.transferForm.productName = data.result.productNme;
                    _this30.transferForm.qty = data.result.qty;
                    _this30.transferForm.warehouse = data.result.warehouse;
                    _this30.transferForm.upc = data.result.upc;
                    _this30.transferForm.productNo = productNo;
                    _this30.transferForm.warehouseNo = warehouseNo;
                }
            });
        },
        transferTo: function transferTo() {
            var _this31 = this;

            this.$refs.transferForm.validate(function (valid) {
                if (valid) {
                    _this31.loading = true;
                    (0, _outboundService.transferTo)(_this31.transferForm).then(function (data) {
                        _this31.loading = false;
                        if (data.status === 200) {
                            _this31.$message.success("Transfer Success.");
                            _this31.transferModelVisiable = false;
                            _this31.getTransferProductList();
                            _this31.getInventoryDetail();
                        } else {
                            _this31.$message.error(data.message);
                        }
                    });
                }
            });
        }
    },
    mounted: function mounted() {
        this.getWorkingOutboundList();
        this.getArchivedOutboundList();
        this.getCloseOutboundList();
        this.getInstructionList();
        this.getNurseList();
        this.getDoctorMembers();
        this.getWarehouse();
        this.getTransferProductList();

        var active = this.$route.params.active;
        if (active) {
            this.activeName = active;
        }

        var user = sessionStorage.getItem('user');
        user = JSON.parse(user);
        this.currentUser = user;
    }
};

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _securityService = __webpack_require__(48);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			offers: {
				open: 0,
				proposed: 0
			},
			inbound: {
				inbound: 0,
				reported: 0
			},
			outbound: {
				outbound: 0
			},
			balance: {
				request: 0,
				requestTotal: 0,
				totalBalance: 0,
				totalPending: 0
			},
			loading: false
		};
	},

	methods: {
		getDoctorHome: function getDoctorHome() {
			var _this = this;

			this.loading = true;
			(0, _securityService.getDoctorHome)().then(function (data) {
				_this.loading = false;
				if (data.status === 200) {
					_this.offers.open = data.result.offerNum;
					_this.offers.proposed = data.result.proposeNum;
					_this.inbound.inbound = data.result.inboundNum;
					_this.inbound.reported = data.result.reportNum;
					_this.outbound.outbound = data.result.outboundNum;
					_this.balance.request = data.result.paymentNum;
					_this.balance.requestTotal = data.result.amount;
					_this.balance.totalBalance = data.result.transactionAmount;
					_this.balance.totalPending = data.result.pending;
				} else {
					_this.$message.error(data.message);
				}
			});
		}
	},
	mounted: function mounted() {
		this.getDoctorHome();
	}
};

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vueQuillEditor = __webpack_require__(74);

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _offerService = __webpack_require__(103);

var _paymentService = __webpack_require__(105);

var _option = __webpack_require__(22);

var _option2 = _interopRequireDefault(_option);

var _exportService = __webpack_require__(23);

var _globalVar = __webpack_require__(7);

var _memberService = __webpack_require__(20);

var _inputNumber = __webpack_require__(281);

var _inputNumber2 = _interopRequireDefault(_inputNumber);

var _storageFeePaymentService = __webpack_require__(209);

var _paymentService4Warehouse = __webpack_require__(208);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        ElInputNumber: _inputNumber2.default,
        ElOption: _option2.default },
    data: function data() {
        var checkAmount = function checkAmount(rule, value, callback) {
            if (value <= 0) {
                return callback(new Error('Amount must more then 0.'));
            } else {
                callback();
            }
        };
        return {
            readOlnyEditorOption: {
                theme: "snow",
                placeholder: "Note",
                height: "400px",
                readOnly: true,
                modules: {
                    toolbar: {
                        container: [["bold", "italic", "underline", "strike"]]
                    }
                }
            },
            editorOption: {
                theme: "snow",
                placeholder: "Note",
                height: "400px",
                modules: {
                    toolbar: {
                        container: [["bold", "italic", "underline", "strike"], ["link"]]
                    }
                }
            },
            banks: [],
            activeName: "first",
            filters: {
                currentUser: "",
                pendingFilter: "",
                pendingUser: "",
                paymentFilter: "",
                paymentStatus: "",
                warehousePaymentStatus: "",
                balanceFilter: "",
                historyFilter: "",
                name: '',
                user: "",
                productName: "",
                feeType: "",
                conditionSearch: ""
            },

            nurseList: [],

            firstListLoading: false,
            secondListLoading: false,
            thirdListLoading: false,
            fourthListLoading: false,
            fifthListLoading: false,

            pageSize: _globalVar.defaultPageSize,
            paymentPage: 1,
            paymentTotal: 0,

            pendingPage: 1,
            pendingTotal: 0,

            balancePage: 1,
            balanceTotal: 0,

            historyPage: 1,
            historyTotal: 0,

            warehouseFeeDetail: [],
            warehouseFeeSummary: [],

            storageFeePaymentPage: 1,
            storageFeePaymentTotal: 0,

            warehouseFeeDetailPage: 1,
            warehouseFeeDetailTotal: 0,
            warehouseFeeDetailModelVisible: false,

            warehouseFeeSummaryPage: 1,
            warehouseFeeSummaryTotal: 0,
            warehouseFeeSummaryModelVisible: false,

            warehouseFeeLoading: false,
            warehouseFeeSummaryLoading: false,
            warehouseFeeDetailId: null,
            warehouseFeeProductNo: null,

            feeTypeList: [{ id: 0, value: "Inbound" }, { id: 1, value: "Outbound" }, { id: 2, value: "Storage" }],

            offers: [],
            pendingPayments: [],
            payments: [],
            transactions: [],
            balances: [],
            storageFeePayments: [],
            total: 0,
            invitations: [],
            invitationTotalPage: 0,
            invitationPage: 1,
            listLoading: false,
            sels: [],
            requestVisible: false,
            addGroupVisible: false,
            invitationVisible: false,
            editLoading: false,
            payRule: {
                note: [{ required: true, message: 'Note is requried.', trigger: 'blur' }]
            },

            warehouseRequestVisible: false,
            warehouseStorageFeeId: null,
            paymentLoading: false,
            paymentListVisible: false,
            warehousePayments: [],
            warehousePaymentPage: 1,
            warehousePaymentTotal: 0,

            warehousePayment: {
                warehouseUserName: "",
                amount: "",
                bank: "",
                note: "",
                paymentNo: "",
                bankAddress: ""
            },

            adjustRule: {
                nurseId: [{ required: true, message: 'User is requried.', trigger: 'blur' }],
                amount: [{ required: true, message: 'Amount is requried.', trigger: 'blur' }, { validator: checkAmount, trigger: 'blur' }],
                note: [{ required: true, message: 'Note is requried.', trigger: 'blur' }]
            },

            addFormVisible: false,
            adjustVisible: false,
            loading: false,

            payment: {
                nurseName: "",
                amount: "",
                bank: "",
                note: "",
                paymentNo: "",
                bankAddress: ""
            },
            adjust: {
                nurseId: "",
                amount: 0.0,
                note: "",
                type: 1,
                balance: 0
            }
        };
    },

    methods: {
        dateFormat: function dateFormat(row, column) {
            if (row) {
                var dT = new Date(row);
                return dT.getFullYear() + "-" + (dT.getMonth() + 1) + "-" + dT.getDate();
            } else {
                return "";
            }
        },
        exportExcel: function exportExcel(url, fileName) {
            var param = {
                url: url,
                fileName: fileName
            };
            (0, _exportService.exportExcel)(param).then(function () {});
        },
        postExportExcel: function postExportExcel(url, fileName) {
            var param = {
                url: url,
                fileName: fileName,
                payNo: this.warehouseFeeDetailId,
                productNo: this.warehouseFeeProductNo,
                productName: this.filters.productName,
                feeType: this.filters.feeType,
                condition: this.filters.conditionSearch
            };
            (0, _exportService.postExportExcel)(param).then(function () {});
        },

        formatMoney: function formatMoney(s, n) {
            n = n > 0 && n <= 20 ? n : 2;
            s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
            var l = s.split(".")[0].split("").reverse();
            var r = s.split(".")[1];
            var t = "";
            if (s < 0) {
                l = (Math.abs(s.split(".")[0]) + "").split("").reverse();
            }
            for (var i = 0; i < l.length; i++) {
                t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "");
            }
            if (s < 0) {
                t += "-";
            }
            var result = t.split("").reverse().join("") + "." + r;
            if (result == null || result == undefined || result.indexOf('NaN') >= 0 || result.indexOf('Undefined') >= 0) {
                result = '0.00';
            }
            return result;
        },
        tableRowClassName: function tableRowClassName(_ref) {
            var row = _ref.row,
                rowIndex = _ref.rowIndex;

            if (row.amount < 0 || row.total < 0) {
                return 'reported-row';
            } else {
                return 'green-row';
            }
        },
        changePaymentRequest: function changePaymentRequest(val) {
            this.paymentPage = val;
            this.getPaymentRequest();
        },
        changePendingRequest: function changePendingRequest(val) {
            this.pendingPage = val;
            this.getPendingTransaction();
        },
        changeBalance: function changeBalance(val) {
            this.balancePage = val;
            this.getBalance();
        },
        changeTransactionHistory: function changeTransactionHistory(val) {
            this.historyPage = val;
            this.getTransactionHistory();
        },
        changeStorageFeePayment: function changeStorageFeePayment(val) {
            this.storageFeePaymentPage = val;
            this.getStorageFeePaymentList();
        },
        changeWarehouseFeeDetail: function changeWarehouseFeeDetail(val) {
            this.warehouseFeeDetailPage = val;
            this.getStorageFeePaymentDetail(this.warehouseFeeProductNo, val);
        },
        changeWarehouseFeeSummary: function changeWarehouseFeeSummary(val) {
            this.warehouseFeeSummaryPage = val;
            this.getStorageFeePaymentSummary(this.warehouseFeeDetailId);
        },
        getTransactionHistory: function getTransactionHistory() {
            var _this = this;

            var param = {
                current: this.historyPage,
                size: this.pageSize,
                nurseNo: this.filters.currentUser,
                condition: this.filters.historyFilter
            };
            this.thirdListLoading = true;
            (0, _paymentService.getTransactionHistory)(param).then(function (data) {
                _this.thirdListLoading = false;
                if (data.status === 200) {
                    _this.transactions = data.result.records;
                    _this.historyTotal = data.result.total;
                }
            });
        },
        getNurseList: function getNurseList() {
            var _this2 = this;

            (0, _memberService.getDoctorNurse)().then(function (data) {
                if (data.status === 200) {
                    _this2.nurseList = data.result;
                }
            });
        },
        editPaymentStatus: function editPaymentStatus(paymentNo, status) {
            var _this3 = this;

            this.$confirm("Are you sure?", "Warning", {
                type: "warning"
            }).then(function () {
                var param = {
                    paymentNo: paymentNo,
                    status: status
                };
                (0, _paymentService.editPaymentStatus)(param).then(function (data) {
                    if (data.status === 200) {
                        _this3.$message.success(data.message);
                        _this3.getPaymentRequest();
                    }
                });
            }).catch(function () {});
        },
        editWarehousePaymentStatus: function editWarehousePaymentStatus(paymentNo, status) {
            var _this4 = this;

            var param = {
                paymentNo: paymentNo,
                status: status
            };
            this.loading = true;
            (0, _paymentService4Warehouse.editPaymentStatus4Warehouse)(param).then(function (data) {
                if (data.status === 200) {
                    _this4.$message.success(data.message);
                    _this4.getPaymentRequest4Warehouse();
                }
                _this4.loading = false;
            });
        },
        requestPayment: function requestPayment(id) {
            var _this5 = this;

            (0, _paymentService.queryPaymentById)({ paymentNo: id }).then(function (data) {
                if (data.status === 200) {
                    _this5.payment.paymentNo = data.result.paymentNo;
                    _this5.payment.nurseName = data.result.nurseName;
                    _this5.payment.amount = data.result.amount;
                    _this5.payment.bank = data.result.accountType + " " + data.result.accountNumber;
                    _this5.payment.bankAddress = data.result.bankAddress;
                    _this5.requestVisible = true;
                }
            });
        },
        pay: function pay() {
            var _this6 = this;

            this.$refs.payment.validate(function (valid) {
                if (valid) {
                    _this6.loading = true;
                    var param = {
                        paymentNo: _this6.payment.paymentNo,
                        note: _this6.payment.note
                    };
                    (0, _paymentService.pay)(param).then(function (data) {
                        _this6.loading = false;
                        if (data.status === 200) {
                            _this6.$message.success(data.message);
                            _this6.requestVisible = false;
                            _this6.$refs.payment.resetFields();
                            _this6.getPaymentRequest();
                            _this6.getTransactionHistory();
                            _this6.getBalance();
                        } else {
                            _this6.$message.error(data.message);
                        }
                    });
                }
            });
        },
        requestWarehousePayment: function requestWarehousePayment(id) {
            var _this7 = this;

            (0, _paymentService4Warehouse.queryPaymentById4Warehouse)({ paymentNo: id }).then(function (data) {
                if (data.status === 200) {
                    _this7.warehousePayment.paymentNo = data.result.paymentNo;
                    _this7.warehousePayment.totalFee = data.result.totalFee;
                    _this7.warehousePayment.warehouseNote = data.result.warehouseNote;
                    _this7.warehousePayment.warehouseUserName = data.result.warehouseUserName;
                    _this7.warehousePayment.amount = data.result.amount;
                    _this7.warehousePayment.bank = data.result.accountType + " " + data.result.accountNumber;
                    _this7.warehousePayment.bankAddress = data.result.bankAddress;
                    _this7.warehouseRequestVisible = true;
                }
            });
        },
        toWarehousePay: function toWarehousePay() {
            var _this8 = this;

            this.$refs.warehousePayment.validate(function (valid) {
                if (valid) {
                    _this8.loading = true;
                    var param = {
                        paymentNo: _this8.warehousePayment.paymentNo,
                        note: _this8.warehousePayment.note
                    };
                    (0, _paymentService4Warehouse.pay4Warehouse)(param).then(function (data) {
                        _this8.loading = false;
                        if (data.status === 200) {
                            _this8.$message.success(data.message);
                            _this8.warehouseRequestVisible = false;
                            _this8.$refs.warehousePayment.resetFields();
                            _this8.paymentListVisible = false;
                            _this8.getStorageFeePaymentList();
                        } else {
                            _this8.$message.error(data.message);
                        }
                    });
                }
            });
        },
        requestStorageFeePayment: function requestStorageFeePayment(id) {
            var _this9 = this;

            this.$confirm("Are you sure?", "Warning", {
                type: "warning"
            }).then(function () {
                _this9.loading = true;
                var param = {
                    id: id
                };
                (0, _storageFeePaymentService.storageFeePay)(param).then(function (data) {
                    _this9.loading = false;
                    if (data.status === 200 && data.result.flag) {
                        _this9.$message.success(data.message);
                        _this9.getStorageFeePaymentList();
                    } else {
                        _this9.$message.error(data.message);
                    }
                });
            });
        },
        getBalance: function getBalance() {
            var _this10 = this;

            var param = {
                current: this.balancePage,
                size: this.pageSize,
                userNo: this.filters.balanceFilter
            };
            this.fourthListLoading = true;
            (0, _paymentService.getBalance)(param).then(function (data) {
                _this10.fourthListLoading = false;
                if (data.status === 200) {
                    _this10.balances = data.result.records;
                    _this10.balanceTotal = data.result.total;
                }
            });
        },
        changeOfferSelect: function changeOfferSelect() {},
        handleClick: function handleClick() {},
        getPendingTransaction: function getPendingTransaction() {
            var _this11 = this;

            var param = {
                current: this.pendingPage,
                size: this.pageSize,
                condition: this.filters.pendingFilter,
                userNo: this.filters.pendingUser
            };
            this.secondListLoading = true;
            (0, _paymentService.getPendingTransaction)(param).then(function (data) {
                _this11.secondListLoading = false;
                if (data.status === 200) {
                    _this11.pendingPayments = data.result.records;
                    _this11.pendingTotal = data.result.total;
                }
            });
        },
        getPaymentRequest: function getPaymentRequest() {
            var _this12 = this;

            var param = {
                current: this.paymentPage,
                size: this.pageSize,
                condition: this.filters.paymentFilter,
                status: this.filters.paymentStatus
            };
            this.firstListLoading = true;
            (0, _paymentService.getPaymentRequest)(param).then(function (data) {
                _this12.firstListLoading = false;
                if (data.status === 200) {
                    _this12.payments = data.result.records;
                    _this12.paymentTotal = data.result.total;
                }
            });
        },
        getPaymentRequest4Warehouse: function getPaymentRequest4Warehouse() {
            var _this13 = this;

            var user = JSON.parse(sessionStorage.getItem("user"));
            var param = {
                current: this.warehousePaymentPage,
                size: this.pageSize,
                status: this.filters.warehousePaymentStatus,
                doctorNo: user.userNo,
                storageFeeId: this.warehouseStorageFeeId
            };
            this.firstListLoading = true;
            (0, _paymentService4Warehouse.getPaymentRequest4Warehouse)(param).then(function (data) {
                _this13.firstListLoading = false;
                if (data.status === 200) {
                    _this13.warehousePayments = data.result.records;
                    _this13.paymentTotal = data.result.total;
                }
            });
        },
        getStorageFeePaymentList: function getStorageFeePaymentList() {
            var _this14 = this;

            var param = {
                current: this.storageFeePaymentPage,
                size: this.pageSize
            };
            this.fifthListLoading = true;
            (0, _storageFeePaymentService.getDoctorList)(param).then(function (data) {
                _this14.fifthListLoading = false;
                if (data.status === 200) {
                    _this14.storageFeePayments = data.result.records;
                    _this14.storageFeePaymentTotal = data.result.total;
                }
            });
        },
        getStorageFeePaymentDetail: function getStorageFeePaymentDetail(productNo, page) {
            var _this15 = this;

            this.warehouseFeeDetailPage = page;
            if (productNo) {
                this.warehouseFeeProductNo = productNo;
            }
            var param = {
                current: page,
                size: this.pageSize,
                payNo: this.warehouseFeeDetailId,
                productNo: this.warehouseFeeProductNo,
                productName: this.filters.productName,
                feeType: this.filters.feeType
            };
            this.warehouseFeeDetailModelVisible = true;
            this.warehouseFeeLoading = true;
            (0, _storageFeePaymentService.warehouseFeeDetail)(param).then(function (data) {
                _this15.warehouseFeeLoading = false;
                if (data.status === 200) {
                    _this15.warehouseFeeDetail = data.result.records;
                    _this15.warehouseFeeDetailTotal = data.result.total;
                }
            });
        },
        getStorageFeePaymentSummary: function getStorageFeePaymentSummary(id) {
            var _this16 = this;

            this.warehouseFeeDetailId = id;
            var param = {
                current: this.warehouseFeeSummaryPage,
                size: this.pageSize,
                payNo: id,
                condition: this.filters.conditionSearch
            };
            this.warehouseFeeSummaryModelVisible = true;
            this.warehouseFeeSummaryLoading = true;
            (0, _storageFeePaymentService.warehouseFeeSummary)(param).then(function (data) {
                _this16.warehouseFeeSummaryLoading = false;
                if (data.status === 200) {
                    _this16.warehouseFeeSummary = data.result.records;
                    _this16.warehouseFeeSummaryTotal = data.result.total;
                }
            });
        },
        showAdjust: function showAdjust() {
            this.adjust.amount = 0.0;
            this.adjust.type = 1;
            this.adjust.nurseId = "";
            this.adjust.note = "";
            this.adjustVisible = true;
        },
        getNusreBalance: function getNusreBalance() {
            var _this17 = this;

            if (this.adjust.nurseId) {
                var user = JSON.parse(sessionStorage.getItem("user"));
                var param = {
                    doctorNo: user.userNo,
                    nurseNo: this.adjust.nurseId
                };
                (0, _memberService.getUserBalance)(param).then(function (res) {
                    if (res.status === 200) {
                        _this17.adjust.balance = res.result.balance;
                    }
                });
            } else {
                this.adjust.balance = 0.0;
            }
        },
        addAdjust: function addAdjust() {
            var _this18 = this;

            this.$refs.adjust.validate(function (valid) {
                if (valid) {
                    _this18.loading = true;
                    var amount = _this18.adjust.amount;
                    if (_this18.adjust.type == "1") {
                        amount = amount * -1;
                    }
                    console.log(_this18.adjust.amount);
                    var param = {
                        nurseId: _this18.adjust.nurseId,
                        amount: amount,
                        note: _this18.adjust.note
                    };

                    (0, _paymentService.addAdjust)(param).then(function (data) {
                        _this18.loading = false;
                        if (data.status === 200) {
                            _this18.adjustVisible = false;
                            _this18.$message.success("Success");
                            _this18.getTransactionHistory();
                            _this18.getBalance();
                        } else {
                            _this18.$message.error(data.message);
                        }
                    });
                }
            });
        },
        showAddWarehousePayment: function showAddWarehousePayment(id) {
            var _this19 = this;

            this.warehouseStorageFeeId = id;
            var user = JSON.parse(sessionStorage.getItem("user"));
            var param = {
                current: this.warehousePaymentPage,
                size: this.pageSize,
                status: this.filters.warehousePaymentStatus,
                doctorNo: user.userNo,
                storageFeeId: id
            };
            (0, _paymentService4Warehouse.getPaymentRequest4Warehouse)(param).then(function (data) {
                _this19.paymentLoading = false;
                _this19.isPaymentPending = false;
                if (data.status === 200) {
                    _this19.paymentListVisible = true;
                    _this19.warehousePayments = data.result.records;
                    _this19.paymentTotal = data.result.total;
                    for (var i = 0; i < _this19.warehousePayments.length; i++) {
                        var p = _this19.warehousePayments[i];
                        if (p.status == 0 || p.status == 1) {
                            _this19.isPaymentPending = true;
                            break;
                        }
                    }
                }
            });
        }
    },
    mounted: function mounted() {
        this.getNurseList();
        this.getPendingTransaction();
        this.getPaymentRequest();
        this.getBalance();
        this.getTransactionHistory();
        this.getStorageFeePaymentList();
        var active = this.$route.params.active;
        if (active) {
            this.activeName = active;
        }
    }
};

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vueQuillEditor = __webpack_require__(74);

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _warehouseService = __webpack_require__(59);

var _option = __webpack_require__(22);

var _option2 = _interopRequireDefault(_option);

var _globalVar = __webpack_require__(7);

var _exportService = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { ElOption: _option2.default },
    data: function data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: 'MTD',
                    onClick: function onClick(picker) {
                        picker.$emit('pick', [new Date(), new Date()]);
                    }
                }, {
                    text: 'YTD',
                    onClick: function onClick(picker) {
                        var end = new Date();
                        var start = new Date(new Date().getFullYear(), 0);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            banks: [],
            activeName: "first",
            filters: {
                warehouse: "",
                date: "",
                product: ""
            },

            firstListLoading: false,

            pageSize: _globalVar.defaultPageSize,
            page: 1,
            total: 0,
            listLoading: false,

            list: [],
            warehouseList: []

        };
    },

    methods: {
        exportExcel: function exportExcel(url, fileName) {
            var param = {
                url: url,
                fileName: fileName
            };
            (0, _exportService.postExportExcel)(param).then(function () {});
        },

        formatMoney: function formatMoney(s, n) {
            n = n > 0 && n <= 20 ? n : 2;
            s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
            var l = s.split(".")[0].split("").reverse();
            var r = s.split(".")[1];
            var t = "";
            if (s < 0) {
                l = (Math.abs(s.split(".")[0]) + "").split("").reverse();
            }
            for (var i = 0; i < l.length; i++) {
                t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "");
            }
            if (s < 0) {
                t += "-";
            }
            var result = t.split("").reverse().join("") + "." + r;
            if (result == null || result == undefined || result.indexOf('NaN') >= 0 || result.indexOf('Undefined') >= 0) {
                result = '0.00';
            }
            return result;
        },
        getWarehouseList: function getWarehouseList() {
            var _this = this;

            (0, _warehouseService.getCurrentWarehouse)({}).then(function (data) {
                if (data.status === 200) {
                    _this.warehouseList = data.result;
                }
            });
        },
        changePage: function changePage(val) {
            this.page = val;
            this.getList();
        },
        getList: function getList() {
            var _this2 = this;

            var param = {
                current: this.page,
                size: this.pageSize,
                warehouse: this.filters.warehouse,
                product_name: this.filters.product
            };
            if (this.filters.date) {
                param.startDate = this.filters.date[0];
                param.endDate = this.filters.date[1];
            }
            this.listLoading = true;
            (0, _warehouseService.getStorageFeeList)(param).then(function (data) {
                _this2.listLoading = false;
                if (data.status === 200) {
                    _this2.list = data.result.records;
                    _this2.total = data.result.total;
                }
            });
        }
    },
    mounted: function mounted() {
        this.getList();
        this.getWarehouseList();
    }
};

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _memberService = __webpack_require__(20);

var _globalVar = __webpack_require__(7);

var _option = __webpack_require__(22);

var _option2 = _interopRequireDefault(_option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { ElOption: _option2.default },
    data: function data() {
        return {
            loading: false,
            firstLoading: false,
            secondLoading: false,
            thirdLoading: false,
            pageSize: _globalVar.defaultPageSize,

            nurseList: [],

            activeName: "first",

            filters: {
                invitationEmail: "",
                groupCondition: "",
                username: '',
                status: ""
            },

            memberList: [],

            editGroupVisible: false,
            editGroupObj: {
                groupNo: '',
                groupName: "",
                users: [],
                pendingTransaction: 7,
                pendingAmount: ""
            },

            groups: [],
            groupTotalPage: 0,
            groupPage: 1,

            invitations: [],

            total: 0,

            invitationFilter: "",
            invitationTotalPage: 0,
            invitationPage: 1,

            membersFilter: "",
            membersTotalPage: 0,
            membersPage: 1,

            sels: [],
            editMemberObj: {},
            editMemberVisible: false,
            addGroupVisible: false,
            invitationVisible: false,

            editLoading: false,
            editFormRules: {
                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
            },
            groupFormRules: {
                groupName: [{ required: true, message: 'Group Name is required.', trigger: 'blur' }]
            },

            editForm: {
                id: 0,
                name: '',
                sex: -1,
                age: 0,
                birth: '',
                addr: ''
            },

            addFormVisible: false,
            invitationRules: {
                role: [{ required: true, message: 'Role is required.', trigger: 'blur' }],
                email: [{ required: true, message: 'Email is required.', trigger: 'blur' }, { validator: _util2.default.validateEmail, trigger: 'blur' }]
            },

            member: {
                id: "",
                userName: "",
                email: "",
                phone: "",
                status: "",
                pendingTransaction: 7,
                pendingAmount: "",
                alias: "",
                minPayment: 0
            },
            group: {
                id: '',
                groupName: "",
                users: [],
                pendingTransaction: 7,
                pendingAmount: "",
                minPayment: 0
            },
            invitation: {
                id: "",
                email: "",
                status: "",
                dateTime: "",
                role: ""
            }

        };
    },

    methods: {
        handleClick: function handleClick(tab, event) {
            if (tab.paneName === "first" && this.memberList.length === 0) {
                this.getDoctorMembers();
            } else if (tab.paneName === "second" && this.groups.length === 0) {} else if (tab.paneName === "third" && this.invitations.length === 0) {
                this.getInvitations();
            }
        },
        formatRole: function formatRole(row, column) {
            if (row.status === 0) {
                return "Pending";
            } else if (row.status === 1) {
                return "Approve";
            } else {
                return "Reject";
            }
        },
        formatMemberStatus: function formatMemberStatus(row, column) {
            if (row.status === "1") {
                return "Active";
            } else if (row.status === "2") {
                return "Limited";
            } else if (row.status === "3") {
                return "Blocked";
            }
        },
        formatTimesTamp: function formatTimesTamp(row, column) {
            return _util2.default.formatDate.format(new Date(row.createDate), 'yyyy-MM-dd hh:mm:ss');
        },
        showEditGroup: function showEditGroup(groupNo) {
            var _this = this;

            (0, _memberService.getDoctorMemberList)({ roleId: 2 }).then(function (res) {
                _this.nurseList = res.result;
                return (0, _memberService.getGroupById)({ groupNo: groupNo });
            }).then(function (res) {
                if (res.status === 200) {
                    var users = [];
                    res.result.userList.forEach(function (item) {
                        users.push(item.userNo);
                    });
                    _this.editGroupObj.users = users;
                    _this.editGroupObj.groupName = res.result.groupName;
                    _this.editGroupObj.pendingTransaction = res.result.transactions;
                    _this.editGroupObj.pendingAmount = res.result.amount;
                    _this.editGroupObj.groupNo = res.result.groupNo;
                    _this.editGroupObj.minPayment = res.result.minPayment;
                    _this.editGroupVisible = true;
                } else {
                    _this.$message({
                        message: res.message,
                        type: "error"
                    });
                }
            });
        },
        showAddGroup: function showAddGroup() {
            var _this2 = this;

            (0, _memberService.getDoctorMemberList)({ roleId: 2 }).then(function (res) {
                if (res.status === 200) {
                    _this2.nurseList = res.result;
                    _this2.addGroupVisible = true;
                }
            });
        },
        getDoctorMembers: function getDoctorMembers() {
            var _this3 = this;

            this.firstLoading = true;
            var para = {
                current: this.membersPage,
                size: this.pageSize,
                userName: this.filters.username,
                status: this.filters.status
            };
            (0, _memberService.getDoctorMembers)(para).then(function (res) {
                _this3.firstLoading = false;
                if (res.status === 200) {
                    _this3.memberList = res.result.records;
                    _this3.membersTotalPage = res.result.total;
                } else {
                    _this3.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        showEditMember: function showEditMember(member) {
            var _this4 = this;

            (0, _memberService.getMembersById)({ membetId: member.membetId }).then(function (res) {
                if (res.status === 200) {
                    _this4.editMemberObj = {
                        id: "",
                        userName: member.username,
                        email: member.email,
                        status: res.result.member.status,
                        pendingTransaction: res.result.member.transactions,
                        pendingAmount: res.result.member.amount,
                        alias: res.result.member.alias,
                        memberId: res.result.member.memberId,
                        membetId: res.result.member.membetId,
                        doctorId: res.result.member.doctorId,
                        minPayment: res.result.member.minPayment
                    };
                    _this4.editMemberVisible = true;
                }
            }).catch(function (err) {});
        },
        editMember: function editMember() {
            var _this5 = this;

            var params = {
                membetId: this.editMemberObj.membetId,
                doctorId: this.editMemberObj.doctorId,
                memberId: this.editMemberObj.memberId,
                status: this.editMemberObj.status,
                transactions: this.editMemberObj.pendingTransaction,
                amount: this.editMemberObj.pendingAmount,
                alias: this.editMemberObj.alias,
                minPayment: this.editMemberObj.minPayment
            };
            this.loading = true;
            (0, _memberService.editMember)(params).then(function (res) {
                _this5.loading = false;
                if (res.status === 200) {
                    _this5.$message({
                        message: res.message,
                        type: "success"
                    });
                    _this5.editMemberVisible = false;
                    _this5.getDoctorMembers();
                } else {
                    _this5.$message({
                        message: res.message,
                        type: "error"
                    });
                }
            });
        },
        handleInvitationPageChange: function handleInvitationPageChange(val) {
            this.invitationPage = val;
            this.getInvitations();
        },
        handleMembersPageChange: function handleMembersPageChange(val) {
            this.membersPage = val;
            this.getDoctorMembers();
        },
        handleGroupPageChange: function handleGroupPageChange(val) {
            this.groupPage = val;
            this.getGroupList();
        },
        getInvitations: function getInvitations() {
            var _this6 = this;

            var para = {
                current: this.invitationPage,
                size: this.pageSize,
                condition: this.filters.invitationEmail
            };

            this.thirdLoading = true;
            (0, _memberService.getInvitations)(para).then(function (res) {
                _this6.thirdLoading = false;
                if (res.status === 200) {
                    _this6.invitations = res.result.records;
                    _this6.invitationTotalPage = res.result.total;
                } else {
                    _this6.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        invitationRegister: function invitationRegister(param) {
            var _this7 = this;

            this.$refs.invitation.validate(function (valid) {
                if (valid) {
                    _this7.loading = true;
                    (0, _memberService.invitationRegister)({ roleId: _this7.invitation.role, email: _this7.invitation.email }).then(function (res) {
                        _this7.loading = false;
                        if (res.status === 200) {
                            _this7.$message({
                                message: 'Success',
                                type: 'success'
                            });
                            _this7.invitationVisible = false;
                            _this7.getInvitations();
                            _this7.$refs.invitation.resetFields();
                        } else {
                            _this7.$message({
                                message: res.message,
                                type: 'error'
                            });
                        }
                    }).catch(function (error) {
                        console.log(error);
                        _this7.loading = false;
                    });
                }
            });
        },
        editGroup: function editGroup() {
            var _this8 = this;

            this.$refs.editGroupObj.validate(function (valid) {
                if (valid) {
                    _this8.loading = true;
                    var params = {
                        groupName: _this8.editGroupObj.groupName,
                        userIds: _this8.editGroupObj.users.join(","),
                        transactions: _this8.editGroupObj.pendingTransaction,
                        amount: _this8.editGroupObj.pendingAmount,
                        groupNo: _this8.editGroupObj.groupNo,
                        minPayment: _this8.editGroupObj.minPayment
                    };
                    (0, _memberService.addGroup)(params).then(function (res) {
                        _this8.loading = false;
                        if (res.status === 200) {
                            _this8.$message({
                                message: res.message,
                                type: "success"
                            });
                            _this8.editGroupVisible = false;
                            _this8.getGroupList();
                        } else {
                            _this8.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    });
                }
            });
        },
        addGroup: function addGroup() {
            var _this9 = this;

            this.$refs.group.validate(function (valid) {
                if (valid) {
                    _this9.loading = true;
                    console.log(_this9.group);
                    var params = {
                        groupName: _this9.group.groupName,
                        userIds: _this9.group.users.join(","),
                        transactions: _this9.group.pendingTransaction,
                        amount: _this9.group.pendingAmount,
                        minPayment: _this9.group.minPayment
                    };
                    (0, _memberService.addGroup)(params).then(function (res) {
                        _this9.loading = false;
                        if (res.status === 200) {
                            _this9.$message({
                                message: res.message,
                                type: "success"
                            });
                            _this9.$refs.group.resetFields();
                            _this9.addGroupVisible = false;
                            _this9.getGroupList();
                        } else {
                            _this9.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    });
                }
            });
        },
        getGroupList: function getGroupList() {
            var _this10 = this;

            var params = {
                current: this.groupPage,
                size: this.pageSize,
                condition: this.filters.groupCondition
            };
            this.secondLoading = true;
            (0, _memberService.getGroupList)(params).then(function (res) {
                _this10.secondLoading = false;
                if (res.status === 200) {
                    _this10.groups = res.result.records;
                    _this10.groupTotalPage = res.result.total;
                }
            }).catch(function (err) {
                console.log(err);
                _this10.secondLoading = false;
            });
        },
        deleteGroup: function deleteGroup(id) {
            var _this11 = this;

            this.$confirm("Are you sure?", "warning", {
                type: "warning"
            }).then(function () {
                (0, _memberService.deleteGroup)({ groupNo: id }).then(function (res) {
                    if (res.status === 200) {
                        _this11.$message({
                            message: res.message,
                            type: "success"
                        });
                        _this11.getGroupList();
                    } else {
                        _this11.$message({
                            message: res.message,
                            type: "error"
                        });
                    }
                });
            }).catch(function (err) {
                return console.log(err);
            });
        }
    },
    mounted: function mounted() {
        this.getDoctorMembers();
        this.getGroupList();
    }
};

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _warehouseService = __webpack_require__(59);

var _globalVar = __webpack_require__(7);

var _memberService = __webpack_require__(20);

var _option = __webpack_require__(22);

var _option2 = _interopRequireDefault(_option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { ElOption: _option2.default },
    data: function data() {
        return {
            filters: {
                name: ''
            },
            adminList: [],
            editWarehouseObj: {},
            warehouses: [],

            listLoading: false,
            editFormVisible: false,
            editLoading: false,
            formRules: {
                state: [{ required: true, message: 'State is required', trigger: 'blur' }],
                city: [{ required: true, message: 'City is required', trigger: 'blur' }],
                address: [{ required: true, message: 'Address is required', trigger: 'blur' }],
                zipCode: [{ required: true, message: 'Zip Code is required', trigger: 'blur' }],
                adminNo: [{ required: true, message: 'Admin is required', trigger: 'blur' }],
                transferAddrKeyWold: [{ min: 3, max: 200, message: '长度在 3 到 200 个字符', trigger: 'blur' }]
            },
            addFormVisible: false,
            addLoading: false,

            warehouseForm: {
                state: '',
                city: '',
                address: '',
                zipCode: '',
                adminNo: '',
                isVisiable: "0",
                transferAddrKeyWold: ''
            },

            page: 1,
            pageSize: _globalVar.defaultPageSize,
            total: 0

        };
    },

    methods: {
        formatAddress: function formatAddress(row, column) {
            return row.address + " " + row.city + " " + row.state;
        },
        pageChange: function pageChange(val) {
            this.page = val;
            this.getWarehouses();
        },
        getAdminList: function getAdminList() {
            var _this = this;

            (0, _memberService.getDoctorMemberList)({ roleId: 3 }).then(function (res) {
                if (res.status === 200) {
                    _this.adminList = res.result;
                }
            });
        },
        deleteWarehouses: function deleteWarehouses(id) {
            var _this2 = this;

            this.$confirm("Are you sure?", "Warning", {
                type: "warning"
            }).then(function () {
                var param = {
                    warehouseNo: id
                };
                (0, _warehouseService.deleteWarehouses)(param).then(function (res) {
                    if (res.status === 200) {
                        _this2.$message({
                            message: res.message,
                            type: 'success'
                        });
                        _this2.getWarehouses();
                    } else {
                        _this2.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            }).catch(function () {});
        },
        getWarehousesById: function getWarehousesById(id) {
            var _this3 = this;

            var param = {
                warehouseNo: id
            };
            (0, _warehouseService.getWarehousesById)(param).then(function (res) {
                if (res.status === 200) {
                    _this3.editWarehouseObj = res.result.warehouse;
                    _this3.editWarehouseObj.isVisiable = _this3.editWarehouseObj.isVisiable.toString();
                    _this3.editFormVisible = true;
                } else {
                    _this3.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        getWarehouses: function getWarehouses() {
            var _this4 = this;

            this.listLoading = true;
            var param = {
                current: this.page,
                size: this.pageSize,
                condition: this.filters.name
            };
            (0, _warehouseService.getWarehouses)(param).then(function (res) {
                _this4.listLoading = false;
                if (res.status === 200) {
                    _this4.warehouses = res.result.records;
                    _this4.total = res.result.total;
                } else {
                    _this4.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            }).catch(function (error) {
                _this4.listLoading = false;
                console.log(error);
            });
        },
        addWarehouse: function addWarehouse() {
            var _this5 = this;

            this.$refs.warehouseForm.validate(function (valid) {
                if (valid) {
                    _this5.addLoading = true;
                    (0, _warehouseService.addWarehouses)(_this5.warehouseForm).then(function (res) {
                        _this5.addLoading = false;
                        if (res.status === 200) {
                            _this5.$refs["warehouseForm"].resetFields();
                            _this5.$message({
                                message: res.message,
                                type: 'success'
                            });
                            _this5.addFormVisible = false;
                            _this5.getWarehouses();
                        } else {
                            _this5.$message({
                                message: res.message,
                                type: 'error'
                            });
                        }
                    }).catch(function (err) {
                        console.log(err);
                        _this5.addLoading = false;
                    });
                }
            });
        },
        editWarehouse: function editWarehouse() {
            var _this6 = this;

            this.$refs.editWarehouseObj.validate(function (valid) {
                if (valid) {
                    _this6.addLoading = true;
                    (0, _warehouseService.addWarehouses)(_this6.editWarehouseObj).then(function (res) {
                        _this6.addLoading = false;
                        if (res.status === 200) {
                            _this6.$message({
                                message: res.message,
                                type: 'success'
                            });
                            _this6.editFormVisible = false;
                            _this6.getWarehouses();
                        } else {
                            _this6.$message({
                                message: res.message,
                                type: 'error'
                            });
                        }
                    }).catch(function (err) {
                        console.log(err);
                        _this6.addLoading = false;
                    });
                }
            });
        }
    },
    mounted: function mounted() {
        this.getWarehouses();
        this.getAdminList();
    }
};

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _securityService = __webpack_require__(48);

var inviteId = "";
var validate = false;
exports.default = {
    data: function data() {
        return {
            validate: validate,
            loading: false,
            ruleForm2: {
                username: '',
                email: ''
            },
            rules2: {
                username: [{ required: true, message: 'Please enter username', trigger: 'blur' }],
                email: [{ required: true, message: 'Please enter email', trigger: 'blur' }]
            },
            checked: true
        };
    },

    methods: {
        validatePassword: function validatePassword(rule, value, callback) {
            if (this.ruleForm2.password !== this.ruleForm2.rePassword) {
                callback(new Error('Password not match.'));
            } else {
                callback();
            }
        },
        submitRegister: function submitRegister() {},
        handleSubmit: function handleSubmit(ev) {
            var _this2 = this;

            var _this = this;
            this.$refs.ruleForm2.validate(function (valid) {
                if (valid) {
                    _this2.loading = true;
                    var params = {
                        userName: _this2.ruleForm2.username,
                        email: _this2.ruleForm2.email
                    };
                    (0, _securityService.requestForgetPassword)(params).then(function (data) {
                        _this2.loading = false;
                        if (data.status === 200) {
                            _this2.$message.success("Email Send Success.");
                        } else {
                            _this2.$message.error(data.message);
                        }
                    }).catch(function (error) {
                        _this2.loading = false;
                        console.log(error);
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    }
};

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _memberService = __webpack_require__(20);

var _inboundService = __webpack_require__(102);

var _inventoryService = __webpack_require__(75);

var _globalVar = __webpack_require__(7);

var _exportService = __webpack_require__(23);

var _button = __webpack_require__(99);

var _button2 = _interopRequireDefault(_button);

var _input = __webpack_require__(100);

var _input2 = _interopRequireDefault(_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        ElInput: _input2.default,
        ElButton: _button2.default },
    created: function created() {
        var _this = this;

        this.$on('changeDoctor', function (value) {
            setTimeout(function () {
                _this.getNurseConfirmList();
                _this.getInboundHistoryList();
                _this.getReportList();
            }, 300);
        });
    },
    data: function data() {
        return {
            text: "",
            headers: {
                Authorization: window.sessionStorage.getItem("authorization")
            },
            uploadUrl: _globalVar.serverUrl + "/multiExcel/batchNurseInboundExcelImport",
            placeholder: "trackNum\r\n" + "trackNum",
            currentCompany: "",
            activeName: "first",
            filters: {
                reportStatus: "",
                reportFilter: "",
                historyFilter: "",
                confirmInboundFilter: "",
                name: ''
            },

            cancel: {
                inboundNo: "",
                cancelNum: 0
            },

            loading: false,
            modalLoading: false,
            firstListLoading: false,
            secondListLoading: false,
            thirdListLoading: false,

            pageSize: _globalVar.defaultPageSize,

            historyPage: 1,
            historyTotal: 0,

            confirmInboundPage: 1,
            confirmInboundTotal: 0,

            reportPage: 1,
            reportTotal: 0,

            confirmInbound: [],
            reportedInbound: [],
            inboundHistory: [],
            total: 0,
            page: 1,
            listLoading: false,

            textImportVisible: false,
            excelImportVisible: false,
            cancelInboundVisible: false,
            unClaimedTrackingVisiable: false,

            selfConfirm: {
                inboundNo: "",
                productName: "",
                company: "",
                price: "",
                num: "",
                leftNum: "",
                quantity: "",
                warehouse: ""

            },
            selfConfirmVisible: false,

            warehouseConfirm: {
                confirmed: false,
                loading: false,
                inboundNo: "",
                productName: "",
                company: "",
                price: "",
                num: "",
                leftNum: "",
                quantity: "",
                warehouse: "",
                trackingNumbers: [],
                trackingNumbersPage: [],
                trackingStatus: "All",
                unClaimedList: [],
                claimedList: [],
                unMatchedList: [],
                bulkConfirmSize: 0,
                total: 0,
                currentPage: 1
            },
            trackingNumbers: [],
            warehouseConfirmVisible: false,

            editLoading: false,

            addFormVisible: false,
            addLoading: false,
            inboundFormRules: {
                quantity: [{ required: true, message: 'Inbound quantity is required.', trigger: 'blur' }, { required: true, message: 'Inbound quantity must more than 1.', trigger: 'blur' }, { validator: this.checkQuantity, trigger: 'blur' }]
            },
            addFormRules: {},
            uploadData: {
                inboundNo: ""
            },
            unClaimedTracking: "",
            removeMultipleSelection: "" };
    },

    methods: {
        preview: function preview() {
            this.modalLoading = true;
        },
        getUnClaimTracking: function getUnClaimTracking() {
            var _this2 = this;

            var param = {
                fkey: this.warehouseConfirm.inboundNo
            };
            (0, _inboundService.getUnClaimTracking)(param).then(function (data) {
                if (data.status === 200) {
                    if (data.result.length > 0) {
                        _this2.unClaimedTracking = data.result.join("\n");
                        _this2.unClaimedTrackingVisiable = true;
                    } else {
                        _this2.$message.error("None UnClaimed Tracking # found.");
                    }
                } else {
                    _this2.$message.error(data.message);
                }
            });
        },
        exportExcel: function exportExcel(url, fileName, type) {
            var param = {
                url: url,
                fileName: fileName,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            (0, _exportService.postExportExcel)(param).then(function () {});
        },
        bulkConfirm: function bulkConfirm() {
            var _this3 = this;

            this.modalLoading = true;
            var param = {
                inboundNo: this.warehouseConfirm.inboundNo,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            (0, _inboundService.bulkClaim)(param).then(function (data) {
                _this3.modalLoading = false;
                if (data.status == 200) {
                    if (data.result == true) {
                        _this3.$message.success(data.message);
                    } else {
                        _this3.$message.error(data.message);
                    }
                    _this3.getInboundHistoryList();
                    _this3.confirmInboundItem(_this3.warehouseConfirm.inboundNo, 'warehouse', false);
                    _this3.getNurseConfirmList();
                } else {
                    _this3.$message.error(data.message);
                }
            });
        },
        bulkRemoveSelected: function bulkRemoveSelected() {
            var _this4 = this;

            this.$confirm("Are you sure to remove selected tracking#?", "Warning", {
                type: "warning"
            }).then(function () {
                var param = {
                    inboundNo: _this4.warehouseConfirm.inboundNo,
                    trackingNos: _this4.removeMultipleSelection
                };
                _this4.modalLoading = true;
                (0, _inboundService.batchRemoveImportTracking)(param).then(function (data) {
                    setTimeout(function () {
                        if (data.status === 200) {
                            if (data.result.length > 0) {
                                _this4.$message.warning("Exist already claimed tracking#:" + data.result);
                            } else {
                                _this4.$message.success("Success");
                            }
                            _this4.confirmInboundItem(_this4.warehouseConfirm.inboundNo, 'warehouse', false).then(function () {
                                _this4.modalLoading = false;
                            });
                        }
                    }, 600);
                });
            }).catch(function () {});
        },
        claim: function claim(item) {
            var _this5 = this;

            var param = {
                inboundNo: this.warehouseConfirm.inboundNo,
                doctorNo: window.sessionStorage.getItem("currentCompany"),
                tracking: item.tracking,
                qty: item.qty
            };
            item.loading = true;
            this.modalLoading = true;
            return (0, _inboundService.claimTracking)(param).then(function (data) {
                item.loading = false;
                _this5.modalLoading = false;
                if (data.status === 200) {
                    if (data.result) {
                        _this5.$refs.warehouseConfirm.resetFields();

                        _this5.$message.success("Tracking# claim operation completed, quantity " + data.result + ".");
                    } else {
                        _this5.$message.success(data.message);
                    }
                    _this5.getInboundHistoryList();
                    _this5.confirmInboundItem(_this5.warehouseConfirm.inboundNo, 'warehouse', false);
                    _this5.getNurseConfirmList();
                    _this5.warehouseConfirm.bulkConfirmSize += 1;
                } else {
                    _this5.$message.error(data.message);
                }
            });
        },
        uploadSuccess: function uploadSuccess(a) {
            this.modalLoading = false;
            if (a.status === 200) {
                this.confirmInboundItem(this.warehouseConfirm.inboundNo, 'warehouse');
                this.excelImportVisible = false;
                this.$refs.upload.clearFiles();
            } else {
                this.$message.error(a.message);
                this.$refs.upload.clearFiles();
            }
        },
        uploadError: function uploadError(a) {
            this.modalLoading = false;
            this.$message.error(a.message);
            this.$refs.upload.clearFiles();
        },
        changeHistory: function changeHistory(val) {
            this.historyPage = val;
            this.getInboundHistoryList();
        },
        showCancelInbound: function showCancelInbound(inboundNo) {
            this.cancel.inboundNo = inboundNo;
            this.cancelInboundVisible = true;
        },
        cancelInbound: function cancelInbound() {
            var _this6 = this;

            if (!this.cancel.cancelNum) {
                this.$message.error("Cancel quantity is required.");
                return;
            }
            if (!this.cancel.cancelNum > 0) {
                this.$message.error("Cancel quantity must more than one.");
                return;
            }
            this.$confirm('Are you sure?', 'Warning', {
                type: 'warning'
            }).then(function () {
                (0, _inboundService.cancelNurseInbound)({ inboundNo: _this6.cancel.inboundNo, cancelNum: _this6.cancel.cancelNum }).then(function (res) {
                    if (res.status === 200) {
                        _this6.$message.success(res.message);
                        _this6.getNurseConfirmList();
                        _this6.getInboundHistoryList();
                        _this6.cancel.cancelNum = 0;
                        _this6.cancel.inboundNo = "";
                        _this6.cancelInboundVisible = false;
                    } else {
                        _this6.$message.error(res.message);
                    }
                });
            }).catch(function () {});
        },
        checkQuantity: function checkQuantity(rule, value, callback) {
            if (!value > 0) {
                return callback(new Error('Inbound quantity must more than 1.'));
            } else if (value > this.selfConfirm.leftNum) {
                return callback(new Error("Inbound quantity can't more than left."));
            } else {
                callback();
            }
        },
        handleConfirmInbound: function handleConfirmInbound() {
            var _this7 = this;

            this.$refs.selfConfirm.validate(function (valid) {
                if (valid) {
                    _this7.loading = true;
                    var param = {
                        inboundNo: _this7.selfConfirm.inboundNo,
                        confirmNum: _this7.selfConfirm.quantity
                    };
                    (0, _inboundService.confirmNurseInbound)(param).then(function (res) {
                        _this7.loading = false;
                        if (res.status === 200) {
                            _this7.$message.success(res.message);
                            _this7.selfConfirmVisible = false;
                            _this7.$refs.selfConfirm.resetFields();
                            _this7.getNurseConfirmList();
                            _this7.getInboundHistoryList();
                        } else {
                            _this7.$message.error(res.message);
                        }
                    });
                }
            });
        },
        changeConfirmInboundPage: function changeConfirmInboundPage(val) {
            this.confirmInboundPage = val;
            this.getNurseConfirmList();
        },
        changeReportPage: function changeReportPage(val) {
            this.reportPage = val;
            this.getReportList();
        },
        removeRow: function removeRow(row) {
            var _this8 = this;

            this.$confirm("Are you sure?", "Warning", {
                type: "warning"
            }).then(function () {
                var param = {
                    inboundNo: _this8.warehouseConfirm.inboundNo,
                    tracking: row.tracking
                };
                _this8.modalLoading = true;
                (0, _inboundService.removeImportTracking)(param).then(function (data) {
                    setTimeout(function () {
                        if (data.status === 200) {
                            _this8.$message.success(data.message);
                            _this8.confirmInboundItem(_this8.warehouseConfirm.inboundNo, 'warehouse', false).then(function () {
                                _this8.modalLoading = false;
                            });
                        }
                    }, 600);
                });
            }).catch(function () {});
        },
        importFromText: function importFromText() {
            var _this9 = this;

            this.loading = true;
            var text = this.text.trim();
            if (!text) {
                this.$message.error("Please enter import text.");
                this.loading = false;
                return;
            }
            var row = [];
            var existTrackings = [];
            var trackings = [];
            var lines = [];
            if (text.indexOf(" ") != -1) {
                lines = text.split(" ");
            } else if (text.indexOf(",") != -1) {
                lines = text.split(",");
            } else if (text.indexOf(";") != -1) {
                lines = text.split(";");
            } else if (text.indexOf(":") != -1) {
                lines = text.split(":");
            } else if (text.indexOf("\t") != -1) {
                lines = text.split("\t");
            } else {
                lines = text.split("\n");
            }

            lines.filter(function (line) {
                return line.trim() !== '';
            }).forEach(function (line) {
                var obj = {};
                obj.tracking = line.trim();

                var exist = trackings.find(function (item) {
                    return item === obj.tracking;
                });
                if (!exist) {
                    trackings.push(obj.tracking);
                } else {
                    existTrackings.push(obj.tracking);
                }
            });

            this.excelImportVisible = false;
            if (existTrackings.length > 0) {
                this.$message.info("Duplicate tracking: " + existTrackings.join(","));
                this.loading = false;
                return;
            }
            var param = {
                trackings: trackings.join(","),
                inboundNo: this.warehouseConfirm.inboundNo
            };
            var resultTrackings = [];
            var existList = [];
            (0, _inboundService.getQtyByTracking)(param).then(function (data) {
                _this9.loading = false;
                if (data.status === 200) {
                    _this9.textImportVisible = false;
                    _this9.confirmInboundItem(_this9.warehouseConfirm.inboundNo, 'warehouse');
                } else {
                    console.log(data);
                    _this9.$message.error(data.message);
                }
            });
        },
        confirmInboundItem: function confirmInboundItem(id, type, isShow) {
            var _this10 = this;

            return (0, _inboundService.getInboundDetail)({ inboundNo: id }).then(function (res) {
                if (res.status === 200) {
                    if (type == "self") {
                        _this10.selfConfirm.inboundNo = id;
                        _this10.selfConfirm.productName = res.result.productName;
                        _this10.selfConfirm.company = res.result.userName;
                        _this10.selfConfirm.price = res.result.price;
                        _this10.selfConfirm.num = res.result.num;
                        _this10.selfConfirm.leftNum = res.result.leftNum;
                        _this10.selfConfirm.warehouse = res.result.warehouse;
                        _this10.selfConfirmVisible = true;
                    } else {
                        _this10.text = "";
                        _this10.warehouseConfirm.inboundNo = id;
                        _this10.uploadData.inboundNo = id;
                        _this10.warehouseConfirm.productName = res.result.productName;
                        _this10.warehouseConfirm.company = res.result.userName;
                        _this10.warehouseConfirm.price = res.result.price;
                        _this10.warehouseConfirm.num = res.result.num;
                        _this10.warehouseConfirm.leftNum = res.result.leftNum;
                        _this10.warehouseConfirm.warehouse = res.result.warehouse;
                        _this10.warehouseConfirm.trackingStatus = "All";
                        _this10.warehouseConfirm.claimedList = res.result.trackingList;
                        _this10.warehouseConfirm.unClaimedList = res.result.unClaimedTrackingList;
                        _this10.warehouseConfirm.unMatchedList = res.result.unMatchedTrackingList;
                        _this10.warehouseConfirm.trackingNumbers = [];
                        _this10.warehouseConfirm.claimedList.forEach(function (item) {
                            item.confirmed = true;
                            item.matched = true;
                            item.loading = false;
                        });
                        _this10.warehouseConfirm.unClaimedList.forEach(function (item) {
                            item.confirmed = false;
                            item.matched = true;
                            item.loading = false;
                        });
                        _this10.warehouseConfirm.unMatchedList.forEach(function (item) {
                            item.confirmed = false;
                            item.matched = false;
                            item.loading = false;
                        });
                        _this10.warehouseConfirm.trackingNumbers = _this10.warehouseConfirm.trackingNumbers.concat(_this10.warehouseConfirm.unClaimedList).concat(_this10.warehouseConfirm.unMatchedList).concat(_this10.warehouseConfirm.claimedList);
                        _this10.warehouseConfirm.trackingNumbersPage = _this10.warehouseConfirm.trackingNumbers.slice(0, 100);
                        _this10.warehouseConfirm.total = _this10.warehouseConfirm.trackingNumbers.length;
                        _this10.warehouseConfirm.currentPage = 1;
                        if (isShow) {
                            _this10.warehouseConfirmVisible = true;
                        }
                    }
                } else {
                    _this10.$message.error(res.message);
                }
            });
        },
        handleSelectionChange: function handleSelectionChange(val) {
            this.removeMultipleSelection = "";
            for (var i = 0; i < val.length; i++) {
                var item = val[i];
                if (i > 0) {
                    this.removeMultipleSelection = this.removeMultipleSelection + "," + item.tracking;
                } else {
                    this.removeMultipleSelection = item.tracking;
                }
            }
        },
        changeImportTrackingPage: function changeImportTrackingPage(val) {
            this.warehouseConfirm.currentPage = val;
            this.warehouseConfirm.trackingNumbersPage = this.warehouseConfirm.trackingNumbers.slice((val - 1) * 100, val * 100);
        },
        changeTrackingFilterStatus: function changeTrackingFilterStatus() {
            var status = this.warehouseConfirm.trackingStatus;
            this.warehouseConfirm.trackingNumbers = [];
            if (status == "All") {
                this.warehouseConfirm.trackingNumbers = this.warehouseConfirm.trackingNumbers.concat(this.warehouseConfirm.unClaimedList).concat(this.warehouseConfirm.unMatchedList).concat(this.warehouseConfirm.claimedList);
            } else if (status == "Claimed") {
                this.warehouseConfirm.trackingNumbers = this.warehouseConfirm.trackingNumbers.concat(this.warehouseConfirm.claimedList);
            } else if (status == "Matched") {
                this.warehouseConfirm.trackingNumbers = this.warehouseConfirm.trackingNumbers.concat(this.warehouseConfirm.unClaimedList);
            } else if (status == "Unmatched") {
                this.warehouseConfirm.trackingNumbers = this.warehouseConfirm.trackingNumbers.concat(this.warehouseConfirm.unMatchedList);
            }
            this.warehouseConfirm.trackingNumbersPage = this.warehouseConfirm.trackingNumbers.slice(0, 100);
            this.warehouseConfirm.total = this.warehouseConfirm.trackingNumbers.length;
            this.warehouseConfirm.currentPage = 1;
        },
        getReportList: function getReportList() {
            var _this11 = this;

            var param = {
                current: this.reportPage,
                size: this.pageSize,
                condition: this.filters.reportFilter,
                doctorNo: window.sessionStorage.getItem("currentCompany"),
                status: this.filters.reportStatus
            };
            this.secondListLoading = true;
            (0, _inventoryService.getInventoryReportList)(param).then(function (data) {
                _this11.secondListLoading = false;
                if (data.status === 200) {
                    _this11.reportedInbound = data.result.records;
                    _this11.reportTotal = data.result.total;
                }
            });
        },
        getInboundHistoryList: function getInboundHistoryList() {
            var _this12 = this;

            this.thirdListLoading = true;
            var param = {
                current: this.historyPage,
                size: this.pageSize,
                productName: this.filters.historyFilter,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            (0, _inboundService.getInboundHistoryList)(param).then(function (data) {
                _this12.thirdListLoading = false;
                if (data.status === 200) {
                    _this12.inboundHistory = data.result.records;
                    _this12.historyTotal = data.result.total;
                }
            });
        },
        getNurseConfirmList: function getNurseConfirmList() {
            var _this13 = this;

            var param = {
                current: this.confirmInboundPage,
                size: this.pageSize,
                condition: this.filters.confirmInboundFilter,
                doctorNo: window.sessionStorage.getItem("currentCompany"),
                status: 0
            };
            this.firstListLoading = true;
            (0, _inboundService.getNurseConfirmList)(param).then(function (data) {
                _this13.firstListLoading = false;
                if (data.status === 200) {
                    _this13.confirmInbound = data.result.records;
                    _this13.confirmInboundTotal = data.result.total;
                }
            });
        }
    },
    mounted: function mounted() {
        this.getReportList();
        this.getInboundHistoryList();
        this.getNurseConfirmList();
    }
};

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(405);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _inventoryService = __webpack_require__(75);

var _globalVar = __webpack_require__(7);

var _exportService = __webpack_require__(23);

var _memberService = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {
        var _this = this;

        this.$on('changeDoctor', function (value) {
            setTimeout(function () {
                _this.getInventory();
            }, 300);
        });
    },
    data: function data() {
        var _ref;

        return _ref = {
            filters: {
                name: '',
                zeroName: "",
                doctorProductName: "",
                productTemplateCondition: ""
            },

            conditions: _globalVar.conditions,

            doctorProductList: [],
            doctorProductTotal: 0,
            doctorProductPage: 1,

            zeroInventory: [],
            zeroInventroyTotal: 0,
            zeroInventoryPage: 1,

            products: [],
            total: 0,
            page: 1,

            pageSize: _globalVar.defaultPageSize,
            activeName: "first",

            listLoading: false,
            loading: false,
            sels: [],

            sizeList: [],

            editFormVisible: false,
            editLoading: false,
            editFormRules: {
                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
            },

            editForm: {
                id: 0,
                name: '',
                sex: -1,
                age: 0,
                birth: '',
                addr: ''
            },

            reportFormVisible: false,
            addFormVisible: false }, (0, _defineProperty3.default)(_ref, 'editFormVisible', false), (0, _defineProperty3.default)(_ref, 'formRules', {
            id: [{ required: true, message: 'Missing Item is required.', trigger: 'blur' }],
            quantity: [{ required: true, message: 'Quantity is required.', trigger: 'blur' }, { validator: this.checkQuantity, trigger: 'blur' }]
        }), (0, _defineProperty3.default)(_ref, 'report', {
            id: "",
            product: '',
            company: "",
            price: "",
            note: "",
            warehouse: "",
            warehouseNo: "",
            quantity: 0,
            total: 0,
            items: []
        }), (0, _defineProperty3.default)(_ref, 'role', ""), (0, _defineProperty3.default)(_ref, 'editProduct', {
            id: "",
            product: '',
            condition: "New",
            price: "",
            asin: "",
            upc: "",
            weight: '',
            note: "",
            size: "",
            storageFreeDuration: undefined
        }), (0, _defineProperty3.default)(_ref, 'addProduct', {
            id: "",
            product: '',
            condition: "New",
            price: "",
            asin: "",
            upc: "",
            weight: '',
            note: "",
            size: "",
            storageFreeDuration: undefined
        }), (0, _defineProperty3.default)(_ref, 'productTemplatePage', 1), (0, _defineProperty3.default)(_ref, 'productTemplateList', []), (0, _defineProperty3.default)(_ref, 'productTemplateTotal', 0), (0, _defineProperty3.default)(_ref, 'productTemplateAddFormVisible', false), (0, _defineProperty3.default)(_ref, 'productTemplateEditFormVisible', false), (0, _defineProperty3.default)(_ref, 'editProductTemplate', {
            id: "",
            product: '',
            condition: "New",
            price: "",
            asin: "",
            upc: "",
            weight: '',
            note: "",
            size: "",
            storageFreeDuration: undefined
        }), (0, _defineProperty3.default)(_ref, 'addProductTemplate', {
            id: "",
            product: '',
            condition: "New",
            price: "",
            asin: "",
            upc: "",
            weight: '',
            note: "",
            size: "",
            storageFreeDuration: undefined
        }), (0, _defineProperty3.default)(_ref, 'distributeSelectedDoctors', []), (0, _defineProperty3.default)(_ref, 'selectedProductNo', null), (0, _defineProperty3.default)(_ref, 'selectDoctorsVisible', false), (0, _defineProperty3.default)(_ref, 'doctorList', []), (0, _defineProperty3.default)(_ref, 'selectedDoctorNames', []), (0, _defineProperty3.default)(_ref, 'productFormRules', {
            product: [{ required: true, message: 'Product Name is required.', trigger: 'blur' }],
            upc: [{ required: true, message: 'UPC is required.', trigger: 'blur' }],
            size: [{ required: true, message: 'Size is required.', trigger: 'blur' }]
        }), _ref;
    },

    methods: {
        changeItem: function changeItem() {
            var reportId = this.report.id;
            var selectItem = this.report.items.find(function (item) {
                return item.id == reportId;
            });
            this.report.total = selectItem.total;
        },
        exportExcel: function exportExcel(url, fileName, type) {
            var param = {
                url: url,
                fileName: fileName,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            (0, _exportService.postExportExcel)(param).then(function () {});
        },
        checkQuantity: function checkQuantity(rule, value, callback) {
            if (!value > 0) {
                return callback(new Error('Report quantity must more than 1.'));
            } else if (value > this.report.total) {
                return callback(new Error("Report quantity can't more than Total."));
            } else {
                callback();
            }
        },
        handleReportInventory: function handleReportInventory() {
            var _this2 = this;

            this.$refs.report.validate(function (valid) {
                if (valid) {
                    var param = {
                        itemId: _this2.report.id,
                        warehouseNo: _this2.report.warehouseNo,
                        note: _this2.report.note,
                        quantity: _this2.report.quantity,
                        doctorNo: window.sessionStorage.getItem("currentCompany")
                    };
                    _this2.loading = true;
                    (0, _inventoryService.reportInventory)(param).then(function (data) {
                        _this2.loading = false;
                        if (data.status === 200) {
                            _this2.$message.success(data.message);
                            _this2.reportFormVisible = false;
                            _this2.$refs.report.resetFields();
                            _this2.getInventory();
                        } else {
                            _this2.$message.error(data.message);
                        }
                    });
                }
            });
        },
        showReportInventory: function showReportInventory(row) {
            var _this3 = this;

            var param = {
                doctorNo: window.sessionStorage.getItem("currentCompany"),
                productNo: row.productNo,
                warehouseNo: row.warehouseNo
            };
            (0, _inventoryService.getInventoryByProduct)(param).then(function (data) {
                _this3.report.items = data.result;
                _this3.report.product = row.productName;
                _this3.report.warehouse = row.warehouse;
                _this3.report.warehouseNo = row.warehouseNo;

                _this3.reportFormVisible = true;
            });
        },
        handleCurrentChange: function handleCurrentChange(val) {
            this.page = val;
            this.getInventory();
        },
        handleZeroChange: function handleZeroChange(val) {
            this.zeroInventoryPage = val;
            this.getZeroInventory();
        },
        handleProductChange: function handleProductChange(val) {
            this.doctorProductPage = val;
            this.getDoctorProductList();
        },
        handleProductTemplateChange: function handleProductTemplateChange(val) {
            this.productTemplatePage = val;
            this.getProductTemplateList();
        },
        getSizeList: function getSizeList() {
            var _this4 = this;

            (0, _inventoryService.getSizeList)({}).then(function (data) {
                if (data.status === 200) {
                    _this4.sizeList = data.result;
                }
            });
        },
        getInventory: function getInventory() {
            var _this5 = this;

            var para = {
                current: this.page,
                size: this.pageSize,
                condition: this.filters.name,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            this.listLoading = true;
            (0, _inventoryService.getUserInventory)(para).then(function (res) {
                _this5.listLoading = false;
                if (res.status === 200) {
                    _this5.products = res.result.records;
                    _this5.total = res.result.total;
                }
            });
        },
        getZeroInventory: function getZeroInventory() {
            var _this6 = this;

            var para = {
                current: this.zeroInventoryPage,
                size: this.pageSize,
                condition: this.filters.zeroName,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            this.listLoading = true;
            (0, _inventoryService.getZeroInventory)(para).then(function (res) {
                _this6.listLoading = false;
                if (res.status === 200) {
                    _this6.zeroInventory = res.result.records;
                    _this6.zeroInventroyTotal = res.result.total;
                }
            });
        },
        getDoctorProductList: function getDoctorProductList() {
            var _this7 = this;

            var para = {
                current: this.doctorProductPage,
                size: this.pageSize,
                condition: this.filters.doctorProductName,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            this.listLoading = true;
            (0, _inventoryService.getDoctorProductList)(para).then(function (res) {
                _this7.listLoading = false;
                if (res.status === 200) {
                    _this7.doctorProductList = res.result.records;
                    _this7.doctorProductTotal = res.result.total;
                } else {
                    _this7.$message.error(res.message);
                }
            });
        },
        getProductTemplateList: function getProductTemplateList() {
            var _this8 = this;

            var para = {
                current: this.productTemplatePage,
                size: this.pageSize,
                upc: this.filters.productTemplateCondition
            };
            this.listLoading = true;
            (0, _inventoryService.getProductTemplateListByCondition)(para).then(function (res) {
                _this8.listLoading = false;
                if (res.status === 200) {
                    _this8.productTemplateList = res.result.records;
                    _this8.productTemplateTotal = res.result.total;
                } else {
                    _this8.$message.error(res.message);
                }
            });
        },

        editSubmit: function editSubmit() {
            var _this9 = this;

            this.$refs.editProduct.validate(function (valid) {
                if (valid) {
                    var param = {
                        productNo: _this9.editProduct.productNo,

                        condition: _this9.editProduct.condition,
                        asin: _this9.editProduct.asin,
                        upc: _this9.editProduct.upc,
                        weight: _this9.editProduct.weight,
                        note: _this9.editProduct.note,
                        size: _this9.editProduct.size,
                        storageFreeDuration: _this9.editProduct.storageFreeDuration,
                        doctorNo: window.sessionStorage.getItem("currentCompany")

                    };
                    _this9.loading = true;
                    (0, _inventoryService.addProduct)(param).then(function (res) {
                        _this9.loading = false;
                        if (res.status === 200) {
                            _this9.$message({
                                message: res.message,
                                type: "success"
                            });
                            _this9.editFormVisible = false;
                            _this9.$refs.editProduct.resetFields();
                            _this9.getDoctorProductList();
                        } else {
                            _this9.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    });
                }
            });
        },

        editSubmitTemplate: function editSubmitTemplate() {
            var _this10 = this;

            this.$refs.editProductTemplate.validate(function (valid) {
                if (valid) {
                    var param = {
                        productNo: _this10.editProductTemplate.productNo,
                        condition: _this10.editProductTemplate.condition,
                        asin: _this10.editProductTemplate.asin,
                        upc: _this10.editProductTemplate.upc,
                        weight: _this10.editProductTemplate.weight,
                        note: _this10.editProductTemplate.note,
                        size: _this10.editProductTemplate.size,
                        storageFreeDuration: _this10.editProductTemplate.storageFreeDuration

                    };
                    _this10.loading = true;
                    (0, _inventoryService.addProductTemplate)(param).then(function (res) {
                        _this10.loading = false;
                        if (res.status === 200) {
                            _this10.$message({
                                message: res.message,
                                type: "success"
                            });
                            _this10.productTemplateEditFormVisible = false;
                            _this10.$refs.editProductTemplate.resetFields();
                            _this10.getProductTemplateList();
                        } else {
                            _this10.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    });
                }
            });
        },

        handleAddProduct: function handleAddProduct() {
            var _this11 = this;

            this.$refs.addProduct.validate(function (valid) {
                if (valid) {
                    var param = {
                        productName: _this11.addProduct.product,
                        condition: _this11.addProduct.condition,
                        asin: _this11.addProduct.asin,
                        upc: _this11.addProduct.upc,
                        weight: _this11.addProduct.weight,
                        note: _this11.addProduct.note,
                        size: _this11.addProduct.size,
                        storageFreeDuration: _this11.addProduct.storageFreeDuration,
                        doctorNo: window.sessionStorage.getItem("currentCompany")
                    };
                    _this11.loading = true;
                    (0, _inventoryService.addProduct)(param).then(function (res) {
                        _this11.loading = false;
                        if (res.status === 200) {
                            _this11.$message({
                                message: res.message,
                                type: "success"
                            });
                            _this11.addFormVisible = false;
                            _this11.$refs.addProduct.resetFields();
                            _this11.getDoctorProductList();
                        } else {
                            _this11.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    });
                }
            });
        },

        handleAddProductTemplate: function handleAddProductTemplate() {
            var _this12 = this;

            this.$refs.addProductTemplate.validate(function (valid) {
                if (valid) {
                    var param = {
                        productName: _this12.addProductTemplate.product,
                        condition: _this12.addProductTemplate.condition,
                        asin: _this12.addProductTemplate.asin,
                        upc: _this12.addProductTemplate.upc,
                        weight: _this12.addProductTemplate.weight,
                        note: _this12.addProductTemplate.note,
                        size: _this12.addProductTemplate.size,
                        storageFreeDuration: _this12.addProductTemplate.storageFreeDuration
                    };
                    _this12.loading = true;
                    (0, _inventoryService.addProductTemplate)(param).then(function (res) {
                        _this12.loading = false;
                        if (res.status === 200) {
                            _this12.$message({
                                message: res.message,
                                type: "success"
                            });
                            _this12.productTemplateAddFormVisible = false;
                            _this12.$refs.addProductTemplate.resetFields();
                            _this12.getProductTemplateList();
                        } else {
                            _this12.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    });
                }
            });
        },
        handleEditProduct: function handleEditProduct(row) {
            var _this13 = this;

            var para = {
                productNo: row.productNo,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            (0, _inventoryService.getProductById)(para).then(function (data) {
                _this13.editProduct = data.result;
                _this13.editFormVisible = true;
                if (_this13.editProduct.storageFreeDuration == null) {
                    _this13.editProduct.storageFreeDuration = undefined;
                }
            });
        },
        handleEditProductTemplate: function handleEditProductTemplate(row) {
            var _this14 = this;

            var para = {
                productNo: row.productNo
            };
            (0, _inventoryService.getProductTemplateById)(para).then(function (data) {
                _this14.editProductTemplate = data.result;
                _this14.productTemplateEditFormVisible = true;
                if (_this14.editProductTemplate.storageFreeDuration == null) {
                    _this14.editProductTemplate.storageFreeDuration = undefined;
                }
            });
        },
        showDistributeSelectDoctorWin: function showDistributeSelectDoctorWin(row) {
            var _this15 = this;

            this.selectedProductNo = row.productNo;
            var para = {
                productNo: row.productNo
            };
            (0, _inventoryService.getDistributedDoctorName)(para).then(function (data) {
                if (data.status === 200) {
                    _this15.selectedDoctorNames = data.result;
                    (0, _memberService.getNurseDoctor)().then(function (res) {
                        _this15.doctorList = res.result;
                        _this15.selectDoctorsVisible = true;
                    });
                } else {
                    _this15.$message({
                        message: data.message,
                        type: "error"
                    });
                }
            });
        },
        distributeProductTempate: function distributeProductTempate() {
            var _this16 = this;

            var para = {
                productNo: this.selectedProductNo,
                doctorNos: this.distributeSelectedDoctors
            };

            this.loading = true;
            (0, _inventoryService.distributeProductTempate)(para).then(function (data) {
                if (data.status === 200) {
                    if (data.result.length == 0) {
                        _this16.$message({
                            message: data.message,
                            type: "success"
                        });
                        _this16.getProductTemplateList();
                        _this16.distributeSelectedDoctors = [];
                        _this16.selectDoctorsVisible = false;
                    } else {
                        var _para = {
                            productNo: _this16.selectedProductNo
                        };
                        (0, _inventoryService.getDistributedDoctorName)(_para).then(function (data) {
                            if (data.status === 200) {
                                _this16.selectedDoctorNames = data.result;
                                (0, _memberService.getNurseDoctor)().then(function (res) {
                                    _this16.doctorList = res.result;
                                    _this16.selectDoctorsVisible = true;
                                });
                            } else {
                                _this16.$message({
                                    message: data.message,
                                    type: "error"
                                });
                            }
                        });
                        _this16.$message({
                            message: "Distribute failed User:" + data.result,
                            type: "error"
                        });
                    }
                } else {
                    _this16.$message({
                        message: data.message,
                        type: "error"
                    });
                }
                _this16.loading = false;
            });
        }
    },
    mounted: function mounted() {
        this.getInventory();
        this.getZeroInventory();
        this.getDoctorProductList();
        this.role = JSON.parse(window.sessionStorage.getItem("user")).roleId;
        if (this.role == '3') {
            this.getProductTemplateList();
            this.getSizeList();
        }
    }
};

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _memberService = __webpack_require__(20);

var _globalVar = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			firstLoading: false,
			secondLoading: false,
			thirdLoading: false,
			pageSize: _globalVar.defaultPageSize,

			activeName: "first",

			filters: {
				email: ''
			},

			members: [],

			groups: [],
			invitations: [],

			total: 0,

			invitationFilter: "",
			invitationTotalPage: 0,
			invitationPage: 1,

			membersFilter: "",
			membersTotalPage: 0,
			membersPage: 1,

			sels: [],
			editMemberObj: {},
			editMemberVisible: false,
			addGroupVisible: false,
			invitationVisible: false,

			editLoading: false,
			editFormRules: {
				name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
			},

			editForm: {
				id: 0,
				name: '',
				sex: -1,
				age: 0,
				birth: '',
				addr: ''
			},

			addFormVisible: false,
			addLoading: false,
			invitationRules: {
				role: [{ required: true, message: 'Role is required.', trigger: 'blur' }],
				email: [{ required: true, message: 'email is required.', trigger: 'blur' }, { validator: _util2.default.validateEmail, trigger: 'blur' }]
			},

			member: {
				id: "",
				userName: "",
				email: "",
				phone: "",
				status: "",
				pendingTransaction: 7,
				pendingAmount: "",
				alias: ""
			},
			group: {
				id: '',
				groupName: "",
				users: [],
				pendingTransaction: 7,
				pendingAmount: ""
			},
			invitation: {
				id: "",
				email: "",
				status: "",
				dateTime: "",
				role: ""
			}

		};
	},

	methods: {
		formatInvitationStatus: function formatInvitationStatus(row, column) {
			if (row.status === 0) {
				return "Pending";
			} else if (row.status === 1) {
				return "Approve";
			} else {
				return "Reject";
			}
		},
		formatTimesTamp: function formatTimesTamp(row, column) {
			return _util2.default.formatDate.format(new Date(row.createDate), 'yyyy-MM-dd hh:mm:ss');
		},
		handleInvitationPageChange: function handleInvitationPageChange(val) {
			this.invitationPage = val;
			this.getInvitations();
		},
		editInvitationStatus: function editInvitationStatus(id, status) {
			var _this = this;

			this.$confirm("Are you sure?", "Warning", {
				type: "warning"
			}).then(function () {
				(0, _memberService.editInvitationStatus)({ invitationNo: id, status: status }).then(function (res) {
					if (res.status === 200) {
						_this.$message({
							message: res.message,
							type: "success"
						});
						_this.getInvitations();
					} else {
						_this.$message({
							message: res.message,
							type: "error"
						});
					}
				});
			}).catch(function () {});
		},
		getInvitations: function getInvitations() {
			var _this2 = this;

			var para = {
				current: this.invitationPage,
				size: this.pageSize,
				condition: this.filters.email
			};

			this.firstLoading = true;
			(0, _memberService.getInvitations)(para).then(function (res) {
				_this2.firstLoading = false;
				if (res.status === 200) {
					_this2.invitations = res.result.records;
					_this2.invitationTotalPage = res.result.total;
				} else {
					_this2.$message({
						message: res.message,
						type: 'error'
					});
				}
			});
		},
		invitationRegister: function invitationRegister(param) {
			var _this3 = this;

			this.$refs.invitation.validate(function (valid) {
				if (valid) {
					(0, _memberService.invitationRegister)({ roleId: _this3.invitation.role, email: _this3.invitation.email }).then(function (res) {
						if (res.status === 200) {
							_this3.$message({
								message: 'Success',
								type: 'success'
							});
							_this3.invitationVisible = false;
							_this3.getInvitations();
						} else {
							_this3.$message({
								message: res.message,
								type: 'error'
							});
						}
					}).catch(function (error) {
						return console.log(error);
					});
				}
			});
		}
	},
	mounted: function mounted() {
		this.getInvitations();
	}
};

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
				value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _globalVar = __webpack_require__(7);

var _offerService = __webpack_require__(103);

var _warehouseService = __webpack_require__(59);

var _exportService = __webpack_require__(23);

var _option = __webpack_require__(22);

var _option2 = _interopRequireDefault(_option);

var _button = __webpack_require__(99);

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
				components: {
								ElButton: _button2.default,
								ElOption: _option2.default },
				props: {
								'current-company': String
				},
				created: function created() {
								var _this = this;

								this.$on('changeDoctor', function (value) {
												setTimeout(function () {
																_this.getOpenOffers();
																_this.getWarehouse();
																_this.getProposedOffers();
																_this.getOfferHistroy();
												}, 300);
								});
				},
				data: function data() {
								return {
												loading: false,
												company: this.currentCompany,
												warehouses: [],
												options: [{
																label: 'Self Category',
																options: [{
																				value: '1',
																				label: 'FL 0001'
																}]
												}, {
																label: 'Warehouse',
																options: [{
																				value: '2',
																				label: 'FL 0002'
																}]
												}],

												pageSize: _globalVar.defaultPageSize,
												openOfferPage: 1,
												openOfferTotal: 0,

												proposedPage: 1,
												proposedTotal: 0,

												historyPage: 1,
												historyTotal: 0,

												expiredPage: 1,
												expiredTotal: 0,

												activeName: "first",
												filters: {
																historyStatus: "",
																historyFilter: "",
																proposedFilter: "",
																openOfferFilter: "",
																expiredFilter: "",
																name: ''
												},

												proposedList: [],

												historyList: [],

												openOffers: [],
												proposedOffers: [],

												expiredList: [],
												total: 0,
												page: 1,

												firstListLoading: false,
												secondListLoading: false,
												thirdListLoading: false,
												fourthListLoading: false,
												listLoading: false,
												sels: [],

												editFormVisible: false,
												editLoading: false,
												formRules: {
																warehouseNo: [{ required: true, message: 'Warehouse is required.', trigger: 'blur' }],
																quantity: [{ required: true, message: 'Quantity is required.', trigger: 'blur' }, { validator: this.checkQuantity, trigger: 'blur' }]
												},

												editForm: {
																id: 0,
																name: '',
																sex: -1,
																age: 0,
																birth: '',
																addr: ''
												},

												takeOfferVisible: false,
												proposedOfferVisible: false,
												addLoading: false,
												proposedFormRules: {
																warehouseNo: [{ required: true, message: 'Warehouse is required.', trigger: 'blur' }],
																quantity: [{ required: true, message: 'Quantity is required.', trigger: 'blur' }, { validator: this.checkProposedQuantity, trigger: 'blur' }]
												},

												takeOffer: {
																createBy: "",
																price: "",
																quantity: 0,
																product: "",
																warehouseNo: ""
												},
												proposedOffer: {
																offer: "",
																createBy: "",
																price: "",
																quantity: "",
																product: "",
																warehouseNo: "",
																offerNo: ""
												}
								};
				},

				methods: {
								cancelProposed: function cancelProposed(id, status) {
												var _this2 = this;

												this.$confirm('Are you sure?', 'Warning', {
																type: 'warning'
												}).then(function () {
																(0, _offerService.removeProposedOffer)({ id: id }).then(function (res) {
																				if (res.status === 200) {
																								_this2.$message.success(res.message);
																								_this2.getProposedOffers();
																				} else {
																								_this2.$message.error(res.message);
																								_this2.getProposedOffers();
																				}
																});
												}).catch(function () {});
								},
								exportExcel: function exportExcel(url, fileName, type) {
												var param = {
																url: url,
																fileName: fileName,
																doctorNo: window.sessionStorage.getItem("currentCompany")
												};
												(0, _exportService.postExportExcel)(param).then(function () {});
								},
								getOfferHistroy: function getOfferHistroy() {
												var _this3 = this;

												var param = {
																current: this.historyPage,
																size: this.pageSize,
																doctorNo: window.sessionStorage.getItem("currentCompany"),
																condition: this.filters.historyFilter,
																status: this.filters.historyStatus
												};
												this.thirdListLoading = true;
												(0, _offerService.getNurseOfferHistoryList)(param).then(function (data) {
																_this3.thirdListLoading = false;
																if (data.status === 200) {
																				_this3.historyList = data.result.records;
																				_this3.historyTotal = data.result.total;
																}
												});
								},
								getExpiredOffers: function getExpiredOffers() {
												var _this4 = this;

												var param = {
																current: this.expiredPage,
																size: this.pageSize,
																doctorNo: window.sessionStorage.getItem("currentCompany"),
																condition: this.filters.expiredFilter
												};
												this.fourthListLoading = true;
												(0, _offerService.expiredOffers)(param).then(function (data) {
																_this4.fourthListLoading = false;
																if (data.status === 200) {
																				_this4.expiredList = data.result.records;
																				_this4.expiredTotal = data.result.total;
																}
												});
								},
								selectProposedOffer: function selectProposedOffer(val) {
												var selected = this.proposedList.filter(function (item) {
																return item.offerNo === val;
												});
												if (selected && selected.length === 1) {
																this.proposedOffer.createBy = selected[0].createBy;
																this.proposedOffer.price = selected[0].price;
												}
								},
								showProposed: function showProposed() {
												var _this5 = this;

												this.getProposedOfferList().then(function () {
																_this5.proposedOfferVisible = true;
												});
								},
								getProposedOfferList: function getProposedOfferList() {
												var _this6 = this;

												var param = {
																doctorNo: window.sessionStorage.getItem("currentCompany")
												};
												return (0, _offerService.getProposedOfferList)(param).then(function (data) {
																if (data.status === 200) {
																				_this6.proposedList = data.result;
																}
												});
								},
								formatProposedStatus: function formatProposedStatus(row, column) {
												if (row.status === 0) {
																return "Pending";
												} else if (row.status === 1) {
																return "Confirmed";
												} else {
																return "Rejected";
												}
								},
								requestProposed: function requestProposed() {
												var _this7 = this;

												this.$refs.proposedOffer.validate(function (valid) {
																if (valid) {
																				_this7.loading = true;
																				var param = {
																								doctorNo: window.sessionStorage.getItem("currentCompany"),
																								offerNo: _this7.proposedOffer.offerNo,
																								warehouseNo: _this7.proposedOffer.warehouseNo,
																								quantity: _this7.proposedOffer.quantity

																				};
																				(0, _offerService.requestProposedOffers)(param).then(function (data) {
																								_this7.loading = false;
																								if (data.status === 200) {
																												_this7.proposedOfferVisible = false;
																												_this7.$message.success(data.message);
																												_this7.$refs.proposedOffer.resetFields();
																												_this7.getProposedOffers();
																												_this7.getOpenOffers();
																								} else {
																												_this7.$message.error(data.message);
																								}
																				});
																}
												});
								},
								changeOfferPage: function changeOfferPage(val) {
												this.openOfferPage = val;
												this.getOpenOffers();
								},
								changeProposedPage: function changeProposedPage(val) {
												this.proposedPage = val;
												this.getProposedOffers();
								},
								changeHistoryPage: function changeHistoryPage(val) {
												this.historyPage = val;
												this.getOfferHistroy();
								},
								changeExpiredPage: function changeExpiredPage(val) {
												this.expiredPage = val;
												this.getExpiredOffers();
								},
								checkQuantity: function checkQuantity(rule, value, callback) {
												if (!value > 0) {
																return callback(new Error('Quantity must more than 1.'));
												} else if (value > this.takeOffer.leftNum) {
																return callback(new Error("Quantity can't more than left."));
												} else {
																callback();
												}
								},
								checkProposedQuantity: function checkProposedQuantity(rule, value, callback) {
												if (!value > 0) {
																return callback(new Error('Quantity must more than 1.'));
												} else {
																callback();
												}
								},
								formatTimesTamp: function formatTimesTamp(row, column) {
												return _util2.default.formatDate.format(new Date(row.createDate), 'yyyy-MM-dd hh:mm:ss');
								},
								getWarehouse: function getWarehouse() {
												var _this8 = this;

												var param = {
																doctorNo: window.sessionStorage.getItem("currentCompany")
												};
												(0, _warehouseService.getNurseWarehouses)(param).then(function (res) {
																if (res.status === 200) {
																				_this8.warehouses = [];
																				var self = {
																								label: 'Self Storage',
																								options: []
																				};
																				var doctors = {
																								label: 'Warehouse',
																								options: []
																				};
																				res.result.forEach(function (item) {
																								if (item.isDoctor === 0) {
																												doctors.options.push(item);
																								} else {
																												self.options.push(item);
																								}
																				});
																				if (self.options.length > 0) {
																								_this8.warehouses.push(self);
																				}
																				if (doctors.options.length > 0) {
																								_this8.warehouses.push(doctors);
																				}
																}
												});
								},
								changeProposedOffer: function changeProposedOffer() {
												this.proposedOffer.product = this.proposedOffer.offer.product;
												this.proposedOffer.price = this.proposedOffer.offer.price;
												this.proposedOffer.createBy = this.proposedOffer.offer.createBy;
								},
								showTakeOffer: function showTakeOffer(offerId) {
												var _this9 = this;

												(0, _offerService.getOfferById)({ offerNo: offerId }).then(function (res) {
																if (res.status === 200) {
																				if (res.result.offer.leftNum > 0) {
																								_this9.takeOffer.offerNo = res.result.offer.offerNo;
																								_this9.takeOffer.product = res.result.productName;
																								_this9.takeOffer.price = res.result.offer.price;
																								_this9.takeOffer.leftNum = res.result.offer.leftNum;
																								_this9.takeOffer.bouns = res.result.offer.bouns;
																								_this9.takeOffer.createBy = res.result.doctorName;
																								_this9.takeOfferVisible = true;
																				} else {
																								_this9.$confirm("Offer quantity is take over, do you want to request a proposed?", "Warning", {
																												type: "warning"
																								}).then(function () {
																												return _this9.getProposedOfferList();
																								}).then(function () {
																												_this9.proposedOfferVisible = true;
																												_this9.proposedOffer.productName = res.result.productName;
																												_this9.proposedOffer.createBy = res.result.doctorName;
																												_this9.proposedOffer.price = res.result.offer.price;
																												_this9.proposedOffer.offerNo = res.result.offer.offerNo;
																								}).catch(function () {});
																				}
																}
												});
								},
								showProposedOffer: function showProposedOffer(offerId) {
												var _this10 = this;

												this.getProposedOfferList().then(function () {
																return (0, _offerService.getOfferById)({ offerNo: offerId });
												}).then(function (res) {
																if (res.status === 200) {
																				_this10.proposedOfferVisible = true;
																				_this10.proposedOffer.productName = res.result.productName;
																				_this10.proposedOffer.createBy = res.result.doctorName;
																				_this10.proposedOffer.price = res.result.offer.price;
																				_this10.proposedOffer.offerNo = res.result.offer.offerNo;
																}
												});
								},
								handleTakeOffer: function handleTakeOffer() {
												var _this11 = this;

												var param = {
																offerNo: this.takeOffer.offerNo,
																warehouseNo: this.takeOffer.warehouseNo,
																quantity: this.takeOffer.quantity,
																doctorNo: window.sessionStorage.getItem("currentCompany")
												};
												this.$refs.takeOffer.validate(function (valid) {
																if (valid) {
																				_this11.loading = true;
																				(0, _offerService.takeOffer)(param).then(function (res) {
																								_this11.loading = false;
																								if (res.status === 200) {
																												_this11.$message.success(res.message);
																												_this11.takeOfferVisible = false;
																												_this11.$refs.takeOffer.resetFields();
																												_this11.getOpenOffers();
																												_this11.getOfferHistroy();
																								} else {
																												_this11.$message.error(res.message);
																								}
																				});
																}
												});
								},
								handleCurrentChange: function handleCurrentChange(val) {
												this.page = val;
								},
								getOpenOffers: function getOpenOffers() {
												var _this12 = this;

												var param = {
																current: this.openOfferPage,
																size: this.pageSize,
																condition: this.filters.openOfferFilter,
																doctorNo: window.sessionStorage.getItem("currentCompany")
												};
												this.firstListLoading = true;
												(0, _offerService.getNurseOffer)(param).then(function (res) {
																_this12.firstListLoading = false;
																_this12.openOffers = res.result.records;
																_this12.openOfferTotal = res.result.total;
												});
								},
								getProposedOffers: function getProposedOffers() {
												var _this13 = this;

												var param = {
																current: this.proposedPage,
																size: this.pageSize,
																condition: this.filters.proposedFilter,
																doctorNo: window.sessionStorage.getItem("currentCompany")
												};
												this.secondListLoading = true;
												(0, _offerService.getProposedOffers)(param).then(function (data) {
																_this13.secondListLoading = false;
																if (data.status === 200) {
																				_this13.proposedOffers = data.result.records;
																				_this13.proposedTotal = data.result.total;
																}
												});
								}
				},
				mounted: function mounted() {
								this.getOpenOffers();
								this.getProposedOffers();
								this.getWarehouse();
								this.getOfferHistroy();
								this.getExpiredOffers();
								var active = this.$route.params.active;
								if (active) {
												this.activeName = active;
								}
				}
};

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _outboundService = __webpack_require__(104);

var _button = __webpack_require__(99);

var _button2 = _interopRequireDefault(_button);

var _main = __webpack_require__(282);

var _main2 = _interopRequireDefault(_main);

var _option = __webpack_require__(22);

var _option2 = _interopRequireDefault(_option);

var _input = __webpack_require__(100);

var _input2 = _interopRequireDefault(_input);

var _globalVar = __webpack_require__(7);

var _exportService = __webpack_require__(23);

var _jsbarcode = __webpack_require__(692);

var _jsbarcode2 = _interopRequireDefault(_jsbarcode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		ElInput: _input2.default,
		ElOption: _option2.default,
		ElLink: _main2.default,
		ElButton: _button2.default },
	created: function created() {
		var _this = this;

		this.$on('changeDoctor', function (value) {
			setTimeout(function () {
				_this.getWorkingOutboundList();
				_this.getArchivedOutboundList();
			}, 300);
		});
	},
	data: function data() {
		return {
			currentCompany: "",
			activeName: "first",
			filters: {
				workingFilter: "",
				workingMainFilter: "",
				archivedFilter: "",
				archivedMainFilter: "",
				name: ''
			},

			pageSize: _globalVar.defaultPageSize,

			workingList: [],
			workingPage: 1,
			workingTotal: 0,
			workingLoading: false,

			archivedList: [],
			archivedPage: 1,
			archivedTotal: 0,
			archivedLoading: false,

			workingOutboundList: [],
			archivedOutboundList: [],
			total: 0,
			page: 1,
			listLoading: false,
			editMemberObj: {},
			packageDetailVisible: false,
			addGroupVisible: false,
			invitationVisible: false,
			editLoading: false,
			editFormRules: {
				name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
			},
			print: {
				instruction: "",
				note: "",
				outboundNo: "",
				outboundShipment: "",
				splitPackagesNum: 1,
				company: "",
				upcs: ""
			},

			editForm: {
				id: 0,
				name: '',
				sex: -1,
				age: 0,
				birth: '',
				addr: ''
			},
			detail: {},
			addFormVisible: false,
			addLoading: false,
			addFormRules: {
				name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
			},

			member: {
				id: "",
				userName: "",
				email: "",
				phone: "",
				status: "",
				pendingTransaction: 7,
				pendingAmount: ""
			},
			group: {
				id: '',
				groupName: "",
				users: [],
				pendingTransaction: 7,
				pendingAmount: ""
			},
			invitation: {
				id: "",
				email: "",
				status: "",
				dateTime: "",
				role: ""
			}

		};
	},

	methods: {
		exportExcel: function exportExcel(url, fileName, type) {
			var param = {
				url: url,
				fileName: fileName,
				doctorNo: window.sessionStorage.getItem("currentCompany"),
				status: type
			};
			(0, _exportService.postExportExcel)(param).then(function () {});
		},
		archivedOutbound: function archivedOutbound(id) {
			var _this2 = this;

			this.$confirm('Are you sure?', 'Warning', {
				type: 'warning'
			}).then(function () {
				var param = {
					outboundNo: id,
					status: 2
				};
				(0, _outboundService.updateOutboundStatus)(param).then(function (data) {
					if (data.status === 200) {
						_this2.$message.success(data.message);
						_this2.getWorkingOutboundList();
						_this2.getArchivedOutboundList();
					} else {
						_this2.$message.error(data.message);
					}
				});
			}).catch(function () {});
		},
		download: function download(id) {
			window.open(_globalVar.serverUrl + "/outboundFile/exportPackageLabelImageById?outboundNo=" + id, "_blank");
		},
		tableRowClassName: function tableRowClassName(_ref) {
			var row = _ref.row,
			    rowIndex = _ref.rowIndex;

			if (row.priority === 2) {
				return 'urgent-row';
			} else if (row.priority === 1) {
				return 'Medium-row';
			}
			return "";
		},
		packageDetail: function packageDetail(row) {
			this.detail = row;
			this.packageDetailVisible = true;
		},
		changeWorkingList: function changeWorkingList(val) {
			this.workingPage = val;
			this.getWorkingOutboundList();
		},
		getWorkingOutboundList: function getWorkingOutboundList() {
			var _this3 = this;

			var param = {
				current: this.workingPage,
				size: this.pageSize,
				status: 1,
				condition: this.filters.workingFilter,
				doctorNo: window.sessionStorage.getItem("currentCompany"),
				main: this.filters.workingMainFilter
			};
			this.workingLoading = true;
			(0, _outboundService.getOutboundList)(param).then(function (data) {
				_this3.workingLoading = false;
				if (data.status === 200) {
					_this3.workingList = data.result.records;
					_this3.workingTotal = data.result.total;
				}
			});
		},
		changeArchivedList: function changeArchivedList(val) {
			this.archivedPage = val;
			this.getArchivedOutboundList();
		},
		getArchivedOutboundList: function getArchivedOutboundList() {
			var _this4 = this;

			var param = {
				current: this.archivedPage,
				size: this.pageSize,
				status: 2,
				condition: this.filters.archivedFilter,
				doctorNo: window.sessionStorage.getItem("currentCompany"),
				main: this.filters.archivedMainFilter
			};
			this.archivedLoading = true;
			(0, _outboundService.getOutboundList)(param).then(function (data) {
				_this4.archivedLoading = false;
				if (data.status === 200) {
					_this4.archivedList = data.result.records;
					_this4.archivedTotal = data.result.total;
				}
			});
		},
		printNote: function printNote(row) {
			var _this5 = this;

			this.print.instruction = row.instruction;
			this.print.upcs = row.upcs;
			this.print.note = row.note;
			this.print.outboundNo = row.outboundId;
			this.print.company = row.company;
			this.print.outboundShipment = row.productName;
			this.print.splitPackagesNum = row.splitPackagesNum;
			this.packageDetailVisible = true;

			setTimeout(function () {
				$("#barcode1").attr('src', '');
				$("#barcode2").attr('src', '');
				$("#barcode3").attr('src', '');
				$("#barcode4").attr('src', '');
				$("#barcode5").attr('src', '');
				$("#barcode6").attr('src', '');
				if (_this5.print.upcs) {
					_this5.print.upcs.split("<br>").forEach(function (item, index) {
						var barHeight = 18;
						var svgId = "#barcode" + (index + 1);
						if (item) {
							(0, _jsbarcode2.default)(svgId, item, {
								format: "CODE128",
								width: 1,
								height: barHeight,
								lineColor: "#000",
								displayValue: false,
								margin: 2 });
						}
					});
				}

				var element = document.getElementById("printArea");
				_this5.$print(element);
				_this5.packageDetailVisible = false;
			}, 800);
		}
	},
	mounted: function mounted() {
		this.getWorkingOutboundList();
		this.getArchivedOutboundList();
	}
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(272)))

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _securityService = __webpack_require__(48);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	created: function created() {
		var _this = this;

		this.$on('changeDoctor', function (value) {
			setTimeout(function () {
				_this.getNurseHome();
			}, 300);
		});
	},
	data: function data() {
		return {
			offers: {
				active: 0,
				expired: 0,
				proposed: 0
			},
			inbound: {
				inbound: 0,
				reported: 0
			},
			outbound: {
				outbound: 0
			},
			balance: {
				request: 0
			},
			loading: false
		};
	},

	methods: {
		getNurseHome: function getNurseHome() {
			var _this2 = this;

			var param = {
				doctorNo: window.sessionStorage.getItem("currentCompany")
			};
			this.loading = true;
			(0, _securityService.getNurseHome)(param).then(function (data) {
				_this2.loading = false;
				if (data.status === 200) {
					_this2.offers.active = data.result.activeOffer;
					_this2.offers.expired = data.result.expiredOffer;
					_this2.offers.proposed = data.result.proposedOffer;
					_this2.inbound.inbound = data.result.inboundItems;
					_this2.inbound.reported = data.result.reportItems;
					_this2.outbound.outbound = data.result.outBoundItems;
					_this2.balance.request = data.result.payment;
				} else {
					_this2.$message.error(data.message);
				}
			});
		}
	},
	mounted: function mounted() {
		this.getNurseHome();
	}
};

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vueQuillEditor = __webpack_require__(74);

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _memberService = __webpack_require__(20);

var _paymentService = __webpack_require__(105);

var _option = __webpack_require__(22);

var _option2 = _interopRequireDefault(_option);

var _globalVar = __webpack_require__(7);

var _exportService = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { ElOption: _option2.default },
    created: function created() {
        var _this = this;

        this.$on('changeDoctor', function (value) {
            setTimeout(function () {
                _this.getPaymentRequest();
                _this.getPendingTransaction();
                _this.getBalance();
                _this.getTransactionHistory();
            }, 300);
        });
    },
    data: function data() {
        return {
            editorOption: {
                theme: "snow",
                placeholder: "Note",
                height: "400px",
                modules: {
                    toolbar: {
                        container: [["bold", "italic", "underline", "strike"], ["link"]]
                    }
                }
            },
            currentUser: "",
            banks: [],
            currentCompany: "",
            activeName: "first",
            filters: {
                pendingFilter: "",
                paymentFilter: "",
                historyFilter: "",
                paymentStatus: "",
                name: ''
            },

            pageSize: _globalVar.defaultPageSize,
            paymentPage: 1,
            paymentTotal: 0,

            pendingPage: 1,
            pendingTotal: 0,

            balancePage: 1,
            balanceTotal: 0,

            historyPage: 1,
            historyTotal: 0,

            firstListLoading: false,
            secondListLoading: false,
            thirdListLoading: false,
            fourthListLoading: false,

            offers: [],
            transactions: [],
            pendingPayments: [],
            payments: [],
            paymentHistory: [],
            balances: [],
            total: 0,
            invitations: [],
            invitationTotalPage: 0,
            invitationPage: 1,
            listLoading: false,
            sels: [],
            requestVisible: false,
            addGroupVisible: false,
            invitationVisible: false,
            editLoading: false,
            requestFormRules: {
                amount: [{ required: true, message: 'Amount is required.', trigger: 'blur' }, { validator: this.validateAmount, trigger: 'blur' }],
                bank: [{ required: true, message: '', trigger: 'blur' }]
            },

            addFormVisible: false,
            loading: false,

            payment: {
                amount: "",
                bank: "",
                note: "",
                balance: 0,
                minPayment: 0
            }
        };
    },

    methods: {
        exportExcel: function exportExcel(url, fileName) {
            var param = {
                url: url,
                fileName: fileName,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            (0, _exportService.postExportExcel)(param).then(function () {});
        },

        formatMoney: function formatMoney(s, n) {
            n = n > 0 && n <= 20 ? n : 2;
            s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
            var l = s.split(".")[0].split("").reverse();
            var r = s.split(".")[1];
            var t = "";
            if (s < 0) {
                l = (Math.abs(s.split(".")[0]) + "").split("").reverse();
            }
            for (var i = 0; i < l.length; i++) {
                t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "");
            }
            if (s < 0) {
                t += "-";
            }
            var result = t.split("").reverse().join("") + "." + r;
            if (result == null || result == undefined || result.indexOf('NaN') >= 0 || result.indexOf('Undefined') >= 0) {
                result = '0.00';
            }
            return result;
        },
        showAddPayment: function showAddPayment() {
            var _this2 = this;

            var user = JSON.parse(sessionStorage.getItem("user"));
            var param = {
                doctorNo: window.sessionStorage.getItem("currentCompany"),
                nurseNo: user.userNo
            };
            (0, _memberService.getUserBalance)(param).then(function (res) {
                if (res.status === 200) {
                    _this2.payment.balance = res.result.balance;
                    _this2.payment.minPayment = res.result.minPayment;
                    _this2.requestVisible = true;
                }
            });
        },
        tableRowClassName: function tableRowClassName(_ref) {
            var row = _ref.row,
                rowIndex = _ref.rowIndex;

            if (row.amount < 0 || row.total < 0) {
                return 'reported-row';
            } else {
                return '';
            }
        },
        changePaymentRequest: function changePaymentRequest(val) {
            this.paymentPage = val;
            this.getPaymentRequest();
        },
        changePendingRequest: function changePendingRequest(val) {
            this.pendingPage = val;
            this.getPendingTransaction();
        },
        changeBalance: function changeBalance(val) {
            this.balancePage = val;
            this.getBalance();
        },
        changeTransactionHistory: function changeTransactionHistory(val) {
            this.historyPage = val;
            this.getTransactionHistory();
        },
        getTransactionHistory: function getTransactionHistory() {
            var _this3 = this;

            var param = {
                current: this.historyPage,
                size: this.pageSize,
                doctorNo: window.sessionStorage.getItem("currentCompany"),
                condition: this.filters.historyFilter
            };
            this.thirdListLoading = true;
            (0, _paymentService.getTransactionHistory)(param).then(function (data) {
                _this3.thirdListLoading = false;
                if (data.status === 200) {
                    _this3.transactions = data.result.records;
                    _this3.historyTotal = data.result.total;
                }
            });
        },
        editPaymentStatus: function editPaymentStatus(paymentNo, status) {
            var _this4 = this;

            this.$confirm("Are you sure?", "Warning", {
                type: "warning"
            }).then(function () {
                var param = {
                    paymentNo: paymentNo,
                    status: status
                };
                (0, _paymentService.editPaymentStatus)(param).then(function (data) {
                    if (data.status === 200) {
                        _this4.$message.success(data.message);
                        _this4.getPaymentRequest();
                    }
                });
            }).catch(function () {});
        },
        getBankList: function getBankList() {
            var _this5 = this;

            (0, _paymentService.getBankList)({}).then(function (data) {
                if (data.status === 200) {
                    _this5.banks = data.result;
                }
            });
        },
        getPendingTransaction: function getPendingTransaction() {
            var _this6 = this;

            var param = {
                current: this.pendingPage,
                size: this.pageSize,
                condition: this.filters.pendingFilter,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            this.secondListLoading = true;
            (0, _paymentService.getPendingTransaction)(param).then(function (data) {
                _this6.secondListLoading = false;
                if (data.status === 200) {
                    _this6.pendingPayments = data.result.records;
                    _this6.pendingTotal = data.result.total;
                }
            });
        },
        requestPayment: function requestPayment() {
            var _this7 = this;

            this.$refs.payment.validate(function (valid) {
                if (valid) {
                    _this7.loading = true;
                    var param = {
                        amount: _this7.payment.amount,
                        bankNo: _this7.payment.bank,
                        doctorNo: window.sessionStorage.getItem("currentCompany"),
                        nurseNote: _this7.payment.note
                    };
                    (0, _paymentService.addPaymentRequest)(param).then(function (data) {
                        _this7.loading = false;
                        if (data.status === 200) {
                            _this7.$message.success(data.message);
                            _this7.requestVisible = false;
                            _this7.$refs.payment.resetFields();
                            _this7.getPaymentRequest();
                            _this7.getTransactionHistory();
                        }
                    });
                }
            });
        },
        validateAmount: function validateAmount(rule, value, callback) {
            if (value > 0) {
                if (value < this.payment.minPayment) {
                    callback(new Error('Your amount must be greater than $' + this.payment.minPayment + '.'));
                } else {
                    callback();
                }
            } else {
                callback(new Error('Amount is required.'));
            }
        },
        getBalance: function getBalance() {
            var _this8 = this;

            var param = {
                current: this.balancePage,
                size: this.pageSize,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            this.fourthListLoading = true;
            (0, _paymentService.getBalance)(param).then(function (data) {
                _this8.fourthListLoading = false;
                if (data.status === 200) {
                    _this8.balances = data.result.records;
                    _this8.balanceTotal = data.result.total;
                }
            });
        },
        handleClick: function handleClick() {},
        getPaymentRequest: function getPaymentRequest() {
            var _this9 = this;

            var param = {
                current: this.paymentPage,
                size: this.pageSize,
                status: this.filters.paymentStatus,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            this.firstListLoading = true;
            (0, _paymentService.getPaymentRequest)(param).then(function (data) {
                _this9.firstListLoading = false;
                if (data.status === 200) {
                    _this9.payments = data.result.records;
                    _this9.paymentTotal = data.result.total;
                }
            });
        }
    },
    mounted: function mounted() {
        this.getPendingTransaction();
        this.getPaymentRequest();
        this.getBalance();
        this.getBankList();
        this.getTransactionHistory();
    }
};

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _warehouseService = __webpack_require__(59);

var _globalVar = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            categoryOption: [{
                value: 'Bill Pay',
                label: 'Bill Pay'
            }, {
                value: 'Bank Transfer',
                label: 'Bank Transfer'
            }],
            currencyOption: [{
                value: 'USD',
                label: 'United States Dollar'
            }, {
                value: 'CNY',
                label: 'China Yuan Renminbi'
            }, {
                value: 'BTC',
                label: 'Bitcoin'
            }],
            filters: {
                name: ''
            },
            editWarehouseObj: {},
            warehouses: [],

            listLoading: false,
            editFormVisible: false,
            editLoading: false,
            formRules: {
                state: [{ required: true, message: 'State is required', trigger: 'blur' }],
                city: [{ required: true, message: 'City is required', trigger: 'blur' }],
                address: [{ required: true, message: 'Address is required', trigger: 'blur' }],
                zipCode: [{ required: true, message: 'Zip Code is required', trigger: 'blur' }]
            },
            addFormVisible: false,
            addLoading: false,

            warehouseForm: {
                state: '',
                city: '',
                address: '',
                zipCode: '',
                admin: ''
            },

            page: 1,
            pageSize: _globalVar.defaultPageSize,
            total: 0

        };
    },

    methods: {
        formatAddress: function formatAddress(row, column) {
            return row.state + " " + row.city + " " + row.address;
        },
        pageChange: function pageChange(val) {
            this.page = val;
            this.getWarehouses();
        },
        deleteWarehouses: function deleteWarehouses(id) {
            var _this = this;

            this.$confirm("Are you sure?", "Warning", {
                type: "warning"
            }).then(function () {
                var param = {
                    warehouseNo: id
                };
                (0, _warehouseService.deleteWarehouses)(param).then(function (res) {
                    if (res.status === 200) {
                        _this.$message({
                            message: res.message,
                            type: 'success'
                        });
                        _this.getWarehouses();
                    } else {
                        _this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            }).catch(function () {});
        },
        getWarehousesById: function getWarehousesById(id) {
            var _this2 = this;

            var param = {
                warehouseNo: id
            };
            (0, _warehouseService.getWarehousesById)(param).then(function (res) {
                if (res.status === 200) {
                    _this2.editWarehouseObj = res.result.warehouse;
                    _this2.editFormVisible = true;
                } else {
                    _this2.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        getWarehouses: function getWarehouses() {
            var _this3 = this;

            this.listLoading = true;
            var param = {
                current: this.page,
                size: this.pageSize,
                condition: this.filters.name
            };
            (0, _warehouseService.getWarehouses)(param).then(function (res) {
                _this3.listLoading = false;
                if (res.status === 200) {
                    _this3.warehouses = res.result.records;
                    _this3.total = res.result.total;
                } else {
                    _this3.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            }).catch(function (error) {
                _this3.listLoading = false;
                console.log(error);
            });
        },
        addWarehouse: function addWarehouse() {
            var _this4 = this;

            this.$refs.warehouseForm.validate(function (valid) {
                if (valid) {
                    _this4.addLoading = true;
                    (0, _warehouseService.addWarehouses)(_this4.warehouseForm).then(function (res) {
                        _this4.addLoading = false;
                        _this4.$refs["warehouseForm"].resetFields();
                        if (res.status === 200) {
                            _this4.$message({
                                message: res.message,
                                type: 'success'
                            });
                            _this4.addFormVisible = false;
                            _this4.getWarehouses();
                        } else {
                            _this4.$message({
                                message: res.message,
                                type: 'error'
                            });
                        }
                    }).catch(function (err) {
                        console.log(err);
                        _this4.addLoading = false;
                    });
                }
            });
        },
        editWarehouse: function editWarehouse() {
            var _this5 = this;

            this.$refs.editWarehouseObj.validate(function (valid) {
                if (valid) {
                    _this5.addLoading = true;
                    (0, _warehouseService.addWarehouses)(_this5.editWarehouseObj).then(function (res) {
                        _this5.addLoading = false;
                        if (res.status === 200) {
                            _this5.$message({
                                message: res.message,
                                type: 'success'
                            });
                            _this5.editFormVisible = false;
                            _this5.getWarehouses();
                        } else {
                            _this5.$message({
                                message: res.message,
                                type: 'error'
                            });
                        }
                    }).catch(function (err) {
                        console.log(err);
                        _this5.addLoading = false;
                    });
                }
            });
        }
    },
    mounted: function mounted() {
        this.getWarehouses();
    }
};

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _securityService = __webpack_require__(48);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			account: {
				userName: "",
				phone: "",
				email: ""
			},
			loading: false,
			formRules: {
				phone: [{ validator: this.checkPhone, trigger: 'blur' }]
			}

		};
	},

	methods: {
		checkPhone: function checkPhone(rule, value, callback) {
			if (value.length === 10) {
				callback();
			} else {
				return callback(new Error("Phone only allow 10 digits."));
			}
		},
		changeUserInfo: function changeUserInfo() {
			var _this = this;

			this.$refs.account.validate(function (valid) {
				if (valid) {
					var param = {
						mobile: _this.account.phone
					};
					_this.loading = true;
					(0, _securityService.changeUserInfo)(param).then(function (res) {
						_this.loading = false;
						if (res.status === 200) {
							_this.getCurrentUser();
							_this.$message({
								message: res.message,
								type: "success"
							});
						} else {
							_this.$message({
								message: res.message,
								type: "error"
							});
						}
					});
				}
			});
		},
		getCurrentUser: function getCurrentUser() {
			var _this2 = this;

			(0, _securityService.getCurrentUser)().then(function (res) {
				if (res.status === 200) {
					_this2.account.userName = res.result.username;
					_this2.account.email = res.result.email;
					_this2.account.phone = res.result.mobile;
				}
			});
		}
	},
	mounted: function mounted() {
		var user = sessionStorage.getItem("user");
		this.getCurrentUser();
	}
};

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(134);

var _assign2 = _interopRequireDefault(_assign);

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _api = __webpack_require__(386);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			filters: {
				name: ''
			},
			users: [],
			total: 0,
			page: 1,
			listLoading: false,
			sels: [],

			editFormVisible: false,
			editLoading: false,
			editFormRules: {
				name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
			},

			editForm: {
				id: 0,
				name: '',
				sex: -1,
				age: 0,
				birth: '',
				addr: ''
			},

			addFormVisible: false,
			addLoading: false,
			addFormRules: {
				name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
			},

			addForm: {
				name: '',
				sex: -1,
				age: 0,
				birth: '',
				addr: ''
			}

		};
	},

	methods: {
		formatSex: function formatSex(row, column) {
			return row.sex == 1 ? '男' : row.sex == 0 ? '女' : '未知';
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
		},
		getUsers: function getUsers() {
			var _this = this;

			var para = {
				page: this.page,
				name: this.filters.name
			};
			this.listLoading = true;

			(0, _api.getUserListPage)(para).then(function (res) {
				_this.total = res.data.total;
				_this.users = res.data.users;
				_this.listLoading = false;
			});
		},

		handleDel: function handleDel(index, row) {
			var _this2 = this;

			this.$confirm('确认删除该记录吗?', '提示', {
				type: 'warning'
			}).then(function () {
				_this2.listLoading = true;

				var para = { id: row.id };
				(0, _api.removeUser)(para).then(function (res) {
					_this2.listLoading = false;

					_this2.$message({
						message: '删除成功',
						type: 'success'
					});
					_this2.getUsers();
				});
			}).catch(function () {});
		},

		handleEdit: function handleEdit(index, row) {
			this.editFormVisible = true;
			this.editForm = (0, _assign2.default)({}, row);
		},

		handleAdd: function handleAdd() {
			this.addFormVisible = true;
			this.addForm = {
				name: '',
				sex: -1,
				age: 0,
				birth: '',
				addr: ''
			};
		},

		editSubmit: function editSubmit() {
			var _this3 = this;

			this.$refs.editForm.validate(function (valid) {
				if (valid) {
					_this3.$confirm('确认提交吗？', '提示', {}).then(function () {
						_this3.editLoading = true;

						var para = (0, _assign2.default)({}, _this3.editForm);
						para.birth = !para.birth || para.birth == '' ? '' : _util2.default.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
						(0, _api.editUser)(para).then(function (res) {
							_this3.editLoading = false;

							_this3.$message({
								message: '提交成功',
								type: 'success'
							});
							_this3.$refs['editForm'].resetFields();
							_this3.editFormVisible = false;
							_this3.getUsers();
						});
					});
				}
			});
		},

		addSubmit: function addSubmit() {
			var _this4 = this;

			this.$refs.addForm.validate(function (valid) {
				if (valid) {
					_this4.$confirm('确认提交吗？', '提示', {}).then(function () {
						_this4.addLoading = true;

						var para = (0, _assign2.default)({}, _this4.addForm);
						para.birth = !para.birth || para.birth == '' ? '' : _util2.default.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
						(0, _api.addUser)(para).then(function (res) {
							_this4.addLoading = false;

							_this4.$message({
								message: '提交成功',
								type: 'success'
							});
							_this4.$refs['addForm'].resetFields();
							_this4.addFormVisible = false;
							_this4.getUsers();
						});
					});
				}
			});
		},
		selsChange: function selsChange(sels) {
			this.sels = sels;
		},

		batchRemove: function batchRemove() {
			var _this5 = this;

			var ids = this.sels.map(function (item) {
				return item.id;
			}).toString();
			this.$confirm('确认删除选中记录吗？', '提示', {
				type: 'warning'
			}).then(function () {
				_this5.listLoading = true;

				var para = { ids: ids };
				(0, _api.batchRemoveUser)(para).then(function (res) {
					_this5.listLoading = false;

					_this5.$message({
						message: '删除成功',
						type: 'success'
					});
					_this5.getUsers();
				});
			}).catch(function () {});
		}
	},
	mounted: function mounted() {}
};

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _globalVar = __webpack_require__(7);

var _paymentService = __webpack_require__(105);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            categoryOption: [{
                value: 'Bill Pay',
                label: 'Bill Pay'
            }, {
                value: 'Bank Transfer',
                label: 'Bank Transfer'
            }],
            currencyOption: [{
                value: 'USD',
                label: 'United States Dollar'
            }, {
                value: 'CNY',
                label: 'China Yuan Renminbi'
            }, {
                value: 'BTC',
                label: 'Bitcoin'
            }],
            filters: {
                name: ''
            },
            list: [],
            page: 1,
            pageSize: _globalVar.defaultPageSize,
            total: 0,
            loading: false,
            listLoading: false,
            sels: [],

            editFormVisible: false,
            editLoading: false,
            editFormRules: {
                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
            },

            addFormVisible: false,
            addFormRules: {
                category: [{ required: true, message: 'Category is required.', trigger: 'blur' }],
                currency: [{ required: true, message: 'Currency is required.', trigger: 'blur' }],
                accountNumber: [{ required: true, message: 'Account Number is required.', trigger: 'blur' }]
            },

            payment: {
                category: '',
                currency: '',
                bankName: '',
                accountType: '',
                accountHolder: '',
                accountNumber: '',
                bankAddress: ''
            },
            editPayment: {
                bankNo: '',
                category: '',
                currency: '',
                bankName: '',
                accountType: '',
                accountHolder: '',
                accountNumber: '',
                bankAddress: ''
            }

        };
    },

    methods: {
        showEditBank: function showEditBank(id) {
            var _this = this;

            (0, _paymentService.queryBankById)({ bankNo: id }).then(function (res) {
                if (res.status === 200) {
                    _this.editPayment = res.result.bank;
                    _this.editFormVisible = true;
                } else {
                    _this.$message({
                        message: res.message,
                        type: "error"
                    });
                }
            });
        },
        editBank: function editBank() {
            var _this2 = this;

            this.$refs.editPayment.validate(function (valid) {
                if (valid) {
                    var params = {
                        bankNo: _this2.editPayment.bankNo,
                        category: _this2.editPayment.category,
                        currency: _this2.editPayment.currency,
                        bankName: _this2.editPayment.bankName,
                        accountType: _this2.editPayment.accountType,
                        accountHolder: _this2.editPayment.accountHolder,
                        accountNumber: _this2.editPayment.accountNumber,
                        bankAddress: _this2.editPayment.bankAddress
                    };
                    _this2.loading = true;
                    (0, _paymentService.addBanks)(params).then(function (res) {
                        _this2.loading = false;
                        if (res.status === 200) {
                            _this2.$message({
                                message: res.message,
                                type: "success"
                            });
                            _this2.$refs.editPayment.resetFields();
                            _this2.editFormVisible = false;
                            _this2.getNursePayments();
                        } else {
                            _this2.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    }).catch(function (err) {
                        console.log(err);
                        _this2.loading = false;
                    });
                }
            });
        },
        addBank: function addBank() {
            var _this3 = this;

            this.$refs.payment.validate(function (valid) {
                if (valid) {
                    var params = {
                        category: _this3.payment.category,
                        currency: _this3.payment.currency,
                        bankName: _this3.payment.bankName,
                        accountType: _this3.payment.accountType,
                        accountHolder: _this3.payment.accountHolder,
                        accountNumber: _this3.payment.accountNumber,
                        bankAddress: _this3.payment.bankAddress
                    };
                    _this3.loading = true;
                    (0, _paymentService.addBanks)(params).then(function (res) {
                        _this3.loading = false;
                        if (res.status === 200) {
                            _this3.$message({
                                message: res.message,
                                type: "success"
                            });
                            _this3.$refs.payment.resetFields();
                            _this3.addFormVisible = false;
                            _this3.getNursePayments();
                        } else {
                            _this3.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    }).catch(function (err) {
                        console.log(err);
                        _this3.loading = false;
                    });
                }
            });
        },
        pageChange: function pageChange(val) {
            this.page = val;
            this.getNursePayments();
        },
        deleteBank: function deleteBank(id) {
            var _this4 = this;

            this.$confirm("Are you sure?", "Warning", {
                type: "warning"
            }).then(function () {
                (0, _paymentService.deleteNurseBanks)({ bankNo: id }).then(function (res) {
                    if (res.status === 200) {
                        _this4.$message({
                            message: res.message,
                            type: "success"
                        });
                        _this4.getNursePayments();
                    } else {
                        _this4.$message({
                            message: res.message,
                            type: "error"
                        });
                    }
                });
            }).catch(function () {});
        },
        getNursePayments: function getNursePayments() {
            var _this5 = this;

            this.listLoading = true;
            var params = {
                current: this.page,
                size: this.pageSize,
                condition: this.filters.name
            };
            (0, _paymentService.getNurseBanks)(params).then(function (res) {
                _this5.listLoading = false;
                if (res.status === 200) {
                    _this5.list = res.result.records;
                    _this5.total = res.result.total;
                } else {
                    _this5.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            }).catch(function (err) {
                _this5.listLoading = false;
                console.log(err);
            });
        }
    },
    mounted: function mounted() {
        this.getNursePayments();
    }
};

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _securityService = __webpack_require__(48);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            loading: false,
            account: {
                old: "",
                new: "",
                confirm: ""
            },
            rule: {
                old: [{ required: true, message: 'Old password is required.', trigger: 'blur' }],
                new: [{ required: true, message: 'New Password is required.', trigger: 'blur' }],
                confirm: [{ required: true, message: 'Confirm Password is required.', trigger: 'blur' }, { validator: this.confirmPassword, trigger: 'blur' }]
            }
        };
    },

    methods: {
        confirmPassword: function confirmPassword(rule, value, callback) {
            if (this.account.new === this.account.confirm) {
                callback();
            } else {
                callback(new Error('Please confirm Password.'));
            }
        },
        changePassword: function changePassword() {
            var _this = this;

            this.$refs.account.validate(function (valid) {
                if (valid) {
                    _this.loading = true;
                    var user = JSON.parse(sessionStorage.getItem("user"));
                    var param = {
                        username: user.username,
                        password: _this.account.old,
                        newPassword: _this.account.new,
                        reNewPassword: _this.account.confirm
                    };
                    (0, _securityService.changePassword)(param).then(function (res) {
                        _this.loading = false;
                        if (res.status === 200) {
                            _this.$refs.account.resetFields();
                            _this.$message({
                                message: res.message,
                                type: 'Password changed success, Please login again.'
                            });
                            setTimeout(function () {
                                sessionStorage.removeItem('user');
                                sessionStorage.removeItem('authorization');
                                window.location.href = "/";
                            }, 3000);
                        } else {
                            _this.$message({
                                message: res.message,
                                type: 'error'
                            });
                        }
                    }).catch(function (res) {
                        console.log(res);
                        _this.loading = false;
                    });
                }
            });
        }
    },
    mounted: function mounted() {}
};

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _securityService = __webpack_require__(48);

var inviteId = "";
var validate = false;
exports.default = {
    data: function data() {
        return {
            validate: validate,
            laoding: false,
            ruleForm2: {
                inviteId: inviteId,
                role: "",
                username: '',
                password: '',
                rePassword: ''
            },
            rules2: {
                username: [{ required: true, message: 'Please enter username', trigger: 'blur' }],
                password: [{ required: true, message: 'Please enter password', trigger: 'blur' }],
                rePassword: [{ required: true, message: 'Please confirm password', trigger: 'blur' }, { validator: this.validatePassword, trigger: 'blur' }]
            },
            checked: true
        };
    },

    methods: {
        validatePassword: function validatePassword(rule, value, callback) {
            if (this.ruleForm2.password !== this.ruleForm2.rePassword) {
                callback(new Error('Password not match.'));
            } else {
                callback();
            }
        },
        submitRegister: function submitRegister() {},
        handleSubmit: function handleSubmit(ev) {
            var _this2 = this;

            var _this = this;
            this.$refs.ruleForm2.validate(function (valid) {
                if (valid) {
                    _this2.laoding = true;
                    var params = {
                        userName: _this2.ruleForm2.username,
                        password: _this2.ruleForm2.password,
                        inviteId: _this2.ruleForm2.inviteId
                    };
                    (0, _securityService.register)(params).then(function (data) {
                        _this2.laoding = false;
                        if (data.status === 200) {
                            _this2.$message.success("Regist Success.");
                            setTimeout(function () {
                                _this2.$router.push({ path: "/login" });
                            }, 3000);
                        } else {
                            _this2.$message.error(data.message);
                        }
                    }).catch(function (error) {
                        _this2.laoding = false;
                        console.log(error);
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    },
    created: function created() {
        var _this3 = this;

        var query = this.$route.query;
        if (!query.id) {
            this.$router.push({ path: "/login" });
        } else {
            this.ruleForm2.inviteId = query.id;
            (0, _securityService.validateRegister)({ id: this.ruleForm2.inviteId }).then(function (data) {
                if (data.status === 200) {
                    _this3.validate = true;
                    _this3.ruleForm2.role = data.result.roleName;
                } else {
                    _this3.validate = false;
                    setTimeout(function () {
                        _this3.$router.push({ path: "/login" });
                    }, 3000);
                    _this3.$message.error(data.message);
                }
            }).catch(function (error) {
                console.log(error);
            });
        }
    }
};

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(106);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(41);

var _typeof3 = _interopRequireDefault(_typeof2);

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _memberService = __webpack_require__(20);

var _inboundService = __webpack_require__(102);

var _option = __webpack_require__(22);

var _option2 = _interopRequireDefault(_option);

var _input = __webpack_require__(100);

var _input2 = _interopRequireDefault(_input);

var _globalVar = __webpack_require__(7);

var _warehouseService = __webpack_require__(59);

var _exportService = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	created: function created() {
		var _this = this;

		this.$on('changeDoctor', function (value) {
			setTimeout(function () {
				_this.getToConfirmTrackingList();
				_this.getWarehouses();
				_this.getHistoryList();
			}, 300);
		});
	},

	components: {
		ElInput: _input2.default,
		ElOption: _option2.default },
	data: function data() {
		return {
			text: "",
			warehouses: [],
			headers: {
				Authorization: window.sessionStorage.getItem("authorization")
			},
			uploadUrl: _globalVar.serverUrl + "/multiExcel/batchInboundExcelImport",
			placeholder: "trackNum,upc,quantity,note\r\n" + "trackNum,upc,quantity,note",
			currentCompany: "",
			activeName: "first",
			filters: {
				toConfirmFilter: "",
				historyFilter: "",
				name: ''
			},

			batchNumbers: [],
			bulkConfirmList: [],
			bulkRemoveList: [],
			bulkReverseList: [],

			pageSize: _globalVar.defaultPageSize,

			toConfirmPage: 1,
			toConfirmTotal: 0,

			historyPage: 1,
			historyTotal: 0,

			firstListLoading: false,
			secondListLoading: false,

			toConfirmList: [],
			confirmInbound: [],
			reportedInbound: [],
			inboundHistory: [],
			total: 0,
			page: 1,
			listLoading: false,

			textImportVisible: false,
			excelImportVisible: false,

			editInbound: {},
			editInboundHistoryVisible: false,
			editToConfirmInboundVisible: false,
			bulkConfirmVisible: false,
			bulkRemoveVisible: false,
			bulkReverseVisible: false,

			importTrack: {
				warehouseNo: "",
				trackingNumbers: [],
				batchNumber: ""
			},
			editTracking: {
				id: "",
				trackingNumber: "",
				upc: "",
				qty: "",
				note: "",
				warehouseNo: ""
			},
			batchNumber: "",
			warehouseImportVisible: false,

			editLoading: false,

			addFormVisible: false,
			loading: false,
			importRule: {
				warehouseNo: [{ required: true, message: 'Warehouse is required.', trigger: 'blur' }],
				trackingNumbers: [{ required: true, message: 'Tracking list is required.', trigger: 'blur' }, { validator: this.checkTracking, trigger: 'blur' }]
			},
			editRule: {
				trackingNumber: [{ required: true, message: 'Tracking Number is required.', trigger: 'blur' }],
				upc: [{ required: true, message: 'UPC Number is required.', trigger: 'blur' }],
				warehouseNo: [{ required: true, message: 'Warehouse is required.', trigger: 'blur' }]
			},
			user: sessionStorage.getItem('user')

		};
	},

	methods: {
		sendMail: function sendMail() {
			var _this2 = this;

			if (this.bulkConfirmList.length > 0) {
				var upcList = this.bulkConfirmList.filter(function (item) {
					return item.productsList.length == 0;
				});
				if (upcList.length > 0) {
					var upcStr = upcList.map(function (item) {
						return item.upc;
					}).join(",");
					var param = {
						doctorId: window.sessionStorage.getItem("currentCompany"),
						upc: upcStr
					};
					(0, _warehouseService.sendEmail)(param).then(function (data) {
						if (data.code == 200) {
							_this2.$message.success("Success");
						}
					});
				} else {
					this.$message.error("None unassigned upc founded");
				}
			} else {
				this.$message.error("Empty confirm list.");
			}
		},
		exportExcel: function exportExcel(url, fileName, type) {
			var param = {
				url: url,
				fileName: fileName,
				doctorNo: window.sessionStorage.getItem("currentCompany"),
				type: type
			};
			(0, _exportService.postExportExcel)(param).then(function () {});
		},
		editConfirmedTracking: function editConfirmedTracking() {
			var _this3 = this;

			var param = {
				cwId: this.editInbound.cwId,
				note: this.editInbound.note,
				qty: this.editInbound.qty,
				doctorNo: window.sessionStorage.getItem("currentCompany")
			};
			this.$confirm("1.reverse the tracking with the original<br>" + "2.reUpload Tracking with updated qty", 'Warning', {
				type: 'warning',
				dangerouslyUseHTMLString: true
			}).then(function () {
				_this3.loading = true;
				(0, _inboundService.editInboundTracking)(param).then(function (data) {
					_this3.loading = false;
					if (data.status === 200) {
						_this3.$message.success(data.message);
						_this3.getHistoryList();
						_this3.getToConfirmTrackingList();
						_this3.editInboundHistoryVisible = false;
					} else {
						_this3.$message.error(data.message);
					}
				});
			}).catch(function () {});
		},
		bulkReverse: function bulkReverse() {
			var _this4 = this;

			if (this.batchNumber) {
				this.$confirm('Are you sure?', 'Warning', {
					type: 'warning'
				}).then(function () {
					var param = {
						batchNumber: _this4.batchNumber,
						doctorNo: window.sessionStorage.getItem("currentCompany")
					};
					_this4.loading = true;
					(0, _inboundService.bulkReverse)(param).then(function (data) {
						_this4.loading = false;
						if (data.status === 200) {
							_this4.$message.success(data.message);
							_this4.getHistoryList();
							_this4.getToConfirmTrackingList();
							_this4.bulkReverseVisible = false;
						} else {
							_this4.$message.error(data.message);
						}
					});
				}).catch(function () {});
			}
		},
		reverseById: function reverseById(id) {
			var _this5 = this;

			this.$confirm('Are you sure?', 'Warning', {
				type: 'warning'
			}).then(function () {
				_this5.loading = true;
				var param = {
					cwId: id,
					doctorNo: window.sessionStorage.getItem("currentCompany")
				};
				(0, _inboundService.reverseById)(param).then(function (data) {
					_this5.loading = false;
					if (data.status === 200) {
						_this5.$message.success(data.message);
						_this5.getHistoryList();
						_this5.getToConfirmTrackingList();
					} else {
						_this5.$message.error(data.message);
					}
				});
			}).catch(function () {});
		},
		bulkConfirm: function bulkConfirm() {
			var _this6 = this;

			if (this.bulkConfirmList.length === 0) {
				this.$message.error('Bulk confirm list is empty.');
				return;
			}
			var list = [];
			for (var i = 0; i < this.bulkConfirmList.length; i++) {
				if (!this.bulkConfirmList[i].productNo) {
					this.bulkConfirmList[i].error = true;
				} else {
					this.bulkConfirmList[i].error = false;
					var item = { productNo: this.bulkConfirmList[i].productNo, upc: this.bulkConfirmList[i].upc, forceChargeTime: this.bulkConfirmList[i].forceChargeTime };
					list.push(item);
				}
			}
			var errorList = this.bulkConfirmList.filter(function (item) {
				return item.error;
			});
			if (errorList.length > 0) {
				this.$message.error('Please select a product for each row.');
				return;
			}
			var param = {
				batchNumber: this.batchNumber,
				doctorNo: window.sessionStorage.getItem("currentCompany"),
				data: list
			};
			this.loading = true;
			(0, _inboundService.bulkConfirm)(param).then(function (data) {
				_this6.loading = false;
				if (data.status === 200) {
					_this6.bulkConfirmVisible = false;
					_this6.bulkConfirmList = [];
					_this6.batchNumber = "";
					_this6.getToConfirmTrackingList();
					_this6.getHistoryList();
				} else {
					_this6.$message.error(data.message);
				}
			});
		},
		bulkRemove: function bulkRemove() {
			var _this7 = this;

			if (this.batchNumber) {
				this.loading = true;
				var param = {
					batchNumber: this.batchNumber,
					doctorNo: window.sessionStorage.getItem("currentCompany"),
					data: this.toConfirmList
				};
				(0, _inboundService.bulkRemove)(param).then(function (data) {
					_this7.loading = false;
					if (data.status === 200) {
						_this7.bulkRemoveVisible = false;
						_this7.getToConfirmTrackingList();
						_this7.getHistoryList();
					} else {
						_this7.$message.error(data.message);
					}
				});
			} else {
				this.$message.error("You must select a batch number before bulk remove.");
			}
		},
		changeBatchNumberForBulkReverse: function changeBatchNumberForBulkReverse() {
			var _this8 = this;

			if (this.batchNumber) {
				var param = {
					doctorNo: window.sessionStorage.getItem("currentCompany"),
					batchNumber: this.batchNumber,
					current: 1,
					size: 99999,
					isReverse: 1
				};
				this.listLoading = true;
				(0, _inboundService.getTrackingList)(param).then(function (data) {
					_this8.listLoading = false;
					if (data.status === 200) {
						_this8.bulkReverseList = data.result.records;
					}
				});
			} else {
				this.bulkReverseList = [];
			}
		},
		changeBatchNumberForBulkRemove: function changeBatchNumberForBulkRemove() {
			var _this9 = this;

			if (this.batchNumber) {
				var param = {
					doctorNo: window.sessionStorage.getItem("currentCompany"),
					batchNumber: this.batchNumber,
					current: 1,
					size: 99999,
					type: 1
				};
				this.listLoading = true;
				(0, _inboundService.getTrackingList)(param).then(function (data) {
					_this9.listLoading = false;
					if (data.status === 200) {
						_this9.bulkRemoveList = data.result.records;
					}
				});
			} else {
				this.bulkRemoveList = [];
			}
		},
		changeBatchNumberForBulkConfirm: function changeBatchNumberForBulkConfirm() {
			var _this10 = this;

			if (this.batchNumber) {
				var param = {
					batchNumber: this.batchNumber,
					doctorNo: window.sessionStorage.getItem("currentCompany"),
					current: 1,
					size: 99999,
					type: 1
				};
				this.listLoading = true;
				(0, _inboundService.getBulkConfirmListByBatchNum)(param).then(function (data) {
					_this10.listLoading = false;
					if (data.status === 200) {
						var records = [];
						for (var i = 0; i < data.result.records.length; i++) {
							var record = data.result.records[i];
							if (record.productsList.length === 1) {
								record.productNo = record.productsList[0].productNo;
							} else {
								record.productNo = "";
							}
							records.push(record);
						}
						_this10.bulkConfirmList = records;
					}
				});
			} else {
				this.bulkConfirmList = [];
			}
		},
		showBulkReverse: function showBulkReverse() {
			var _this11 = this;

			this.getBatchNumberList(3).then(function () {
				_this11.batchNumber = "";
				_this11.bulkReverseList = [];
				_this11.bulkReverseVisible = true;
			});
		},
		showBulkRemove: function showBulkRemove() {
			var _this12 = this;

			this.getBatchNumberList(1).then(function () {
				_this12.batchNumber = "";
				_this12.bulkRemoveList = [];
				_this12.bulkRemoveVisible = true;
			});
		},
		showBulkConfirm: function showBulkConfirm() {
			var _this13 = this;

			this.getBatchNumberList(1).then(function () {
				_this13.batchNumber = "";
				_this13.bulkConfirmList = [];
				_this13.bulkConfirmVisible = true;
			});
		},
		getBatchNumberList: function getBatchNumberList(type) {
			var _this14 = this;

			var param = {
				type: type,
				doctorNo: window.sessionStorage.getItem("currentCompany")
			};
			return (0, _inboundService.getBatchNumberList)(param).then(function (data) {
				console.log(data);
				if (data.status === 200) {
					_this14.batchNumbers = data.result;
				} else {
					_this14.$message.error(data.message);
				}
			});
		},
		handleEdit: function handleEdit() {
			var _this15 = this;

			this.$refs.editTracking.validate(function (valid) {
				if (valid) {
					_this15.loading = true;
					var param = {
						cwId: _this15.editTracking.id,
						warehouseNo: _this15.editTracking.warehouseNo,
						tracking: _this15.editTracking.trackingNumber,
						upc: _this15.editTracking.upc,
						qty: _this15.editTracking.qty,
						note: _this15.editTracking.note
					};
					(0, _inboundService.editTrackingById)(param).then(function (data) {
						_this15.loading = false;
						if (data.status === 200) {
							_this15.$message.success(data.message);
							_this15.getToConfirmTrackingList();
							_this15.$refs.editTracking.resetFields();
							_this15.editToConfirmInboundVisible = false;
						} else {
							_this15.$message.error(data.message);
						}
					});
				}
			});
		},
		showEdit: function showEdit(id) {
			var _this16 = this;

			(0, _inboundService.getTrackingById)({ cwId: id }).then(function (data) {
				if (data.status === 200) {
					_this16.editTracking.id = data.result.cwId;
					_this16.editTracking.note = data.result.note;
					_this16.editTracking.qty = data.result.qty;
					_this16.editTracking.upc = data.result.upc;
					_this16.editTracking.warehouseNo = data.result.warehouseNo;
					_this16.editTracking.trackingNumber = data.result.tracking;
					_this16.editToConfirmInboundVisible = true;
				} else {
					_this16.$message.error(data.message);
				}
			});
		},
		removeTracking: function removeTracking(id) {
			var _this17 = this;

			this.$confirm('Are you sure?', 'Warning', {
				type: 'warning'
			}).then(function () {
				(0, _inboundService.removeTracking)({ cwId: id }).then(function (data) {
					if (data.status === 200) {
						_this17.$message.success(data.message);
						_this17.getToConfirmTrackingList();
					} else {
						_this17.$message.error(data.message);
					}
				});
			}).catch(function () {});
		},
		importTracking: function importTracking() {
			var _this18 = this;

			this.$refs.importTrack.validate(function (valid) {
				if (valid) {
					_this18.loading = true;
					var param = {
						batchNumber: _this18.importTrack.batchNumber,
						doctorNo: window.sessionStorage.getItem("currentCompany"),
						warehouseNo: _this18.importTrack.warehouseNo,
						data: _this18.importTrack.trackingNumbers
					};
					(0, _inboundService.importTracking)(param).then(function (data) {
						_this18.loading = false;
						if (data.status === 200) {
							_this18.$message.success(data.message);
							_this18.$refs.importTrack.resetFields();
							_this18.importTrack.trackingNumbers = [];
							_this18.warehouseImportVisible = false;
							_this18.getToConfirmTrackingList();
						} else {
							_this18.$message.error(data.message);
						}
					});
				}
			});
		},
		checkTracking: function checkTracking(rule, value, callback) {
			if (!value.length > 0) {
				return callback(new Error('Tracking list is empty.'));
			} else {
				callback();
			}
		},
		uploadSuccess: function uploadSuccess(a) {
			var _this19 = this;

			if (a.status === 200) {
				var trackingNumbers = [];

				var _loop = function _loop(i) {
					var exsit = trackingNumbers.find(function (item) {
						return item.upc == a.result[i].upc && item.tracking == a.result[i].trackingNumber && item.qty == a.result[i].qty;
					});
					if (exsit) {
						_this19.$message.error("Same data exists, please check.");
						_this19.$refs.upload.clearFiles();
						return {
							v: void 0
						};
					}
					trackingNumbers.push({ note: a.result[i].note, qty: a.result[i].qty, upc: a.result[i].upc, tracking: a.result[i].trackingNumber });
				};

				for (var i = 0; i < a.result.length; i++) {
					var _ret = _loop(i);

					if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
				}
				this.importTrack.trackingNumbers = trackingNumbers;
				this.excelImportVisible = false;
				this.$refs.upload.clearFiles();
			} else {
				this.$message.error(a.message);
			}
		},
		uploadError: function uploadError(a) {
			this.$message.error(a.message);
			this.$refs.upload.clearFiles();
		},
		getWarehouses: function getWarehouses() {
			var _this20 = this;

			(0, _warehouseService.getWarehouseForWarehouseAdmin)({ doctorNo: window.sessionStorage.getItem("currentCompany") }).then(function (data) {
				if (data.code === 200) {
					_this20.warehouses = data.records;
				}
			});
		},
		changeConfirmPage: function changeConfirmPage(val) {
			this.toConfirmPage = val;
			this.getToConfirmTrackingList();
		},
		getToConfirmTrackingList: function getToConfirmTrackingList() {
			var _this21 = this;

			var param = {
				doctorNo: window.sessionStorage.getItem("currentCompany"),
				current: this.toConfirmPage,
				size: this.pageSize,
				type: 1,
				condition: this.filters.toConfirmFilter
			};
			this.firstListLoading = true;
			(0, _inboundService.getTrackingList)(param).then(function (data) {
				_this21.firstListLoading = false;
				if (data.status === 200) {
					_this21.toConfirmList = data.result.records;
					_this21.toConfirmTotal = data.result.total;
				}
			});
		},
		changeHistoryList: function changeHistoryList(val) {
			this.historyPage = val;
			this.getHistoryList();
		},
		getHistoryList: function getHistoryList() {
			var _this22 = this;

			var param = {
				doctorNo: window.sessionStorage.getItem("currentCompany"),
				current: this.historyPage,
				size: this.pageSize,
				type: 3,
				condition: this.filters.historyFilter
			};
			this.secondListLoading = true;
			(0, _inboundService.getTrackingList)(param).then(function (data) {
				_this22.secondListLoading = false;
				if (data.status === 200) {
					_this22.inboundHistory = data.result.records;
					_this22.historyTotal = data.result.total;
				}
			});
		},
		showImport: function showImport() {
			var _this23 = this;

			(0, _inboundService.getBatchNumber)().then(function (data) {
				if (data.status === 200) {
					_this23.importTrack.batchNumber = data.result.batchNumber;
					_this23.warehouseImportVisible = true;
				} else {
					_this23.$message.error(data.message);
				}
			});
		},
		removeRow: function removeRow(row) {
			this.importTrack.trackingNumbers.splice(this.importTrack.trackingNumbers.indexOf(row), 1);
		},
		removeAllItem: function removeAllItem() {
			this.importTrack.trackingNumbers.splice(0);
		},
		removeItem: function removeItem(row) {
			this.bulkConfirmList.splice(this.bulkConfirmList.indexOf(row), 1);
		},
		importFromText: function importFromText() {
			var _this24 = this;

			var text = this.text.trim();
			if (!text) {
				this.$message.error("Please enter import text.");
				return;
			}
			var row = [];
			var trackings = [];
			var existTrackings = [];
			var lines = text.split("\n");
			lines.filter(function (line) {
				return line.trim() !== '';
			}).forEach(function (line) {
				var obj = {};
				var columns = [];
				if (line.indexOf(" ") !== -1) {
					columns = line.split(" ");
				} else if (line.indexOf("\t") !== -1) {
					columns = line.split("\t");
				} else if (line.indexOf(",") !== -1) {
					columns = line.split(",");
				}
				obj.tracking = columns[0] ? columns[0].trim() : "";
				obj.upc = columns[1] ? columns[1].trim() : "";
				obj.qty = columns[2] ? columns[2].trim() : "";
				obj.note = columns[3] ? columns[3].trim() : "";

				var existInput = trackings.find(function (item) {
					return item.tracking === obj.tracking && item.upc === obj.upc && item.qty === obj.qty;
				});
				if (existInput) {
					existTrackings.push(obj.tracking);
				}

				var exist = _this24.importTrack.trackingNumbers.find(function (item) {
					return item.tracking === obj.tracking && item.upc === obj.upc && item.qty === obj.qty;
				});
				if (!exist) {
					trackings.push(obj);
				} else {
					existTrackings.push(obj.tracking);
				}
			});


			if (existTrackings.length > 0) {
				this.$message.error("Same data tracking for \"" + existTrackings.join(", ") + "\" exists, please check.");
				return;
			}
			this.text = "";
			this.importTrack.trackingNumbers.push.apply(this.importTrack.trackingNumbers, trackings);
			this.textImportVisible = false;
		},
		editInboundHistory: function editInboundHistory(row) {
			this.editInboundHistoryVisible = true;
			this.editInbound = {};
			this.editInbound = JSON.parse((0, _stringify2.default)(row));
		},
		confirmWarehouseItem: function confirmWarehouseItem(row) {
			this.importTrack.company = row.company;
			this.importTrack.warehouse = row.warehouse;
			this.importTrack.price = row.price;
			this.importTrack.quantity = row.quantity;
			this.importTrack.product = row.product;
			this.warehouseConfirmVisible = true;
		}
	},
	mounted: function mounted() {
		this.getWarehouses();
		this.getToConfirmTrackingList();
		this.getHistoryList();


		var user = sessionStorage.getItem('user');
		user = JSON.parse(user);
		this.user = user;
	}
};

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _globalVar = __webpack_require__(7);

var _boxsizeService = __webpack_require__(387);

var _customBoxSizeConfigService = __webpack_require__(388);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            firstLoading: false,
            secondLoading: false,
            thirdLoading: false,
            pageSize: _globalVar.defaultPageSize,

            activeName: "first",

            filters: {
                email: ''
            },

            boxSizes: [],

            userRates: [],

            customCategoryConfigs: [],

            total: 0,
            page: 1,

            editVisible: false,
            customEditVisible: false,

            editLoading: false,
            customEditLoading: false,
            editFormRules: {
                sizeLabel: [{ required: true, message: 'Short label is required.', trigger: 'blur' }],
                sizeDefined: [{ required: true, message: 'Full label is required.', trigger: 'blur' }],
                inboundBaseFee: [{ required: true, message: 'Inbound Base Fee is required.', trigger: 'blur' }],
                inboundRate: [{ required: true, message: 'Inbound Rate is required.', trigger: 'blur' }],
                outboundBaseFee: [{ required: true, message: 'Outbound Base Fee is required.', trigger: 'blur' }],
                outboundRate: [{ required: true, message: 'Outbound Rate is required.', trigger: 'blur' }],
                storageBaseFee: [{ required: true, message: 'Storage Base Fee is required.', trigger: 'blur' }],
                storageBaseFeeOver: [{ required: true, message: 'Storage Base Fee Over is required.', trigger: 'blur' }],
                isPrintBarCode: [{ required: true, message: 'Please set is print bar code.', trigger: 'blur' }]
            },

            addCategory: {
                sizeLabel: "",
                sizeDefined: "",
                inboundBaseFee: 0.0,
                inboundRate: 0.0,
                outboundBaseFee: 0.0,
                outboundRate: 0.0,
                storageBaseFee: 0.0,
                storageBaseFeeOver: 0.0,
                desc: "",
                isPrintBarCode: 0,
                id: null
            },

            editCategory: {
                sizeLabel: "",
                sizeDefined: "",
                inboundBaseFee: 0.0,
                inboundRate: 0.0,
                outboundBaseFee: 0.0,
                outboundRate: 0.0,
                storageBaseFee: 0.0,
                storageBaseFeeOver: 0.0,
                desc: "",
                isPrintBarCode: 0,
                id: null
            },

            customEditCategory: {
                boxSizeId: null,
                doctorNo: "",
                inboundBaseFee: 0.0,
                inboundRate: 0.0,
                outboundBaseFee: 0.0,
                outboundRate: 0.0,
                storageBaseFee: 0.0,
                storageBaseFeeOver: 0.0,
                id: null
            },

            addFormVisible: false,
            userRateVisible: false,
            customCategoryVisible: false,
            formRules: {
                sizeLabel: [{ required: true, message: 'Short label is required.', trigger: 'blur' }],
                sizeDefined: [{ required: true, message: 'Full label is required.', trigger: 'blur' }],
                inboundBaseFee: [{ required: true, message: 'Inbound Base Fee is required.', trigger: 'blur' }],
                inboundRate: [{ required: true, message: 'Inbound Rate is required.', trigger: 'blur' }],
                outboundBaseFee: [{ required: true, message: 'Outbound Base Fee is required.', trigger: 'blur' }],
                outboundRate: [{ required: true, message: 'Outbound Rate is required.', trigger: 'blur' }],
                storageBaseFee: [{ required: true, message: 'Storage Base Fee is required.', trigger: 'blur' }],
                storageBaseFeeOver: [{ required: true, message: 'Storage Base Fee Over is required.', trigger: 'blur' }],
                isPrintBarCode: [{ required: true, message: 'Please set is print bar code.', trigger: 'blur' }]
            }
        };
    },

    methods: {
        formatHasBeanSet: function formatHasBeanSet(row, column) {
            if (row.hasSingleSeted === true) {
                return "Already Set";
            } else {
                return "Not Set";
            }
        },
        formatPrintStatus: function formatPrintStatus(row, column) {
            if (row.isPrintBarCode === 1) {
                return "Printed";
            } else {
                return "Not Print";
            }
        },
        handlePageChange: function handlePageChange(val) {
            this.page = val;
            this.getBoxSizeList();
        },
        handleAddBoxSize: function handleAddBoxSize() {
            var _this = this;

            this.$refs.addCategory.validate(function (valid) {
                if (valid) {
                    _this.loading = true;
                    var param = {
                        sizeLabel: _this.addCategory.sizeLabel,
                        sizeDefined: _this.addCategory.sizeDefined,
                        inboundBaseFee: _this.addCategory.inboundBaseFee,
                        inboundRate: _this.addCategory.inboundRate,
                        outboundBaseFee: _this.addCategory.outboundBaseFee,
                        outboundRate: _this.addCategory.outboundRate,
                        storageBaseFee: _this.addCategory.storageBaseFee,
                        storageBaseFeeOver: _this.addCategory.storageBaseFeeOver,
                        desc: _this.addCategory.desc,
                        isPrintBarCode: _this.addCategory.isPrintBarCode,
                        id: null
                    };
                    (0, _boxsizeService.editBoxSize)(param).then(function (res) {
                        _this.loading = false;
                        if (res.status === 200) {
                            _this.addFormVisible = false;
                            _this.$message.success(res.message);
                            _this.$refs.addCategory.resetFields();
                            _this.getBoxSizeList();
                        } else {
                            _this.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    });
                }
            });
        },
        showAdd: function showAdd() {
            this.addFormVisible = true;
            this.addCategory.id = null;
            this.addCategory.sizeLabel = "";
            this.addCategory.sizeDefined = "";
            this.addCategory.inboundBaseFee = 0;
            this.addCategory.inboundRate = 0;
            this.addCategory.outboundBaseFee = 0;
            this.addCategory.outboundRate = 0;
            this.addCategory.storageBaseFee = 0;
            this.addCategory.storageBaseFeeOver = 0;
            this.addCategory.desc = "";
            this.addCategory.isPrintBarCode = 0;
        },
        showEdit: function showEdit(row) {
            var _this2 = this;

            (0, _boxsizeService.getBoxSizeById)(row).then(function (res) {
                if (res.status === 200) {
                    _this2.editVisible = true;
                    _this2.editCategory = res.result;
                }
            });
        },
        showCustomEdit: function showCustomEdit(row) {
            var _this3 = this;

            var para = {
                doctorNo: row.doctorNo,
                boxSizeId: row.boxSizeId,
                id: row.id
            };
            (0, _customBoxSizeConfigService.getCustomBoxSizeById)(para).then(function (res) {
                if (res.status === 200) {
                    _this3.customEditVisible = true;
                    _this3.customEditCategory = res.result;
                }
            });
        },
        deleteCustomItem: function deleteCustomItem(row) {
            var _this4 = this;

            this.editLoading = true;
            var para = {
                doctorNo: row.doctorNo,
                boxSizeId: row.boxSizeId,
                id: row.id
            };
            (0, _customBoxSizeConfigService.deleteCustomBoxSizeConfigs)(para).then(function (res) {
                _this4.editLoading = false;
                if (res.status === 200) {
                    _this4.$message({
                        message: res.message,
                        type: "success"
                    });
                    _this4.showCategoryEdit(row.doctorNo);
                    _this4.editVisible = false;
                } else {
                    _this4.$message({
                        message: res.message,
                        type: "error"
                    });
                }
            });
        },
        editSubmit: function editSubmit() {
            var _this5 = this;

            this.editLoading = true;
            var para = {
                sizeLabel: this.editCategory.sizeLabel,
                sizeDefined: this.editCategory.sizeDefined,
                inboundBaseFee: this.editCategory.inboundBaseFee,
                inboundRate: this.editCategory.inboundRate,
                outboundBaseFee: this.editCategory.outboundBaseFee,
                outboundRate: this.editCategory.outboundRate,
                storageBaseFee: this.editCategory.storageBaseFee,
                storageBaseFeeOver: this.editCategory.storageBaseFeeOver,
                desc: this.editCategory.desc,
                isPrintBarCode: this.editCategory.isPrintBarCode,
                id: this.editCategory.id
            };
            (0, _boxsizeService.editBoxSize)(para).then(function (res) {
                _this5.editLoading = false;
                if (res.status === 200) {
                    _this5.$message({
                        message: res.message,
                        type: "success"
                    });
                    _this5.getBoxSizeList();
                    _this5.editVisible = false;
                } else {
                    _this5.$message({
                        message: res.message,
                        type: "error"
                    });
                }
            });
        },
        customEditSubmit: function customEditSubmit() {
            var _this6 = this;

            this.customEditLoading = true;
            var para = {
                boxSizeId: this.customEditCategory.boxSizeId,
                doctorNo: this.customEditCategory.doctorNo,
                inboundBaseFee: this.customEditCategory.inboundBaseFee,
                inboundRate: this.customEditCategory.inboundRate,
                outboundBaseFee: this.customEditCategory.outboundBaseFee,
                outboundRate: this.customEditCategory.outboundRate,
                storageBaseFee: this.customEditCategory.storageBaseFee,
                storageBaseFeeOver: this.customEditCategory.storageBaseFeeOver,
                id: this.customEditCategory.id
            };
            (0, _customBoxSizeConfigService.editCustomBoxSizeConfigs)(para).then(function (res) {
                _this6.customEditLoading = false;
                _this6.customEditVisible = false;
                if (res.status === 200) {
                    _this6.$message({
                        message: res.message,
                        type: "success"
                    });
                    _this6.getDoctorCustomCategoryRate(_this6.customEditCategory.doctorNo);
                } else {
                    _this6.$message({
                        message: res.message,
                        type: "error"
                    });
                }
            });
        },
        getBoxSizeList: function getBoxSizeList() {
            var _this7 = this;

            var para = {
                current: this.page,
                size: this.pageSize
            };

            this.firstLoading = true;
            (0, _boxsizeService.getBoxSizeList)(para).then(function (res) {
                _this7.firstLoading = false;
                if (res.status === 200) {
                    _this7.boxSizes = res.result.records;
                    _this7.total = res.result.total;
                } else {
                    _this7.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        getAllUserRate: function getAllUserRate() {
            var _this8 = this;

            var para = {
                current: 1,
                size: 1000
            };

            this.secondLoading = true;
            (0, _customBoxSizeConfigService.getDoctorUserList)(para).then(function (res) {
                _this8.secondLoading = false;
                if (res.status === 200) {
                    _this8.userRates = res.result.records;
                    _this8.total = res.result.total;
                } else {
                    _this8.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        getDoctorCustomCategoryRate: function getDoctorCustomCategoryRate(rowDoctorNo) {
            var _this9 = this;

            var para = {
                current: 1,
                size: 1000,
                doctorNo: rowDoctorNo
            };

            this.thirdLoading = true;
            (0, _customBoxSizeConfigService.getCustomBoxSizeList)(para).then(function (res) {
                _this9.thirdLoading = false;
                if (res.status === 200) {
                    _this9.customCategoryConfigs = res.result;
                } else {
                    _this9.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        showUserRate: function showUserRate() {
            this.userRateVisible = true;
            this.getAllUserRate();
        },
        showCategoryEdit: function showCategoryEdit(rowDoctorNo) {
            this.customCategoryVisible = true;
            this.getDoctorCustomCategoryRate(rowDoctorNo);
        }
    },
    mounted: function mounted() {
        this.getBoxSizeList();
    }
};

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _globalVar = __webpack_require__(7);

var _discountService = __webpack_require__(207);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            firstLoading: false,
            pageSize: _globalVar.defaultPageSize,

            activeName: "first",

            filters: {
                email: ''
            },

            discounts: [],

            total: 0,
            page: 1,

            editVisible: false,

            editLoading: false,
            editFormRules: {
                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
            },

            editDiscount: {
                userNo: "",
                doctorNo: "",
                doctorName: "",
                storageFreeDuration: 3,
                discountRate: 1.00,
                storageFeeOverDays: undefined,
                id: null
            },

            addFormVisible: false,
            addLoading: false,
            formRules: {
                storageFreeDuration: [{ required: true, message: 'Storage Free Duration is required.', trigger: 'blur' }],
                discountRate: [{ required: true, message: 'Discount Rate is required.', trigger: 'blur' }]
            }

        };
    },

    methods: {
        handlePageChange: function handlePageChange(val) {
            this.page = val;
            this.getDiscounts();
        },
        showEdit: function showEdit(row) {
            this.editDiscount = row;
            this.editVisible = true;
        },
        editSubmit: function editSubmit() {
            var _this = this;

            this.editLoading = true;
            var para = {
                userNo: this.editDiscount.userNo,
                doctorNo: this.editDiscount.doctorNo,
                doctorName: this.editDiscount.doctorName,
                storageFreeDuration: this.editDiscount.storageFreeDuration,
                discountRate: this.editDiscount.discountRate,
                storageFeeOverDays: this.editDiscount.storageFeeOverDays,
                id: this.editDiscount.id
            };
            (0, _discountService.editDiscount)(para).then(function (res) {
                _this.editLoading = false;
                if (res.status === 200) {
                    _this.$message({
                        message: res.message,
                        type: "success"
                    });
                    _this.getDiscounts();
                    _this.editVisible = false;
                } else {
                    _this.$message({
                        message: res.message,
                        type: "error"
                    });
                }
            });
        },
        getDiscounts: function getDiscounts() {
            var _this2 = this;

            var para = {
                current: this.page,
                size: this.pageSize
            };

            this.firstLoading = true;
            (0, _discountService.getDiscountList)(para).then(function (res) {
                _this2.firstLoading = false;
                if (res.status === 200) {
                    _this2.discounts = res.result.records;
                    _this2.total = res.result.total;
                } else {
                    _this2.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        }
    },
    mounted: function mounted() {
        this.getDiscounts();
    }
};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _globalVar = __webpack_require__(7);

var _discountService = __webpack_require__(207);

var _storageFeePaymentService = __webpack_require__(209);

var _paymentService = __webpack_require__(105);

var _paymentService4Warehouse = __webpack_require__(208);

var _exportService = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            firstLoading: false,
            pageSize: _globalVar.defaultPageSize,

            isEnable: true,

            filters: {
                productName: "",
                feeType: "",
                conditionSearch: "",
                paymentStatus: "",

                searchMonth: ""
            },

            activeName: "first",

            storageFeePayments: [],

            loading: false,

            warehouseFeeDetail: [],
            warehouseFeeSummary: [],

            storageFeePaymentPage: 1,
            storageFeePaymentTotal: 0,

            warehouseFeeDetailPage: 1,
            warehouseFeeDetailTotal: 0,
            warehouseFeeDetailModelVisible: false,

            warehouseFeeSummaryPage: 1,
            warehouseFeeSummaryTotal: 0,
            warehouseFeeSummaryModelVisible: false,

            warehouseFeeLoading: false,
            warehouseFeeSummaryLoading: false,
            warehouseFeeDetailId: null,
            warehouseFeeProductNo: null,
            conditionSearch: "",

            feeTypeList: [{ id: 0, value: "Inbound" }, { id: 1, value: "Outbound" }, { id: 2, value: "Storage" }],

            banks: [],
            requestFormRules: {
                amount: [{ required: true, message: 'Payable amount is required.', trigger: 'blur' }, { validator: this.validateAmount, trigger: 'blur' }],
                bank: [{ required: true, message: '', trigger: 'blur' }]
            },
            editorOption: {
                theme: "snow",
                placeholder: "Note",
                height: "400px",
                modules: {
                    toolbar: {
                        container: [["bold", "italic", "underline", "strike"], ["link"]]
                    }
                }
            },

            editVisible: false,
            paymentListVisible: false,
            requestVisible: false,

            editLoading: false,
            editFormRules: {
                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
            },

            editDiscount: {
                userNo: "",
                doctorNo: "",
                doctorName: "",
                storageFreeDuration: 3,
                discountRate: 1.00,
                id: null
            },

            paymentPage: 1,
            paymentTotal: 0,
            payment: {
                amount: 0,
                bank: "",
                note: "",
                balance: 0,
                minPayment: 0.1,
                payStatus: 0,
                doctorNo: "",
                monthlyStorageFeeId: "" },
            isPaymentPending: false,
            paymentLoading: false,
            payments: [],

            addFormVisible: false,
            addLoading: false,
            formRules: {
                storageFreeDuration: [{ required: true, message: 'Storage Free Duration is required.', trigger: 'blur' }],
                discountRate: [{ required: true, message: 'Discount Rate is required.', trigger: 'blur' }]
            },
            user: sessionStorage.getItem('user'),

            requestRebuildVisible: false,
            rebuildDailyModel: {
                dates: ""
            },

            requestRebuildMonthVisible: false,
            rebuildMonthModel: {
                month: ""
            }

        };
    },

    methods: {
        dateFormat: function dateFormat(row, column) {
            if (row) {
                var dT = new Date(row);
                return dT.getFullYear() + "-" + (dT.getMonth() + 1) + "-" + dT.getDate();
            } else {
                return "";
            }
        },
        changeSearchMonth: function changeSearchMonth(val) {
            this.filters.searchMonth = val;
            this.getStorageFeePaymentList();
        },
        exportExcel: function exportExcel(url, fileName, type) {
            var param = {
                url: url,
                fileName: fileName,
                doctorNo: window.sessionStorage.getItem("currentCompany"),
                payNo: this.warehouseFeeDetailId,
                productNo: this.warehouseFeeProductNo,
                productName: this.filters.productName,
                feeType: this.filters.feeType,
                condition: this.filters.conditionSearch
            };
            (0, _exportService.postExportExcel)(param).then(function () {});
        },
        changeStorageFeePayment: function changeStorageFeePayment(val) {
            this.storageFeePaymentPage = val;
            this.getStorageFeePaymentList();
        },

        formatMoney: function formatMoney(s, n) {
            n = n > 0 && n <= 20 ? n : 2;
            s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
            var l = s.split(".")[0].split("").reverse();
            var r = s.split(".")[1];
            var t = "";
            if (s < 0) {
                l = (Math.abs(s.split(".")[0]) + "").split("").reverse();
            }
            for (var i = 0; i < l.length; i++) {
                t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "");
            }
            if (s < 0) {
                t += "-";
            }
            var result = t.split("").reverse().join("") + "." + r;
            if (result == null || result == undefined || result.indexOf('NaN') >= 0 || result.indexOf('Undefined') >= 0) {
                result = '0.00';
            }
            return result;
        },
        changeWarehouseFeeDetail: function changeWarehouseFeeDetail(val) {
            this.warehouseFeeDetailPage = val;
            this.getStorageFeePaymentDetail(this.warehouseFeeProductNo, val);
        },
        changeWarehouseFeeSummary: function changeWarehouseFeeSummary(val) {
            this.warehouseFeeSummaryPage = val;
            this.getStorageFeePaymentSummary(this.warehouseFeeDetailId);
        },
        getStorageFeePaymentList: function getStorageFeePaymentList() {
            var _this = this;

            var param = {
                current: this.storageFeePaymentPage,
                size: this.pageSize,
                searchMonth: this.filters.searchMonth
            };
            this.loading = true;
            (0, _storageFeePaymentService.getWarehouseList)(param).then(function (data) {
                _this.loading = false;
                if (data.status === 200) {
                    _this.storageFeePayments = data.result.records;
                    _this.storageFeePaymentTotal = data.result.total;
                }
            });
        },
        getStorageFeePaymentDetail: function getStorageFeePaymentDetail(productNo, page) {
            var _this2 = this;

            this.warehouseFeeDetailPage = page;
            if (productNo) {
                this.warehouseFeeProductNo = productNo;
            }
            var param = {
                current: page,
                size: this.pageSize,
                payNo: this.warehouseFeeDetailId,
                productNo: this.warehouseFeeProductNo,
                productName: this.filters.productName,
                feeType: this.filters.feeType
            };
            this.warehouseFeeDetailModelVisible = true;
            this.warehouseFeeLoading = true;
            (0, _storageFeePaymentService.warehouseFeeDetail)(param).then(function (data) {
                _this2.warehouseFeeLoading = false;
                if (data.status === 200) {
                    _this2.warehouseFeeDetail = data.result.records;
                    _this2.warehouseFeeDetailTotal = data.result.total;
                }
            });
        },
        getStorageFeePaymentSummary: function getStorageFeePaymentSummary(id) {
            var _this3 = this;

            this.warehouseFeeDetailId = id;
            var param = {
                current: this.warehouseFeeSummaryPage,
                size: this.pageSize,
                condition: this.filters.conditionSearch,
                payNo: id
            };
            this.warehouseFeeSummaryModelVisible = true;
            this.warehouseFeeSummaryLoading = true;
            (0, _storageFeePaymentService.warehouseFeeSummary)(param).then(function (data) {
                _this3.warehouseFeeSummaryLoading = false;
                if (data.status === 200) {
                    _this3.warehouseFeeSummary = data.result.records;
                    _this3.warehouseFeeSummaryTotal = data.result.total;
                }
            });
        },
        getBankList: function getBankList() {
            var _this4 = this;

            (0, _paymentService.getBankList)({}).then(function (data) {
                if (data.status === 200) {
                    _this4.banks = data.result;
                }
            });
        },
        showPaymentList: function showPaymentList(row) {
            this.payment.balance = row.totalFee;
            this.payment.amount = parseFloat(row.totalFee);
            this.payment.payStatus = row.payStatus;
            this.payment.monthlyStorageFeeId = row.id;
            this.payment.doctorNo = row.doctorNo;
            this.paymentListVisible = true;
            this.getPaymentRequest();
        },
        showAddPayment: function showAddPayment() {
            this.getBankList();
            this.requestVisible = true;
        },
        requestPayment: function requestPayment() {
            var _this5 = this;

            this.$refs.payment.validate(function (valid) {
                if (valid) {
                    _this5.loading = true;
                    var param = {
                        amount: _this5.payment.amount,
                        bankNo: _this5.payment.bank,
                        doctorNo: _this5.payment.doctorNo,
                        warehouseNote: _this5.payment.note,
                        monthlyStorageFeeId: _this5.payment.monthlyStorageFeeId
                    };
                    (0, _paymentService4Warehouse.addPaymentRequest4Warehouse)(param).then(function (data) {
                        _this5.loading = false;
                        if (data.status === 200) {
                            _this5.$message.success(data.message);
                            _this5.requestVisible = false;
                            _this5.$refs.payment.resetFields();
                            _this5.getPaymentRequest();
                        }
                    });
                }
            });
        },
        getPaymentRequest: function getPaymentRequest() {
            var _this6 = this;

            var param = {
                current: this.paymentPage,
                size: this.pageSize,
                status: this.filters.paymentStatus,
                doctorNo: this.payment.doctorNo,
                storageFeeId: this.payment.monthlyStorageFeeId
            };
            this.paymentLoading = true;
            (0, _paymentService4Warehouse.getPaymentRequest4Warehouse)(param).then(function (data) {
                _this6.paymentLoading = false;
                _this6.isPaymentPending = false;
                if (data.status === 200) {
                    _this6.payments = data.result.records;
                    _this6.paymentTotal = data.result.total;
                    console.log('this.payments', _this6.payments);
                    for (var i = 0; i < _this6.payments.length; i++) {
                        var p = _this6.payments[i];
                        if (p.status == 0 || p.status == 1) {
                            _this6.isPaymentPending = true;
                            break;
                        }
                    }
                    console.log('this.isPaymentPending', _this6.isPaymentPending);
                }
            });
        },
        changePaymentRequest: function changePaymentRequest(val) {
            this.paymentPage = val;
            this.getPaymentRequest();
        },
        editPaymentStatus: function editPaymentStatus(paymentNo, status) {
            var _this7 = this;

            this.$confirm("Are you sure?", "Warning", {
                type: "warning"
            }).then(function () {

                _this7.loading = true;
                var param = {
                    paymentNo: paymentNo,
                    status: status
                };
                (0, _paymentService4Warehouse.editPaymentStatus4Warehouse)(param).then(function (data) {
                    _this7.loading = false;
                    if (data.status === 200) {
                        _this7.$message.success(data.message);
                        _this7.getPaymentRequest();
                    } else {
                        _this7.$message.error(data.message);
                    }
                });
            }).catch(function () {
                _this7.$message.error(data.message);
            });
        },
        validateAmount: function validateAmount(rule, value, callback) {
            if (value > 0) {
                if (value < this.payment.minPayment) {
                    callback(new Error('Your payable amount must be greater than $' + this.payment.minPayment + '.'));
                } else {
                    callback();
                }
            } else {
                callback(new Error('Payable amount is required.'));
            }
        },
        testGenStorageFeeByMonthly: function testGenStorageFeeByMonthly() {
            var _this8 = this;

            if (!this.isEnable) return;

            this.isEnable = false;
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
            var param = {
                logId: year + "-" + month
            };
            (0, _storageFeePaymentService.testGenStorageFeeByMonthly)(param).then(function (data) {
                if (data.status === 200) {
                    console.log("操作成功");
                    _this8.$message.success('Monthly Fee generate success');
                }
                setTimeout(function () {
                    _this8.isEnable = true;
                }, 5000);
            });
        },
        testGenStorageFeeByDaily: function testGenStorageFeeByDaily() {
            var _this9 = this;

            if (!this.isEnable) return;

            this.isEnable = false;
            var param = {};
            (0, _storageFeePaymentService.testGenStorageFeeByDaily)(param).then(function (data) {
                console.log("操作中...");
                if (data.status === 200) {
                    console.log("操作成功");
                    _this9.$message.success('Daily Fee generate success');
                }
                setTimeout(function () {
                    _this9.isEnable = true;
                }, 5000);
            });
        },
        showRebuildStorageFeeByDailyWin: function showRebuildStorageFeeByDailyWin() {
            this.requestRebuildVisible = true;
        },
        showRebuildStorageFeeByMonthWin: function showRebuildStorageFeeByMonthWin() {
            this.requestRebuildMonthVisible = true;
        },
        rebuildStorageFeeByDaily: function rebuildStorageFeeByDaily() {
            var _this10 = this;

            if (!this.isEnable) return;

            this.isEnable = false;
            var param = {
                dates: this.rebuildDailyModel.dates
            };
            (0, _storageFeePaymentService.testRebuildStorageFeeByDaily)(param).then(function (data) {
                if (data.status === 200) {
                    console.log("操作成功");
                    _this10.$message.success('Rebuild Storage Daily Fee success');
                    _this10.getPaymentRequest();
                }
                setTimeout(function () {
                    _this10.isEnable = true;
                    _this10.requestRebuildVisible = false;
                }, 5000);
            });
        },
        rebuildStorageFeeByMonth: function rebuildStorageFeeByMonth() {
            var _this11 = this;

            if (!this.isEnable) return;

            this.isEnable = false;
            var param = {
                logId: this.rebuildMonthModel.month
            };
            console.log('aaa ------>', param, this.rebuildMonthModel.month);
            (0, _storageFeePaymentService.testGenStorageFeeByMonthly)(param).then(function (data) {
                if (data.status === 200) {
                    console.log("操作成功");
                    _this11.$message.success('Rebuild Monthly Fee success');
                    _this11.getPaymentRequest();
                }
                setTimeout(function () {
                    _this11.isEnable = true;
                    _this11.requestRebuildMonthVisible = false;
                }, 5000);
            });
        }
    },
    mounted: function mounted() {
        this.getStorageFeePaymentList();

        var user = sessionStorage.getItem('user');
        user = JSON.parse(user);
        this.user = user;
    }
};

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _globalVar = __webpack_require__(7);

var _serviceFeeService = __webpack_require__(390);

var _customServiceFeeConfigService = __webpack_require__(389);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            firstLoading: false,
            pageSize: _globalVar.defaultPageSize,

            activeName: "first",

            filters: {
                email: ''
            },

            serviceFees: [],

            userRates: [],

            customServiceFeeConfigs: [],

            total: 0,
            page: 1,

            editVisible: false,
            secondLoading: false,
            thirdLoading: false,
            customEditLoading: false,

            editLoading: false,
            editFormRules: {
                serviceLabel: [{ required: true, message: 'Label is required.', trigger: 'blur' }]
            },

            addServiceFee: {
                serviceLabel: "",
                serviceBaseFee: 0.0,
                serviceDesc: "",
                id: null
            },

            editServiceFee: {
                serviceLabel: "",
                serviceBaseFee: 0.0,
                serviceDesc: "",
                id: null
            },

            addFormVisible: false,
            formRules: {
                serviceLabel: [{ required: true, message: 'Label is required.', trigger: 'blur' }]
            },

            userRateVisible: false,
            customServiceFeeVisible: false,

            editDoctorNo: '',

            customEditVisible: false,
            customEditServiceFee: {
                serviceFeeId: null,
                doctorNo: "",
                serviceBaseFee: 0.0,
                id: null
            }

        };
    },

    methods: {
        formatHasBeanSet: function formatHasBeanSet(row, column) {
            if (row.hasSingleSeted === true) {
                return "Already Set";
            } else {
                return "Not Set";
            }
        },
        handlePageChange: function handlePageChange(val) {
            this.page = val;
            this.getServiceFeeList();
        },
        handleAddServiceFee: function handleAddServiceFee() {
            var _this = this;

            this.$refs.addServiceFee.validate(function (valid) {
                if (valid) {
                    _this.loading = true;
                    var param = {
                        serviceLabel: _this.addServiceFee.serviceLabel,
                        serviceBaseFee: _this.addServiceFee.serviceBaseFee,
                        serviceDesc: _this.addServiceFee.serviceDesc,
                        id: null
                    };
                    (0, _serviceFeeService.editServiceFee)(param).then(function (res) {
                        _this.loading = false;
                        if (res.status === 200) {
                            _this.addFormVisible = false;
                            _this.$message.success(res.message);
                            _this.$refs.addServiceFee.resetFields();
                            _this.getServiceFeeList();
                        } else {
                            _this.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    });
                }
            });
        },
        showAdd: function showAdd() {
            this.addFormVisible = true;
            this.addServiceFee.id = null;
            this.addServiceFee.serviceLabel = "";
            this.addServiceFee.serviceBaseFee = 0;
            this.addServiceFee.serviceDesc = "";
        },
        showEdit: function showEdit(row) {
            var _this2 = this;

            (0, _serviceFeeService.getServiceFeeById)(row).then(function (res) {
                if (res.status === 200) {
                    _this2.editVisible = true;
                    _this2.editServiceFee = res.result;
                }
            });
        },
        editSubmit: function editSubmit() {
            var _this3 = this;

            this.editLoading = true;
            var para = {
                serviceLabel: this.editServiceFee.serviceLabel,
                serviceBaseFee: this.editServiceFee.serviceBaseFee,
                serviceDesc: this.editServiceFee.serviceDesc,
                id: this.editServiceFee.id
            };
            (0, _serviceFeeService.editServiceFee)(para).then(function (res) {
                _this3.editLoading = false;
                if (res.status === 200) {
                    _this3.$message({
                        message: res.message,
                        type: "success"
                    });
                    _this3.getServiceFeeList();
                    _this3.editVisible = false;
                } else {
                    _this3.$message({
                        message: res.message,
                        type: "error"
                    });
                }
            });
        },
        getServiceFeeList: function getServiceFeeList() {
            var _this4 = this;

            var para = {
                current: this.page,
                size: this.pageSize
            };

            this.firstLoading = true;
            (0, _serviceFeeService.getServiceFeeList)(para).then(function (res) {
                _this4.firstLoading = false;
                if (res.status === 200) {
                    _this4.serviceFees = res.result.records;
                    _this4.total = res.result.total;
                } else {
                    _this4.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        showUserRate: function showUserRate() {
            this.userRateVisible = true;
            this.getAllUserRate();
        },
        showServiceFeeEdit: function showServiceFeeEdit(rowDoctorNo) {
            this.customServiceFeeVisible = true;;
            this.getDoctorCustomServiceFeeRate(rowDoctorNo);
        },
        getAllUserRate: function getAllUserRate() {
            var _this5 = this;

            var para = {
                current: 1,
                size: 1000
            };

            this.secondLoading = true;
            (0, _customServiceFeeConfigService.getDoctorUserList)(para).then(function (res) {
                _this5.secondLoading = false;
                if (res.status === 200) {
                    _this5.userRates = res.result.records;
                    _this5.total = res.result.total;
                } else {
                    _this5.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        getDoctorCustomServiceFeeRate: function getDoctorCustomServiceFeeRate(rowDoctorNo) {
            var _this6 = this;

            var para = {
                current: 1,
                size: 1000,
                doctorNo: rowDoctorNo
            };

            this.thirdLoading = true;
            (0, _customServiceFeeConfigService.getCustomServiceFeeList)(para).then(function (res) {
                _this6.thirdLoading = false;
                if (res.status === 200) {
                    _this6.customServiceFeeConfigs = res.result;
                } else {
                    _this6.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        showCustomEdit: function showCustomEdit(row) {
            var _this7 = this;

            var para = {
                doctorNo: row.doctorNo,
                serviceFeeId: row.serviceFeeId,
                id: row.id
            };
            (0, _customServiceFeeConfigService.getCustomServiceFeeById)(para).then(function (res) {
                if (res.status === 200) {
                    _this7.customEditVisible = true;
                    _this7.customEditServiceFee = res.result;
                }
            });
        },
        deleteCustomItem: function deleteCustomItem(row) {
            var _this8 = this;

            this.editLoading = true;
            var para = {
                doctorNo: row.doctorNo,
                serviceFeeId: row.serviceFeeId,
                id: row.id
            };
            (0, _customServiceFeeConfigService.deleteCustomServiceFeeConfigs)(para).then(function (res) {
                _this8.editLoading = false;
                if (res.status === 200) {
                    _this8.$message({
                        message: res.message,
                        type: "success"
                    });
                    _this8.showServiceFeeEdit(row.doctorNo);
                    _this8.editVisible = false;
                } else {
                    _this8.$message({
                        message: res.message,
                        type: "error"
                    });
                }
            });
        },
        customEditSubmit: function customEditSubmit() {
            var _this9 = this;

            this.customEditLoading = true;
            var para = {
                serviceFeeId: this.customEditServiceFee.serviceFeeId,
                serviceLabel: this.customEditServiceFee.serviceLabel,
                serviceDesc: this.customEditServiceFee.serviceDesc,
                doctorNo: this.customEditServiceFee.doctorNo,
                serviceBaseFee: this.customEditServiceFee.serviceBaseFee,
                id: this.customEditServiceFee.id
            };
            (0, _customServiceFeeConfigService.editCustomServiceFeeConfigs)(para).then(function (res) {
                _this9.customEditLoading = false;
                _this9.customEditVisible = false;
                if (res.status === 200) {
                    _this9.$message({
                        message: res.message,
                        type: "success"
                    });
                    _this9.getDoctorCustomServiceFeeRate(_this9.customEditServiceFee.doctorNo);
                } else {
                    _this9.$message({
                        message: res.message,
                        type: "error"
                    });
                }
            });
        }
    },
    mounted: function mounted() {
        this.getServiceFeeList();
    }
};

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(6);

var _util2 = _interopRequireDefault(_util);

var _globalVar = __webpack_require__(7);

var _outboundService = __webpack_require__(104);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            firstLoading: false,
            pageSize: _globalVar.defaultPageSize,
            workingPage: 1,
            workingTotal: 0,

            filters: {
                markChecked: "",
                conditionSearch: ""
            },

            dataList: [],

            loading: false,

            user: sessionStorage.getItem('user')
        };
    },
    created: function created() {
        var _this = this;

        this.$on('changeDoctor', function (value) {
            setTimeout(function () {
                _this.getTrasferUserInfo();
            }, 300);
        });
    },

    methods: {
        getTrasferUserInfo: function getTrasferUserInfo() {
            var _this2 = this;

            var param = {
                current: this.workingPage,
                size: this.pageSize,
                markChecked: this.filters.markChecked,
                conditionSearch: this.filters.conditionSearch,
                doctorNo: window.sessionStorage.getItem("currentCompany")
            };
            this.firstLoading = true;
            (0, _outboundService.getTransferUserInfoWithWarehouseByDoctorNo)(param).then(function (data) {
                _this2.firstLoading = false;
                if (data.status === 200) {
                    _this2.dataList = data.result.records;
                    _this2.workingTotal = data.result.total;
                }
            });
        },
        markChecked: function markChecked(id) {
            var _this3 = this;

            this.$confirm('Please confirm if the goods have been properly handled?', 'Warning', {
                type: 'warning'
            }).then(function () {
                var param = {
                    transferId: id
                };
                (0, _outboundService.markChecked)(param).then(function (data) {
                    if (data.status === 200 && data.result) {
                        _this3.getTrasferUserInfo();
                    } else {
                        _this3.$message.error(data.message);
                    }
                });
            }).catch(function () {
                _this3.$message.error('Cannot mark the transfer log, please try again later');
            });
        }
    },
    mounted: function mounted() {
        this.getTrasferUserInfo();
        var user = sessionStorage.getItem('user');
        user = JSON.parse(user);
        this.user = user;
    }
};

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addUser = exports.editUser = exports.batchRemoveUser = exports.removeUser = exports.getUserListPage = exports.getUserList = exports.requestLogin = undefined;

var _axios = __webpack_require__(198);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var requestLogin = exports.requestLogin = function requestLogin(params) {
  return _axios2.default.post(base + '/login', params).then(function (res) {
    return res.data;
  });
};

var getUserList = exports.getUserList = function getUserList(params) {
  return _axios2.default.get(base + '/user/list', { params: params });
};

var getUserListPage = exports.getUserListPage = function getUserListPage(params) {
  return _axios2.default.get(base + '/user/listpage', { params: params });
};

var removeUser = exports.removeUser = function removeUser(params) {
  return _axios2.default.get(base + '/user/remove', { params: params });
};

var batchRemoveUser = exports.batchRemoveUser = function batchRemoveUser(params) {
  return _axios2.default.get(base + '/user/batchremove', { params: params });
};

var editUser = exports.editUser = function editUser(params) {
  return _axios2.default.get(base + '/user/edit', { params: params });
};

var addUser = exports.addUser = function addUser(params) {
  return _axios2.default.get(base + '/user/add', { params: params });
};

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBoxSizeById = exports.editBoxSize = exports.getBoxSizeList = undefined;

var _axiosInit = __webpack_require__(14);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getBoxSizeList = exports.getBoxSizeList = function getBoxSizeList(params) {
    return _axiosInit2.default.post("/boxsizes/getBoxSizeList", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editBoxSize = exports.editBoxSize = function editBoxSize(params) {
    return _axiosInit2.default.post("/boxsizes/saveOrUpdateById", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getBoxSizeById = exports.getBoxSizeById = function getBoxSizeById(params) {
    return _axiosInit2.default.post("/boxsizes/getBoxSizeById", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deleteCustomBoxSizeConfigs = exports.editCustomBoxSizeConfigs = exports.getCustomBoxSizeById = exports.getCustomBoxSizeList = exports.getDoctorUserList = undefined;

var _axiosInit = __webpack_require__(14);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDoctorUserList = exports.getDoctorUserList = function getDoctorUserList(params) {
    return _axiosInit2.default.post('/custom_box_size_config/getDoctorUserList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getCustomBoxSizeList = exports.getCustomBoxSizeList = function getCustomBoxSizeList(params) {
    return _axiosInit2.default.post('/custom_box_size_config/getBoxSizeList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getCustomBoxSizeById = exports.getCustomBoxSizeById = function getCustomBoxSizeById(params) {
    return _axiosInit2.default.post('/custom_box_size_config/getBoxSizeById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editCustomBoxSizeConfigs = exports.editCustomBoxSizeConfigs = function editCustomBoxSizeConfigs(params) {
    return _axiosInit2.default.post('/custom_box_size_config/addOrEditCustomBoxSizeConfigs', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var deleteCustomBoxSizeConfigs = exports.deleteCustomBoxSizeConfigs = function deleteCustomBoxSizeConfigs(params) {
    return _axiosInit2.default.post('/custom_box_size_config/restoreCustomBoxSizeConfigs', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deleteCustomServiceFeeConfigs = exports.editCustomServiceFeeConfigs = exports.getCustomServiceFeeById = exports.getCustomServiceFeeList = exports.getDoctorUserList = undefined;

var _axiosInit = __webpack_require__(14);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDoctorUserList = exports.getDoctorUserList = function getDoctorUserList(params) {
    return _axiosInit2.default.post('/custom_service_fee_config/getDoctorUserList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getCustomServiceFeeList = exports.getCustomServiceFeeList = function getCustomServiceFeeList(params) {
    return _axiosInit2.default.post('/custom_service_fee_config/getServiceFeeList', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getCustomServiceFeeById = exports.getCustomServiceFeeById = function getCustomServiceFeeById(params) {
    return _axiosInit2.default.post('/custom_service_fee_config/getServiceFeeById', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editCustomServiceFeeConfigs = exports.editCustomServiceFeeConfigs = function editCustomServiceFeeConfigs(params) {
    return _axiosInit2.default.post('/custom_service_fee_config/addOrEditCustomServiceFeeConfigs', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var deleteCustomServiceFeeConfigs = exports.deleteCustomServiceFeeConfigs = function deleteCustomServiceFeeConfigs(params) {
    return _axiosInit2.default.post('/custom_service_fee_config/restoreCustomServiceFeeConfigs', params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getServiceFeeById = exports.editServiceFee = exports.getServiceFeeList = undefined;

var _axiosInit = __webpack_require__(14);

var _axiosInit2 = _interopRequireDefault(_axiosInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getServiceFeeList = exports.getServiceFeeList = function getServiceFeeList(params) {
    return _axiosInit2.default.post("/serviceFee/getServiceFeeList", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var editServiceFee = exports.editServiceFee = function editServiceFee(params) {
    return _axiosInit2.default.post("/serviceFee/saveOrUpdateById", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

var getServiceFeeById = exports.getServiceFeeById = function getServiceFeeById(params) {
    return _axiosInit2.default.post("/serviceFee/getServiceFeeById", params).then(function (res) {
        return res.data;
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _babelPolyfill = __webpack_require__(289);

var _babelPolyfill2 = _interopRequireDefault(_babelPolyfill);

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(298);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(290);

var _elementUi2 = _interopRequireDefault(_elementUi);

var _en = __webpack_require__(291);

var _en2 = _interopRequireDefault(_en);

__webpack_require__(292);

var _vueRouter = __webpack_require__(299);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(288);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(196);

var _vuex2 = _interopRequireDefault(_vuex);

var _vueQuillEditor = __webpack_require__(74);

var _vueQuillEditor2 = _interopRequireDefault(_vueQuillEditor);

__webpack_require__(296);

__webpack_require__(297);

__webpack_require__(295);

var _nprogress = __webpack_require__(195);

var _nprogress2 = _interopRequireDefault(_nprogress);

__webpack_require__(294);

__webpack_require__(293);

var _routes = __webpack_require__(287);

var _routes2 = _interopRequireDefault(_routes);

var _print = __webpack_require__(286);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_elementUi2.default, { locale: _en2.default });
_vue2.default.use(_vuex2.default);
_vue2.default.use(_vueQuillEditor2.default);
_vue2.default.use(_print2.default);

global.antRouter = '';

_nprogress2.default.configure({ showSpinner: false });
var router = new _vueRouter2.default({
    routes: _routes2.default
});
var addRouFlag = false;

router.beforeEach(function (to, from, next) {
    _nprogress2.default.start();
    if (to.path === '/login') {}
    var user = JSON.parse(sessionStorage.getItem('user'));
    if (!user && to.path !== '/login' && to.path !== '/forgetPassword' && to.path !== '/changePassword' && to.path.indexOf("/register") === -1) {
        next({ path: '/login' });
    } else {
        if (user && !addRouFlag) {
            var role = user.roleId;

            addRouFlag = true;

            var menu = getMenuByRole(role);

            global.antRouter = menu;

            router.addRoutes(menu);

            router.push({ path: to.path });
        }
        next();
    }
});

var getMenuByRole = function getMenuByRole(roleId) {
    if (roleId === "1") {
        return _routes.defaultRoutes.concat(_routes.doctorRoutes);
    } else if (roleId === "2") {
        return _routes.defaultRoutes.concat(_routes.nurseRoutes);
    } else if (roleId === "3") {
        return _routes.defaultRoutes.concat(_routes.warehouseAdminRoutes);
    } else if (roleId === '0') {
        return _routes.defaultRoutes.concat(_routes.superAdminRouter);
    }
};

router.afterEach(function (transition) {
    _nprogress2.default.done();
});

new _vue2.default({
    router: router,
    store: _store2.default,

    render: function render(h) {
        return h(_App2.default);
    }
}).$mount('#app');
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)))

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Home = __webpack_require__(101);

var _Home2 = _interopRequireDefault(_Home);

var _overview = __webpack_require__(745);

var _overview2 = _interopRequireDefault(_overview);

var _inventory = __webpack_require__(742);

var _inventory2 = _interopRequireDefault(_inventory);

var _inbound = __webpack_require__(741);

var _inbound2 = _interopRequireDefault(_inbound);

var _offer = __webpack_require__(743);

var _offer2 = _interopRequireDefault(_offer);

var _outbound = __webpack_require__(744);

var _outbound2 = _interopRequireDefault(_outbound);

var _payments = __webpack_require__(746);

var _payments2 = _interopRequireDefault(_payments);

var _storageFee = __webpack_require__(748);

var _storageFee2 = _interopRequireDefault(_storageFee);

var _settings = __webpack_require__(747);

var _settings2 = _interopRequireDefault(_settings);

var _teams = __webpack_require__(749);

var _teams2 = _interopRequireDefault(_teams);

var _warehouse = __webpack_require__(750);

var _warehouse2 = _interopRequireDefault(_warehouse);

var _account = __webpack_require__(193);

var _account2 = _interopRequireDefault(_account);

var _amazon = __webpack_require__(757);

var _amazon2 = _interopRequireDefault(_amazon);

var _bank = __webpack_require__(194);

var _bank2 = _interopRequireDefault(_bank);

var _password = __webpack_require__(132);

var _password2 = _interopRequireDefault(_password);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var doctorRoutes = [{
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-home',
    leaf: true,
    children: [{ path: '/overview', component: _overview2.default, name: 'Home' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-file-text-o',
    leaf: true,
    children: [{ path: '/offer', component: _offer2.default, name: 'Offers' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-inbox',
    leaf: true,
    children: [{ path: '/inbound', component: _inbound2.default, name: 'Inbound' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-product-hunt',
    leaf: true,
    children: [{ path: '/inventory', component: _inventory2.default, name: 'Inventory' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-outdent',
    leaf: true,
    children: [{ path: '/outbound', component: _outbound2.default, name: 'Outbound' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-usd',
    leaf: true,
    children: [{ path: '/storageFee', component: _storageFee2.default, name: 'Storage Fee' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-credit-card',
    leaf: true,
    children: [{ path: '/payments', component: _payments2.default, name: 'Payments' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-university',
    leaf: true,
    children: [{ path: '/warehouse', component: _warehouse2.default, name: 'Warehouse' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-users',
    leaf: true,
    children: [{ path: '/teams', component: _teams2.default, name: 'Teams' }]
}, {
    path: '/',
    component: _Home2.default,
    name: 'Settings',
    iconCls: 'fa fa-cog',
    children: [{ path: '/account', iconCls: 'fa fa-user', component: _account2.default, name: 'Account' }, { path: '/password', iconCls: 'fa fa-key', component: _password2.default, name: 'Password' }]
}];

exports.default = doctorRoutes;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Home = __webpack_require__(101);

var _Home2 = _interopRequireDefault(_Home);

var _overview = __webpack_require__(754);

var _overview2 = _interopRequireDefault(_overview);

var _inventory = __webpack_require__(283);

var _inventory2 = _interopRequireDefault(_inventory);

var _Inbound = __webpack_require__(752);

var _Inbound2 = _interopRequireDefault(_Inbound);

var _offer = __webpack_require__(753);

var _offer2 = _interopRequireDefault(_offer);

var _outbound = __webpack_require__(285);

var _outbound2 = _interopRequireDefault(_outbound);

var _payments = __webpack_require__(755);

var _payments2 = _interopRequireDefault(_payments);

var _warehouse = __webpack_require__(756);

var _warehouse2 = _interopRequireDefault(_warehouse);

var _invitations = __webpack_require__(284);

var _invitations2 = _interopRequireDefault(_invitations);

var _account = __webpack_require__(193);

var _account2 = _interopRequireDefault(_account);

var _bank = __webpack_require__(194);

var _bank2 = _interopRequireDefault(_bank);

var _password = __webpack_require__(132);

var _password2 = _interopRequireDefault(_password);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nurseRoutes = [{
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-home',
    leaf: true,
    children: [{ path: '/overview', component: _overview2.default, name: 'Home' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-file-text-o',
    leaf: true,
    children: [{ path: '/offer', component: _offer2.default, name: 'Offers' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-inbox',
    leaf: true,
    children: [{ path: '/inbound', component: _Inbound2.default, name: 'Inbound' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-product-hunt',
    leaf: true,
    children: [{ path: '/inventory', component: _inventory2.default, name: 'Inventory' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-outdent',
    leaf: true,
    children: [{ path: '/outbound', component: _outbound2.default, name: 'Outbound' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-credit-card',
    leaf: true,
    children: [{ path: '/payments', component: _payments2.default, name: 'Payments' }]
}, {
    path: '/',
    component: _Home2.default,
    name: 'Settings',
    iconCls: 'fa fa-cog',
    children: [{ path: '/account', iconCls: 'fa fa-user', component: _account2.default, name: 'Account' }, { path: '/password', iconCls: 'fa fa-key', component: _password2.default, name: 'Password' }, { path: '/bank', iconCls: 'fa fa-credit-card-alt', component: _bank2.default, name: 'Bank' }, { path: '/selfStorage', iconCls: 'fa fa-university', component: _warehouse2.default, name: 'Self Storage' }, { path: '/invitations', iconCls: 'fa fa-handshake-o', component: _invitations2.default, name: 'Invitations' }]
}];

exports.default = nurseRoutes;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Home = __webpack_require__(101);

var _Home2 = _interopRequireDefault(_Home);

var _userlist = __webpack_require__(739);

var _userlist2 = _interopRequireDefault(_userlist);

var _password = __webpack_require__(132);

var _password2 = _interopRequireDefault(_password);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var adminRoutes = [{
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-users',
    leaf: true,
    children: [{ path: '/users', component: _userlist2.default, name: 'Users' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-user',
    leaf: true,
    children: [{ path: '/password', component: _password2.default, name: 'Password' }]
}];

exports.default = adminRoutes;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Home = __webpack_require__(101);

var _Home2 = _interopRequireDefault(_Home);

var _overview = __webpack_require__(762);

var _overview2 = _interopRequireDefault(_overview);

var _inventory = __webpack_require__(283);

var _inventory2 = _interopRequireDefault(_inventory);

var _Inbound = __webpack_require__(759);

var _Inbound2 = _interopRequireDefault(_Inbound);

var _outbound = __webpack_require__(285);

var _outbound2 = _interopRequireDefault(_outbound);

var _invitations = __webpack_require__(284);

var _invitations2 = _interopRequireDefault(_invitations);

var _account = __webpack_require__(193);

var _account2 = _interopRequireDefault(_account);

var _password = __webpack_require__(132);

var _password2 = _interopRequireDefault(_password);

var _discounts = __webpack_require__(761);

var _discounts2 = _interopRequireDefault(_discounts);

var _boxsizes = __webpack_require__(760);

var _boxsizes2 = _interopRequireDefault(_boxsizes);

var _payments = __webpack_require__(763);

var _payments2 = _interopRequireDefault(_payments);

var _bank = __webpack_require__(194);

var _bank2 = _interopRequireDefault(_bank);

var _transferCheck = __webpack_require__(765);

var _transferCheck2 = _interopRequireDefault(_transferCheck);

var _serviceFeeConfig = __webpack_require__(764);

var _serviceFeeConfig2 = _interopRequireDefault(_serviceFeeConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warehouseAdminRouter = [{
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-inbox',
    leaf: true,
    children: [{ path: '/inbound', component: _Inbound2.default, name: 'Inbound' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-product-hunt',
    leaf: true,
    children: [{ path: '/inventory', component: _inventory2.default, name: 'Inventory' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-outdent',
    leaf: true,
    children: [{ path: '/outbound', component: _outbound2.default, name: 'Outbound' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-credit-card',
    leaf: true,
    children: [{ path: '/payments', component: _payments2.default, name: 'Payment' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-paper-plane',
    leaf: true,
    children: [{ path: '/transferCheck', component: _transferCheck2.default, name: 'Transfers' }]
}, {
    path: '/',
    component: _Home2.default,
    name: 'Settings',
    iconCls: 'fa fa-cog',
    children: [{ path: '/account', iconCls: 'fa fa-user', component: _account2.default, name: 'Account' }, { path: '/password', iconCls: 'fa fa-key', component: _password2.default, name: 'Password' }, { path: '/bank', iconCls: 'fa fa-credit-card-alt', component: _bank2.default, name: 'Bank' }, { path: '/invitations', iconCls: 'fa fa-handshake-o', component: _invitations2.default, name: 'Invitations' }, { path: '/discounts', iconCls: 'fa fa-dollar', component: _discounts2.default, name: 'Discounts' }, { path: '/boxsizes', iconCls: 'fa fa-dollar', component: _boxsizes2.default, name: 'Category Set' }, { path: '/serviceFee', iconCls: 'fa fa-dollar', component: _serviceFeeConfig2.default, name: 'Service Fee Set' }]
}];

exports.default = warehouseAdminRouter;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var increment = exports.increment = function increment(_ref) {
    var commit = _ref.commit;

    commit('INCREMENT');
};
var decrement = exports.decrement = function decrement(_ref2) {
    var commit = _ref2.commit;

    commit('DECREMENT');
};

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getCount = exports.getCount = function getCount(state) {
    return state.count;
};

/***/ }),
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 682 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 685 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 688 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 689 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(688)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(803),
  /* scopeId */
  "data-v-c4e77826",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(684)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(787),
  /* scopeId */
  "data-v-5f4b1384",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(768),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(679)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(773),
  /* scopeId */
  "data-v-28631f46",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(777),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(681)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(780),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(682)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(781),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(805),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(791),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(687)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(801),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(778),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(680)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(779),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(785),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(771),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(685)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(790),
  /* scopeId */
  "data-v-665f7a03",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(766),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(782),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(783),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(678)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(770),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(806),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(784),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(677)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(769),
  /* scopeId */
  "data-v-03abbdbe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(683)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(786),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(802),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(788),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(775),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(789),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(799),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(794),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "To Confirm",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Offer",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getNurseConfirmList($event)
      }
    },
    model: {
      value: (_vm.filters.confirmInboundFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "confirmInboundFilter", $$v)
      },
      expression: "filters.confirmInboundFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getNurseConfirmList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNurseToConfirm', 'toConfirm.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstListLoading),
      expression: "firstListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.confirmInbound,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "inboundNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product",
      "width": "300px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.productName) + "\n                        "), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.createDate))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leftNum",
      "label": "Left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor === 1) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.confirmInboundItem(scope.row.inboundNo, 'self', true)
            }
          }
        }, [_vm._v("Confirm\n                        ")]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor === 0) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.confirmInboundItem(scope.row.inboundNo, 'warehouse', true)
            }
          }
        }, [_vm._v("\n                            Confirm\n                        ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.showCancelInbound(scope.row.inboundNo)
            }
          }
        }, [_vm._v("Cancel")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.confirmInboundTotal
    },
    on: {
      "current-change": _vm.changeConfirmInboundPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Reported",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Offer",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getReportList($event)
      }
    },
    model: {
      value: (_vm.filters.reportFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "reportFilter", $$v)
      },
      expression: "filters.reportFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getReportList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "change": _vm.getReportList
    },
    model: {
      value: (_vm.filters.reportStatus),
      callback: function($$v) {
        _vm.$set(_vm.filters, "reportStatus", $$v)
      },
      expression: "filters.reportStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Rejected",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Confirmed",
      "value": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNurseReported', 'report.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondListLoading),
      expression: "secondListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.reportedInbound,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product",
      "label": "Offer"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.productName) + " (" + _vm._s(scope.row.offerCreateDate) + ")")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Report Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "note",
      "label": "Note"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.changeReportPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Inbound History",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Offer",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getInboundHistoryList($event)
      }
    },
    model: {
      value: (_vm.filters.historyFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "historyFilter", $$v)
      },
      expression: "filters.historyFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getInboundHistoryList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNurseInboundHistory', 'inboundHistory.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdListLoading),
      expression: "thirdListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.inboundHistory,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctorName",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "offerCreateDate",
      "label": "Offer Create Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundDate",
      "label": "Inbound Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.historyTotal
    },
    on: {
      "current-change": _vm.changeHistory
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Confirm Inbound Items to self storage",
      "width": "80%",
      "visible": _vm.selfConfirmVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.selfConfirmVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "selfConfirm",
    attrs: {
      "model": _vm.selfConfirm,
      "label-width": "220px",
      "rules": _vm.inboundFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.selfConfirm.productName),
      callback: function($$v) {
        _vm.$set(_vm.selfConfirm, "productName", $$v)
      },
      expression: "selfConfirm.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Company"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.selfConfirm.company),
      callback: function($$v) {
        _vm.$set(_vm.selfConfirm, "company", $$v)
      },
      expression: "selfConfirm.company"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.selfConfirm.price),
      callback: function($$v) {
        _vm.$set(_vm.selfConfirm, "price", $$v)
      },
      expression: "selfConfirm.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Total"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.selfConfirm.num),
      callback: function($$v) {
        _vm.$set(_vm.selfConfirm, "num", $$v)
      },
      expression: "selfConfirm.num"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Left"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.selfConfirm.leftNum),
      callback: function($$v) {
        _vm.$set(_vm.selfConfirm, "leftNum", $$v)
      },
      expression: "selfConfirm.leftNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Inbound quantity",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.selfConfirm.quantity),
      callback: function($$v) {
        _vm.$set(_vm.selfConfirm, "quantity", $$v)
      },
      expression: "selfConfirm.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.selfConfirm.warehouse),
      callback: function($$v) {
        _vm.$set(_vm.selfConfirm, "warehouse", $$v)
      },
      expression: "selfConfirm.warehouse"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.selfConfirmVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleConfirmInbound($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.modalLoading),
      expression: "modalLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "title": "Confirm Inbound Items to shared warehouse",
      "width": "80%",
      "visible": _vm.warehouseConfirmVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.warehouseConfirmVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "warehouseConfirm",
    attrs: {
      "model": _vm.warehouseConfirm,
      "label-width": "220px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.warehouseConfirm.productName),
      callback: function($$v) {
        _vm.$set(_vm.warehouseConfirm, "productName", $$v)
      },
      expression: "warehouseConfirm.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Company"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.warehouseConfirm.company),
      callback: function($$v) {
        _vm.$set(_vm.warehouseConfirm, "company", $$v)
      },
      expression: "warehouseConfirm.company"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.warehouseConfirm.price),
      callback: function($$v) {
        _vm.$set(_vm.warehouseConfirm, "price", $$v)
      },
      expression: "warehouseConfirm.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Total"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.warehouseConfirm.num),
      callback: function($$v) {
        _vm.$set(_vm.warehouseConfirm, "num", $$v)
      },
      expression: "warehouseConfirm.num"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Left"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.warehouseConfirm.leftNum),
      callback: function($$v) {
        _vm.$set(_vm.warehouseConfirm, "leftNum", $$v)
      },
      expression: "warehouseConfirm.leftNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.warehouseConfirm.warehouse),
      callback: function($$v) {
        _vm.$set(_vm.warehouseConfirm, "warehouse", $$v)
      },
      expression: "warehouseConfirm.warehouse"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('p', [_vm._v("Import tracking number as\n                "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.textImportVisible = true
      }
    }
  }, [_vm._v("Text")]), _vm._v("\n                or\n                "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.excelImportVisible = true
      }
    }
  }, [_vm._v("Excel")])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tracking Staus"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Status"
    },
    on: {
      "change": _vm.changeTrackingFilterStatus
    },
    model: {
      value: (_vm.warehouseConfirm.trackingStatus),
      callback: function($$v) {
        _vm.$set(_vm.warehouseConfirm, "trackingStatus", $$v)
      },
      expression: "warehouseConfirm.trackingStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "All",
      "value": "All"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Claimed",
      "value": "Claimed"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Matched",
      "value": "Matched"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Unmatched",
      "value": "Unmatched"
    }
  })], 1), _vm._v(" "), (_vm.warehouseConfirm.unClaimedList.length > 0) ? _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.bulkConfirm($event)
      }
    }
  }, [_vm._v("Bulk Confirm")]) : _vm._e(), _vm._v(" "), (_vm.warehouseConfirm.unClaimedList.length > 0 || _vm.warehouseConfirm.unMatchedList.length > 0) ? _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "type": "warning"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.bulkRemoveSelected($event)
      }
    }
  }, [_vm._v("Bulk Remove Seleted")]) : _vm._e(), _vm._v(" "), _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.warehouseConfirm.trackingNumbersPage,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "#"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.inboundDetailId) ? _c('span', [_vm._v(_vm._s(scope.row.inboundDetailId))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking Number"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.confirmed) ? _c('div', [(scope.row.matched) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary",
            "loading": scope.row.loading
          },
          on: {
            "click": function($event) {
              return _vm.claim(scope.row)
            }
          }
        }, [_vm._v("Claim\n                                    ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.removeRow(scope.row)
            }
          }
        }, [_vm._v("Remove\n                                    ")])], 1) : _c('div', [_vm._v("\n                                    claimed\n                                ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.warehouseConfirm.currentPage,
      "page-size": 100,
      "total": _vm.warehouseConfirm.total
    },
    on: {
      "current-change": _vm.changeImportTrackingPage
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.warehouseConfirmVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.modalLoading),
      expression: "modalLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "title": "Import tracking number from text",
      "width": "80%",
      "visible": _vm.textImportVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.textImportVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.warehouseConfirm,
      "label-width": "220px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "10",
      "placeholder": _vm.placeholder,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("The tracking number import of text needs to contain tracking Numbers, multiple records must be separated by newline.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.textImportVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.importFromText($event)
      }
    }
  }, [_vm._v("Import")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.modalLoading),
      expression: "modalLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "title": "Import tracking number from excel",
      "width": "80%",
      "visible": _vm.excelImportVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.excelImportVisible = $event
      }
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "on-progress": _vm.preview,
      "on-success": _vm.uploadSuccess,
      "on-error": _vm.uploadError,
      "name": "filename",
      "drag": "",
      "action": _vm.uploadUrl,
      "headers": _vm.headers,
      "data": _vm.uploadData,
      "limit": 1,
      "accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('em', [_vm._v("click to upload")]), _vm._v(" or drag and drop file")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("Only allowed .xls,.xlsx files, please follow the columns format with trackingNum. include the header.")])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Cancel Inbound",
      "width": "80%",
      "visible": _vm.cancelInboundVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.cancelInboundVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.cancel,
      "label-width": "220px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Cancel Number"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.cancel.cancelNum),
      callback: function($$v) {
        _vm.$set(_vm.cancel, "cancelNum", $$v)
      },
      expression: "cancel.cancelNum"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.cancelInboundVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelInbound($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "UnClaimed Tracking#",
      "width": "80%",
      "visible": _vm.unClaimedTrackingVisiable,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.unClaimedTrackingVisiable = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "220px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tracking #"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "15"
    },
    model: {
      value: (_vm.unClaimedTracking),
      callback: function($$v) {
        _vm.unClaimedTracking = $$v
      },
      expression: "unClaimedTracking"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.unClaimedTrackingVisiable = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 767 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Working",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getWorkingOutboundList($event)
      }
    },
    model: {
      value: (_vm.filters.workingFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "workingFilter", $$v)
      },
      expression: "filters.workingFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getWorkingOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Main Product Name",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getWorkingOutboundList($event)
      }
    },
    model: {
      value: (_vm.filters.workingMainFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "workingMainFilter", $$v)
      },
      expression: "filters.workingMainFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getWorkingOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNurseOutbound', 'Working.xls', 1)
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.workingLoading),
      expression: "workingLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.workingList,
      "highlight-current-row": "",
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "outboundId"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Outbound Shipment"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.productName)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "splitPackagesNum",
      "label": "Split Package Num"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "instruction",
      "label": "Instruction"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.instruction)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundDate",
      "label": "Last Update"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "300px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.printNote(scope.row)
            }
          }
        }, [_vm._v("Print")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.download(scope.row.outboundId)
            }
          }
        }, [_vm._v("Package Label")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.archivedOutbound(scope.row.outboundId)
            }
          }
        }, [_vm._v("Archived")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.workingTotal
    },
    on: {
      "current-change": _vm.changeWorkingList
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Archived",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "Product Name or UPC"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getArchivedOutboundList($event)
      }
    },
    model: {
      value: (_vm.filters.archivedFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "archivedFilter", $$v)
      },
      expression: "filters.archivedFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getArchivedOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "Main Product"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getArchivedOutboundList($event)
      }
    },
    model: {
      value: (_vm.filters.archivedMainFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "archivedMainFilter", $$v)
      },
      expression: "filters.archivedMainFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getArchivedOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNurseOutbound', 'Archived.xls', 2)
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.archivedLoading),
      expression: "archivedLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.archivedList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "outboundId"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outbound",
      "label": "Outbound Shipment"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.productName)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "splitPackagesNum",
      "label": "Split Package Num"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "instruction",
      "label": "Instruction"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.instruction)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundDate",
      "label": "Last Update"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "300px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.printNote(scope.row)
            }
          }
        }, [_vm._v("Print")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.archivedTotal
    },
    on: {
      "current-change": _vm.changeArchivedList
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Print",
      "width": "80%",
      "visible": _vm.packageDetailVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.packageDetailVisible = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "printArea"
    }
  }, [_c('p', [_c('b', [_vm._v("Outbound ID : " + _vm._s(_vm.print.outboundNo))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Company : " + _vm._s(_vm.print.company))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Outbound Shipment : ")])]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.print.outboundShipment)
    }
  }), _vm._v(" "), _c('p', [_c('b', [_vm._v("Package Num : " + _vm._s(_vm.print.splitPackagesNum))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Instruction :")])]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.print.instruction)
    }
  }), _vm._v(" "), _c('p', [_c('b', [_vm._v("Note :")])]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.print.note)
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "bottom",
      "clear": "both"
    },
    attrs: {
      "id": "barcode1"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "bottom",
      "clear": "both"
    },
    attrs: {
      "id": "barcode2"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "bottom",
      "clear": "both"
    },
    attrs: {
      "id": "barcode3"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "bottom",
      "clear": "both"
    },
    attrs: {
      "id": "barcode4"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "bottom",
      "clear": "both"
    },
    attrs: {
      "id": "barcode5"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "bottom",
      "clear": "both"
    },
    attrs: {
      "id": "barcode6"
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),
/* 768 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "User List",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Email",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.email),
      callback: function($$v) {
        _vm.$set(_vm.filters, "email", $$v)
      },
      expression: "filters.email"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getUserList
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstListLoading),
      expression: "firstListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.users,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "User Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "Email"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Date Time",
      "formatter": _vm.formatTimesTamp
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "statusName",
      "label": "Status"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.statusName === 'Enabled') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.editUserStatus(scope.row.userNo, 2)
            }
          }
        }, [_vm._v("Disable\n                        ")]) : _vm._e(), _vm._v(" "), (scope.row.statusName === 'Disabled') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editUserStatus(scope.row.userNo, 1)
            }
          }
        }, [_vm._v("Enable\n                        ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleUserPageChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Invitation List",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Email",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.invitationEmail),
      callback: function($$v) {
        _vm.$set(_vm.filters, "invitationEmail", $$v)
      },
      expression: "filters.invitationEmail"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getInvitationList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.invitationVisible = true
      }
    }
  }, [_vm._v("Invitation")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondListLoading),
      expression: "secondListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.invitations,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "Email"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Date Time",
      "formatter": _vm.formatTimesTamp
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "statusName",
      "label": "Status",
      "formatter": _vm.formatRole
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.invitationTotal
    },
    on: {
      "current-change": _vm.handleInvitationPageChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Invite Doctor",
      "width": "80%",
      "visible": _vm.invitationVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.invitationVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "invitation",
    attrs: {
      "model": _vm.invitation,
      "label-width": "220px",
      "rules": _vm.invitationRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email"
    },
    model: {
      value: (_vm.invitation.email),
      callback: function($$v) {
        _vm.$set(_vm.invitation, "email", $$v)
      },
      expression: "invitation.email"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.invitationVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.invitationRegister($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.validate) ? _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "150px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Register")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Role"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "Role",
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm2.role),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "role", $$v)
      },
      expression: "ruleForm2.role"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "username",
      "label": "UserName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "UserName"
    },
    model: {
      value: (_vm.ruleForm2.username),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "username", $$v)
      },
      expression: "ruleForm2.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password",
      "label": "Password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "Password"
    },
    model: {
      value: (_vm.ruleForm2.password),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "password", $$v)
      },
      expression: "ruleForm2.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "rePassword",
      "label": "Confirm Password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "Confirm Password"
    },
    model: {
      value: (_vm.ruleForm2.rePassword),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "rePassword", $$v)
      },
      expression: "ruleForm2.rePassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.laoding
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit($event)
      }
    }
  }, [_vm._v("\n            Register\n        ")])], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Payment Requests",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Status",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getPaymentRequest()
      }
    },
    model: {
      value: (_vm.filters.paymentStatus),
      callback: function($$v) {
        _vm.$set(_vm.filters, "paymentStatus", $$v)
      },
      expression: "filters.paymentStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Confirmed",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Canceled",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Archived",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Rejected",
      "value": "4"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNursePayment', 'payment.xls')
      }
    }
  }, [_vm._v("Export")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAddPayment
    }
  }, [_vm._v("Request a payment")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstListLoading),
      expression: "firstListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.payments,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "paymentNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctorName",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "Amount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.formatMoney(scope.row.amount, 2)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctorNote",
      "label": "Doctor Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.doctorNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nurseNote",
      "label": "Nurse Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.nurseNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Request Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Canceled")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 4) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.editPaymentStatus(scope.row.paymentNo, 2)
            }
          }
        }, [_vm._v("Cancel\n                            ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.paymentTotal
    },
    on: {
      "current-change": _vm.changePaymentRequest
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Pending Transactions",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Offer",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.pendingFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "pendingFilter", $$v)
      },
      expression: "filters.pendingFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getPendingTransaction
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondListLoading),
      expression: "secondListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.pendingPayments,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "offerNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "takeDate",
      "label": "Offer Create Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundDate",
      "label": "Inbound Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.pendingTotal
    },
    on: {
      "current-change": _vm.changePendingRequest
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Transaction History",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search Product Name, Note, Account etc.",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.historyFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "historyFilter", $$v)
      },
      expression: "filters.historyFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getTransactionHistory
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdListLoading),
      expression: "thirdListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.transactions,
      "highlight-current-row": "",
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Transaction"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 'transaction') ? _c('div', [_c('p', [_vm._v("For " + _vm._s(scope.row.productName) + ", " + _vm._s(scope.row.dateTime))]), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v("$" + _vm._s(scope.row.price) + " * " + _vm._s(scope.row.quantity) + ".\n                                    " + _vm._s(scope.row.warehouse))])]) : _vm._e(), _vm._v(" "), (scope.row.type == 'reported') ? _c('div', [_c('p', [_vm._v("Reported for " + _vm._s(scope.row.productName) + ", " + _vm._s(scope.row.dateTime))]), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v("$" + _vm._s(scope.row.price) + " * " + _vm._s(scope.row.quantity) + ".\n                                    " + _vm._s(scope.row.warehouse))])]) : _vm._e(), _vm._v(" "), (scope.row.type == 'adjust') ? _c('div', [(scope.row.amount > 0) ? _c('p', [_vm._v("Increase Balance, " + _vm._s(scope.row.dateTime))]) : _vm._e(), _vm._v(" "), (scope.row.amount <= 0) ? _c('p', [_vm._v("Decrease Balance, " + _vm._s(scope.row.dateTime))]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "note",
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.type == 'payment') ? _c('div', [_c('p', [_vm._v("Withdraw to " + _vm._s(scope.row.productName) + ", " + _vm._s(scope.row.dateTime) + "\n                                    "), (scope.row.status === 0) ? _c('span', [_vm._v("(waiting for pay)")]) : (scope.row.status === 1) ? _c('span', [_vm._v("(paid)")]) : (scope.row.status === 2) ? _c('span', [_vm._v("(canceled)")]) : (scope.row.status === 3) ? _c('span', [_vm._v("(rollover)")]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "note",
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "Amount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.formatMoney(scope.row.amount, 2)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Balance",
      "prop": "balance"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.historyTotal
    },
    on: {
      "current-change": _vm.changeTransactionHistory
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Balance",
      "name": "fourth"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fourthListLoading),
      expression: "fourthListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.balances,
      "highlight-current-row": "",
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total",
      "label": "Total"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.formatMoney(scope.row.total, 2)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pendingAmount",
      "label": "Pending"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.formatMoney(scope.row.pendingAmount, 2)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "requestAmount",
      "label": "Request Pay"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.formatMoney(scope.row.requestAmount, 2)) + "\n                        ")]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.balanceTotal
    },
    on: {
      "current-change": _vm.changeBalance
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Request a payment",
      "width": "80%",
      "visible": _vm.requestVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.requestVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "payment",
    attrs: {
      "model": _vm.payment,
      "label-width": "220px",
      "rules": _vm.requestFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Total Balance",
      "prop": "balance"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.payment.balance),
      callback: function($$v) {
        _vm.$set(_vm.payment, "balance", $$v)
      },
      expression: "payment.balance"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Amount",
      "prop": "amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": _vm.payment.balance
    },
    model: {
      value: (_vm.payment.amount),
      callback: function($$v) {
        _vm.$set(_vm.payment, "amount", $$v)
      },
      expression: "payment.amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bank Account",
      "prop": "bank"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.payment.bank),
      callback: function($$v) {
        _vm.$set(_vm.payment, "bank", $$v)
      },
      expression: "payment.bank"
    }
  }, _vm._l((_vm.banks), function(bank, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": bank.category + ' ' + bank.accountNumber + ' (' + bank.accountType + ')',
        "value": bank.bankNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.payment.note),
      callback: function($$v) {
        _vm.$set(_vm.payment, "note", $$v)
      },
      expression: "payment.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.requestVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.requestPayment($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addFormVisible = true
      }
    }
  }, [_vm._v("Add warehouse")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.warehouses,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": function($event) {}
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "warehouseNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "Address",
      "width": "400px",
      "formatter": _vm.formatAddress
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "zipCode",
      "label": "Zip Code"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "admin",
      "label": "Admin"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.getWarehousesById(scope.row.warehouseNo)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.deleteWarehouses(scope.row.warehouseNo)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add warehouse",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "warehouseForm",
    attrs: {
      "model": _vm.warehouseForm,
      "label-width": "180px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.address),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "address", $$v)
      },
      expression: "warehouseForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "City",
      "prop": "city"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.city),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "city", $$v)
      },
      expression: "warehouseForm.city"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "State",
      "prop": "state"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.state),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "state", $$v)
      },
      expression: "warehouseForm.state"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Zip Code",
      "prop": "zipCode"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.zipCode),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "zipCode", $$v)
      },
      expression: "warehouseForm.zipCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Transfer Addr Key Wold",
      "prop": "transferAddrKeyWold"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.transferAddrKeyWold),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "transferAddrKeyWold", $$v)
      },
      expression: "warehouseForm.transferAddrKeyWold"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Admin",
      "prop": "adminNo"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.warehouseForm.adminNo),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "adminNo", $$v)
      },
      expression: "warehouseForm.adminNo"
    }
  }, _vm._l((_vm.adminList), function(admin, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": admin.userNo,
        "label": admin.username
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Visible",
      "prop": "hide"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.warehouseForm.isVisiable),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "isVisiable", $$v)
      },
      expression: "warehouseForm.isVisiable"
    }
  }, [_vm._v("Show")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.warehouseForm.isVisiable),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "isVisiable", $$v)
      },
      expression: "warehouseForm.isVisiable"
    }
  }, [_vm._v("Hide")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addWarehouse($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit warehouse",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editWarehouseObj",
    attrs: {
      "model": _vm.editWarehouseObj,
      "label-width": "180px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "State",
      "prop": "state"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.state),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "state", $$v)
      },
      expression: "editWarehouseObj.state"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "City",
      "prop": "city"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.city),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "city", $$v)
      },
      expression: "editWarehouseObj.city"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.address),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "address", $$v)
      },
      expression: "editWarehouseObj.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Zip Code",
      "prop": "zipCode"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.zipCode),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "zipCode", $$v)
      },
      expression: "editWarehouseObj.zipCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Transfer Addr Key Wold",
      "prop": "transferAddrKeyWold"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.transferAddrKeyWold),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "transferAddrKeyWold", $$v)
      },
      expression: "editWarehouseObj.transferAddrKeyWold"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Admin",
      "prop": "adminNo"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.editWarehouseObj.adminNo),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "adminNo", $$v)
      },
      expression: "editWarehouseObj.adminNo"
    }
  }, _vm._l((_vm.adminList), function(admin, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": admin.userNo,
        "label": admin.username
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Visible",
      "prop": "isVisiable"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.editWarehouseObj.isVisiable),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "isVisiable", $$v)
      },
      expression: "editWarehouseObj.isVisiable"
    }
  }, [_vm._v("Show")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.editWarehouseObj.isVisiable),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "isVisiable", $$v)
      },
      expression: "editWarehouseObj.isVisiable"
    }
  }, [_vm._v("Hide")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editWarehouse($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', _vm._b({
    class: [
      'el-link',
      _vm.type ? ("el-link--" + _vm.type) : '',
      _vm.disabled && 'is-disabled',
      _vm.underline && !_vm.disabled && 'is-underline'
    ],
    attrs: {
      "href": _vm.disabled ? null : _vm.href
    },
    on: {
      "click": _vm.handleClick
    }
  }, 'a', _vm.$attrs, false), [(_vm.icon) ? _c('i', {
    class: _vm.icon
  }) : _vm._e(), _vm._v(" "), (_vm.$slots.default) ? _c('span', {
    staticClass: "el-link--inner"
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.icon) ? [(_vm.$slots.icon) ? _vm._t("icon") : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 773 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.validate) ? _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "150px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Change Password")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password",
      "label": "Password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "Password"
    },
    model: {
      value: (_vm.ruleForm2.password),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "password", $$v)
      },
      expression: "ruleForm2.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "rePassword",
      "label": "Confirm Password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "Confirm Password"
    },
    model: {
      value: (_vm.ruleForm2.rePassword),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "rePassword", $$v)
      },
      expression: "ruleForm2.rePassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit($event)
      }
    }
  }, [_vm._v("\n            Submit\n        ")])], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 774 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      _vm.type === 'textarea' ? 'el-textarea' : 'el-input',
      _vm.inputSize ? 'el-input--' + _vm.inputSize : '',
      {
        'is-disabled': _vm.inputDisabled,
        'is-exceed': _vm.inputExceed,
        'el-input-group': _vm.$slots.prepend || _vm.$slots.append,
        'el-input-group--append': _vm.$slots.append,
        'el-input-group--prepend': _vm.$slots.prepend,
        'el-input--prefix': _vm.$slots.prefix || _vm.prefixIcon,
        'el-input--suffix': _vm.$slots.suffix || _vm.suffixIcon || _vm.clearable || _vm.showPassword
      }
    ],
    on: {
      "mouseenter": function($event) {
        _vm.hovering = true
      },
      "mouseleave": function($event) {
        _vm.hovering = false
      }
    }
  }, [(_vm.type !== 'textarea') ? [(_vm.$slots.prepend) ? _c('div', {
    staticClass: "el-input-group__prepend"
  }, [_vm._t("prepend")], 2) : _vm._e(), _vm._v(" "), (_vm.type !== 'textarea') ? _c('input', _vm._b({
    ref: "input",
    staticClass: "el-input__inner",
    attrs: {
      "tabindex": _vm.tabindex,
      "type": _vm.showPassword ? (_vm.passwordVisible ? 'text' : 'password') : _vm.type,
      "disabled": _vm.inputDisabled,
      "readonly": _vm.readonly,
      "autocomplete": _vm.autoComplete || _vm.autocomplete,
      "aria-label": _vm.label
    },
    on: {
      "compositionstart": _vm.handleCompositionStart,
      "compositionend": _vm.handleCompositionEnd,
      "input": _vm.handleInput,
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "change": _vm.handleChange
    }
  }, 'input', _vm.$attrs, false)) : _vm._e(), _vm._v(" "), (_vm.$slots.prefix || _vm.prefixIcon) ? _c('span', {
    staticClass: "el-input__prefix"
  }, [_vm._t("prefix"), _vm._v(" "), (_vm.prefixIcon) ? _c('i', {
    staticClass: "el-input__icon",
    class: _vm.prefixIcon
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.getSuffixVisible()) ? _c('span', {
    staticClass: "el-input__suffix"
  }, [_c('span', {
    staticClass: "el-input__suffix-inner"
  }, [(!_vm.showClear || !_vm.showPwdVisible || !_vm.isWordLimitVisible) ? [_vm._t("suffix"), _vm._v(" "), (_vm.suffixIcon) ? _c('i', {
    staticClass: "el-input__icon",
    class: _vm.suffixIcon
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.showClear) ? _c('i', {
    staticClass: "el-input__icon el-icon-circle-close el-input__clear",
    on: {
      "click": _vm.clear
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPwdVisible) ? _c('i', {
    staticClass: "el-input__icon el-icon-view el-input__clear",
    on: {
      "click": _vm.handlePasswordVisible
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isWordLimitVisible) ? _c('span', {
    staticClass: "el-input__count"
  }, [_c('span', {
    staticClass: "el-input__count-inner"
  }, [_vm._v("\n            " + _vm._s(_vm.textLength) + "/" + _vm._s(_vm.upperLimit) + "\n          ")])]) : _vm._e()], 2), _vm._v(" "), (_vm.validateState) ? _c('i', {
    staticClass: "el-input__icon",
    class: ['el-input__validateIcon', _vm.validateIcon]
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$slots.append) ? _c('div', {
    staticClass: "el-input-group__append"
  }, [_vm._t("append")], 2) : _vm._e()] : _c('textarea', _vm._b({
    ref: "textarea",
    staticClass: "el-textarea__inner",
    style: (_vm.textareaStyle),
    attrs: {
      "tabindex": _vm.tabindex,
      "disabled": _vm.inputDisabled,
      "readonly": _vm.readonly,
      "autocomplete": _vm.autoComplete || _vm.autocomplete,
      "aria-label": _vm.label
    },
    on: {
      "compositionstart": _vm.handleCompositionStart,
      "compositionend": _vm.handleCompositionEnd,
      "input": _vm.handleInput,
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "change": _vm.handleChange
    }
  }, 'textarea', _vm.$attrs, false)), _vm._v(" "), (_vm.isWordLimitVisible && _vm.type === 'textarea') ? _c('span', {
    staticClass: "el-input__count"
  }, [_vm._v(_vm._s(_vm.textLength) + "/" + _vm._s(_vm.upperLimit))]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("Overview\n")])
},staticRenderFns: []}

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "el-select-dropdown__item",
    class: {
      'selected': _vm.itemSelected,
      'is-disabled': _vm.disabled || _vm.groupDisabled || _vm.limitReached,
        'hover': _vm.hover
    },
    on: {
      "mouseenter": _vm.hoverItem,
      "click": function($event) {
        $event.stopPropagation();
        return _vm.selectOptionClick($event)
      }
    }
  }, [_vm._t("default", [_c('span', [_vm._v(_vm._s(_vm.currentLabel))])])], 2)
},staticRenderFns: []}

/***/ }),
/* 777 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "To Confirm",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Offer or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getInboundList($event)
      }
    },
    model: {
      value: (_vm.filters.viewedInboundFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "viewedInboundFilter", $$v)
      },
      expression: "filters.viewedInboundFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getInboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportInboundViewing', 'Viewing.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstLoading),
      expression: "firstLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.viewedInbound,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "inboundNo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "Take"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leftNum",
      "label": "Not Claimed"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Take Offer Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.cancelInbound(scope.row.inboundNo)
            }
          }
        }, [_vm._v("Cancel")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.viewInboundTotal
    },
    on: {
      "current-change": _vm.changeViewList
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Reported/Missed",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Offer or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getReportList($event)
      }
    },
    model: {
      value: (_vm.filters.reportFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "reportFilter", $$v)
      },
      expression: "filters.reportFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getReportList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "change": _vm.getReportList
    },
    model: {
      value: (_vm.filters.reportStatus),
      callback: function($$v) {
        _vm.$set(_vm.filters, "reportStatus", $$v)
      },
      expression: "filters.reportStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Rejected",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Confirmed",
      "value": 1
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportInboundViewingReported', 'reported.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondLoading),
      expression: "secondLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.reportedInbound,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product",
      "label": "Offer"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.productName) + " " + _vm._s(scope.row.offerCreateDate ? "(" + scope.row.offerCreateDate + ")" : ""))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Report Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "note",
      "label": "Note"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('div', [_c('el-button', {
          attrs: {
            "size": "small",
            "loading": scope.row.loading || _vm.globalLoading
          },
          on: {
            "click": function($event) {
              return _vm.editReportStatus(scope.row.id, 1, scope.row)
            }
          }
        }, [_vm._v("Confirm")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "loading": scope.row.loading || _vm.globalLoading,
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.editReportStatus(scope.row.id, 2, scope.row)
            }
          }
        }, [_vm._v("Reject")])], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.reportTotal
    },
    on: {
      "current-change": _vm.changeReportPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Inbound History",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Offer or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getInboundHistoryList($event)
      }
    },
    model: {
      value: (_vm.filters.historyFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "historyFilter", $$v)
      },
      expression: "filters.historyFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getInboundHistoryList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportInboundHistory', 'inboundHistory.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdLoading),
      expression: "thirdLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.inboundHistory,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": function($event) {}
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "offerCreateDate",
      "label": "Offer Creation Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundDate",
      "label": "Inbound Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.historyTotal
    },
    on: {
      "current-change": _vm.changeHistoryList
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Nurse Cancelled",
      "name": "fourth"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Offer or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getCancelInboundList($event)
      }
    },
    model: {
      value: (_vm.filters.cancelFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "cancelFilter", $$v)
      },
      expression: "filters.cancelFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getCancelInboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportInboundNurseCancel', 'cancel.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fourthLoading),
      expression: "fourthLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.cancelList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nurseName",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Cancel Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.cancelTotal
    },
    on: {
      "current-change": _vm.changeCancelList
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Tracking",
      "name": "five"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Tracking Number or UPC, Product Name, Offer Id ",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getTrackingList($event)
      }
    },
    model: {
      value: (_vm.filters.trackingNumFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "trackingNumFilter", $$v)
      },
      expression: "filters.trackingNumFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getTrackingList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "value-format": "yyyy-MM-dd",
      "type": "daterange",
      "range-separator": "to",
      "start-placeholder": "startDate",
      "end-placeholder": "endDate"
    },
    on: {
      "change": _vm.getTrackingList
    },
    model: {
      value: (_vm.filters.trackingDate),
      callback: function($$v) {
        _vm.$set(_vm.filters, "trackingDate", $$v)
      },
      expression: "filters.trackingDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportInboundTracking', 'tracking.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fiveLoading),
      expression: "fiveLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.trackingList,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": function($event) {}
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "trackingNumber",
      "label": "Tracking Number"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Offer ID"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.offerNo == 0) ? _c('p') : _c('p', [_vm._v(_vm._s(scope.row.offerNo))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dateTime",
      "label": "DateTime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.trackingTotal
    },
    on: {
      "current-change": _vm.changeTracking
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Offer Take Detail",
      "width": "80%",
      "visible": _vm.detailVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.detailVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Offer"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.detailLoading),
      expression: "detailLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.inboundDetail,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": function($event) {}
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "inboundNo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Take Offer Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": function($event) {}
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.detailVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("settings\n")])
},staticRenderFns: []}

/***/ }),
/* 779 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList($event)
      }
    },
    model: {
      value: (_vm.filters.product),
      callback: function($$v) {
        _vm.$set(_vm.filters, "product", $$v)
      },
      expression: "filters.product"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.getList()
      }
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Warehouse",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getList()
      }
    },
    model: {
      value: (_vm.filters.warehouse),
      callback: function($$v) {
        _vm.$set(_vm.filters, "warehouse", $$v)
      },
      expression: "filters.warehouse"
    }
  }, _vm._l((_vm.warehouseList), function(w, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": w.address + ' ' + w.city + ' ' + w.state,
        "value": w.warehouseNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "type": "monthrange",
      "value-format": "yyyy-MM",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "to",
      "start-placeholder": "start",
      "end-placeholder": "end",
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.filters.date),
      callback: function($$v) {
        _vm.$set(_vm.filters, "date", $$v)
      },
      expression: "filters.date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportStorageFee', 'StorageFee.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "stripe": "",
      "data": _vm.list,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product_name",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "charge_total",
      "label": "Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm.formatMoney(scope.row.charge_total, 2)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "charge_date",
      "label": "Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.changePage
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getInventory($event)
      }
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getInventory
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportInventory', 'inventory.xls')
      }
    }
  }, [_vm._v("Export")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addFormVisible = true
      }
    }
  }, [_vm._v("Add Product")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.products,
      "highlight-current-row": "",
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "productNo",
      "width": "80px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product",
      "label": "Product",
      "width": "400px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.condition) + " - "), _c('b', [_vm._v(_vm._s(scope.row.productName))]), _vm._v(" (" + _vm._s(scope.row.createDate) + ")\n                "), _c('p', [_vm._v(_vm._s(scope.row.upc))]), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.note))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "size",
      "label": "Categroy"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inbound",
      "label": "INBD"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "stock",
      "label": "FBM"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "noClaimed",
      "label": "Not Claimed"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditProduct(scope.row)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showDetail(scope.row.productNo)
            }
          }
        }, [_vm._v("Detail")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteProduct(scope.row.productNo)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.inventoryTotal
    },
    on: {
      "current-change": _vm.handleInventoryChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Product",
      "width": "80%",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addProduct",
    attrs: {
      "model": _vm.addProduct,
      "label-width": "220px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "product"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.product),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "product", $$v)
      },
      expression: "addProduct.product"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.addProduct.price),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "price", $$v)
      },
      expression: "addProduct.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Condition",
      "prop": "condition"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.condition),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "condition", $$v)
      },
      expression: "addProduct.condition"
    }
  }, _vm._l((_vm.conditions), function(condition, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": condition,
        "label": condition
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ASIN",
      "prop": "asin"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.asin),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "asin", $$v)
      },
      expression: "addProduct.asin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC",
      "prop": "upc"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.upc),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "upc", $$v)
      },
      expression: "addProduct.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Weight",
      "prop": "weight"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.weight),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "weight", $$v)
      },
      expression: "addProduct.weight"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.note),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "note", $$v)
      },
      expression: "addProduct.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddProduct($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Product",
      "width": "80%",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editProduct",
    attrs: {
      "model": _vm.editProduct,
      "label-width": "220px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProduct.productName),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "productName", $$v)
      },
      expression: "editProduct.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editProduct.price),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "price", $$v)
      },
      expression: "editProduct.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Category",
      "prop": "size"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off",
      "disabled": true
    },
    model: {
      value: (_vm.editProduct.size),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "size", $$v)
      },
      expression: "editProduct.size"
    }
  }, _vm._l((_vm.sizeList), function(size, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": size,
        "label": size
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Condition",
      "prop": "condition"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProduct.condition),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "condition", $$v)
      },
      expression: "editProduct.condition"
    }
  }, _vm._l((_vm.conditions), function(condition, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": condition,
        "label": condition
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ASIN"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editProduct.asin),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "asin", $$v)
      },
      expression: "editProduct.asin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editProduct.upc),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "upc", $$v)
      },
      expression: "editProduct.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Weight"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editProduct.weight),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "weight", $$v)
      },
      expression: "editProduct.weight"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProduct.note),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "note", $$v)
      },
      expression: "editProduct.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Product FBM",
      "width": "80%",
      "visible": _vm.editFBMVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFBMVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "fbm",
    attrs: {
      "model": _vm.fbm,
      "label-width": "220px",
      "rules": _vm.fbmFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "productName"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.fbm.productName),
      callback: function($$v) {
        _vm.$set(_vm.fbm, "productName", $$v)
      },
      expression: "fbm.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouseNo"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.fbm.warehouseNo),
      callback: function($$v) {
        _vm.$set(_vm.fbm, "warehouseNo", $$v)
      },
      expression: "fbm.warehouseNo"
    }
  }, _vm._l((_vm.warehouseList), function(warehouse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": warehouse.warehouseNo,
        "label": warehouse.state + ' ' + warehouse.city + ' ' + warehouse.address
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.fbm.price),
      callback: function($$v) {
        _vm.$set(_vm.fbm, "price", $$v)
      },
      expression: "fbm.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Quantity",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.fbm.quantity),
      callback: function($$v) {
        _vm.$set(_vm.fbm, "quantity", $$v)
      },
      expression: "fbm.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.fbm.note),
      callback: function($$v) {
        _vm.$set(_vm.fbm, "note", $$v)
      },
      expression: "fbm.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFBMVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addFBM($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Product Detail",
      "width": "80%",
      "visible": _vm.detailVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.detailVisible = $event
      }
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": function($event) {}
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Inbound History",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Tracking Number",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getInboundList($event)
      }
    },
    model: {
      value: (_vm.filters.tracking),
      callback: function($$v) {
        _vm.$set(_vm.filters, "tracking", $$v)
      },
      expression: "filters.tracking"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getInboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "User",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getInboundList()
      }
    },
    model: {
      value: (_vm.filters.inboundUser),
      callback: function($$v) {
        _vm.$set(_vm.filters, "inboundUser", $$v)
      },
      expression: "filters.inboundUser"
    }
  }, _vm._l((_vm.members), function(member, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": member.username,
        "value": member.userNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Inbound Source",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getInboundList()
      }
    },
    model: {
      value: (_vm.filters.inboundType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "inboundType", $$v)
      },
      expression: "filters.inboundType"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "Offer",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "Channel",
      "label": "Channel"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstListLoading),
      expression: "firstListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.inboundList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundType",
      "label": "Inbound Source"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundDate",
      "label": "Inbound Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.inboundTotal
    },
    on: {
      "current-change": _vm.handleChangeInboundList
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "FBM",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "ProductName",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.inventoryProduct),
      callback: function($$v) {
        _vm.$set(_vm.filters, "inventoryProduct", $$v)
      },
      expression: "filters.inventoryProduct"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getInventoryDetail(null)
      }
    }
  }, [_vm._v("Search")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Filter by user",
      "filterable": true
    },
    on: {
      "change": function($event) {
        return _vm.getInventoryDetail(null)
      }
    },
    model: {
      value: (_vm.filters.inventoryNurse),
      callback: function($$v) {
        _vm.$set(_vm.filters, "inventoryNurse", $$v)
      },
      expression: "filters.inventoryNurse"
    }
  }, _vm._l((_vm.members), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fbmDetailLoading),
      expression: "fbmDetailLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.fbmDetail,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productNme",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseUserName",
      "label": "UserName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.fbmTotal
    },
    on: {
      "current-change": _vm.handleInventoryDetailPageChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Outbound History",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "User",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.getOutboundList
    },
    model: {
      value: (_vm.filters.outboundUser),
      callback: function($$v) {
        _vm.$set(_vm.filters, "outboundUser", $$v)
      },
      expression: "filters.outboundUser"
    }
  }, _vm._l((_vm.members), function(member, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": member.username,
        "value": member.userNo
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdListLoading),
      expression: "thirdListLoading"
    }],
    attrs: {
      "stripe": "",
      "data": _vm.outboundList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "outboundId",
      "label": "#",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.productName)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "users",
      "label": "Users"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 1) ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Success")]) : _vm._e(), _vm._v(" "), (scope.row.status === 3) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Closed")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundDate",
      "label": "Outbound Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.outboundTotal
    },
    on: {
      "current-change": _vm.handleChangeOutboundList
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Reported/Missed",
      "name": "fourth"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fourthListLoading),
      expression: "fourthListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.reportedInbound,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product",
      "label": "Offer"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.productName) + " " + _vm._s(scope.row.offerCreateDate ? "(" + scope.row.offerCreateDate + ")" : ""))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Report Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "note",
      "label": "Note"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.reportTotal
    },
    on: {
      "current-change": _vm.changeReportPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Not Claimed",
      "name": "five"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Tracking",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.notClaimedTracking),
      callback: function($$v) {
        _vm.$set(_vm.filters, "notClaimedTracking", $$v)
      },
      expression: "filters.notClaimedTracking"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getNotClaimed
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fiveListLoading),
      expression: "fiveListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.notClaimed,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "ProductName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "trackingNumber",
      "label": "Tracking Number"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dateTime",
      "label": "DateTime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.notClaimedTotal
    },
    on: {
      "current-change": _vm.changeNotClaimedPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "FBM Operation Log",
      "name": "six"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Type",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.getStockList
    },
    model: {
      value: (_vm.filters.stockFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "stockFilter", $$v)
      },
      expression: "filters.stockFilter"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "All",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Nurse Claimed",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Doctor Confirm Report",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Doctor Outbound",
      "value": 3
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Doctor Cancel Outbound",
      "value": 7
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Warehouse Inbound",
      "value": 4
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Warehouse Reverse",
      "value": 5
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Warehouse Batch Reverse",
      "value": 8
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Warehouse Edit FBM",
      "value": 6
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Doctor Transfer",
      "value": 9
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.sixListLoading),
      expression: "sixListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.stockList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "srcStock",
      "label": "Before operating FBM"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "destStock",
      "label": "After operating FBM"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.bizType == 1) ? _c('p', [_vm._v("Nurse Claimed")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 2) ? _c('p', [_vm._v("Doctor Confirm Report")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 3) ? _c('p', [_vm._v("Doctor Outbound")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 4) ? _c('p', [_vm._v("Warehouse Inbound")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 5) ? _c('p', [_vm._v("Warehouse Reverse")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 6) ? _c('p', [_vm._v("Warehouse Edit FBM")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 7) ? _c('p', [_vm._v("Doctor Cancel Outbound")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 8) ? _c('p', [_vm._v("Warehouse Batch Reverse")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 9) ? _c('p', [_vm._v("Doctor Transfer")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operator",
      "prop": "userName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createdTime",
      "label": "DateTime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.stockTotal
    },
    on: {
      "current-change": _vm.changeStockPage
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.detailVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "FBM Detail",
      "width": "80%",
      "visible": _vm.fbmDetailVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.fbmDetailVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.fbmDetailVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 781 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Open",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getOpenOffers($event)
      }
    },
    model: {
      value: (_vm.filters.openOfferFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "openOfferFilter", $$v)
      },
      expression: "filters.openOfferFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getOpenOffers
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportOfferOpen', 'Active Offer.xls')
      }
    }
  }, [_vm._v("Export")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAddProduct
    }
  }, [_vm._v("Add Offer")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstListLoading),
      expression: "firstListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.openOffers,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "offerNo",
      "width": "80px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Offer",
      "width": "300px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productName) + "\n\t\t\t\t\t\t\t"), _c('div', {
          staticClass: "note",
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bouns",
      "label": "Bonus"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Total"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leftNum",
      "label": "Left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Date Created"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "expireDate",
      "label": "Expiration Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showEditOffer(scope.row.offerNo)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.archiveOffer(scope.row.offerNo)
            }
          }
        }, [_vm._v("Archived")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.openOfferTotal
    },
    on: {
      "current-change": _vm.handleChangeOpenOffer
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Proposed",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getProposedOffers($event)
      }
    },
    model: {
      value: (_vm.filters.proposedFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "proposedFilter", $$v)
      },
      expression: "filters.proposedFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getProposedOffers
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Status : "
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "change": _vm.getProposedOffers
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.$set(_vm.filters, "status", $$v)
      },
      expression: "filters.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Confirmed",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Rejected",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportOfferProposed', 'Proposed Offer.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondListLoading),
      expression: "secondListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.proposedOffers,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 3) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("cancelled")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Date Created"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "expireDate",
      "label": "Offer Expiration Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.status === 0) ? [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.confirmProposed(scope.row.id, 1)
            }
          }
        }, [_vm._v("Confirm")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.confirmProposed(scope.row.id, 2)
            }
          }
        }, [_vm._v("Reject")])] : undefined
      }
    }], null, true)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.proposedTotal
    },
    on: {
      "current-change": _vm.getProposedOffers
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Offer History",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getOfferHistory($event)
      }
    },
    model: {
      value: (_vm.filters.historyFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "historyFilter", $$v)
      },
      expression: "filters.historyFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getOfferHistory
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Status : "
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "change": _vm.getOfferHistory
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.$set(_vm.filters, "status", $$v)
      },
      expression: "filters.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Offering",
      "value": "offering"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Archived",
      "value": "archived"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Expired",
      "value": "expired"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportOfferHistory', 'Offer History.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdListLoading),
      expression: "thirdListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.offerHistory,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "offerNo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Total"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leftNum",
      "label": "Left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Date Created"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status != 'offering') ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.reListOffer(scope.row.offerNo)
            }
          }
        }, [_vm._v("Relist")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.getOfferDetail(scope.row.offerNo)
            }
          }
        }, [_vm._v("Detail")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.historyTotal
    },
    on: {
      "current-change": _vm.handleChangeOfferHistory
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Offer",
      "width": "80%",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addOffer",
    attrs: {
      "model": _vm.addOffer,
      "label-width": "220px",
      "rules": _vm.addOfferFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product",
      "prop": "productNo"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "800px"
    },
    attrs: {
      "filterable": "",
      "auto-complete": "off",
      "clearable": ""
    },
    model: {
      value: (_vm.addOffer.productNo),
      callback: function($$v) {
        _vm.$set(_vm.addOffer, "productNo", $$v)
      },
      expression: "addOffer.productNo"
    }
  }, _vm._l((_vm.products), function(product, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": product.productNo,
        "label": product.productName
      }
    }, [_vm._v(_vm._s(product.condition + ' - ' + product.productName + ' (' + product.createDate + ')'))])
  }), 1), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-left": "20px",
      "text-decoration": "underline",
      "color": "blue",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.addProductVisible = true
      }
    }
  }, [_vm._v("Add Product")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.addOffer.price),
      callback: function($$v) {
        _vm.$set(_vm.addOffer, "price", $$v)
      },
      expression: "addOffer.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Total",
      "prop": "total"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.addOffer.total),
      callback: function($$v) {
        _vm.$set(_vm.addOffer, "total", $$v)
      },
      expression: "addOffer.total"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Expires At",
      "prop": "expireDate"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.addOffer.expireDate),
      callback: function($$v) {
        _vm.$set(_vm.addOffer, "expireDate", $$v)
      },
      expression: "addOffer.expireDate"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("By default, expires in 3 days")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.addOffer.note),
      callback: function($$v) {
        _vm.$set(_vm.addOffer, "note", $$v)
      },
      expression: "addOffer.note"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bonus",
      "prop": "bouns"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.addOffer.bouns),
      callback: function($$v) {
        _vm.$set(_vm.addOffer, "bouns", $$v)
      },
      expression: "addOffer.bouns"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "scope"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addOffer.scope),
      callback: function($$v) {
        _vm.$set(_vm.addOffer, "scope", $$v)
      },
      expression: "addOffer.scope"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "public"
    }
  }, [_vm._v("public")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "private"
    }
  }, [_vm._v("private")])], 1)], 1), _vm._v(" "), (_vm.addOffer.scope === 'private') ? _c('el-form-item', {
    attrs: {
      "label": "Users"
    }
  }, [_c('el-tree', {
    ref: "tree",
    attrs: {
      "data": _vm.groups,
      "show-checkbox": "",
      "default-expand-all": "",
      "node-key": "userNo",
      "highlight-current": "",
      "props": _vm.defaultProps
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-checkbox', {
    model: {
      value: (_vm.addOffer.notify),
      callback: function($$v) {
        _vm.$set(_vm.addOffer, "notify", $$v)
      },
      expression: "addOffer.notify"
    }
  }, [_vm._v("Notify every who can see the offer")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddOffer($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Offer",
      "width": "80%",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editOffer",
    attrs: {
      "model": _vm.editOffer,
      "label-width": "220px",
      "rules": _vm.editOfferFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product",
      "prop": "productNo"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editOffer.productNo),
      callback: function($$v) {
        _vm.$set(_vm.editOffer, "productNo", $$v)
      },
      expression: "editOffer.productNo"
    }
  }, _vm._l((_vm.products), function(product, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": product.productNo,
        "label": product.productName
      }
    }, [_vm._v(_vm._s(product.condition + ' - ' + product.productName + ' (' + product.createDate + ')'))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editOffer.price),
      callback: function($$v) {
        _vm.$set(_vm.editOffer, "price", $$v)
      },
      expression: "editOffer.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Original Total",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editOffer.quantity),
      callback: function($$v) {
        _vm.$set(_vm.editOffer, "quantity", $$v)
      },
      expression: "editOffer.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Left",
      "prop": "leftNum"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": _vm.editOffer.quantity
    },
    model: {
      value: (_vm.editOffer.leftNum),
      callback: function($$v) {
        _vm.$set(_vm.editOffer, "leftNum", $$v)
      },
      expression: "editOffer.leftNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Expires At",
      "prop": "expireDate"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.editOffer.expireDate),
      callback: function($$v) {
        _vm.$set(_vm.editOffer, "expireDate", $$v)
      },
      expression: "editOffer.expireDate"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("By default, expires in 3 days")])]), _vm._v(" "), (_vm.editOffer.scope == 'private') ? _c('el-form-item', {
    attrs: {
      "label": "User"
    }
  }, _vm._l((_vm.editOffer.users), function(user, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "type": "info"
      }
    }, [_vm._v(_vm._s(user))])
  }), 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.editOffer.note),
      callback: function($$v) {
        _vm.$set(_vm.editOffer, "note", $$v)
      },
      expression: "editOffer.note"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bonus",
      "prop": "bouns"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editOffer.bouns),
      callback: function($$v) {
        _vm.$set(_vm.editOffer, "bouns", $$v)
      },
      expression: "editOffer.bouns"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleEditOffer($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "ReList Offer",
      "width": "80%",
      "visible": _vm.relistFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.relistFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "relistOffer",
    attrs: {
      "model": _vm.relistOffer,
      "label-width": "220px",
      "rules": _vm.editOfferFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product",
      "prop": "productNo"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.relistOffer.productNo),
      callback: function($$v) {
        _vm.$set(_vm.relistOffer, "productNo", $$v)
      },
      expression: "relistOffer.productNo"
    }
  }, _vm._l((_vm.products), function(product, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": product.productNo,
        "label": product.productName
      }
    }, [_vm._v(_vm._s(product.condition + ' - ' + product.productName + ' (' + product.createDate + ')'))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.relistOffer.price),
      callback: function($$v) {
        _vm.$set(_vm.relistOffer, "price", $$v)
      },
      expression: "relistOffer.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Original Total",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.relistOffer.quantity),
      callback: function($$v) {
        _vm.$set(_vm.relistOffer, "quantity", $$v)
      },
      expression: "relistOffer.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Left",
      "prop": "leftNum"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": _vm.relistOffer.quantity
    },
    model: {
      value: (_vm.relistOffer.leftNum),
      callback: function($$v) {
        _vm.$set(_vm.relistOffer, "leftNum", $$v)
      },
      expression: "relistOffer.leftNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Expires At",
      "prop": "expireDate"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "disabled": true
    },
    model: {
      value: (_vm.relistOffer.expireDate),
      callback: function($$v) {
        _vm.$set(_vm.relistOffer, "expireDate", $$v)
      },
      expression: "relistOffer.expireDate"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "New Expires At",
      "prop": "newExpireDate"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.relistOffer.newExpireDate),
      callback: function($$v) {
        _vm.$set(_vm.relistOffer, "newExpireDate", $$v)
      },
      expression: "relistOffer.newExpireDate"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("By default, expires in 3 days")])]), _vm._v(" "), (_vm.relistOffer.scope == 'private') ? _c('el-form-item', {
    attrs: {
      "label": "User"
    }
  }, _vm._l((_vm.relistOffer.users), function(user, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "type": "info"
      }
    }, [_vm._v(_vm._s(user))])
  }), 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.relistOffer.note),
      callback: function($$v) {
        _vm.$set(_vm.relistOffer, "note", $$v)
      },
      expression: "relistOffer.note"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bonus",
      "prop": "bouns"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.relistOffer.bouns),
      callback: function($$v) {
        _vm.$set(_vm.relistOffer, "bouns", $$v)
      },
      expression: "relistOffer.bouns"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.relistFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleReListOffer($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Product",
      "width": "80%",
      "visible": _vm.addProductVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addProductVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addProduct",
    attrs: {
      "model": _vm.addProduct,
      "label-width": "220px",
      "rules": _vm.addProductFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "product"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.product),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "product", $$v)
      },
      expression: "addProduct.product"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.addProduct.price),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "price", $$v)
      },
      expression: "addProduct.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Condition",
      "prop": "condition"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.condition),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "condition", $$v)
      },
      expression: "addProduct.condition"
    }
  }, _vm._l((_vm.conditions), function(condition, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": condition,
        "label": condition
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ASIN",
      "prop": "asin"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.asin),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "asin", $$v)
      },
      expression: "addProduct.asin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC",
      "prop": "upc"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.upc),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "upc", $$v)
      },
      expression: "addProduct.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Weight",
      "prop": "weight"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.weight),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "weight", $$v)
      },
      expression: "addProduct.weight"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.note),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "note", $$v)
      },
      expression: "addProduct.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addProductVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddProduct($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Offer Detail",
      "width": "80%",
      "visible": _vm.offerDetailVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.offerDetailVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "User",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getOfferDetail()
      }
    },
    model: {
      value: (_vm.filters.offerDetailFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "offerDetailFilter", $$v)
      },
      expression: "filters.offerDetailFilter"
    }
  }, _vm._l((_vm.nurseList), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.offerDetails,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": function($event) {}
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "takeDate",
      "label": "Offer Take Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.offerDetailTotal
    },
    on: {
      "current-change": _vm.handleChangeOfferDetail
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.offerDetailVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 782 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Active",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getOpenOffers($event)
      }
    },
    model: {
      value: (_vm.filters.openOfferFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "openOfferFilter", $$v)
      },
      expression: "filters.openOfferFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getOpenOffers
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNurseActiveOffer', 'activeOffer.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstListLoading),
      expression: "firstListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.openOffers,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "offerNo",
      "width": "80px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Offer",
      "width": "300px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productName) + "\n\t\t\t\t\t\t\t"), _c('div', {
          staticClass: "note",
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createBy",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bouns",
      "label": "Bouns"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leftNum",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.leftNum > 0) ? _c('p', [_c('el-tag', [_vm._v("Can Take")])], 1) : _vm._e(), _vm._v(" "), (scope.row.leftNum <= 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("No surplus")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Create Date",
      "formatter": _vm.formatTimesTamp
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showTakeOffer(scope.row.offerNo)
            }
          }
        }, [_vm._v("Take")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.openOfferTotal
    },
    on: {
      "current-change": _vm.changeOfferPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Proposed",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getProposedOffers($event)
      }
    },
    model: {
      value: (_vm.filters.proposedFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "proposedFilter", $$v)
      },
      expression: "filters.proposedFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getProposedOffers
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showProposed
    }
  }, [_vm._v("Request")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNurseProposedOffer', 'proposedOffer.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondListLoading),
      expression: "secondListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.proposedOffers,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Create Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 3) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("cancelled")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.status === 0) ? [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.cancelProposed(scope.row.id, 2)
            }
          }
        }, [_vm._v("Cancel")])] : undefined
      }
    }], null, true)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.proposedTotal
    },
    on: {
      "current-change": _vm.changeProposedPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Expired",
      "name": "fourth"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getExpiredOffers($event)
      }
    },
    model: {
      value: (_vm.filters.expiredFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "expiredFilter", $$v)
      },
      expression: "filters.expiredFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getExpiredOffers
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fourthListLoading),
      expression: "fourthListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.expiredList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "offerNo",
      "width": "80px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Offer",
      "width": "300px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productName) + "\n\t\t\t\t\t\t\t"), _c('div', {
          staticClass: "note",
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createBy",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bouns",
      "label": "Bouns"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leftNum",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Create Date",
      "formatter": _vm.formatTimesTamp
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showProposedOffer(scope.row.offerNo)
            }
          }
        }, [_vm._v("Propose")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.expiredTotal
    },
    on: {
      "current-change": _vm.changeExpiredPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Offer History",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getOfferHistroy($event)
      }
    },
    model: {
      value: (_vm.filters.historyFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "historyFilter", $$v)
      },
      expression: "filters.historyFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getOfferHistroy
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Status",
      "clearable": ""
    },
    on: {
      "change": _vm.getOfferHistroy
    },
    model: {
      value: (_vm.filters.historyStatus),
      callback: function($$v) {
        _vm.$set(_vm.filters, "historyStatus", $$v)
      },
      expression: "filters.historyStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Completed",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Canceled",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNurseOfferHistory', 'offerHistory.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdListLoading),
      expression: "thirdListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.historyList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "offerNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctor",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "offerCreateTime",
      "label": "Offer Create Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "takeDate",
      "label": "Take Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Completed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Canceled")])], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Take Offer",
      "width": "80%",
      "visible": _vm.takeOfferVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.takeOfferVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "takeOffer",
    attrs: {
      "model": _vm.takeOffer,
      "label-width": "220px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "company",
      "prop": "Company"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.takeOffer.createBy),
      callback: function($$v) {
        _vm.$set(_vm.takeOffer, "createBy", $$v)
      },
      expression: "takeOffer.createBy"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Product",
      "prop": "product"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.takeOffer.product),
      callback: function($$v) {
        _vm.$set(_vm.takeOffer, "product", $$v)
      },
      expression: "takeOffer.product"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true,
      "min": 0
    },
    model: {
      value: (_vm.takeOffer.price),
      callback: function($$v) {
        _vm.$set(_vm.takeOffer, "price", $$v)
      },
      expression: "takeOffer.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bonus"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": true
    },
    model: {
      value: (_vm.takeOffer.bouns),
      callback: function($$v) {
        _vm.$set(_vm.takeOffer, "bouns", $$v)
      },
      expression: "takeOffer.bouns"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Left",
      "prop": "leftNum"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.takeOffer.leftNum),
      callback: function($$v) {
        _vm.$set(_vm.takeOffer, "leftNum", _vm._n($$v))
      },
      expression: "takeOffer.leftNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Quantity",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.takeOffer.quantity),
      callback: function($$v) {
        _vm.$set(_vm.takeOffer, "quantity", _vm._n($$v))
      },
      expression: "takeOffer.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouseNo"
    }
  }, [_c('el-select', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "clearable": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.takeOffer.warehouseNo),
      callback: function($$v) {
        _vm.$set(_vm.takeOffer, "warehouseNo", $$v)
      },
      expression: "takeOffer.warehouseNo"
    }
  }, _vm._l((_vm.warehouses), function(group) {
    return _c('el-option-group', {
      key: group.label,
      attrs: {
        "label": group.label
      }
    }, _vm._l((group.options), function(item, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "label": item.state + ' ' + item.city + ' ' + item.address,
          "value": item.warehouseNo
        }
      })
    }), 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.takeOfferVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleTakeOffer($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Proposed offer",
      "width": "80%",
      "visible": _vm.proposedOfferVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.proposedOfferVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "proposedOffer",
    attrs: {
      "model": _vm.proposedOffer,
      "label-width": "220px",
      "rules": _vm.proposedFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product",
      "prop": "offerNo"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off",
      "clearable": "",
      "disabled": ""
    },
    on: {
      "change": _vm.selectProposedOffer
    },
    model: {
      value: (_vm.proposedOffer.offerNo),
      callback: function($$v) {
        _vm.$set(_vm.proposedOffer, "offerNo", $$v)
      },
      expression: "proposedOffer.offerNo"
    }
  }, _vm._l((_vm.proposedList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.productName + ' (' + item.createDate + ')',
        "value": item.offerNo
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.proposedOffer.offerNo) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "company",
      "prop": "createBy"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.proposedOffer.createBy),
      callback: function($$v) {
        _vm.$set(_vm.proposedOffer, "createBy", $$v)
      },
      expression: "proposedOffer.createBy"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true,
      "min": 0
    },
    model: {
      value: (_vm.proposedOffer.price),
      callback: function($$v) {
        _vm.$set(_vm.proposedOffer, "price", $$v)
      },
      expression: "proposedOffer.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Quantity",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.proposedOffer.quantity),
      callback: function($$v) {
        _vm.$set(_vm.proposedOffer, "quantity", $$v)
      },
      expression: "proposedOffer.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouseNo"
    }
  }, [_c('el-select', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "clearable": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.proposedOffer.warehouseNo),
      callback: function($$v) {
        _vm.$set(_vm.proposedOffer, "warehouseNo", $$v)
      },
      expression: "proposedOffer.warehouseNo"
    }
  }, _vm._l((_vm.warehouses), function(group) {
    return _c('el-option-group', {
      key: group.label,
      attrs: {
        "label": group.label
      }
    }, _vm._l((group.options), function(item, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "label": item.state + ' ' + item.city + ' ' + item.address,
          "value": item.warehouseNo
        }
      })
    }), 1)
  }), 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.proposedOfferVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.requestProposed($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 783 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Offers")])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Offers',
          params: {
            active: 'first'
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.offers.active) + " active offers")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Offers',
          params: {
            active: 'second'
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.offers.proposed) + " proposed offers")])], 1)])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5,
      "offset": 1
    }
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Inbound")])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Inbound',
          params: {
            active: 'first'
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.inbound.inbound) + " inbound items")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Inbound',
          params: {
            active: 'second'
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.inbound.reported) + " reported item")])], 1)])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5,
      "offset": 1
    }
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Outbound")])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/outbound')
      }
    }
  }, [_vm._v(_vm._s(_vm.outbound.outbound) + " outbound shipments")])], 1)])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5,
      "offset": 1
    }
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Payments")])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/payments')
      }
    }
  }, [_vm._v(_vm._s(_vm.balance.request) + " payment request")])], 1)])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getUsers
    }
  }, [_vm._v("Search")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("Add Offer")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.users,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sex",
      "label": "性别",
      "width": "100",
      "formatter": _vm.formatSex
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "age",
      "label": "年龄",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "birth",
      "label": "生日",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "addr",
      "label": "地址",
      "min-width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.editForm.sex),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "sex", $$v)
      },
      expression: "editForm.sex"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("女")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "年龄"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.editForm.age),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "age", $$v)
      },
      expression: "editForm.age"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "生日"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.editForm.birth),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "birth", $$v)
      },
      expression: "editForm.birth"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.editForm.addr),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "addr", $$v)
      },
      expression: "editForm.addr"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addForm.sex),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "sex", $$v)
      },
      expression: "addForm.sex"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("女")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "年龄"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.addForm.age),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "age", $$v)
      },
      expression: "addForm.age"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "生日"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.addForm.birth),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "birth", $$v)
      },
      expression: "addForm.birth"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.addForm.addr),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "addr", $$v)
      },
      expression: "addForm.addr"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 785 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Member List",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "User Name",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.username),
      callback: function($$v) {
        _vm.$set(_vm.filters, "username", $$v)
      },
      expression: "filters.username"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getDoctorMembers
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Status",
      "clearable": ""
    },
    on: {
      "change": _vm.getDoctorMembers
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.$set(_vm.filters, "status", $$v)
      },
      expression: "filters.status"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "1",
      "label": "Active"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "2",
      "label": "Limited"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "3",
      "label": "Blocked"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstLoading),
      expression: "firstLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.memberList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "User Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "Email"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "roleId",
      "label": "role"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.roleId == '2') ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Nurse")]) : _vm._e(), _vm._v(" "), (scope.row.roleId == '3') ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Wareshoue Admin")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "alias",
      "label": "Alias"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "Phone"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status",
      "formatter": _vm.formatMemberStatus
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showEditMember(scope.row)
            }
          }
        }, [_vm._v("Edit")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.membersTotalPage
    },
    on: {
      "current-change": _vm.handleMembersPageChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Groups",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Group Name",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.groupCondition),
      callback: function($$v) {
        _vm.$set(_vm.filters, "groupCondition", $$v)
      },
      expression: "filters.groupCondition"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getGroupList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAddGroup
    }
  }, [_vm._v("Add Group")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondLoading),
      expression: "secondLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.groups,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "groupNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "groupName",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Users"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.userList), function(user, index) {
          return _c('el-tag', {
            key: index,
            attrs: {
              "type": "success",
              "disable-transitions": ""
            }
          }, [_vm._v(_vm._s(user.username) + "\n                        ")])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showEditGroup(scope.row.groupNo)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteGroup(scope.row.groupNo)
            }
          }
        }, [_vm._v("Delete\n                        ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.groupTotalPage
    },
    on: {
      "current-change": _vm.handleGroupPageChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Invitations",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Email",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.invitationEmail),
      callback: function($$v) {
        _vm.$set(_vm.filters, "invitationEmail", $$v)
      },
      expression: "filters.invitationEmail"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getInvitations
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.invitationVisible = true
      }
    }
  }, [_vm._v("Invitation")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdLoading),
      expression: "thirdLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.invitations
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "invitationNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "Email"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "role_name",
      "label": "Role"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "DateTime",
      "formatter": _vm.formatTimesTamp
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status",
      "formatter": _vm.formatRole
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.invitationTotalPage
    },
    on: {
      "current-change": _vm.handleInvitationPageChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Member",
      "width": "80%",
      "visible": _vm.editMemberVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editMemberVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.editMemberObj,
      "label-width": "220px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "UserName",
      "prop": "userName"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editMemberObj.userName),
      callback: function($$v) {
        _vm.$set(_vm.editMemberObj, "userName", $$v)
      },
      expression: "editMemberObj.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Status"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.editMemberObj.status),
      callback: function($$v) {
        _vm.$set(_vm.editMemberObj, "status", $$v)
      },
      expression: "editMemberObj.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("Limited")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    }
  }, [_vm._v("Blocked")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Alias"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editMemberObj.alias),
      callback: function($$v) {
        _vm.$set(_vm.editMemberObj, "alias", $$v)
      },
      expression: "editMemberObj.alias"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Payment Pending transactions"
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.editMemberObj.pendingTransaction),
      callback: function($$v) {
        _vm.$set(_vm.editMemberObj, "pendingTransaction", $$v)
      },
      expression: "editMemberObj.pendingTransaction"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Payment Pending amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editMemberObj.pendingAmount),
      callback: function($$v) {
        _vm.$set(_vm.editMemberObj, "pendingAmount", $$v)
      },
      expression: "editMemberObj.pendingAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Minimum Payment"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editMemberObj.minPayment),
      callback: function($$v) {
        _vm.$set(_vm.editMemberObj, "minPayment", $$v)
      },
      expression: "editMemberObj.minPayment"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editMemberVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editMember($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Group",
      "width": "80%",
      "visible": _vm.addGroupVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addGroupVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "group",
    attrs: {
      "model": _vm.group,
      "label-width": "220px",
      "rules": _vm.groupFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Group Name",
      "prop": "groupName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.group.groupName),
      callback: function($$v) {
        _vm.$set(_vm.group, "groupName", $$v)
      },
      expression: "group.groupName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "User"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: (_vm.group.users),
      callback: function($$v) {
        _vm.$set(_vm.group, "users", $$v)
      },
      expression: "group.users"
    }
  }, _vm._l((_vm.nurseList), function(user, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": user.username,
        "value": user.userNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Payment Pending transactions"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.group.pendingTransaction),
      callback: function($$v) {
        _vm.$set(_vm.group, "pendingTransaction", $$v)
      },
      expression: "group.pendingTransaction"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Payment Pending amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.group.pendingAmount),
      callback: function($$v) {
        _vm.$set(_vm.group, "pendingAmount", $$v)
      },
      expression: "group.pendingAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Minimum Payment"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.group.minPayment),
      callback: function($$v) {
        _vm.$set(_vm.group, "minPayment", $$v)
      },
      expression: "group.minPayment"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addGroupVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addGroup($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Group",
      "width": "80%",
      "visible": _vm.editGroupVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editGroupVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editGroupObj",
    attrs: {
      "model": _vm.editGroupObj,
      "label-width": "220px",
      "rules": _vm.groupFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Group Name",
      "prop": "groupName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editGroupObj.groupName),
      callback: function($$v) {
        _vm.$set(_vm.editGroupObj, "groupName", $$v)
      },
      expression: "editGroupObj.groupName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "User"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: (_vm.editGroupObj.users),
      callback: function($$v) {
        _vm.$set(_vm.editGroupObj, "users", $$v)
      },
      expression: "editGroupObj.users"
    }
  }, _vm._l((_vm.nurseList), function(user, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": user.username,
        "value": user.userNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Payment Pending transactions"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editGroupObj.pendingTransaction),
      callback: function($$v) {
        _vm.$set(_vm.editGroupObj, "pendingTransaction", $$v)
      },
      expression: "editGroupObj.pendingTransaction"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Payment Pending amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editGroupObj.pendingAmount),
      callback: function($$v) {
        _vm.$set(_vm.editGroupObj, "pendingAmount", $$v)
      },
      expression: "editGroupObj.pendingAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Minimum Payment"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editGroupObj.minPayment),
      callback: function($$v) {
        _vm.$set(_vm.editGroupObj, "minPayment", $$v)
      },
      expression: "editGroupObj.minPayment"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editGroupVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editGroup($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Invitation",
      "width": "80%",
      "visible": _vm.invitationVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.invitationVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "invitation",
    attrs: {
      "model": _vm.invitation,
      "label-width": "220px",
      "rules": _vm.invitationRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Role Name",
      "prop": "role"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "required": ""
    },
    model: {
      value: (_vm.invitation.role),
      callback: function($$v) {
        _vm.$set(_vm.invitation, "role", $$v)
      },
      expression: "invitation.role"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "2",
      "label": "Nurse"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "3",
      "label": "Warehouse Admin"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email"
    },
    model: {
      value: (_vm.invitation.email),
      callback: function($$v) {
        _vm.$set(_vm.invitation, "email", $$v)
      },
      expression: "invitation.email"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.invitationVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.invitationRegister($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "To Confirm",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Tracking or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getToConfirmTrackingList($event)
      }
    },
    model: {
      value: (_vm.filters.toConfirmFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "toConfirmFilter", $$v)
      },
      expression: "filters.toConfirmFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getToConfirmTrackingList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showImport
    }
  }, [_vm._v("Import")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showBulkConfirm
    }
  }, [_vm._v("Bulk Confirm")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showBulkRemove
    }
  }, [_vm._v("Bulk Remove")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportWarehouseTracking', 'Tracking.xls', 1)
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstListLoading),
      expression: "firstListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.toConfirmList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "batchNumber",
      "label": "Batch Number"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking #"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.tracking))]), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.note))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Import Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showEdit(scope.row.cwId)
            }
          }
        }, [_vm._v("Edit\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.removeTracking(scope.row.cwId)
            }
          }
        }, [_vm._v("Remove")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.toConfirmTotal
    },
    on: {
      "current-change": _vm.changeConfirmPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Inbound History",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Name、Tracking or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getHistoryList($event)
      }
    },
    model: {
      value: (_vm.filters.historyFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "historyFilter", $$v)
      },
      expression: "filters.historyFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getHistoryList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showBulkReverse
    }
  }, [_vm._v("Bulk Reverse")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportWarehouseInboundHistory', 'inboundHistory.xls', 3)
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondListLoading),
      expression: "secondListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.inboundHistory,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "cwId"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Shared warehouse inbound"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productName) + " (" + _vm._s(scope.row.lastUpdateDate) + ")\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nurseName",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), (_vm.user.userNo == 'user-9aa177023c4340609ce337d618d0bd99' || _vm.user.userNo == 'user-bcfde657d5684dd694d89ae424f11530') ? _c('el-table-column', {
    attrs: {
      "prop": "forceChargeTime",
      "label": "Force Charge Time"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productStatus",
      "label": "productStatus"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editInboundHistory(scope.row)
            }
          }
        }, [_vm._v("Edit\n\t\t\t\t\t\t\t")]), _vm._v(" "), (scope.row.productStatus && scope.row.productStatus.indexOf('Can be reverse') !== -1) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.reverseById(scope.row.cwId)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\tReverse\n\t\t\t\t\t\t\t")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.historyTotal
    },
    on: {
      "current-change": _vm.changeHistoryList
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Inbound",
      "width": "80%",
      "visible": _vm.editToConfirmInboundVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editToConfirmInboundVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editTracking",
    attrs: {
      "model": _vm.editTracking,
      "label-width": "220px",
      "rules": _vm.editRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouseNo"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editTracking.warehouseNo),
      callback: function($$v) {
        _vm.$set(_vm.editTracking, "warehouseNo", $$v)
      },
      expression: "editTracking.warehouseNo"
    }
  }, _vm._l((_vm.warehouses), function(warehouse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": warehouse.warehouseNo,
        "label": warehouse.state + ' ' + warehouse.city + ' ' + warehouse.address
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tracking Number",
      "prop": "trackingNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editTracking.trackingNumber),
      callback: function($$v) {
        _vm.$set(_vm.editTracking, "trackingNumber", $$v)
      },
      expression: "editTracking.trackingNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC",
      "prop": "upc"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editTracking.upc),
      callback: function($$v) {
        _vm.$set(_vm.editTracking, "upc", $$v)
      },
      expression: "editTracking.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Qty",
      "prop": "qty"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editTracking.qty),
      callback: function($$v) {
        _vm.$set(_vm.editTracking, "qty", $$v)
      },
      expression: "editTracking.qty"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editTracking.note),
      callback: function($$v) {
        _vm.$set(_vm.editTracking, "note", $$v)
      },
      expression: "editTracking.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editToConfirmInboundVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleEdit($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Inbound",
      "width": "80%",
      "visible": _vm.editInboundHistoryVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editInboundHistoryVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editInbound",
    attrs: {
      "model": _vm.editInbound,
      "label-width": "220px",
      "rules": _vm.editRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editInbound.productName),
      callback: function($$v) {
        _vm.$set(_vm.editInbound, "productName", $$v)
      },
      expression: "editInbound.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Company"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editInbound.company),
      callback: function($$v) {
        _vm.$set(_vm.editInbound, "company", $$v)
      },
      expression: "editInbound.company"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tracking Number"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editInbound.tracking),
      callback: function($$v) {
        _vm.$set(_vm.editInbound, "tracking", $$v)
      },
      expression: "editInbound.tracking"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editInbound.upc),
      callback: function($$v) {
        _vm.$set(_vm.editInbound, "upc", $$v)
      },
      expression: "editInbound.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editInbound.warehouse),
      callback: function($$v) {
        _vm.$set(_vm.editInbound, "warehouse", $$v)
      },
      expression: "editInbound.warehouse"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Qty"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editInbound.qty),
      callback: function($$v) {
        _vm.$set(_vm.editInbound, "qty", $$v)
      },
      expression: "editInbound.qty"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editInbound.note),
      callback: function($$v) {
        _vm.$set(_vm.editInbound, "note", $$v)
      },
      expression: "editInbound.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editInboundHistoryVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editConfirmedTracking($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Import",
      "width": "80%",
      "visible": _vm.warehouseImportVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.warehouseImportVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "importTrack",
    attrs: {
      "model": _vm.importTrack,
      "label-width": "220px",
      "rules": _vm.importRule
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.removeAllItem($event)
      }
    }
  }, [_vm._v("Remove All Tracking")]), _vm._v(" "), _c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.importTracking($event)
      }
    }
  }, [_vm._v("Submit")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Batch number",
      "prop": "batchNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off",
      "value": _vm.batchNumber
    },
    model: {
      value: (_vm.importTrack.batchNumber),
      callback: function($$v) {
        _vm.$set(_vm.importTrack, "batchNumber", $$v)
      },
      expression: "importTrack.batchNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouseNo"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off",
      "clearable": ""
    },
    model: {
      value: (_vm.importTrack.warehouseNo),
      callback: function($$v) {
        _vm.$set(_vm.importTrack, "warehouseNo", $$v)
      },
      expression: "importTrack.warehouseNo"
    }
  }, _vm._l((_vm.warehouses), function(warehouse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": warehouse.warehouseNo,
        "label": warehouse.state + ' ' + warehouse.city + ' ' + warehouse.address
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tracking Number",
      "prop": "trackingNumbers"
    }
  }, [(_vm.importTrack.trackingNumbers.length > 0) ? _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.importTrack.trackingNumbers,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking Number"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "note",
      "label": "Note"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.removeRow(scope.row)
            }
          }
        }, [_vm._v("Remove\n\t\t\t\t\t\t\t\t\t")])]
      }
    }], null, false, 3656174827)
  })], 1)], 1) : _c('div', [_c('p', {
    staticStyle: {
      "padding": "0",
      "margin": "0",
      "font-size": "18px",
      "color": "#11b95c"
    }
  }, [_vm._v("You have not uploaded tracking\n\t\t\t\t\t\t\tnumber, please upload tracking number.")])]), _vm._v(" "), _c('p', [_vm._v("Import tracking number as\n\t\t\t\t\t\t"), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.textImportVisible = true
      }
    }
  }, [_vm._v("Text")]), _vm._v("\n\t\t\t\t\t\tor\n\t\t\t\t\t\t"), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.excelImportVisible = true
      }
    }
  }, [_vm._v("Excel")])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.warehouseImportVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.removeAllItem($event)
      }
    }
  }, [_vm._v("Remove All Tracking")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.importTracking($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Bulk confirm shared warehouse inbound items",
      "width": "80%",
      "visible": _vm.bulkConfirmVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.bulkConfirmVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "label": "Batch Number :"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select a batch number",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.changeBatchNumberForBulkConfirm
    },
    model: {
      value: (_vm.batchNumber),
      callback: function($$v) {
        _vm.batchNumber = $$v
      },
      expression: "batchNumber"
    }
  }, _vm._l((_vm.batchNumbers), function(b, i) {
    return _c('el-option', {
      key: i,
      attrs: {
        "value": b,
        "label": b
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sendMail
    }
  }, [_vm._v("Send Email")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.bulkConfirmList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "select a product"
          },
          model: {
            value: (scope.row.productNo),
            callback: function($$v) {
              _vm.$set(scope.row, "productNo", $$v)
            },
            expression: "scope.row.productNo"
          }
        }, _vm._l((scope.row.productsList), function(p, i) {
          return _c('el-option', {
            key: i,
            attrs: {
              "label": p.productName,
              "value": p.productNo
            }
          })
        }), 1)]
      }
    }])
  }), _vm._v(" "), (_vm.user.userNo == 'user-9aa177023c4340609ce337d618d0bd99' || _vm.user.userNo == 'user-bcfde657d5684dd694d89ae424f11530') ? _c('el-table-column', {
    attrs: {
      "label": "Force Charge Time"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-date-picker', {
          attrs: {
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "Force Charge Time"
          },
          model: {
            value: (scope.row.forceChargeTime),
            callback: function($$v) {
              _vm.$set(scope.row, "forceChargeTime", $$v)
            },
            expression: "scope.row.forceChargeTime"
          }
        })]
      }
    }], null, false, 403668256)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.removeItem(scope.row)
            }
          }
        }, [_vm._v("Remove")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.bulkConfirm($event)
      }
    }
  }, [_vm._v("Bulk Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Bulk remove shared warehouse inbound items",
      "width": "80%",
      "visible": _vm.bulkRemoveVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.bulkRemoveVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "label": "Batch Number :"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select a batch number",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.changeBatchNumberForBulkRemove
    },
    model: {
      value: (_vm.batchNumber),
      callback: function($$v) {
        _vm.batchNumber = $$v
      },
      expression: "batchNumber"
    }
  }, _vm._l((_vm.batchNumbers), function(b, i) {
    return _c('el-option', {
      key: i,
      attrs: {
        "value": b,
        "label": b
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.bulkRemoveList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking #"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "Company"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.bulkRemove($event)
      }
    }
  }, [_vm._v("Bulk Remove")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Bulk reverse",
      "width": "80%",
      "visible": _vm.bulkReverseVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.bulkReverseVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "label": "Batch Number :"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select a batch number",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.changeBatchNumberForBulkReverse
    },
    model: {
      value: (_vm.batchNumber),
      callback: function($$v) {
        _vm.batchNumber = $$v
      },
      expression: "batchNumber"
    }
  }, _vm._l((_vm.batchNumbers), function(b, i) {
    return _c('el-option', {
      key: i,
      attrs: {
        "value": b,
        "label": b
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.bulkReverseList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Shared warehouse inbound"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t" + _vm._s(scope.row.productName) + " (" + _vm._s(scope.row.lastUpdateDate) + ")\n\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  }), _vm._v(" "), (_vm.user.userNo == 'user-9aa177023c4340609ce337d618d0bd99' || _vm.user.userNo == 'user-bcfde657d5684dd694d89ae424f11530') ? _c('el-table-column', {
    attrs: {
      "prop": "forceChargeTime",
      "label": "Force Charge Time"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.bulkReverse($event)
      }
    }
  }, [_vm._v("Bulk Reverse")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Import tracking number from text",
      "width": "80%",
      "visible": _vm.textImportVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.textImportVisible = $event
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "10",
      "placeholder": _vm.placeholder,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("The tracking number import of text needs to contain tracking Numbers, upc, quantity, note,\n\t\t\t\tseparated by commas,space or tab, and multiple records must be separated by newline.")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.textImportVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.importFromText($event)
      }
    }
  }, [_vm._v("Import")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Import tracking number from excel",
      "width": "80%",
      "visible": _vm.excelImportVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.excelImportVisible = $event
      }
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "on-success": _vm.uploadSuccess,
      "on-error": _vm.uploadError,
      "name": "filename",
      "drag": "",
      "action": _vm.uploadUrl,
      "headers": _vm.headers,
      "limit": 1,
      "accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('em', [_vm._v("click to upload")]), _vm._v(" or drag and drop file")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("Only allowed .xls,.xlsx files, please follow the columns format with trackingNum,upc,quantity,note, include the header.")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 787 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Login")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "UserName"
    },
    model: {
      value: (_vm.ruleForm2.account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "account", $$v)
      },
      expression: "ruleForm2.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "Password"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "margin-bottom": "15px",
      "cursor": "pointer",
      "color": "#409eff"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('forgetPassword')
      }
    }
  }, [_vm._v("Forgot Password")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "native-type": "submit",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2($event)
      }
    }
  }, [_vm._v("\n                Login\n            ")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Choose Company",
      "width": "80%",
      "visible": _vm.selectCompanyVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.selectCompanyVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "obj",
    attrs: {
      "model": _vm.obj,
      "label-width": "220px",
      "rules": _vm.rule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Company",
      "prop": "currentCompany"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.obj.currentCompany),
      callback: function($$v) {
        _vm.$set(_vm.obj, "currentCompany", $$v)
      },
      expression: "obj.currentCompany"
    }
  }, _vm._l((_vm.doctors), function(doctor, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": doctor.userName,
        "value": doctor.userNo
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.selectCompanyVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleSelectCompany($event)
      }
    }
  }, [_vm._v("Choose")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstLoading),
      expression: "firstLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.discounts,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "doctorName",
      "label": "Doctor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageFreeDuration",
      "label": "Free duration (Month)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "discountRate",
      "label": "Discount rate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageFeeOverDays",
      "label": "Storage Fee Over days"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showEdit(scope.row)
            }
          }
        }, [_vm._v("Edit")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Discount",
      "width": "80%",
      "visible": _vm.editVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editDiscount",
    attrs: {
      "model": _vm.editDiscount,
      "label-width": "220px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Doctor Name",
      "prop": "doctorName"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editDiscount.doctorName),
      callback: function($$v) {
        _vm.$set(_vm.editDiscount, "doctorName", $$v)
      },
      expression: "editDiscount.doctorName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Free Duration (Month)",
      "prop": "storageFreeDuration"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 3
    },
    model: {
      value: (_vm.editDiscount.storageFreeDuration),
      callback: function($$v) {
        _vm.$set(_vm.editDiscount, "storageFreeDuration", $$v)
      },
      expression: "editDiscount.storageFreeDuration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Discount Rate",
      "prop": "discountRate"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 2,
      "step": 0.05,
      "min": 0.01,
      "max": 1.0
    },
    model: {
      value: (_vm.editDiscount.discountRate),
      callback: function($$v) {
        _vm.$set(_vm.editDiscount, "discountRate", $$v)
      },
      expression: "editDiscount.discountRate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Fee Over days",
      "prop": "storageFeeOverDays"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 0,
      "step": 1,
      "min": 0
    },
    model: {
      value: (_vm.editDiscount.storageFeeOverDays),
      callback: function($$v) {
        _vm.$set(_vm.editDiscount, "storageFeeOverDays", $$v)
      },
      expression: "editDiscount.storageFeeOverDays"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editVisible = false;
        _vm.getDiscounts();
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 789 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "value-format": "yyyy-MM",
      "placeholder": "Search by Month",
      "type": "month"
    },
    on: {
      "change": _vm.changeSearchMonth
    },
    model: {
      value: (_vm.filters.searchMonth),
      callback: function($$v) {
        _vm.$set(_vm.filters, "searchMonth", $$v)
      },
      expression: "filters.searchMonth"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [(_vm.user.userNo == 'user-bcfde657d5684dd694d89ae424f11530') ? _c('el-button', {
    attrs: {
      "disabled": !_vm.isEnable,
      "type": "primary"
    },
    on: {
      "click": _vm.testGenStorageFeeByDaily
    }
  }, [_vm._v("Build Storage Fee for Today")]) : _vm._e(), _vm._v(" "), (_vm.user.userNo == 'user-9aa177023c4340609ce337d618d0bd99' || _vm.user.userNo == 'user-bcfde657d5684dd694d89ae424f11530') ? _c('el-button', {
    attrs: {
      "disabled": !_vm.isEnable,
      "type": "primary"
    },
    on: {
      "click": _vm.testGenStorageFeeByMonthly
    }
  }, [_vm._v("Build Storage Fee for Month")]) : _vm._e(), _vm._v(" "), (_vm.user.userNo == 'user-9aa177023c4340609ce337d618d0bd99' || _vm.user.userNo == 'user-bcfde657d5684dd694d89ae424f11530') ? _c('el-button', {
    attrs: {
      "disabled": !_vm.isEnable,
      "type": "primary"
    },
    on: {
      "click": _vm.showRebuildStorageFeeByDailyWin
    }
  }, [_vm._v("Rebuild Storage Fee for Daily")]) : _vm._e(), _vm._v(" "), (_vm.user.userNo == 'user-9aa177023c4340609ce337d618d0bd99' || _vm.user.userNo == 'user-bcfde657d5684dd694d89ae424f11530') ? _c('el-button', {
    attrs: {
      "disabled": !_vm.isEnable,
      "type": "primary"
    },
    on: {
      "click": _vm.showRebuildStorageFeeByMonthWin
    }
  }, [_vm._v("Rebuild Fee for Month")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.storageFeePayments,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctorName",
      "label": "Doctor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportMonth",
      "label": "Report Month"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalFee",
      "label": "Total Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(_vm.formatMoney(scope.row.totalFee, 2)) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payStatus",
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.payStatus == 0 && scope.row.totalFee > 0) ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Created")]) : (scope.row.payStatus == 0 && scope.row.totalFee <= 0) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("No need to pay")]) : (scope.row.payStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")]) : (scope.row.payStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("Canceled")]) : (scope.row.payStatus == 3) ? _c('el-tag', [_vm._v("Archived")]) : (scope.row.payStatus == 4) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")]) : (scope.row.payStatus == 5) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("Requested")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.getStorageFeePaymentSummary(scope.row.id)
            }
          }
        }, [_vm._v("\n                        Detail\n                    ")]), _vm._v(" "), (scope.row.totalFee > 0) ? _c('el-button', {
          attrs: {
            "type": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showPaymentList(scope.row)
            }
          }
        }, [_vm._v("Payment")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.storageFeePaymentTotal
    },
    on: {
      "current-change": _vm.changeStorageFeePayment
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Warehouse Fee Detail",
      "width": "90%",
      "visible": _vm.warehouseFeeDetailModelVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.warehouseFeeDetailModelVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "ProductName",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getStorageFeePaymentDetail(null, 1)
      }
    },
    model: {
      value: (_vm.filters.productName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "productName", $$v)
      },
      expression: "filters.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getStorageFeePaymentDetail(null, 1)
      }
    }
  }, [_vm._v("Search")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportWarehouseFeeDetail', 'Warehouse Fee Detail.xls', 1)
      }
    }
  }, [_vm._v("Export")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Filter Fee Type",
      "filterable": true
    },
    on: {
      "change": function($event) {
        return _vm.getStorageFeePaymentDetail(null, 1)
      }
    },
    model: {
      value: (_vm.filters.feeType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "feeType", $$v)
      },
      expression: "filters.feeType"
    }
  }, _vm._l((_vm.feeTypeList), function(fee, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": fee.value,
        "value": fee.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.warehouseFeeLoading),
      expression: "warehouseFeeLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.warehouseFeeDetail,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "feeType",
      "label": "Fee Type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.feeType == 0) ? _c('p', [_vm._v("Inbound")]) : _vm._e(), _vm._v(" "), (scope.row.feeType == 1) ? _c('p', [_vm._v("Outbound")]) : _vm._e(), _vm._v(" "), (scope.row.feeType == 2) ? _c('p', [_vm._v("Storage")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalFee",
      "label": "Total Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        $" + _vm._s(_vm.formatMoney(scope.row.totalFee, 4)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productSize",
      "label": "Category"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "baseFee",
      "label": "Storage Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "baseFeeOver",
      "label": "Storage > Years Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Storage Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundFee",
      "label": "Inbound Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundRate",
      "label": "Inbound Rate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundQty",
      "label": "Inbound Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundFee",
      "label": "Outbound Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundRate",
      "label": "Outbound Rate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundQty",
      "label": "Outbound Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceFee",
      "label": "Service Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceType",
      "label": "Service Type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceQty",
      "label": "Service Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "splitPackagesNum",
      "label": "Package Num"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundDate",
      "label": "Inbound Date"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.dateFormat(scope.row.inboundDate)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportDate",
      "label": "Report Date"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.dateFormat(scope.row.reportDate)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "descs",
      "label": "Desc"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.warehouseFeeDetailTotal,
      "current-page": _vm.warehouseFeeDetailPage
    },
    on: {
      "current-change": _vm.changeWarehouseFeeDetail,
      "update:currentPage": function($event) {
        _vm.warehouseFeeDetailPage = $event
      },
      "update:current-page": function($event) {
        _vm.warehouseFeeDetailPage = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.warehouseFeeDetailModelVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Warehouse Fee Summary",
      "width": "80%",
      "visible": _vm.warehouseFeeSummaryModelVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.warehouseFeeSummaryModelVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getStorageFeePaymentSummary(_vm.warehouseFeeDetailId)
      }
    },
    model: {
      value: (_vm.filters.conditionSearch),
      callback: function($$v) {
        _vm.$set(_vm.filters, "conditionSearch", $$v)
      },
      expression: "filters.conditionSearch"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.getStorageFeePaymentSummary(_vm.warehouseFeeDetailId)
      }
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportWarehouseFeeSummary', 'Warehouse Fee Summary.xls', 1)
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.warehouseFeeSummaryLoading),
      expression: "warehouseFeeSummaryLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.warehouseFeeSummary,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productNo",
      "label": "Product No"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundFee",
      "label": "Inbound Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        $" + _vm._s(_vm.formatMoney(scope.row.inboundFee, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundFee",
      "label": "Outbound Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        $" + _vm._s(_vm.formatMoney(scope.row.outboundFee, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageFee",
      "label": "Storage Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        $" + _vm._s(_vm.formatMoney(scope.row.storageFee, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportDate",
      "label": "Report Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.getStorageFeePaymentDetail(scope.row.productNo, 1)
            }
          }
        }, [_vm._v("\n                            Detail\n                        ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.warehouseFeeSummaryTotal
    },
    on: {
      "current-change": _vm.changeWarehouseFeeSummary
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.warehouseFeeSummaryModelVisible = false;
        _vm.filters.conditionSearch = ''
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Payment List",
      "width": "80%",
      "visible": _vm.paymentListVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.paymentListVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Status",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getPaymentRequest()
      }
    },
    model: {
      value: (_vm.filters.paymentStatus),
      callback: function($$v) {
        _vm.$set(_vm.filters, "paymentStatus", $$v)
      },
      expression: "filters.paymentStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Confirmed",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Canceled",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Archived",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Rejected",
      "value": "4"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [(!_vm.isPaymentPending) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAddPayment
    }
  }, [_vm._v("Request a payment")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.paymentLoading),
      expression: "paymentLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.payments,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "paymentNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportDate",
      "label": "Report Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctorName",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalFee",
      "label": "Total Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.formatMoney(scope.row.totalFee, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "Apply amount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.formatMoney(scope.row.amount, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctorNote",
      "label": "Doctor Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.doctorNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseNote",
      "label": "Warehouse Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.warehouseNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Request Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Canceled")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 4) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger",
            "loading": _vm.loading
          },
          on: {
            "click": function($event) {
              return _vm.editPaymentStatus(scope.row.paymentNo, 2)
            }
          }
        }, [_vm._v("Cancel\n                        ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.paymentTotal
    },
    on: {
      "current-change": _vm.changePaymentRequest
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.paymentListVisible = false;
        _vm.filters.paymentStatus = '';
        _vm.getStorageFeePaymentList();
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Request a payment",
      "width": "80%",
      "visible": _vm.requestVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.requestVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "payment",
    attrs: {
      "model": _vm.payment,
      "label-width": "220px",
      "rules": _vm.requestFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Total payment",
      "prop": "balance"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.payment.balance),
      callback: function($$v) {
        _vm.$set(_vm.payment, "balance", $$v)
      },
      expression: "payment.balance"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Payable amount",
      "prop": "amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.payment.amount),
      callback: function($$v) {
        _vm.$set(_vm.payment, "amount", $$v)
      },
      expression: "payment.amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bank Account",
      "prop": "bank"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.payment.bank),
      callback: function($$v) {
        _vm.$set(_vm.payment, "bank", $$v)
      },
      expression: "payment.bank"
    }
  }, _vm._l((_vm.banks), function(bank, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": bank.category + ' ' + bank.accountNumber + ' (' + bank.accountType + ')',
        "value": bank.bankNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.payment.note),
      callback: function($$v) {
        _vm.$set(_vm.payment, "note", $$v)
      },
      expression: "payment.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.requestVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.requestPayment($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Rebuild Daily for Storage Fee",
      "width": "80%",
      "visible": _vm.requestRebuildVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.requestRebuildVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "rebuildDailyModel",
    attrs: {
      "model": _vm.rebuildDailyModel,
      "label-width": "220px",
      "rules": _vm.requestFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Rebuild Date",
      "prop": "dates"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Rebuild dates, example: 2023-09-01,2023-09-02,2023-09-10 etc.",
      "clearable": ""
    },
    model: {
      value: (_vm.rebuildDailyModel.dates),
      callback: function($$v) {
        _vm.$set(_vm.rebuildDailyModel, "dates", $$v)
      },
      expression: "rebuildDailyModel.dates"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.requestRebuildVisible = false;
        _vm.rebuildDailyModel.dates = '';
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.isEnable
    },
    nativeOn: {
      "click": function($event) {
        return _vm.rebuildStorageFeeByDaily($event)
      }
    }
  }, [_vm._v("Rebuild")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Rebuild Month for Storage Fee",
      "width": "80%",
      "visible": _vm.requestRebuildMonthVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.requestRebuildMonthVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "rebuildMonthModel",
    attrs: {
      "model": _vm.rebuildMonthModel,
      "label-width": "220px",
      "rules": _vm.requestFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Rebuild Month",
      "prop": "month"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Monthly Fee Report Rebuild, example: 2023-09  only one, dont set multiple month`s.",
      "clearable": ""
    },
    model: {
      value: (_vm.rebuildMonthModel.month),
      callback: function($$v) {
        _vm.$set(_vm.rebuildMonthModel, "month", $$v)
      },
      expression: "rebuildMonthModel.month"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.requestRebuildMonthVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.isEnable
    },
    nativeOn: {
      "click": function($event) {
        return _vm.rebuildStorageFeeByMonth($event)
      }
    }
  }, [_vm._v("Rebuild")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 790 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "150px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Forget Password")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "username",
      "label": "UserName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "UserName"
    },
    model: {
      value: (_vm.ruleForm2.username),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "username", $$v)
      },
      expression: "ruleForm2.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "email",
      "label": "Email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "Password"
    },
    model: {
      value: (_vm.ruleForm2.email),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "email", $$v)
      },
      expression: "ruleForm2.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "margin-bottom": "15px",
      "cursor": "pointer",
      "color": "#409eff"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('login')
      }
    }
  }, [_vm._v("Login")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit($event)
      }
    }
  }, [_vm._v("\n            Submit\n        ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Offers")])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Offers',
          params: {
            active: 'first'
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.offers.open) + " open offers")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Offers',
          params: {
            active: 'second'
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.offers.proposed) + " proposed offers")])], 1)])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5,
      "offset": 1
    }
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Inbound")])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Inbound',
          params: {
            active: 'first'
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.inbound.inbound) + " inbound items")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Inbound',
          params: {
            active: 'second'
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.inbound.reported) + " reported item")])], 1)])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5,
      "offset": 1
    }
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Outbound")])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Outbound',
          params: {
            active: 'second'
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.outbound.outbound) + " outbound shipments")])], 1)])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5,
      "offset": 1
    }
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Payments")])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Payments',
          params: {
            active: 'first'
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.balance.request) + " Nurse payment request")]), _vm._v(" for a total of $" + _vm._s(_vm.balance.requestTotal))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('p', [_vm._v("Balance: $" + _vm._s(_vm.balance.totalBalance))]), _vm._v(" "), _c('p', [_vm._v("Pending: $" + _vm._s(_vm.balance.totalPending))])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 792 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12,
      "offset": 6
    }
  }, [_c('el-form', {
    ref: "account",
    attrs: {
      "model": _vm.account,
      "rules": _vm.rule,
      "label-width": "200px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Old Password",
      "prop": "old"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.account.old),
      callback: function($$v) {
        _vm.$set(_vm.account, "old", $$v)
      },
      expression: "account.old"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "New Password",
      "prop": "new"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.account.new),
      callback: function($$v) {
        _vm.$set(_vm.account, "new", $$v)
      },
      expression: "account.new"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Confirm Password",
      "prop": "confirm"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.account.confirm),
      callback: function($$v) {
        _vm.$set(_vm.account, "confirm", $$v)
      },
      expression: "account.confirm"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.changePassword
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 793 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      'el-input-number',
      _vm.inputNumberSize ? 'el-input-number--' + _vm.inputNumberSize : '',
      {
        'is-disabled': _vm.inputNumberDisabled
      },
      {
        'is-without-controls': !_vm.controls
      },
      {
        'is-controls-right': _vm.controlsAtRight
      }
    ],
    on: {
      "dragstart": function($event) {
        $event.preventDefault();
      }
    }
  }, [(_vm.controls) ? _c('span', {
    directives: [{
      name: "repeat-click",
      rawName: "v-repeat-click",
      value: (_vm.decrease),
      expression: "decrease"
    }],
    staticClass: "el-input-number__decrease",
    class: {
      'is-disabled': _vm.minDisabled
    },
    attrs: {
      "role": "button"
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.decrease($event)
      }
    }
  }, [_c('i', {
    class: ("el-icon-" + (_vm.controlsAtRight ? 'arrow-down' : 'minus'))
  })]) : _vm._e(), _vm._v(" "), (_vm.controls) ? _c('span', {
    directives: [{
      name: "repeat-click",
      rawName: "v-repeat-click",
      value: (_vm.increase),
      expression: "increase"
    }],
    staticClass: "el-input-number__increase",
    class: {
      'is-disabled': _vm.maxDisabled
    },
    attrs: {
      "role": "button"
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.increase($event)
      }
    }
  }, [_c('i', {
    class: ("el-icon-" + (_vm.controlsAtRight ? 'arrow-up' : 'plus'))
  })]) : _vm._e(), _vm._v(" "), _c('el-input', {
    ref: "input",
    attrs: {
      "value": _vm.displayValue,
      "placeholder": _vm.placeholder,
      "disabled": _vm.inputNumberDisabled,
      "size": _vm.inputNumberSize,
      "max": _vm.max,
      "min": _vm.min,
      "name": _vm.name,
      "label": _vm.label
    },
    on: {
      "blur": _vm.handleBlur,
      "focus": _vm.handleFocus,
      "input": _vm.handleInput,
      "change": _vm.handleInputChange
    },
    nativeOn: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.preventDefault();
        return _vm.increase($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        return _vm.decrease($event)
      }]
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getTrasferUserInfo($event)
      }
    },
    model: {
      value: (_vm.filters.conditionSearch),
      callback: function($$v) {
        _vm.$set(_vm.filters, "conditionSearch", $$v)
      },
      expression: "filters.conditionSearch"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getTrasferUserInfo
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Select Mark Checked",
      "clearable": ""
    },
    on: {
      "change": _vm.getTrasferUserInfo
    },
    model: {
      value: (_vm.filters.markChecked),
      callback: function($$v) {
        _vm.$set(_vm.filters, "markChecked", $$v)
      },
      expression: "filters.markChecked"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Yes",
      "value": true
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "No",
      "value": false
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstLoading),
      expression: "firstLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.dataList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "transferNo",
      "label": "Transfer#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "Transferer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "transferToUserName",
      "label": "Acceptor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseAddress",
      "label": "Transfer Warehouse Address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "transferToAddress",
      "label": "Acceptor Warehouse Address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Transfer Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "moved",
      "label": "Checked"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.moved ? 'green' : 'red'
          })
        }, [_vm._v("\n                        " + _vm._s(scope.row.moved ? "Yes" : "No") + "\n                    ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updateDate",
      "label": "Checked Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.markChecked(scope.row.id)
            }
          }
        }, [_vm._v("\n                        Mark Down\n                    ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.workingTotal
    },
    on: {
      "current-change": _vm.getTrasferUserInfo
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 795 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "el-button",
    class: [
      _vm.type ? 'el-button--' + _vm.type : '',
      _vm.buttonSize ? 'el-button--' + _vm.buttonSize : '',
      {
        'is-disabled': _vm.buttonDisabled,
        'is-loading': _vm.loading,
        'is-plain': _vm.plain,
        'is-round': _vm.round,
        'is-circle': _vm.circle
      }
    ],
    attrs: {
      "disabled": _vm.buttonDisabled || _vm.loading,
      "autofocus": _vm.autofocus,
      "type": _vm.nativeType
    },
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.loading) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e(), _vm._v(" "), (_vm.icon && !_vm.loading) ? _c('i', {
    class: _vm.icon
  }) : _vm._e(), _vm._v(" "), (_vm.$slots.default) ? _c('span', [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12,
      "offset": 6
    }
  }, [_c('el-form', {
    ref: "account",
    attrs: {
      "model": _vm.account,
      "label-width": "200px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.account.userName),
      callback: function($$v) {
        _vm.$set(_vm.account, "userName", $$v)
      },
      expression: "account.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.account.email),
      callback: function($$v) {
        _vm.$set(_vm.account, "email", $$v)
      },
      expression: "account.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Phone",
      "prop": "phone"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.account.phone),
      callback: function($$v) {
        _vm.$set(_vm.account, "phone", $$v)
      },
      expression: "account.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.changeUserInfo
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addFormVisible = true
      }
    }
  }, [_vm._v("Add a payment method")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.list,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": function($event) {}
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "bankNo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "category",
      "label": "Category"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "currency",
      "label": "Currency"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accountNumber",
      "label": "Account Number"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showEditBank(scope.row.bankNo)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.deleteBank(scope.row.bankNo)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add a payment method",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "payment",
    attrs: {
      "model": _vm.payment,
      "label-width": "180px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Category",
      "prop": "category"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.payment.category),
      callback: function($$v) {
        _vm.$set(_vm.payment, "category", $$v)
      },
      expression: "payment.category"
    }
  }, _vm._l((_vm.categoryOption), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Currency",
      "prop": "currency"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.payment.currency),
      callback: function($$v) {
        _vm.$set(_vm.payment, "currency", $$v)
      },
      expression: "payment.currency"
    }
  }, _vm._l((_vm.currencyOption), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.payment.category) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": _vm.payment.category == 'Bill Pay' ? 'Credit card company' : 'Bank Name',
      "prop": "company"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.payment.company),
      callback: function($$v) {
        _vm.$set(_vm.payment, "company", $$v)
      },
      expression: "payment.company"
    }
  }), _vm._v(" "), (_vm.payment.category == 'Bill Pay') ? _c('p', {
    staticClass: "note"
  }, [_vm._v("E.g., Chase, Bank of America, Wells Fargo,\n                        U.S. Bank, Citibank, Captial One, PNC, BarclayCard US, Staples, Office Depot, Dell,\n                        Target.")]) : _c('p', {
    staticClass: "note"
  }, [_vm._v("E.g., Chase, Bank of America, Wells Fargo, Citibank, PNC.")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.payment.category == 'Bill Pay' ? 'Card network' : 'Account type',
      "prop": "accountType"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.payment.accountType),
      callback: function($$v) {
        _vm.$set(_vm.payment, "accountType", $$v)
      },
      expression: "payment.accountType"
    }
  }), _vm._v(" "), (_vm.payment.category == 'Bill Pay') ? _c('p', {
    staticClass: "note"
  }, [_vm._v("E.g., Visa, MasterCard, American Express,\n                        Discover, Store credit card.")]) : _c('p', {
    staticClass: "note"
  }, [_vm._v("E.g., Checking, Saving.")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Account holder",
      "prop": "accountHolder"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.payment.accountHolder),
      callback: function($$v) {
        _vm.$set(_vm.payment, "accountHolder", $$v)
      },
      expression: "payment.accountHolder"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Account number",
      "prop": "accountNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.payment.accountNumber),
      callback: function($$v) {
        _vm.$set(_vm.payment, "accountNumber", $$v)
      },
      expression: "payment.accountNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.payment.category == 'Bill Pay' ? 'Bank address (PO box)' : 'Account holder\'s address',
      "prop": "bankAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5"
    },
    model: {
      value: (_vm.payment.bankAddress),
      callback: function($$v) {
        _vm.$set(_vm.payment, "bankAddress", $$v)
      },
      expression: "payment.bankAddress"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addBank($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit payment method",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editPayment",
    attrs: {
      "model": _vm.editPayment,
      "label-width": "180px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Category",
      "prop": "category"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editPayment.category),
      callback: function($$v) {
        _vm.$set(_vm.editPayment, "category", $$v)
      },
      expression: "editPayment.category"
    }
  }, _vm._l((_vm.categoryOption), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Currency",
      "prop": "currency"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editPayment.currency),
      callback: function($$v) {
        _vm.$set(_vm.editPayment, "currency", $$v)
      },
      expression: "editPayment.currency"
    }
  }, _vm._l((_vm.currencyOption), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.editPayment.category) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": _vm.editPayment.category == 'Bill Pay' ? 'Credit card company' : 'Bank Name',
      "prop": "company"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editPayment.bankName),
      callback: function($$v) {
        _vm.$set(_vm.editPayment, "bankName", $$v)
      },
      expression: "editPayment.bankName"
    }
  }), _vm._v(" "), (_vm.editPayment.category == 'Bill Pay') ? _c('p', {
    staticClass: "note"
  }, [_vm._v("E.g., Chase, Bank of America, Wells Fargo,\n                        U.S. Bank, Citibank, Captial One, PNC, BarclayCard US, Staples, Office Depot, Dell,\n                        Target.")]) : _c('p', {
    staticClass: "note"
  }, [_vm._v("E.g., Chase, Bank of America, Wells Fargo, Citibank, PNC.")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.editPayment.category == 'Bill Pay' ? 'Card network' : 'Account type',
      "prop": "accountType"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editPayment.accountType),
      callback: function($$v) {
        _vm.$set(_vm.editPayment, "accountType", $$v)
      },
      expression: "editPayment.accountType"
    }
  }), _vm._v(" "), (_vm.editPayment.category == 'Bill Pay') ? _c('p', {
    staticClass: "note"
  }, [_vm._v("E.g., Visa, MasterCard, American Express,\n                        Discover, Store credit card.")]) : _c('p', {
    staticClass: "note"
  }, [_vm._v("E.g., Checking, Saving.")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Account holder",
      "prop": "accountHolder"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editPayment.accountHolder),
      callback: function($$v) {
        _vm.$set(_vm.editPayment, "accountHolder", $$v)
      },
      expression: "editPayment.accountHolder"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Account number",
      "prop": "accountNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editPayment.accountNumber),
      callback: function($$v) {
        _vm.$set(_vm.editPayment, "accountNumber", $$v)
      },
      expression: "editPayment.accountNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.editPayment.category == 'Bill Pay' ? 'Bank address (PO box)' : 'Account holder\'s address',
      "prop": "bankAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5"
    },
    model: {
      value: (_vm.editPayment.bankAddress),
      callback: function($$v) {
        _vm.$set(_vm.editPayment, "bankAddress", $$v)
      },
      expression: "editPayment.bankAddress"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editBank($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 799 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAdd
    }
  }, [_vm._v("Add Service Fee")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showUserRate
    }
  }, [_vm._v("User Rate")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstLoading),
      expression: "firstLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.serviceFees,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "serviceLabel",
      "label": "Label"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceBaseFee",
      "label": "Service Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceDesc",
      "label": "Desc"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showEdit(scope.row)
            }
          }
        }, [_vm._v("Edit")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Category",
      "width": "80%",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addServiceFee",
    attrs: {
      "model": _vm.addServiceFee,
      "label-width": "220px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Label",
      "prop": "serviceLabel"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addServiceFee.serviceLabel),
      callback: function($$v) {
        _vm.$set(_vm.addServiceFee, "serviceLabel", $$v)
      },
      expression: "addServiceFee.serviceLabel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Service Fee",
      "prop": "serviceBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.addServiceFee.serviceBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.addServiceFee, "serviceBaseFee", $$v)
      },
      expression: "addServiceFee.serviceBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Desc",
      "prop": "serviceDesc"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addServiceFee.serviceDesc),
      callback: function($$v) {
        _vm.$set(_vm.addServiceFee, "serviceDesc", $$v)
      },
      expression: "addServiceFee.serviceDesc"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddServiceFee($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Category",
      "width": "80%",
      "visible": _vm.editVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editServiceFee",
    attrs: {
      "model": _vm.editServiceFee,
      "label-width": "220px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Label",
      "prop": "serviceLabel"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editServiceFee.serviceLabel),
      callback: function($$v) {
        _vm.$set(_vm.editServiceFee, "serviceLabel", $$v)
      },
      expression: "editServiceFee.serviceLabel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Service Fee",
      "prop": "serviceBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.editServiceFee.serviceBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.editServiceFee, "serviceBaseFee", $$v)
      },
      expression: "editServiceFee.serviceBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Desc",
      "prop": "serviceDesc"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editServiceFee.serviceDesc),
      callback: function($$v) {
        _vm.$set(_vm.editServiceFee, "serviceDesc", $$v)
      },
      expression: "editServiceFee.serviceDesc"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "User Rate List",
      "width": "80%",
      "visible": _vm.userRateVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.userRateVisible = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondLoading),
      expression: "secondLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.userRates,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "doctorName",
      "label": "Doctor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hasSingleSeted",
      "label": "Has bean set"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.hasSingleSeted ? "Already Set" : "Not Set") + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showServiceFeeEdit(scope.row.doctorNo)
            }
          }
        }, [_vm._v("Edit")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.userRateVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Custom Service Fee Set",
      "width": "80%",
      "visible": _vm.customServiceFeeVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.customServiceFeeVisible = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdLoading),
      expression: "thirdLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.customServiceFeeConfigs,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "serviceLabel",
      "label": "Service Label"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.serviceLabel) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceBaseFee",
      "label": "Service Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.serviceBaseFee) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceDesc",
      "label": "Description"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.serviceDesc) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showCustomEdit(scope.row)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), (scope.row.hasSingleSeted) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.deleteCustomItem(scope.row)
            }
          }
        }, [_vm._v("Restore")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.customServiceFeeVisible = false;
        _vm.getAllUserRate()
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Custom Edit Service Fee",
      "width": "80%",
      "visible": _vm.customEditVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.customEditVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "customEditServiceFee",
    attrs: {
      "model": _vm.customEditServiceFee,
      "label-width": "220px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Service Label",
      "prop": "serviceLabel"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.customEditServiceFee.serviceLabel),
      callback: function($$v) {
        _vm.$set(_vm.customEditServiceFee, "serviceLabel", $$v)
      },
      expression: "customEditServiceFee.serviceLabel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Service Fee",
      "prop": "serviceBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.customEditServiceFee.serviceBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.customEditServiceFee, "serviceBaseFee", $$v)
      },
      expression: "customEditServiceFee.serviceBaseFee"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.customEditVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.customEditLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.customEditSubmit($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Email",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.email),
      callback: function($$v) {
        _vm.$set(_vm.filters, "email", $$v)
      },
      expression: "filters.email"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getInvitations
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstLoading),
      expression: "firstLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.invitations,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "user_name",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "Email"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Date Time",
      "formatter": _vm.formatTimesTamp
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status",
      "formatter": _vm.formatInvitationStatus
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.status === 0) ? [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.editInvitationStatus(scope.row.invitationNo, 1)
            }
          }
        }, [_vm._v("Approve")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.editInvitationStatus(scope.row.invitationNo, 2)
            }
          }
        }, [_vm._v("Reject")])] : undefined
      }
    }], null, true)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.invitationTotalPage
    },
    on: {
      "current-change": _vm.handleInvitationPageChange
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 801 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Nurse Payment Requests",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "User",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getPaymentRequest()
      }
    },
    model: {
      value: (_vm.filters.paymentFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "paymentFilter", $$v)
      },
      expression: "filters.paymentFilter"
    }
  }, _vm._l((_vm.nurseList), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Status",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getPaymentRequest()
      }
    },
    model: {
      value: (_vm.filters.paymentStatus),
      callback: function($$v) {
        _vm.$set(_vm.filters, "paymentStatus", $$v)
      },
      expression: "filters.paymentStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Confirmed",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Rejected",
      "value": "4"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportPaymentRequest', 'Active Offer.xls')
      }
    }
  }, [_vm._v("Export")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAdjust()
      }
    }
  }, [_vm._v("Adjust Balance")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstListLoading),
      expression: "firstListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.payments,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "paymentNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Request Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctorNote",
      "label": "Doctor Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.doctorNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nurseNote",
      "label": "Nurse Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.nurseNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nurseName",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "Amount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.formatMoney(scope.row.amount, 2)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Canceled")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 4) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.status === 0) ? [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.requestPayment(scope.row.paymentNo)
            }
          }
        }, [_vm._v("Pay")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.editPaymentStatus(scope.row.paymentNo, 4)
            }
          }
        }, [_vm._v("\n                                Reject\n                            ")])] : undefined
      }
    }], null, true)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.paymentTotal
    },
    on: {
      "current-change": _vm.changePaymentRequest
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Pending Transactions",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Offer",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.filters.pendingFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "pendingFilter", $$v)
      },
      expression: "filters.pendingFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getPendingTransaction
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "User",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.getPendingTransaction
    },
    model: {
      value: (_vm.filters.pendingUser),
      callback: function($$v) {
        _vm.$set(_vm.filters, "pendingUser", $$v)
      },
      expression: "filters.pendingUser"
    }
  }, _vm._l((_vm.nurseList), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondListLoading),
      expression: "secondListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.pendingPayments,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "offerNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "takeDate",
      "label": "Offer Create Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundDate",
      "label": "Inbound Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.pendingTotal
    },
    on: {
      "current-change": _vm.changePendingRequest
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Transaction",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "User",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.getTransactionHistory
    },
    model: {
      value: (_vm.filters.currentUser),
      callback: function($$v) {
        _vm.$set(_vm.filters, "currentUser", $$v)
      },
      expression: "filters.currentUser"
    }
  }, _vm._l((_vm.nurseList), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search Product Name, Note, Account etc.",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.historyFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "historyFilter", $$v)
      },
      expression: "filters.historyFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getTransactionHistory
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdListLoading),
      expression: "thirdListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.transactions,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dateTime",
      "label": "Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Transaction"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 'transaction') ? _c('div', [_c('p', [_vm._v("For " + _vm._s(scope.row.productName) + ", " + _vm._s(scope.row.dateTime))]), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v("$" + _vm._s(scope.row.price) + " * " + _vm._s(scope.row.quantity) + ".\n                                    " + _vm._s(scope.row.warehouse))])]) : _vm._e(), _vm._v(" "), (scope.row.type == 'reported') ? _c('div', [_c('p', [_vm._v("Reported for " + _vm._s(scope.row.productName) + ", " + _vm._s(scope.row.dateTime))]), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v("$" + _vm._s(scope.row.price) + " * " + _vm._s(scope.row.quantity) + ".\n                                    " + _vm._s(scope.row.warehouse))])]) : _vm._e(), _vm._v(" "), (scope.row.type == 'adjust') ? _c('div', [(scope.row.amount > 0) ? _c('p', [_vm._v("Increase Balance, " + _vm._s(scope.row.dateTime))]) : _vm._e(), _vm._v(" "), (scope.row.amount <= 0) ? _c('p', [_vm._v("Decrease Balance, " + _vm._s(scope.row.dateTime))]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "note",
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.type == 'payment') ? _c('div', [_c('p', [_vm._v("Withdraw to " + _vm._s(scope.row.productName) + ", " + _vm._s(scope.row.dateTime) + "\n                                    "), (scope.row.status === 0) ? _c('span', [_vm._v("(waiting for pay)")]) : (scope.row.status === 1) ? _c('span', [_vm._v("(paid)")]) : (scope.row.status === 2) ? _c('span', [_vm._v("(canceled)")]) : (scope.row.status === 3) ? _c('span', [_vm._v("(rollover)")]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "note",
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "Amount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.amount >= 0) ? _c('span', {
          staticClass: "green-row"
        }, [_vm._v(_vm._s(_vm.formatMoney(scope.row.amount, 2)))]) : _c('span', {
          staticClass: "reported-row"
        }, [_vm._v(_vm._s(_vm.formatMoney(scope.row.amount, 2)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Balance",
      "prop": "balance"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Nurse",
      "prop": "nurseName"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.historyTotal
    },
    on: {
      "current-change": _vm.changeTransactionHistory
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Balance",
      "name": "fourth"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "User",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.getBalance
    },
    model: {
      value: (_vm.filters.balanceFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "balanceFilter", $$v)
      },
      expression: "filters.balanceFilter"
    }
  }, _vm._l((_vm.nurseList), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fourthListLoading),
      expression: "fourthListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.balances,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": function($event) {}
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total",
      "label": "Balance"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.total >= 0) ? _c('span', {
          staticClass: "green-row"
        }, [_vm._v(_vm._s(_vm.formatMoney(scope.row.total, 2)))]) : _c('span', {
          staticClass: "reported-row"
        }, [_vm._v(_vm._s(_vm.formatMoney(scope.row.total, 2)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pendingAmount",
      "label": "Pending"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.pendingAmount >= 0) ? _c('span', {
          staticClass: "green-row"
        }, [_vm._v(_vm._s(_vm.formatMoney(scope.row.pendingAmount, 2)))]) : _c('span', {
          staticClass: "reported-row"
        }, [_vm._v(_vm._s(_vm.formatMoney(scope.row.pendingAmount, 2)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "requestAmount",
      "label": "Requestable"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.requestAmount >= 0) ? _c('span', {
          staticClass: "green-row"
        }, [_vm._v(_vm._s(_vm.formatMoney(scope.row.requestAmount, 2)))]) : _c('span', {
          staticClass: "reported-row"
        }, [_vm._v(_vm._s(_vm.formatMoney(scope.row.requestAmount, 2)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.balanceTotal
    },
    on: {
      "current-change": _vm.changeBalance
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Warehouse fee payment",
      "name": "fifth"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fifthListLoading),
      expression: "fifthListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.storageFeePayments,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": function($event) {}
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportMonth",
      "label": "Report Month"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalFee",
      "label": "Total Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.formatMoney(scope.row.totalFee, 2)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payStatus",
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.payStatus == 0 && scope.row.totalFee > 0) ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Created")]) : (scope.row.payStatus == 0 && scope.row.totalFee <= 0) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("No need to pay")]) : (scope.row.payStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")]) : (scope.row.payStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("Canceled")]) : (scope.row.payStatus == 3) ? _c('el-tag', [_vm._v("Archived")]) : (scope.row.payStatus == 4) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")]) : (scope.row.payStatus == 5) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("Requested")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.totalFee > 0) ? _c('el-button', {
          attrs: {
            "size": "small",
            "loading": _vm.loading
          },
          on: {
            "click": function($event) {
              return _vm.showAddWarehousePayment(scope.row.id)
            }
          }
        }, [_vm._v("to Pay")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.getStorageFeePaymentSummary(scope.row.id)
            }
          }
        }, [_vm._v("\n                                Detail\n                            ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.storageFeePaymentTotal
    },
    on: {
      "current-change": _vm.changeStorageFeePayment
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Warehouse Payment List",
      "width": "80%",
      "visible": _vm.paymentListVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.paymentListVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Status",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getPaymentRequest4Warehouse()
      }
    },
    model: {
      value: (_vm.filters.warehousePaymentStatus),
      callback: function($$v) {
        _vm.$set(_vm.filters, "warehousePaymentStatus", $$v)
      },
      expression: "filters.warehousePaymentStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Confirmed",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Canceled",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Archived",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Rejected",
      "value": "4"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.paymentLoading),
      expression: "paymentLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.warehousePayments,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "paymentNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportDate",
      "label": "Report Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalFee",
      "label": "Total Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.formatMoney(scope.row.totalFee, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "Apply amount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.formatMoney(scope.row.amount, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctorNote",
      "label": "Doctor Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.doctorNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseNote",
      "label": "Warehouse Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.warehouseNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Request Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Canceled")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 4) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 5) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("Requested")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.status === 0) ? [_c('el-button', {
          attrs: {
            "size": "small",
            "loading": _vm.loading
          },
          on: {
            "click": function($event) {
              return _vm.requestWarehousePayment(scope.row.paymentNo)
            }
          }
        }, [_vm._v("Pay")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger",
            "loading": _vm.loading
          },
          on: {
            "click": function($event) {
              return _vm.editWarehousePaymentStatus(scope.row.paymentNo, 4)
            }
          }
        }, [_vm._v("\n                            Reject\n                        ")])] : undefined
      }
    }], null, true)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.paymentTotal
    },
    on: {
      "current-change": _vm.changePaymentRequest
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.paymentListVisible = false;
        _vm.filters.paymentStatus = '';
        _vm.getStorageFeePaymentList();
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Confirm a payment",
      "width": "80%",
      "visible": _vm.requestVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.requestVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "payment",
    attrs: {
      "model": _vm.payment,
      "label-width": "220px",
      "rules": _vm.payRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User",
      "prop": "nurseName"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.payment.nurseName),
      callback: function($$v) {
        _vm.$set(_vm.payment, "nurseName", $$v)
      },
      expression: "payment.nurseName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Amount",
      "prop": "amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true,
      "min": 0
    },
    model: {
      value: (_vm.payment.amount),
      callback: function($$v) {
        _vm.$set(_vm.payment, "amount", $$v)
      },
      expression: "payment.amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bank Account",
      "prop": "bank"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "type": "textarea",
      "rows": "5"
    },
    model: {
      value: (_vm.payment.bank),
      callback: function($$v) {
        _vm.$set(_vm.payment, "bank", $$v)
      },
      expression: "payment.bank"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bank Address",
      "prop": "bank"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "type": "textarea",
      "rows": "5"
    },
    model: {
      value: (_vm.payment.bankAddress),
      callback: function($$v) {
        _vm.$set(_vm.payment, "bankAddress", $$v)
      },
      expression: "payment.bankAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.payment.note),
      callback: function($$v) {
        _vm.$set(_vm.payment, "note", $$v)
      },
      expression: "payment.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.requestVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.pay($event)
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Confirm a payment 4 warehouse",
      "width": "80%",
      "visible": _vm.warehouseRequestVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.warehouseRequestVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "warehousePayment",
    attrs: {
      "model": _vm.warehousePayment,
      "label-width": "220px",
      "rules": _vm.payRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User",
      "prop": "warehouseUserName"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.warehousePayment.warehouseUserName),
      callback: function($$v) {
        _vm.$set(_vm.warehousePayment, "warehouseUserName", $$v)
      },
      expression: "warehousePayment.warehouseUserName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Total Amount",
      "prop": "totalFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true,
      "min": 0
    },
    model: {
      value: (_vm.warehousePayment.totalFee),
      callback: function($$v) {
        _vm.$set(_vm.warehousePayment, "totalFee", $$v)
      },
      expression: "warehousePayment.totalFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Payable amount",
      "prop": "amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true,
      "min": 0
    },
    model: {
      value: (_vm.warehousePayment.amount),
      callback: function($$v) {
        _vm.$set(_vm.warehousePayment, "amount", $$v)
      },
      expression: "warehousePayment.amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bank Account",
      "prop": "bank"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "type": "textarea",
      "rows": "5"
    },
    model: {
      value: (_vm.warehousePayment.bank),
      callback: function($$v) {
        _vm.$set(_vm.warehousePayment, "bank", $$v)
      },
      expression: "warehousePayment.bank"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bank Address",
      "prop": "bank"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "type": "textarea",
      "rows": "5"
    },
    model: {
      value: (_vm.warehousePayment.bankAddress),
      callback: function($$v) {
        _vm.$set(_vm.warehousePayment, "bankAddress", $$v)
      },
      expression: "warehousePayment.bankAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse Note",
      "prop": "warehouseNote"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    staticStyle: {
      "background-color": "#F5F7FA"
    },
    attrs: {
      "disabled": true,
      "options": _vm.readOlnyEditorOption,
      "type": "textarea"
    },
    model: {
      value: (_vm.warehousePayment.warehouseNote),
      callback: function($$v) {
        _vm.$set(_vm.warehousePayment, "warehouseNote", $$v)
      },
      expression: "warehousePayment.warehouseNote"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.warehousePayment.note),
      callback: function($$v) {
        _vm.$set(_vm.warehousePayment, "note", $$v)
      },
      expression: "warehousePayment.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.warehouseRequestVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toWarehousePay($event)
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Adjust Balance",
      "width": "80%",
      "visible": _vm.adjustVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.adjustVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "adjust",
    attrs: {
      "model": _vm.adjust,
      "label-width": "220px",
      "rules": _vm.adjustRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User",
      "prop": "nurseId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "User",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.getNusreBalance
    },
    model: {
      value: (_vm.adjust.nurseId),
      callback: function($$v) {
        _vm.$set(_vm.adjust, "nurseId", $$v)
      },
      expression: "adjust.nurseId"
    }
  }, _vm._l((_vm.nurseList), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Total Balance",
      "prop": "balance"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.adjust.balance),
      callback: function($$v) {
        _vm.$set(_vm.adjust, "balance", $$v)
      },
      expression: "adjust.balance"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Amount",
      "prop": "amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.adjust.amount),
      callback: function($$v) {
        _vm.$set(_vm.adjust, "amount", $$v)
      },
      expression: "adjust.amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-radio', {
    attrs: {
      "label": 1,
      "che": ""
    },
    model: {
      value: (_vm.adjust.type),
      callback: function($$v) {
        _vm.$set(_vm.adjust, "type", $$v)
      },
      expression: "adjust.type"
    }
  }, [_vm._v("Decrease Balance")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    },
    model: {
      value: (_vm.adjust.type),
      callback: function($$v) {
        _vm.$set(_vm.adjust, "type", $$v)
      },
      expression: "adjust.type"
    }
  }, [_vm._v("Increase Balance")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.adjust.note),
      callback: function($$v) {
        _vm.$set(_vm.adjust, "note", $$v)
      },
      expression: "adjust.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.adjustVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addAdjust($event)
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Warehouse Fee Detail",
      "width": "80%",
      "visible": _vm.warehouseFeeDetailModelVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.warehouseFeeDetailModelVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "ProductName",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getStorageFeePaymentDetail(null, 1)
      }
    },
    model: {
      value: (_vm.filters.productName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "productName", $$v)
      },
      expression: "filters.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getStorageFeePaymentDetail(null, 1)
      }
    }
  }, [_vm._v("Search")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.postExportExcel('/excel/exportWarehouseFeeDetail', 'Warehouse Fee Detail.xls', 1)
      }
    }
  }, [_vm._v("Export")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Filter Fee Type",
      "filterable": true
    },
    on: {
      "change": function($event) {
        return _vm.getStorageFeePaymentDetail(null, 1)
      }
    },
    model: {
      value: (_vm.filters.feeType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "feeType", $$v)
      },
      expression: "filters.feeType"
    }
  }, _vm._l((_vm.feeTypeList), function(fee, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": fee.value,
        "value": fee.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.warehouseFeeLoading),
      expression: "warehouseFeeLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.warehouseFeeDetail,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "feeType",
      "label": "Fee Type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.feeType == 0) ? _c('p', [_vm._v("Inbound")]) : _vm._e(), _vm._v(" "), (scope.row.feeType == 1) ? _c('p', [_vm._v("Outbound")]) : _vm._e(), _vm._v(" "), (scope.row.feeType == 2) ? _c('p', [_vm._v("Storage")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productSize",
      "label": "Category"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "baseFee",
      "label": "Storage Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "baseFeeOver",
      "label": "Storage > Years Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Storage Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundFee",
      "label": "Inbound Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundRate",
      "label": "Inbound Rate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundQty",
      "label": "Inbound Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundFee",
      "label": "Outbound Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundRate",
      "label": "Outbound Rate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundQty",
      "label": "Outbound Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceFee",
      "label": "Service Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceType",
      "label": "Service Type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceQty",
      "label": "Service Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "splitPackagesNum",
      "label": "Package Num"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalFee",
      "label": "Total Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        $" + _vm._s(_vm.formatMoney(scope.row.totalFee, 5)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundDate",
      "label": "Inbound Date"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.dateFormat(scope.row.inboundDate)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportDate",
      "label": "Report Date"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.dateFormat(scope.row.reportDate)) + "\n                    ")]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.warehouseFeeDetailTotal,
      "current-page": _vm.warehouseFeeDetailPage
    },
    on: {
      "current-change": _vm.changeWarehouseFeeDetail,
      "update:currentPage": function($event) {
        _vm.warehouseFeeDetailPage = $event
      },
      "update:current-page": function($event) {
        _vm.warehouseFeeDetailPage = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.warehouseFeeDetailModelVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Warehouse Fee Summary",
      "width": "80%",
      "visible": _vm.warehouseFeeSummaryModelVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.warehouseFeeSummaryModelVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getStorageFeePaymentSummary(_vm.warehouseFeeDetailId)
      }
    },
    model: {
      value: (_vm.filters.conditionSearch),
      callback: function($$v) {
        _vm.$set(_vm.filters, "conditionSearch", $$v)
      },
      expression: "filters.conditionSearch"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.getStorageFeePaymentSummary(_vm.warehouseFeeDetailId)
      }
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.postExportExcel('/excel/exportWarehouseFeeSummary', 'Warehouse Fee Summary.xls', 1)
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.warehouseFeeSummaryLoading),
      expression: "warehouseFeeSummaryLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.warehouseFeeSummary,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productNo",
      "label": "Product No"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundFee",
      "label": "Inbound Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        $" + _vm._s(_vm.formatMoney(scope.row.inboundFee, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundFee",
      "label": "Outbound Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        $" + _vm._s(_vm.formatMoney(scope.row.outboundFee, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageFee",
      "label": "Storage Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        $" + _vm._s(_vm.formatMoney(scope.row.storageFee, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportDate",
      "label": "Report Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.getStorageFeePaymentDetail(scope.row.productNo, 1)
            }
          }
        }, [_vm._v("\n                            Detail\n                        ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.warehouseFeeSummaryTotal
    },
    on: {
      "current-change": _vm.changeWarehouseFeeSummary
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.warehouseFeeSummaryModelVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 802 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAdd
    }
  }, [_vm._v("Add Category")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showUserRate
    }
  }, [_vm._v("User Rate")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstLoading),
      expression: "firstLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.boxSizes,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sizeDefined",
      "label": "Full Label"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sizeLabel",
      "label": "Short Label"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundBaseFee",
      "label": "Inbound Base Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundRate",
      "label": "Inbound Rate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundBaseFee",
      "label": "Outbound Base Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundRate",
      "label": "Outbound Rate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageBaseFee",
      "label": "Storage Base Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageBaseFeeOver",
      "label": "Storage Base Fee > Years"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isPrintBarCode",
      "label": "Print Bar Code",
      "formatter": _vm.formatPrintStatus
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showEdit(scope.row)
            }
          }
        }, [_vm._v("Edit")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Category",
      "width": "80%",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addCategory",
    attrs: {
      "model": _vm.addCategory,
      "label-width": "220px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Short Label",
      "prop": "sizeLabel"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addCategory.sizeLabel),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "sizeLabel", $$v)
      },
      expression: "addCategory.sizeLabel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Full Label",
      "prop": "sizeDefined"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addCategory.sizeDefined),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "sizeDefined", $$v)
      },
      expression: "addCategory.sizeDefined"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Inbound Base Fee",
      "prop": "inboundBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.addCategory.inboundBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "inboundBaseFee", $$v)
      },
      expression: "addCategory.inboundBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Inbound Rate",
      "prop": "inboundRate"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.addCategory.inboundRate),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "inboundRate", $$v)
      },
      expression: "addCategory.inboundRate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Outbound Base Fee",
      "prop": "outboundBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.addCategory.outboundBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "outboundBaseFee", $$v)
      },
      expression: "addCategory.outboundBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Outbound Rate",
      "prop": "outboundRate"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.addCategory.outboundRate),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "outboundRate", $$v)
      },
      expression: "addCategory.outboundRate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Base Fee",
      "prop": "storageBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.addCategory.storageBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "storageBaseFee", $$v)
      },
      expression: "addCategory.storageBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Base Fee >Years",
      "prop": "storageBaseFeeOver"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.addCategory.storageBaseFeeOver),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "storageBaseFeeOver", $$v)
      },
      expression: "addCategory.storageBaseFeeOver"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Is Print Bar Code",
      "prop": "isPrintBarCode"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select Print Bar Code",
      "clearable": "",
      "required": ""
    },
    model: {
      value: (_vm.addCategory.isPrintBarCode),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "isPrintBarCode", $$v)
      },
      expression: "addCategory.isPrintBarCode"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "Printed"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 0,
      "label": "Not Print"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddBoxSize($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Category",
      "width": "80%",
      "visible": _vm.editVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editCategory",
    attrs: {
      "model": _vm.editCategory,
      "label-width": "220px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Short Label",
      "prop": "sizeLabel"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editCategory.sizeLabel),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "sizeLabel", $$v)
      },
      expression: "editCategory.sizeLabel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Full Label",
      "prop": "sizeDefined"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editCategory.sizeDefined),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "sizeDefined", $$v)
      },
      expression: "editCategory.sizeDefined"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Inbound Base Fee",
      "prop": "inboundBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.editCategory.inboundBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "inboundBaseFee", $$v)
      },
      expression: "editCategory.inboundBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Inbound Rate",
      "prop": "inboundRate"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.editCategory.inboundRate),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "inboundRate", $$v)
      },
      expression: "editCategory.inboundRate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Outbound Base Fee",
      "prop": "outboundBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.editCategory.outboundBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "outboundBaseFee", $$v)
      },
      expression: "editCategory.outboundBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Outbound Rate",
      "prop": "outboundRate"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.editCategory.outboundRate),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "outboundRate", $$v)
      },
      expression: "editCategory.outboundRate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Base Fee",
      "prop": "storageBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.editCategory.storageBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "storageBaseFee", $$v)
      },
      expression: "editCategory.storageBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Base Fee >Years",
      "prop": "storageBaseFeeOver"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.editCategory.storageBaseFeeOver),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "storageBaseFeeOver", $$v)
      },
      expression: "editCategory.storageBaseFeeOver"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Is Print Bar Code",
      "prop": "isPrintBarCode"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select Print Bar Code",
      "clearable": "",
      "required": ""
    },
    model: {
      value: (_vm.editCategory.isPrintBarCode),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "isPrintBarCode", $$v)
      },
      expression: "editCategory.isPrintBarCode"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "Printed"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 0,
      "label": "Not Print"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "User Rate List",
      "width": "80%",
      "visible": _vm.userRateVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.userRateVisible = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondLoading),
      expression: "secondLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.userRates,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "doctorName",
      "label": "Doctor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hasSingleSeted",
      "label": "Has bean set"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.hasSingleSeted ? "Already Set" : "Not Set") + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showCategoryEdit(scope.row.doctorNo)
            }
          }
        }, [_vm._v("Edit")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.userRateVisible = false;
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Custom Category Set",
      "width": "80%",
      "visible": _vm.customCategoryVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.customCategoryVisible = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdLoading),
      expression: "thirdLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.customCategoryConfigs,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sizeDefined",
      "label": "Full Label"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.sizeDefined) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sizeLabel",
      "label": "Short Label"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.sizeLabel) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundBaseFee",
      "label": "Inbound Base Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.inboundBaseFee) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundRate",
      "label": "Inbound Rate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.inboundRate) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundBaseFee",
      "label": "Outbound Base Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.outboundBaseFee) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundRate",
      "label": "Outbound Rate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.outboundRate) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageBaseFee",
      "label": "Storage Base Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.storageBaseFee) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageBaseFeeOver",
      "label": "Storage Base Fee > Years"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.storageBaseFeeOver) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showCustomEdit(scope.row)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), (scope.row.hasSingleSeted) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.deleteCustomItem(scope.row)
            }
          }
        }, [_vm._v("Restore")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.customCategoryVisible = false;
        _vm.getAllUserRate()
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Custom Edit Category",
      "width": "80%",
      "visible": _vm.customEditVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.customEditVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "customEditCategory",
    attrs: {
      "model": _vm.customEditCategory,
      "label-width": "220px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Short Label",
      "prop": "sizeLabel"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.customEditCategory.sizeLabel),
      callback: function($$v) {
        _vm.$set(_vm.customEditCategory, "sizeLabel", $$v)
      },
      expression: "customEditCategory.sizeLabel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Full Label",
      "prop": "sizeDefined"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.customEditCategory.sizeDefined),
      callback: function($$v) {
        _vm.$set(_vm.customEditCategory, "sizeDefined", $$v)
      },
      expression: "customEditCategory.sizeDefined"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Inbound Base Fee",
      "prop": "inboundBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.customEditCategory.inboundBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.customEditCategory, "inboundBaseFee", $$v)
      },
      expression: "customEditCategory.inboundBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Inbound Rate",
      "prop": "inboundRate"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.customEditCategory.inboundRate),
      callback: function($$v) {
        _vm.$set(_vm.customEditCategory, "inboundRate", $$v)
      },
      expression: "customEditCategory.inboundRate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Outbound Base Fee",
      "prop": "outboundBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.customEditCategory.outboundBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.customEditCategory, "outboundBaseFee", $$v)
      },
      expression: "customEditCategory.outboundBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Outbound Rate",
      "prop": "outboundRate"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.customEditCategory.outboundRate),
      callback: function($$v) {
        _vm.$set(_vm.customEditCategory, "outboundRate", $$v)
      },
      expression: "customEditCategory.outboundRate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Base Fee",
      "prop": "storageBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.customEditCategory.storageBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.customEditCategory, "storageBaseFee", $$v)
      },
      expression: "customEditCategory.storageBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Base Fee >Years",
      "prop": "storageBaseFeeOver"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.customEditCategory.storageBaseFeeOver),
      callback: function($$v) {
        _vm.$set(_vm.customEditCategory, "storageBaseFeeOver", $$v)
      },
      expression: "customEditCategory.storageBaseFeeOver"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.customEditVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.customEditLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.customEditSubmit($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 803 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ }),
/* 804 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 10
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "tools",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.collapse($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  })])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 8
    }
  }, [_c('el-dropdown', {
    staticClass: "pull-right",
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('i', {
    staticClass: "fa fa-user-circle-o user-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.sysUserName))]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v("Logout")])], 1)], 1), _vm._v(" "), (_vm.user.roleId == 2 || _vm.user.roleId == 3) ? _c('el-select', {
    staticClass: "pull-right",
    attrs: {
      "size": "small",
      "placeholder": "Company"
    },
    on: {
      "change": _vm.changeDoctor
    },
    model: {
      value: (_vm.currentCompany),
      callback: function($$v) {
        _vm.currentCompany = $$v
      },
      expression: "currentCompany"
    }
  }, _vm._l((_vm.doctors), function(doctor, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": doctor.userName,
        "value": doctor.userNo
      }
    })
  }), 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [_c('el-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "el-menu-vertical-demo el-menu-open",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": ""
    }
  }, [_vm._l((_vm.getRoutes), function(item, index) {
    return (!item.hidden) ? [(!item.leaf) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('div', {
      staticClass: "el-menu-item"
    }, [_c('el-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 10
      }
    }, [_c('i', {
      class: item.iconCls,
      staticStyle: {
        "margin-left": "12px"
      }
    })]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "text-align": "left"
      },
      attrs: {
        "span": 14
      }
    }, [_vm._v(_vm._s(item.name))])], 1)]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [_c('el-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 10
        }
      }, [_c('i', {
        class: child.iconCls
      })]), _vm._v(" "), _c('el-col', {
        staticStyle: {
          "text-align": "left"
        },
        attrs: {
          "span": 14
        }
      }, [_vm._v(_vm._s(child.name))])], 1) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('el-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 10
      }
    }, [_c('i', {
      class: item.iconCls,
      staticStyle: {
        "margin-left": "12px"
      }
    })]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "text-align": "left"
      },
      attrs: {
        "span": 14
      }
    }, [_vm._v(_vm._s(item.children[0].name))])], 1) : _vm._e()] : _vm._e()
  })], 2), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapsed),
      expression: "collapsed"
    }],
    ref: "menuCollapsed",
    staticClass: "el-menu el-menu-vertical-demo collapsed"
  }, _vm._l((_vm.getRoutes), function(item, index) {
    return (!item.hidden) ? _c('li', {
      staticClass: "el-submenu item"
    }, [(!item.leaf) ? [_c('div', {
      staticClass: "el-submenu__title el-menu-item",
      staticStyle: {
        "padding-left": "20px"
      },
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })]), _vm._v(" "), _c('ul', {
      staticClass: "el-menu submenu",
      class: 'submenu-hook-' + index,
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('li', {
        key: child.path,
        staticClass: "el-menu-item",
        class: _vm.$route.path == child.path ? 'is-active' : '',
        staticStyle: {
          "padding-left": "40px"
        },
        on: {
          "click": function($event) {
            return _vm.$router.push(child.path)
          }
        }
      }, [_vm._v("\n                                    " + _vm._s(child.name) + "\n                                ")]) : _vm._e()
    }), 0)] : [_c('li', {
      staticClass: "el-submenu"
    }, [_c('div', {
      staticClass: "el-submenu__title el-menu-item",
      class: _vm.$route.path == item.children[0].path ? 'is-active' : '',
      staticStyle: {
        "padding-left": "20px",
        "height": "56px",
        "line-height": "56px",
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push(item.children[0].path)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })])])]], 2) : _vm._e()
  }), 0)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$route.name))])]), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    ref: "child",
    attrs: {
      "current-company": _vm.currentCompany
    }
  })], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 805 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleTabClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "To anyone",
      "name": "first"
    }
  }, [_c('el-form', {
    ref: "outbound",
    attrs: {
      "model": _vm.outbound,
      "label-position": "top",
      "label-width": "220px"
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "30px"
    }
  }, [_vm._v("Outbound items")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin-left": "20px"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.showAddInventory
    }
  }, [_vm._v("Add Product")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.changeCustomizationPage(1)
      }
    }
  }, [_vm._v("Add customization Product")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.outbound.items,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('h3', [_vm._v(_vm._s(scope.row.productNme))]), _vm._v(" "), (scope.row.mainProductName) ? _c('h3', [_vm._v(_vm._s("Main Product : " + scope.row.mainProductName))]) : _vm._e(), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.upc))]), _vm._v(" "), _vm._l((scope.row.items), function(sub, index) {
          return _c('p', {
            key: index,
            staticClass: "note",
            staticStyle: {
              "margin-bottom": "2px"
            }
          }, [_vm._v("\n                                        " + _vm._s(sub.qty) + " x " + _vm._s(sub.productName) + "(" + _vm._s(sub.upc) + ") "), (sub.service && sub.service !== 'None') ? _c('span', {
            staticStyle: {
              "color": "#ff2218"
            }
          }, [_vm._v(_vm._s(sub.service))]) : _vm._e()])
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "To ship",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          attrs: {
            "min": 1,
            "max": scope.row.qty ? parseInt(scope.row.qty) : 99999
          },
          model: {
            value: (scope.row.toShip),
            callback: function($$v) {
              _vm.$set(scope.row, "toShip", $$v)
            },
            expression: "scope.row.toShip"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "width": "100px",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.removeInventory(scope.row)
            }
          }
        }, [_vm._v("Remove")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Package Label"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "auto-upload": false,
      "name": "file",
      "drag": "",
      "action": _vm.uploadUrl,
      "http-request": _vm.upload,
      "file-list": _vm.fileList,
      "headers": _vm.headers
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('em', [_vm._v("click to upload")]), _vm._v(" or drag and drop file")])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tracking number",
      "prop": "trackingNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.outbound.trackingNumber),
      callback: function($$v) {
        _vm.$set(_vm.outbound, "trackingNumber", $$v)
      },
      expression: "outbound.trackingNumber"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("Optional.")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Carrier",
      "prop": "carrier"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.outbound.carrier),
      callback: function($$v) {
        _vm.$set(_vm.outbound, "carrier", $$v)
      },
      expression: "outbound.carrier"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("Optional.")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Carrier name",
      "prop": "carrierName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.outbound.carrierName),
      callback: function($$v) {
        _vm.$set(_vm.outbound, "carrierName", $$v)
      },
      expression: "outbound.carrierName"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("Required if carrier is  'Other'.")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User",
      "prop": "user"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.outbound.user),
      callback: function($$v) {
        _vm.$set(_vm.outbound, "user", $$v)
      },
      expression: "outbound.user"
    }
  }, _vm._l((_vm.members), function(member, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": member.username,
        "value": member.userNo
      }
    })
  }), 1), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("By default, the user of the first shipment item will be notified.")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Priority",
      "prop": "priority"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.outbound.priority),
      callback: function($$v) {
        _vm.$set(_vm.outbound, "priority", $$v)
      },
      expression: "outbound.priority"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 0,
      "label": "Normal"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 1,
      "label": "Medium"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 2,
      "label": "Urgent"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Numb of box Per Shipment",
      "prop": "splitPackagesNum"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 99999
    },
    model: {
      value: (_vm.outbound.splitPackagesNum),
      callback: function($$v) {
        _vm.$set(_vm.outbound, "splitPackagesNum", $$v)
      },
      expression: "outbound.splitPackagesNum"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 40
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Instruction",
      "prop": "instruction"
    }
  }, [_c('el-row', [_c('el-select', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": "Append preset",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.changeInstruction
    },
    model: {
      value: (_vm.selectedInstruction),
      callback: function($$v) {
        _vm.selectedInstruction = $$v
      },
      expression: "selectedInstruction"
    }
  }, _vm._l((_vm.instructionTemps), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item,
        "label": item.instructionName
      }
    })
  }), 1), _vm._v(" "), _c('el-link', {
    staticStyle: {
      "margin-left": "20px"
    },
    on: {
      "click": _vm.getInstructionListByPage
    }
  }, [_vm._v("Instruction Template")])], 1), _vm._v(" "), _c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.outbound.instruction),
      callback: function($$v) {
        _vm.$set(_vm.outbound, "instruction", $$v)
      },
      expression: "outbound.instruction"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("Instruction (optional) will only appear in the email sent to the user.")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.outbound.note),
      callback: function($$v) {
        _vm.$set(_vm.outbound, "note", $$v)
      },
      expression: "outbound.note"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("Store essential information in note for future reference.")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleOutbound
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Working",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getWorkingOutboundList($event)
      }
    },
    model: {
      value: (_vm.filters.workingFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "workingFilter", $$v)
      },
      expression: "filters.workingFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getWorkingOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Main Product",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getWorkingOutboundList($event)
      }
    },
    model: {
      value: (_vm.filters.workingMainFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "workingMainFilter", $$v)
      },
      expression: "filters.workingMainFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getWorkingOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportOutboundByType', 'working.xls', '1')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.workingLoading),
      expression: "workingLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.workingList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "outboundId",
      "label": "#",
      "min-width": "3%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product Name",
      "min-width": "30%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.productName)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "instruction",
      "label": "Instruction",
      "min-width": "22%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.instruction)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Note",
      "min-width": "15%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "users",
      "label": "Users",
      "min-width": "8%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "splitPackagesNum",
      "label": "Split Package Num",
      "min-width": "5%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundDate",
      "label": "Outbound Date",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "min-width": "12%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.download(scope.row.outboundId)
            }
          }
        }, [_vm._v("Package Label")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.closeOutbound(scope.row.outboundId)
            }
          }
        }, [_vm._v("Cancel")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.workingTotal
    },
    on: {
      "current-change": _vm.changeWorkingList
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Archived",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getArchivedOutboundList($event)
      }
    },
    model: {
      value: (_vm.filters.archivedFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "archivedFilter", $$v)
      },
      expression: "filters.archivedFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getArchivedOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Main Product",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getArchivedOutboundList($event)
      }
    },
    model: {
      value: (_vm.filters.archivedMainFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "archivedMainFilter", $$v)
      },
      expression: "filters.archivedMainFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getArchivedOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportOutboundByType', 'archived.xls', '2')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.archivedLoading),
      expression: "archivedLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.archivedList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "outboundId",
      "label": "#",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.productName)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "instruction",
      "label": "Instruction"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.instruction)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "users",
      "label": "Users"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "splitPackagesNum",
      "label": "Split Package Num"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundDate",
      "label": "Outbound Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.download(scope.row.outboundId)
            }
          }
        }, [_vm._v("Package Label")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.archivedTotal
    },
    on: {
      "current-change": _vm.changeArchivedList
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Cancelled",
      "name": "fourth"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getCloseOutboundList($event)
      }
    },
    model: {
      value: (_vm.filters.closeFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "closeFilter", $$v)
      },
      expression: "filters.closeFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getCloseOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Main Product",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getCloseOutboundList($event)
      }
    },
    model: {
      value: (_vm.filters.closeMainFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "closeMainFilter", $$v)
      },
      expression: "filters.closeMainFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getCloseOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportOutboundByType', 'Cancelled.xls', '3')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.closeLoading),
      expression: "closeLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.closeList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "outboundId",
      "label": "#",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.productName)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "instruction",
      "label": "Instruction"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.instruction)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "users",
      "label": "Users"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "splitPackagesNum",
      "label": "Split Package Num"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundDate",
      "label": "Outbound Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.closeTotal
    },
    on: {
      "current-change": _vm.changeCloseList
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Transfer To",
      "name": "five"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "inline": true
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Product Name",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getTransferProductList($event)
      }
    },
    model: {
      value: (_vm.filters.productFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "productFilter", $$v)
      },
      expression: "filters.productFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getTransferProductList
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.productLoading),
      expression: "productLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.productList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "productNo",
      "width": "80px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product",
      "label": "Product",
      "width": "400px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.condition) + " - "), _c('b', [_vm._v(_vm._s(scope.row.productName))]), _vm._v(" (" + _vm._s(scope.row.createDate) + ")\n                            "), _c('p', [_vm._v(_vm._s(scope.row.upc))]), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.note))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "stock",
      "label": "FBM"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showWarehouseFBM(scope.row.productNo)
            }
          }
        }, [_vm._v("Transfer")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.productTotal
    },
    on: {
      "current-change": _vm.handleProductPageChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    key: 'transferLogsTab',
    attrs: {
      "label": "Transfer Logs",
      "name": "six"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.transferLogsLoading),
      expression: "transferLogsLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.transferLogsList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "transferNo",
      "label": "Transfer#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "Transferer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "transferToUserName",
      "label": "Acceptor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseAddress",
      "label": "Transfer Warehouse Address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "transferToAddress",
      "label": "Acceptor Warehouse Address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Transfer Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "moved",
      "label": "Checked"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.moved ? 'green' : 'red'
          })
        }, [_vm._v("\n                                " + _vm._s(scope.row.moved ? "Yes" : "No") + "\n                            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updateDate",
      "label": "Checked Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.transferLogsPageSize,
      "total": _vm.transferLogsWorkingTotal
    },
    on: {
      "current-change": _vm.getTrasferUserLogs
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Product Summary",
      "width": "80%",
      "visible": _vm.inventroySummary,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.inventroySummary = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "ProductName or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchInventorySummary($event)
      }
    },
    model: {
      value: (_vm.filters.inventoryProductSummary),
      callback: function($$v) {
        _vm.$set(_vm.filters, "inventoryProductSummary", $$v)
      },
      expression: "filters.inventoryProductSummary"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchInventorySummary
    }
  }, [_vm._v("Search")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Filter by user",
      "filterable": true
    },
    on: {
      "change": _vm.getInventorySummaryByUser
    },
    model: {
      value: (_vm.filters.inventorySummaryNurse),
      callback: function($$v) {
        _vm.$set(_vm.filters, "inventorySummaryNurse", $$v)
      },
      expression: "filters.inventorySummaryNurse"
    }
  }, _vm._l((_vm.members), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.filters.inventorySummaryNurse) ? _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.inventorySummaryLoading),
      expression: "inventorySummaryLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.inventoriesSummary,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "productNo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productNme",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          on: {
            "click": function($event) {
              return _vm.getInventory(scope.row.productNo)
            }
          }
        }, [_vm._v("Detail")])]
      }
    }], null, false, 2992596343)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.inventorySummaryTotal
    },
    on: {
      "current-change": _vm.handleInventorySummaryPageChange
    }
  })], 1)], 1) : _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.inventorySummaryLoading),
      expression: "inventorySummaryLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.inventoriesSummaryByUser,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "productNo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productNme",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseUserName",
      "label": "UserName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          on: {
            "click": function($event) {
              return _vm.selectInventory(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.selected ? 'selected' : 'select'))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.inventorySummaryByUserTotal
    },
    on: {
      "current-change": _vm.handleInventorySummaryByUserPageChange
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.inventroySummary = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Product",
      "width": "80%",
      "visible": _vm.addInventory,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addInventory = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "ProductName",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getInventory(null)
      }
    },
    model: {
      value: (_vm.filters.inventoryProduct),
      callback: function($$v) {
        _vm.$set(_vm.filters, "inventoryProduct", $$v)
      },
      expression: "filters.inventoryProduct"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getInventory(null)
      }
    }
  }, [_vm._v("Search")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Filter by user",
      "filterable": true
    },
    on: {
      "change": function($event) {
        return _vm.getInventory(null)
      }
    },
    model: {
      value: (_vm.filters.inventoryNurse),
      callback: function($$v) {
        _vm.$set(_vm.filters, "inventoryNurse", $$v)
      },
      expression: "filters.inventoryNurse"
    }
  }, _vm._l((_vm.members), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.inventoryLoading),
      expression: "inventoryLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.inventories,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "productNo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productNme",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseUserName",
      "label": "UserName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          on: {
            "click": function($event) {
              return _vm.selectInventory(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.selected ? 'selected' : 'select'))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.inventoryTotal
    },
    on: {
      "current-change": _vm.handleInventoryPageChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addInventory = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Customization Product",
      "width": "80%",
      "visible": _vm.customizationVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.customizationVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "Template Name or Mian Product",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getCustomizationProduct($event)
      }
    },
    model: {
      value: (_vm.filters.customizationName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "customizationName", $$v)
      },
      expression: "filters.customizationName"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getCustomizationProduct
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openNewCustomizationWindow
    }
  }, [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.customizationLoading),
      expression: "customizationLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.customizationProduct,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "templateName",
      "label": "Template Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mainProductName",
      "label": "Main Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product",
      "label": "Product"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('h3', [_vm._v(_vm._s(scope.row.product))]), _vm._v(" "), _vm._l((scope.row.items), function(sub, index) {
          return _c('p', {
            key: index,
            staticClass: "note"
          }, [_vm._v("\n                            " + _vm._s(sub.productName) + " * " + _vm._s(sub.qty) + " "), (sub.service && sub.service !== 'None') ? _c('span', {
            staticStyle: {
              "color": "#ff2218"
            }
          }, [_vm._v("(" + _vm._s(sub.service) + ")")]) : _vm._e()])
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.selectCustomization(scope.row)
            }
          }
        }, [_vm._v("Select")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.eitCustomization(scope.row)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteCustomization(scope.row.id)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.customizationVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Customization Product",
      "width": "80%",
      "visible": _vm.addCustomizationVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addCustomizationVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "customization",
    attrs: {
      "model": _vm.customization,
      "label-width": "220px",
      "rules": _vm.customizationRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouse"
    }
  }, [_c('el-select', {
    on: {
      "change": _vm.getProductsByWarehouseId
    },
    model: {
      value: (_vm.customization.warehouse),
      callback: function($$v) {
        _vm.$set(_vm.customization, "warehouse", $$v)
      },
      expression: "customization.warehouse"
    }
  }, _vm._l((_vm.warehouses), function(w, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": w.state + ' ' + w.city + ' ' + w.address,
        "value": w.warehouseNo
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.customization.warehouse) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Main Product",
      "prop": "mainProduct"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": true
    },
    model: {
      value: (_vm.customization.mainProduct),
      callback: function($$v) {
        _vm.$set(_vm.customization, "mainProduct", $$v)
      },
      expression: "customization.mainProduct"
    }
  }, _vm._l((_vm.inventories), function(product, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": product.productNo,
        "label": product.productNme + '(Stock:' + product.stock + ')'
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Main Product Qty",
      "prop": "mainProductQty"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.customization.mainProductQty),
      callback: function($$v) {
        _vm.$set(_vm.customization, "mainProductQty", $$v)
      },
      expression: "customization.mainProductQty"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Template Name",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.customization.name),
      callback: function($$v) {
        _vm.$set(_vm.customization, "name", $$v)
      },
      expression: "customization.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Products"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addAccessories
    }
  }, [_vm._v("Add Product")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.customization.sub,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "filterable": true
          },
          model: {
            value: (scope.row.productNo),
            callback: function($$v) {
              _vm.$set(scope.row, "productNo", $$v)
            },
            expression: "scope.row.productNo"
          }
        }, _vm._l((_vm.inventories), function(product, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "value": product.productNo,
              "label": product.productNme + '(Stock:' + product.stock + ')'
            }
          })
        }), 1)]
      }
    }], null, false, 3483873928)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Qty",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          model: {
            value: (scope.row.qty),
            callback: function($$v) {
              _vm.$set(scope.row, "qty", $$v)
            },
            expression: "scope.row.qty"
          }
        })]
      }
    }], null, false, 4082218523)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Service",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "filterable": true
          },
          model: {
            value: (scope.row.service),
            callback: function($$v) {
              _vm.$set(scope.row, "service", $$v)
            },
            expression: "scope.row.service"
          }
        }, [_c('el-option', {
          attrs: {
            "value": "None"
          }
        }, [_vm._v("None")]), _vm._v(" "), _vm._l((_vm.serviceList), function(service, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "value": service,
              "label": service
            }
          })
        })], 2)]
      }
    }], null, false, 2962174138)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteSub(scope.row)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }], null, false, 1512946399)
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addCustomizationVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addCustomizationTemplate($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Customization Product",
      "width": "80%",
      "visible": _vm.editCustomizationVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editCustomizationVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editCustomization",
    attrs: {
      "model": _vm.editCustomization,
      "label-width": "220px",
      "rules": _vm.customizationRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouse"
    }
  }, [_c('el-select', {
    on: {
      "change": _vm.getProductsByWarehouseId
    },
    model: {
      value: (_vm.editCustomization.warehouse),
      callback: function($$v) {
        _vm.$set(_vm.editCustomization, "warehouse", $$v)
      },
      expression: "editCustomization.warehouse"
    }
  }, _vm._l((_vm.warehouses), function(w, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": w.state + ' ' + w.city + ' ' + w.address,
        "value": w.warehouseNo
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.editCustomization.warehouse) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Template Name",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editCustomization.name),
      callback: function($$v) {
        _vm.$set(_vm.editCustomization, "name", $$v)
      },
      expression: "editCustomization.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Main Product",
      "prop": "mainProduct"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": true
    },
    model: {
      value: (_vm.editCustomization.mainProduct),
      callback: function($$v) {
        _vm.$set(_vm.editCustomization, "mainProduct", $$v)
      },
      expression: "editCustomization.mainProduct"
    }
  }, _vm._l((_vm.inventories), function(product, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": product.productNo,
        "label": product.productNme + '(Stock:' + product.stock + ')'
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Main Product Qty",
      "prop": "mainProductQty"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.editCustomization.mainProductQty),
      callback: function($$v) {
        _vm.$set(_vm.editCustomization, "mainProductQty", $$v)
      },
      expression: "editCustomization.mainProductQty"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Products"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addEditAccessories
    }
  }, [_vm._v("Add Product")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.editCustomization.sub,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "filterable": true
          },
          model: {
            value: (scope.row.productNo),
            callback: function($$v) {
              _vm.$set(scope.row, "productNo", $$v)
            },
            expression: "scope.row.productNo"
          }
        }, _vm._l((_vm.inventories), function(product, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "value": product.productNo,
              "label": product.productNme + '(Stock:' + product.stock + ')'
            }
          })
        }), 1)]
      }
    }], null, false, 3483873928)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Qty",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          model: {
            value: (scope.row.qty),
            callback: function($$v) {
              _vm.$set(scope.row, "qty", $$v)
            },
            expression: "scope.row.qty"
          }
        })]
      }
    }], null, false, 4082218523)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Service",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "filterable": true
          },
          model: {
            value: (scope.row.service),
            callback: function($$v) {
              _vm.$set(scope.row, "service", $$v)
            },
            expression: "scope.row.service"
          }
        }, [_c('el-option', {
          attrs: {
            "value": "None"
          }
        }, [_vm._v("None")]), _vm._v(" "), _vm._l((_vm.serviceList), function(service, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "value": service,
              "label": service
            }
          })
        })], 2)]
      }
    }], null, false, 2962174138)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteEditSub(scope.row)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }], null, false, 1628885603)
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editCustomizationVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editCustomizationTemplate($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Instruction Template",
      "width": "80%",
      "visible": _vm.instructionTemplateVisiable,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.instructionTemplateVisiable = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addInstructionVisible = true
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.instructionLoading),
      expression: "instructionLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.instructionListPage,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "instructionName",
      "label": "Instruction Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Text"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.instructionText)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.instructionNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editInstruction(scope.row)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteInstruction(scope.row.id)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.instructionTotal
    },
    on: {
      "current-change": _vm.handleInventoryPageChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.instructionTemplateVisiable = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Instruction",
      "width": "80%",
      "visible": _vm.addInstructionVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addInstructionVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addInstruction",
    attrs: {
      "model": _vm.addInstruction,
      "label-width": "220px",
      "rules": _vm.addInstructionRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addInstruction.name),
      callback: function($$v) {
        _vm.$set(_vm.addInstruction, "name", $$v)
      },
      expression: "addInstruction.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Text",
      "prop": "text"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.addInstruction.text),
      callback: function($$v) {
        _vm.$set(_vm.addInstruction, "text", $$v)
      },
      expression: "addInstruction.text"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.addInstruction.note),
      callback: function($$v) {
        _vm.$set(_vm.addInstruction, "note", $$v)
      },
      expression: "addInstruction.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addInstructionVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddInstruction($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Instruction",
      "width": "80%",
      "visible": _vm.editInstructionVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editInstructionVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editInstructionObj",
    attrs: {
      "model": _vm.editInstructionObj,
      "label-width": "220px",
      "rules": _vm.addInstructionRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editInstructionObj.name),
      callback: function($$v) {
        _vm.$set(_vm.editInstructionObj, "name", $$v)
      },
      expression: "editInstructionObj.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Text",
      "prop": "text"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.editInstructionObj.text),
      callback: function($$v) {
        _vm.$set(_vm.editInstructionObj, "text", $$v)
      },
      expression: "editInstructionObj.text"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.editInstructionObj.note),
      callback: function($$v) {
        _vm.$set(_vm.editInstructionObj, "note", $$v)
      },
      expression: "editInstructionObj.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editInstructionVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleEditInstruction($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Product FBM List",
      "width": "80%",
      "visible": _vm.fbmModelVisiable,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.fbmModelVisiable = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fbmLoading),
      expression: "fbmLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.fbmDetail,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productNme",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseUserName",
      "label": "UserName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showTransfer(scope.row.productNo, scope.row.warehouseNo)
            }
          }
        }, [_vm._v("Transfer To")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.fbmTotal
    },
    on: {
      "current-change": _vm.handleInventoryDetailPageChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.fbmModelVisiable = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Transfer To",
      "width": "40%",
      "visible": _vm.transferModelVisiable,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.transferModelVisiable = $event
      }
    }
  }, [_c('el-form', {
    ref: "transferForm",
    attrs: {
      "model": _vm.transferForm,
      "label-width": "220px",
      "rules": _vm.transferRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.transferForm.productName),
      callback: function($$v) {
        _vm.$set(_vm.transferForm, "productName", $$v)
      },
      expression: "transferForm.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.transferForm.warehouse),
      callback: function($$v) {
        _vm.$set(_vm.transferForm, "warehouse", $$v)
      },
      expression: "transferForm.warehouse"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.transferForm.upc),
      callback: function($$v) {
        _vm.$set(_vm.transferForm, "upc", $$v)
      },
      expression: "transferForm.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Qty"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.transferForm.qty),
      callback: function($$v) {
        _vm.$set(_vm.transferForm, "qty", $$v)
      },
      expression: "transferForm.qty"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Transfer To",
      "prop": "to"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "User Name"
    },
    model: {
      value: (_vm.transferForm.to),
      callback: function($$v) {
        _vm.$set(_vm.transferForm, "to", $$v)
      },
      expression: "transferForm.to"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Transfer Qty",
      "prop": "transferQty"
    }
  }, [_c('el-input-number', {
    attrs: {
      "max": parseInt(_vm.transferForm.qty)
    },
    model: {
      value: (_vm.transferForm.transferQty),
      callback: function($$v) {
        _vm.$set(_vm.transferForm, "transferQty", $$v)
      },
      expression: "transferForm.transferQty"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.transferModelVisiable = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.transferTo($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 806 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addFormVisible = true
      }
    }
  }, [_vm._v("Add Self Storage")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.warehouses,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": function($event) {}
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "Address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "city",
      "label": "City"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "state",
      "label": "State"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "zipCode",
      "label": "Zip Code"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.getWarehousesById(scope.row.warehouseNo)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.deleteWarehouses(scope.row.warehouseNo)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": function($event) {}
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add warehouse",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "warehouseForm",
    attrs: {
      "model": _vm.warehouseForm,
      "label-width": "180px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.address),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "address", $$v)
      },
      expression: "warehouseForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "City",
      "prop": "city"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.city),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "city", $$v)
      },
      expression: "warehouseForm.city"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "State",
      "prop": "state"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.state),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "state", $$v)
      },
      expression: "warehouseForm.state"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Zip Code",
      "prop": "zipCode"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.zipCode),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "zipCode", $$v)
      },
      expression: "warehouseForm.zipCode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addWarehouse($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit warehouse",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editWarehouseObj",
    attrs: {
      "model": _vm.editWarehouseObj,
      "label-width": "180px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "State",
      "prop": "state"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.state),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "state", $$v)
      },
      expression: "editWarehouseObj.state"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "City",
      "prop": "city"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.city),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "city", $$v)
      },
      expression: "editWarehouseObj.city"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.address),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "address", $$v)
      },
      expression: "editWarehouseObj.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Zip Code",
      "prop": "zipCode"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.zipCode),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "zipCode", $$v)
      },
      expression: "editWarehouseObj.zipCode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editWarehouse($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Inventory",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "ProduceName or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getInventory($event)
      }
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getInventory
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNurseInventory', 'Inventory.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.products,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productNo) + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "ProductName"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productName) + " " + _vm._s(scope.row.createDate ? "(" + scope.row.createDate + ")" : "") + "\n\t\t\t\t\t\t\t"), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.upc))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "left",
      "label": "Left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showReportInventory(scope.row)
            }
          }
        }, [_vm._v("Report")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), (_vm.role == 3) ? _c('el-tab-pane', {
    attrs: {
      "label": "Zero Storage",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "ProduceName or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getZeroInventory($event)
      }
    },
    model: {
      value: (_vm.filters.zeroName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "zeroName", $$v)
      },
      expression: "filters.zeroName"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getZeroInventory
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.zeroInventory,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productNo) + "\n\t\t\t\t\t\t")]
      }
    }], null, false, 1750233183)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "ProductName"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productName) + " " + _vm._s(scope.row.createDate ? "(" + scope.row.createDate + ")" : "") + "\n\t\t\t\t\t\t\t"), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.upc))])]
      }
    }], null, false, 1926563046)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "left",
      "label": "Left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.zeroInventroyTotal
    },
    on: {
      "current-change": _vm.handleZeroChange
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.role == 3) ? _c('el-tab-pane', {
    attrs: {
      "label": "Products",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "ProduceName or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getDoctorProductList($event)
      }
    },
    model: {
      value: (_vm.filters.doctorProductName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "doctorProductName", $$v)
      },
      expression: "filters.doctorProductName"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getDoctorProductList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addFormVisible = true
      }
    }
  }, [_vm._v("Add Product")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.doctorProductList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productNo) + "\n\t\t\t\t\t\t")]
      }
    }], null, false, 1750233183)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "ProductName"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productName) + " " + _vm._s(scope.row.createDate ? "(" + scope.row.createDate + ")" : "") + "\n\t\t\t\t\t\t\t"), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.upc))])]
      }
    }], null, false, 1926563046)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "size",
      "label": "Category"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditProduct(scope.row)
            }
          }
        }, [_vm._v("Edit Product")])]
      }
    }], null, false, 2749166596)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleProductChange
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.role == 3) ? _c('el-tab-pane', {
    attrs: {
      "label": "Product Pool",
      "name": "fourth"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "ProduceName or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getProductTemplateList($event)
      }
    },
    model: {
      value: (_vm.filters.productTemplateCondition),
      callback: function($$v) {
        _vm.$set(_vm.filters, "productTemplateCondition", $$v)
      },
      expression: "filters.productTemplateCondition"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getProductTemplateList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.productTemplateAddFormVisible = true
      }
    }
  }, [_vm._v("Add Product")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.productTemplateList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productNo) + "\n\t\t\t\t\t\t")]
      }
    }], null, false, 1750233183)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "ProductName"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productName) + " " + _vm._s(scope.row.createDate ? "(" + scope.row.createDate + ")" : "") + "\n\t\t\t\t\t\t\t"), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.upc))])]
      }
    }], null, false, 1926563046)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "size",
      "label": "Category"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageFreeDuration",
      "label": "Storage Free Duration (Month)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.storageFreeDuration != null ? scope.row.storageFreeDuration : "Not Set") + "\n\t\t\t\t\t\t")]
      }
    }], null, false, 2879858912)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("Not Distribute")]) : (scope.row.status == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Distributed")]) : _vm._e()]
      }
    }], null, false, 1894842330)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditProductTemplate(scope.row)
            }
          }
        }, [_vm._v("Edit Product Template")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.showDistributeSelectDoctorWin(scope.row)
            }
          }
        }, [_vm._v("Distribute")])]
      }
    }], null, false, 1468722737)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.productTemplateTotal
    },
    on: {
      "current-change": _vm.handleProductTemplateChange
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Report Missing Items",
      "width": "80%",
      "visible": _vm.reportFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.reportFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "report",
    attrs: {
      "model": _vm.report,
      "label-width": "220px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product Name",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.report.product),
      callback: function($$v) {
        _vm.$set(_vm.report, "product", $$v)
      },
      expression: "report.product"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Missing Item",
      "prop": "id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.changeItem()
      }
    },
    model: {
      value: (_vm.report.id),
      callback: function($$v) {
        _vm.$set(_vm.report, "id", $$v)
      },
      expression: "report.id"
    }
  }, _vm._l((_vm.report.items), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.id,
        "label": item.displayName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Quantity",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.report.quantity),
      callback: function($$v) {
        _vm.$set(_vm.report, "quantity", $$v)
      },
      expression: "report.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.report.note),
      callback: function($$v) {
        _vm.$set(_vm.report, "note", $$v)
      },
      expression: "report.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.reportFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleReportInventory($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Product",
      "width": "80%",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addProduct",
    attrs: {
      "model": _vm.addProduct,
      "label-width": "220px",
      "rules": _vm.productFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "product"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.product),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "product", $$v)
      },
      expression: "addProduct.product"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Category",
      "prop": "size"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.size),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "size", $$v)
      },
      expression: "addProduct.size"
    }
  }, _vm._l((_vm.sizeList), function(size, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": size,
        "label": size
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Free Duration (Month)",
      "prop": "storageFreeDuration"
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.addProduct.storageFreeDuration),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "storageFreeDuration", $$v)
      },
      expression: "addProduct.storageFreeDuration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Condition",
      "prop": "condition"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.condition),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "condition", $$v)
      },
      expression: "addProduct.condition"
    }
  }, _vm._l((_vm.conditions), function(condition, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": condition,
        "label": condition
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ASIN",
      "prop": "asin"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.asin),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "asin", $$v)
      },
      expression: "addProduct.asin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC",
      "prop": "upc"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.upc),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "upc", $$v)
      },
      expression: "addProduct.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Weight",
      "prop": "weight"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.weight),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "weight", $$v)
      },
      expression: "addProduct.weight"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.note),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "note", $$v)
      },
      expression: "addProduct.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddProduct($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Product",
      "width": "80%",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editProduct",
    attrs: {
      "model": _vm.editProduct,
      "label-width": "220px",
      "rules": _vm.productFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProduct.productName),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "productName", $$v)
      },
      expression: "editProduct.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Free Duration (Month)",
      "prop": "storageFreeDuration"
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.editProduct.storageFreeDuration),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "storageFreeDuration", $$v)
      },
      expression: "editProduct.storageFreeDuration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Category",
      "prop": "size"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProduct.size),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "size", $$v)
      },
      expression: "editProduct.size"
    }
  }, _vm._l((_vm.sizeList), function(size, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": size,
        "label": size
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Condition",
      "prop": "condition"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProduct.condition),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "condition", $$v)
      },
      expression: "editProduct.condition"
    }
  }, _vm._l((_vm.conditions), function(condition, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": condition,
        "label": condition
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ASIN"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editProduct.asin),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "asin", $$v)
      },
      expression: "editProduct.asin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editProduct.upc),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "upc", $$v)
      },
      expression: "editProduct.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Weight"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editProduct.weight),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "weight", $$v)
      },
      expression: "editProduct.weight"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProduct.note),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "note", $$v)
      },
      expression: "editProduct.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Product Template",
      "width": "80%",
      "visible": _vm.productTemplateAddFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.productTemplateAddFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addProductTemplate",
    attrs: {
      "model": _vm.addProductTemplate,
      "label-width": "220px",
      "rules": _vm.productFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "product"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProductTemplate.product),
      callback: function($$v) {
        _vm.$set(_vm.addProductTemplate, "product", $$v)
      },
      expression: "addProductTemplate.product"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Category",
      "prop": "size"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProductTemplate.size),
      callback: function($$v) {
        _vm.$set(_vm.addProductTemplate, "size", $$v)
      },
      expression: "addProductTemplate.size"
    }
  }, _vm._l((_vm.sizeList), function(size, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": size,
        "label": size
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Free Duration (Month)",
      "prop": "storageFreeDuration"
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.addProductTemplate.storageFreeDuration),
      callback: function($$v) {
        _vm.$set(_vm.addProductTemplate, "storageFreeDuration", $$v)
      },
      expression: "addProductTemplate.storageFreeDuration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Condition",
      "prop": "condition"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProductTemplate.condition),
      callback: function($$v) {
        _vm.$set(_vm.addProductTemplate, "condition", $$v)
      },
      expression: "addProductTemplate.condition"
    }
  }, _vm._l((_vm.conditions), function(condition, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": condition,
        "label": condition
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ASIN",
      "prop": "asin"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProductTemplate.asin),
      callback: function($$v) {
        _vm.$set(_vm.addProductTemplate, "asin", $$v)
      },
      expression: "addProductTemplate.asin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC",
      "prop": "upc"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProductTemplate.upc),
      callback: function($$v) {
        _vm.$set(_vm.addProductTemplate, "upc", $$v)
      },
      expression: "addProductTemplate.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Weight",
      "prop": "weight"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProductTemplate.weight),
      callback: function($$v) {
        _vm.$set(_vm.addProductTemplate, "weight", $$v)
      },
      expression: "addProductTemplate.weight"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProductTemplate.note),
      callback: function($$v) {
        _vm.$set(_vm.addProductTemplate, "note", $$v)
      },
      expression: "addProductTemplate.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.productTemplateAddFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddProductTemplate($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Product Template",
      "width": "80%",
      "visible": _vm.productTemplateEditFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.productTemplateEditFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editProductTemplate",
    attrs: {
      "model": _vm.editProductTemplate,
      "label-width": "220px",
      "rules": _vm.productFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProductTemplate.productName),
      callback: function($$v) {
        _vm.$set(_vm.editProductTemplate, "productName", $$v)
      },
      expression: "editProductTemplate.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Free Duration (Month)",
      "prop": "storageFreeDuration"
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.editProductTemplate.storageFreeDuration),
      callback: function($$v) {
        _vm.$set(_vm.editProductTemplate, "storageFreeDuration", $$v)
      },
      expression: "editProductTemplate.storageFreeDuration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Category",
      "prop": "size"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProductTemplate.size),
      callback: function($$v) {
        _vm.$set(_vm.editProductTemplate, "size", $$v)
      },
      expression: "editProductTemplate.size"
    }
  }, _vm._l((_vm.sizeList), function(size, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": size,
        "label": size
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Condition",
      "prop": "condition"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProductTemplate.condition),
      callback: function($$v) {
        _vm.$set(_vm.editProductTemplate, "condition", $$v)
      },
      expression: "editProductTemplate.condition"
    }
  }, _vm._l((_vm.conditions), function(condition, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": condition,
        "label": condition
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ASIN"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editProductTemplate.asin),
      callback: function($$v) {
        _vm.$set(_vm.editProductTemplate, "asin", $$v)
      },
      expression: "editProductTemplate.asin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.editProductTemplate.status == 1 ? true : false
    },
    model: {
      value: (_vm.editProductTemplate.upc),
      callback: function($$v) {
        _vm.$set(_vm.editProductTemplate, "upc", $$v)
      },
      expression: "editProductTemplate.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Weight"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editProductTemplate.weight),
      callback: function($$v) {
        _vm.$set(_vm.editProductTemplate, "weight", $$v)
      },
      expression: "editProductTemplate.weight"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProductTemplate.note),
      callback: function($$v) {
        _vm.$set(_vm.editProductTemplate, "note", $$v)
      },
      expression: "editProductTemplate.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.productTemplateEditFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmitTemplate($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Select which users to send under",
      "width": "80%",
      "visible": _vm.selectDoctorsVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.selectDoctorsVisible = $event
      }
    }
  }, [_c('div', _vm._l((_vm.selectedDoctorNames), function(userName, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "effect": "dark"
      }
    }, [_vm._v(_vm._s(userName))])
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: (_vm.distributeSelectedDoctors),
      callback: function($$v) {
        _vm.distributeSelectedDoctors = $$v
      },
      expression: "distributeSelectedDoctors"
    }
  }, _vm._l((_vm.doctorList), function(user, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": user.userName,
        "value": user.userNo
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.selectDoctorsVisible = false;
        _vm.distributeSelectedDoctors = [];
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.distributeProductTempate($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })
],[391]);


// WEBPACK FOOTER //
// static/js/app.9f6fb5898c04e2a1e19b.js